// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5Tqlz":[function(require,module,exports) {
// import React from "react";
// import ReactDOMClient from "react-dom/client";
// import { Frame } from "./screens/Frame";
// import FrameNew from "./screens/Frame/frameNew";
// const app = document.getElementById("app");
// const root = ReactDOMClient.createRoot(app);
// // root.render(<Frame />);
// root.render(<FrameNew />);
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactRouterDom = require("react-router-dom"); // Import the Router
var _frame = require("./screens/Frame"); // Assuming this is another component
var _frameNew = require("./screens/Frame/frameNew"); // Your FrameNew component
var _frameNewDefault = parcelHelpers.interopDefault(_frameNew);
var _pagenotfound = require("./screens/Frame/pagenotfound");
var _pagenotfoundDefault = parcelHelpers.interopDefault(_pagenotfound);
var _noAudioEnglish = require("./screens/Frame/noAudioEnglish");
var _noAudioEnglishDefault = parcelHelpers.interopDefault(_noAudioEnglish);
var _botUserApp = require("./screens/botUserApp/botUserApp");
var _botUserAppDefault = parcelHelpers.interopDefault(_botUserApp);
const app = document.getElementById("app");
const root = (0, _clientDefault.default).createRoot(app);
// Wrap your FrameNew component in Router
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/:companyname/:module/:avatar",
                exact: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noAudioEnglishDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagenotfoundDefault.default), {})
            })
        ]
    })
}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom/client":"5ccwt","react-router-dom":"l6ORY","./screens/Frame":"5VfA9","./screens/Frame/frameNew":"j7Pmb","./screens/Frame/pagenotfound":"1bn3Q","./screens/Frame/noAudioEnglish":"2BPVl","./screens/botUserApp/botUserApp":"6DYtW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"l6ORY":[function(require,module,exports) {
/**
 * React Router DOM v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"6uln9","react-dom":"b8T3j","react-router":"kbGcH","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbGcH":[function(require,module,exports) {
/**
 * React Router v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

},{"react":"6uln9","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNWKZ":[function(require,module,exports) {
/**
 * @remix-run/router v1.19.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
parcelHelpers.export(exports, "unstable_data", ()=>data);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId, error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId, error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false);
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation, nextLocation, historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: findNearestBoundary(discoverResult.partialMatches).route.id,
            error: getInternalRouterError(400, {
                type: "route-discovery",
                pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches
            };
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await callDataStrategyImpl(unstable_dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path,
                matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = convertRoutesToDataRoutes(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = convertRoutesToDataRoutes(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref6) {
    let { matches } = _ref6;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init3, _result$init4;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"5VfA9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Frame", ()=>(0, _frame.Frame));
var _frame = require("./Frame");

},{"./Frame":"lcZB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcZB7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Frame", ()=>Frame);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const Frame = ()=>{
    const [inputValue, setInputValue] = (0, _react.useState)("");
    const [videoUrl, setVideoUrl] = (0, _react.useState)(null);
    const handleInputChange = (e)=>{
        setInputValue(e.target.value);
    };
    const handleSubmit = ()=>{
        const data = {
            user_input: inputValue
        };
        fetch("https://av.pranathiss.com/api/generate_video/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response)=>response.json()).then((data)=>{
            if (data.success && data.video_url) setVideoUrl(data.video_url);
            else console.error("Video URL not found in the response");
        }).catch((error)=>{
            console.error("Error:", error);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "div"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-wrapper",
                                children: "Chat with"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Siri (chat bot name)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "fi",
                                alt: "Fi",
                                src: "/img/fi-2961937.svg"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "line",
                                alt: "Line",
                                src: "/img/line-26.svg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "chat-and-video-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chat-section",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "chat",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "operator",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "div-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "p",
                                                            children: "\uD83D\uDC4B\xa0\xa0Hello and Welcome to our site!"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "div-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "p",
                                                            children: "My name is Siri, How can I assist you today?"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "operator-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "div-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "p",
                                                            children: "Sure! Please choose an option"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "operator-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "div-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "p",
                                                            children: "To view your leave balance"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "operator-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-3",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "click-on-the-leave-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "click-on-the-leave",
                                                            children: 'Click on the "Leave" section in your dashboard'
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-wrapper-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-wrapper-4",
                                                children: "I need to check my leave balance"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "fi-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "fi-6",
                                                alt: "Fi",
                                                src: "/img/fi-456212.svg"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "video-section",
                                children: videoUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Your Video:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                            width: "100%",
                                            controls: true,
                                            autoPlay: true,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                    src: videoUrl,
                                                    type: "video/mp4"
                                                }),
                                                "Your browser does not support the video tag."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overlap-group-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "type-text",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "group-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "line-3",
                                                        alt: "Line",
                                                        src: "/img/line-25.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-3",
                                                                children: "Type Your Message..."
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                type: "text",
                                                                value: inputValue,
                                                                onChange: handleInputChange,
                                                                placeholder: "Enter your message"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "fi-2",
                                                        alt: "Fi",
                                                        src: "/img/fi-561106.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "fi-3",
                                                        alt: "Fi",
                                                        src: "/img/fi-1933691.svg"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "fi-4",
                                                alt: "Fi",
                                                src: "/img/fi-5264505.svg",
                                                onClick: handleSubmit
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "fi-5",
                                    alt: "Fi",
                                    src: "/img/fi-107737.svg"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./style.css":"3yaJr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yaJr":[function() {},{}],"j7Pmb":[function(require,module,exports) {
// import React, { useState, useRef, useEffect } from 'react';
// import Picker from 'emoji-picker-react';
// import './frameNew.css';
// import chatBoxImage from '../../../static/img/chatBoxImageCrop1.png'
// import arrowDown from '../../../static/img/arrowDownConvert.png'
// import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
// import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
// import { useFetcher, useLocation, useParams } from 'react-router-dom';
// const MessageInput = () => {
//   // const avatarList = [
//   //   { name: 'Shweta', image: '/img/avatar/woman.png' },
//   //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Aman', image: '/img/avatar/man.png' },
//   //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Alex', image: '/img/avatar/man.png' },
//   //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
//   // ];
//   const languages = [
//     {
//       "language": "Afrikaans",
//       "code": "af"
//     },
//     {
//       "language": "Albanian",
//       "code": "sq"
//     },
//     {
//       "language": "Amharic",
//       "code": "am"
//     },
//     {
//       "language": "Arabic",
//       "code": "ar"
//     },
//     {
//       "language": "Armenian",
//       "code": "hy"
//     },
//     {
//       "language": "Azerbaijani",
//       "code": "az"
//     },
//     {
//       "language": "Basque",
//       "code": "eu"
//     },
//     {
//       "language": "Belarusian",
//       "code": "be"
//     },
//     {
//       "language": "Bengali",
//       "code": "bn"
//     },
//     {
//       "language": "Bosnian",
//       "code": "bs"
//     },
//     {
//       "language": "Bulgarian",
//       "code": "bg"
//     },
//     {
//       "language": "Catalan",
//       "code": "ca"
//     },
//     {
//       "language": "Cebuano",
//       "code": "ceb"
//     },
//     {
//       "language": "Chinese (Simplified)",
//       "code": "zh-CN"
//     },
//     {
//       "language": "Chinese (Traditional)",
//       "code": "zh-TW"
//     },
//     {
//       "language": "Corsican",
//       "code": "co"
//     },
//     {
//       "language": "Croatian",
//       "code": "hr"
//     },
//     {
//       "language": "Czech",
//       "code": "cs"
//     },
//     {
//       "language": "Danish",
//       "code": "da"
//     },
//     {
//       "language": "Dutch",
//       "code": "nl"
//     },
//     {
//       "language": "English",
//       "code": "en"
//     },
//     {
//       "language": "Esperanto",
//       "code": "eo"
//     },
//     {
//       "language": "Estonian",
//       "code": "et"
//     },
//     {
//       "language": "Finnish",
//       "code": "fi"
//     },
//     {
//       "language": "French",
//       "code": "fr"
//     },
//     {
//       "language": "Frisian",
//       "code": "fy"
//     },
//     {
//       "language": "Galician",
//       "code": "gl"
//     },
//     {
//       "language": "Georgian",
//       "code": "ka"
//     },
//     {
//       "language": "German",
//       "code": "de"
//     },
//     {
//       "language": "Greek",
//       "code": "el"
//     },
//     {
//       "language": "Gujarati",
//       "code": "gu"
//     },
//     {
//       "language": "Haitian Creole",
//       "code": "ht"
//     },
//     {
//       "language": "Hausa",
//       "code": "ha"
//     },
//     {
//       "language": "Hawaiian",
//       "code": "haw"
//     },
//     {
//       "language": "Hebrew",
//       "code": "iw"
//     },
//     {
//       "language": "Hindi",
//       "code": "hi"
//     },
//     {
//       "language": "Hmong",
//       "code": "hmn"
//     },
//     {
//       "language": "Hungarian",
//       "code": "hu"
//     },
//     {
//       "language": "Icelandic",
//       "code": "is"
//     },
//     {
//       "language": "Igbo",
//       "code": "ig"
//     },
//     {
//       "language": "Indonesian",
//       "code": "id"
//     },
//     {
//       "language": "Irish",
//       "code": "ga"
//     },
//     {
//       "language": "Italian",
//       "code": "it"
//     },
//     {
//       "language": "Japanese",
//       "code": "ja"
//     },
//     {
//       "language": "Javanese",
//       "code": "jw"
//     },
//     {
//       "language": "Kannada",
//       "code": "kn"
//     },
//     {
//       "language": "Kazakh",
//       "code": "kk"
//     },
//     {
//       "language": "Khmer",
//       "code": "km"
//     },
//     {
//       "language": "Korean",
//       "code": "ko"
//     },
//     {
//       "language": "Kurdish",
//       "code": "ku"
//     },
//     {
//       "language": "Kyrgyz",
//       "code": "ky"
//     },
//     {
//       "language": "Lao",
//       "code": "lo"
//     },
//     {
//       "language": "Latin",
//       "code": "la"
//     },
//     {
//       "language": "Latvian",
//       "code": "lv"
//     },
//     {
//       "language": "Lithuanian",
//       "code": "lt"
//     },
//     {
//       "language": "Luxembourgish",
//       "code": "lb"
//     },
//     {
//       "language": "Macedonian",
//       "code": "mk"
//     },
//     {
//       "language": "Malagasy",
//       "code": "mg"
//     },
//     {
//       "language": "Malay",
//       "code": "ms"
//     },
//     {
//       "language": "Malayalam",
//       "code": "ml"
//     },
//     {
//       "language": "Maltese",
//       "code": "mt"
//     },
//     {
//       "language": "Maori",
//       "code": "mi"
//     },
//     {
//       "language": "Marathi",
//       "code": "mr"
//     },
//     {
//       "language": "Mongolian",
//       "code": "mn"
//     },
//     {
//       "language": "Myanmar (Burmese)",
//       "code": "my"
//     },
//     {
//       "language": "Nepali",
//       "code": "ne"
//     },
//     {
//       "language": "Norwegian",
//       "code": "no"
//     },
//     {
//       "language": "Nyanja (Chichewa)",
//       "code": "ny"
//     },
//     {
//       "language": "Pashto",
//       "code": "ps"
//     },
//     {
//       "language": "Persian",
//       "code": "fa"
//     },
//     {
//       "language": "Polish",
//       "code": "pl"
//     },
//     {
//       "language": "Portuguese (Portugal, Brazil)",
//       "code": "pt"
//     },
//     {
//       "language": "Punjabi",
//       "code": "pa"
//     },
//     {
//       "language": "Romanian",
//       "code": "ro"
//     },
//     {
//       "language": "Russian",
//       "code": "ru"
//     },
//     {
//       "language": "Samoan",
//       "code": "sm"
//     },
//     {
//       "language": "Scots Gaelic",
//       "code": "gd"
//     },
//     {
//       "language": "Serbian",
//       "code": "sr"
//     },
//     {
//       "language": "Sesotho",
//       "code": "st"
//     },
//     {
//       "language": "Shona",
//       "code": "sn"
//     },
//     {
//       "language": "Sindhi",
//       "code": "sd"
//     },
//     {
//       "language": "Sinhala (Sinhalese)",
//       "code": "si"
//     },
//     {
//       "language": "Slovak",
//       "code": "sk"
//     },
//     {
//       "language": "Slovenian",
//       "code": "sl"
//     },
//     {
//       "language": "Somali",
//       "code": "so"
//     },
//     {
//       "language": "Spanish",
//       "code": "es"
//     },
//     {
//       "language": "Sundanese",
//       "code": "su"
//     },
//     {
//       "language": "Swahili",
//       "code": "sw"
//     },
//     {
//       "language": "Swedish",
//       "code": "sv"
//     },
//     {
//       "language": "Tagalog (Filipino)",
//       "code": "tl"
//     },
//     {
//       "language": "Tajik",
//       "code": "tg"
//     },
//     {
//       "language": "Tamil",
//       "code": "ta"
//     },
//     {
//       "language": "Telugu",
//       "code": "te"
//     },
//     {
//       "language": "Thai",
//       "code": "th"
//     },
//     {
//       "language": "Turkish",
//       "code": "tr"
//     },
//     {
//       "language": "Ukrainian",
//       "code": "uk"
//     },
//     {
//       "language": "Urdu",
//       "code": "ur"
//     },
//     {
//       "language": "Uzbek",
//       "code": "uz"
//     },
//     {
//       "language": "Vietnamese",
//       "code": "vi"
//     },
//     {
//       "language": "Welsh",
//       "code": "cy"
//     },
//     {
//       "language": "Xhosa",
//       "code": "xh"
//     },
//     {
//       "language": "Yiddish",
//       "code": "yi"
//     },
//     {
//       "language": "Yoruba",
//       "code": "yo"
//     },
//     {
//       "language": "Zulu",
//       "code": "zu"
//     }
//   ]
//   const [inputValue, setInputValue] = useState('');
//   const [welcomeApiMsg, setWelcomeApiMsg] = useState('');
//   const [staticApiVideo, setStaticApiVideo] = useState('');
//   const [welcomeApiVideo, setWelcomeApiVideo] = useState('');
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [videoUrl, setVideoUrl] = useState('');
//   const [audioToText, setAudioToText] = useState('');
//   const [recording, setRecording] = useState(false);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [timer, setTimer] = useState(0);
//   const [isSoundOn, setIsSoundOn] = useState(true);
//   const [videoLoading, setVideoLoading] = useState(true);
//   const [showChatBot, setShowChatBot] = useState(false);
//   const [recordMessage, setRecordMessage] = useState(false);
//   const [isApiCalled, setIsApiCalled] = useState(false);
//   const videoRef = useRef(null);
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const timerRef = useRef(null);
//   const chatHeadRef = useRef(null);
//   const messagesEndRef = useRef(null); // Ref for the autoscroll
//   const inputRef = useRef(null);
//   const dropdownAvatarRef = useRef(null);
//   const dropdownLanguageRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const [showInitialText, setShowInitialText] = useState(true);
//   const [recentBotIndex, setRecentBotIndex] = useState(null);
//   const [showWelcomeMsg, setShowWelcomeMsg] = useState(false);
//   const [checkAudio, setCheckAudio] = useState(false);
//   const [showWelcomeVideo, setShowWelcomeVideo] = useState(true);
//   const [showLanguages, setShowLanguages] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredLanguages, setFilteredLanguages] = useState(languages);
//   const [showAvatar, setShowAvatar] = useState(false);
//   const [selectedLanguage, setSelectedLanguage] = useState('English');
//   const [languageCode, setLanguageCode] = useState('en');
//   const [isRecordingTemp, setIsRecordingTemp] = useState(false);
//   const [audioUrlTemp, setAudioUrlTemp] = useState(null);
//   const [apiResponseTemp, setApiResponseTemp] = useState('');
//   const mediaRecorderRefTemp = useRef(null);
//   const recordedChunksRefTemp = useRef([]);
//   const mediaStreamRefTemp = useRef(null);
//   const audioRef = useRef(null); 
//   const audioConstraintsTemp = {
//     audio: {
//       sampleRate: 16000,
//       channelCount: 1,
//       echoCancellation: false,
//       noiseSuppression: false,
//       autoGainControl: false,
//     },
//   };
//   // taking params from parent app and passing in iframe api
//   // const [params, setParams] = useState({
//   //   companyName: '',
//   //   moduleName: '',
//   //   avatarName: ''
//   // });
//   // useEffect(() => {
//   //   const receiveMessage = (event) => {
//   //     const { companyName, moduleName, avatarName } = event.data;
//   //     setParams({ companyName, moduleName, avatarName });
//   //   };
//   //   window.addEventListener('message', receiveMessage, false);
//   //   return () => {
//   //     window.removeEventListener('message', receiveMessage);
//   //   };
//   // }, []);
//   // taking params from iframe url only and passing in iframe api
//   const params = useLocation();
//   const pathSegments = params.pathname.split('/').filter(segment => segment);
//   const companyName = pathSegments[pathSegments.length - 3];
//   const moduleName = pathSegments[pathSegments.length - 2];
//   const avatarName = pathSegments[pathSegments.length - 1];
//   const avatarList = [
//     { name: 'Natasha', image: 'image1.png' },
//     // { name: 'Avatar2', image: 'image2.png' },
//   ];
//   const defaultAvatar = avatarList[0];
//   const [selectedAvatar, setSelectedAvatar] = useState({
//     name: defaultAvatar.name,
//     image: defaultAvatar.image,
//   });
//   useEffect(() => {
//     if (avatarName) {
//       const foundAvatar = avatarList.find(avatar => avatar.name.toLowerCase() === avatarName.toLowerCase());
//       if (foundAvatar) {
//         setSelectedAvatar({
//           name: foundAvatar.name,
//           image: foundAvatar.image,
//         });
//       } else {
//         setSelectedAvatar(defaultAvatar);
//       }
//     } else {
//       setSelectedAvatar(defaultAvatar);
//     }
//   }, [avatarName]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) {
//         setShowAvatar(false);
//       }
//     };
//     if (showAvatar) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showAvatar]);
//   const handleAvatarToggle = () => {
//     setShowAvatar(!showAvatar);
//   };
//   const handleLanguageToggle = () => {
//     setShowLanguages(!showLanguages);
//     if (!showLanguages) {
//       setFilteredLanguages(languages);
//       setSearchTerm('');
//     }
//   };
//   const handleLanguageSelect = (language) => {
//     setSelectedLanguage(language.language);
//     setSearchTerm('');
//     setFilteredLanguages(languages);
//     setShowLanguages(false);
//     setLanguageCode(language.code)
//   };
//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//     const filtered = languages.filter((language) =>
//       language.language.toLowerCase().includes(event.target.value.toLowerCase())
//     );
//     setFilteredLanguages(filtered);
//   };
//   useEffect(() => {
//     if (showLanguages) {
//       searchInputRef.current.focus();
//     }
//   }, [showLanguages]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) {
//         setShowLanguages(false);
//       }
//     };
//     if (showLanguages) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showLanguages]);
//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter' && filteredLanguages.length > 0) {
//       handleLanguageSelect(filteredLanguages[0]);
//     }
//   };
//   const handleAvatarSelect = (avatar) => {
//     setSelectedAvatar(avatar);
//     setShowAvatar(false);
//   };
//   const handleWelcomeVideoEnd = () => {
//     setShowWelcomeVideo(false);
//   };
//   useEffect(() => {
//     const showTimeout = setTimeout(() => {
//       setShowWelcomeMsg(true);
//     }, 1);
//     const hideTimeout = setTimeout(() => {
//       setShowWelcomeMsg(false);
//     }, 3000);
//     return () => {
//       clearTimeout(showTimeout);
//       clearTimeout(hideTimeout);
//     };
//   }, []);
//   useEffect(() => {
//     const callApiOnPageLoad = async () => {
//       const payload = { user_input: 'hi' };
//       try {
//         const response = await fetch(
//           `https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`,
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(payload),
//           }
//         );
//         if (response.ok) {
//           const data = await response.json();
//           setWelcomeApiMsg(data.responses[0])
//           setStaticApiVideo(data.static_video)
//           setWelcomeApiVideo(data.video_path)
//         } else {
//           console.error('API error:', response.statusText);
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//       }
//     };
//     callApiOnPageLoad();
//   }, [companyName, moduleName, selectedAvatar]);
//   useEffect(() => {
//     const latestBotIndex = messages
//       .map((item, index) => (item.type === 'bot' ? index : null))
//       .filter(index => index !== null)
//       .pop();
//     if (latestBotIndex !== null) {
//       setRecentBotIndex(latestBotIndex);
//       const timer = setTimeout(() => {
//         setShowInitialText(false);
//       }, 1300);
//       setShowInitialText(true);
//       return () => clearTimeout(timer);
//     }
//   }, [messages]);
//   const handleKeyPress = (event) => {
//     if (event.key === 'Enter') {
//       handleSendMessage();
//     }
//   };
//   const handleSendMessage = async () => {
//     setInputValue(''); // Clear the input field at the start
//     if (inputValue.trim() || audioToText) {
//       setLoading(true);
//       setIsApiCalled(true);
//       const userMessage = {
//         message: audioToText || inputValue.trim() || '',
//         type: 'user',
//         audioUrl: audioToText,
//         isActive: true,
//       };
//       setMessages((prevMessages) => [...prevMessages, userMessage]);
//       const payload = {
//         user_input: audioToText ? audioToText : inputValue.trim() || '',
//         lang: languageCode,
//         companyName: companyName,
//         moduleName: moduleName,
//         avatarName: selectedAvatar.name,
//       };
//       if (messagesEndRef.current) {
//         messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//       }
//       try {
//         const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(payload),
//         });
//         const data = await response.json();
//         setAudioToText('');
//         setAudioBlob(null);
//         setTimer(0);
//         handleResponse(data); // Call handleResponse to play audio and video
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       } catch (error) {
//         console.error('Error:', error);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };
//   const handleResponse = (data) => {
//     // Check if there are bot responses
//     if (data.responses && data.responses.length > 0) {
//       const botMessage = data.responses.join(' ');
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: botMessage,
//           type: 'bot',
//         },
//       ]);
//     } else {
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: "Could you please repeat?",
//           type: 'bot',
//         },
//       ]);
//     }
//     // Check if there is a video path in the response
//     if (data.video_path) {
//       const fullVideoUrl = data.video_path;
//       setVideoUrl(fullVideoUrl);
//       // If there is audio data in base64 format, handle the audio
//       if (data.audio_data) {
//         // Convert the base64 audio data to a Blob
//         const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
//         const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
//         // Create audio and video elements
//         const videoElement = document.createElement('video');
//         videoElement.src = fullVideoUrl;
//         videoElement.controls = true;
//         videoElement.autoplay = true;
//         videoElement.muted = true; // Mute the video to avoid overlapping sound
//         const audioElement = document.createElement('audio');
//         audioElement.src = audioUrl;
//         audioElement.autoplay = true;
//         // const audioElement = new Audio(audioUrl);
//       audioRef.current = audioElement; 
//         // Sync the audio and video playback
//         videoElement.addEventListener('play', () => {
//           audioElement.play();
//         });
//         videoElement.addEventListener('pause', () => {
//           audioElement.pause();
//         });
//         // Append the video element to a container (assuming there is a container for the video)
//         const videoContainer = document.getElementById('video-container');
//         videoContainer.innerHTML = ''; // Clear any previous video
//         videoContainer.appendChild(videoElement);
//       } else {
//         console.log('No audio data received.');
//       }
//     } else {
//       setVideoUrl(''); // Clear the video if no path is provided
//     }
//   };
//   // Utility function to convert base64 to Blob
//   const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
//     const byteCharacters = atob(base64Data);
//     const byteArrays = [];
//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//       const slice = byteCharacters.slice(offset, offset + sliceSize);
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) {
//         byteNumbers[i] = slice.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//     }
//     return new Blob(byteArrays, { type: contentType });
//   };
//   useEffect(() => {
//     if (videoUrl) {
//       setVideoLoading(true);
//       const video = videoRef.current;
//       if (video) {
//         video.onloadeddata = () => {
//           setVideoLoading(false);
//           video.onended = () => {
//             setVideoUrl('');
//           };
//         };
//       }
//     }
//   }, [videoUrl]);
//   // useEffect(() => {
//   //   if (!loading && !recording) {
//   //     inputRef.current?.focus();
//   //   }
//   //   if (showWelcomeVideo) {
//   //     inputRef.current?.focus();
//   //   }
//   // }, [loading, recording, inputValue, messages]);
//   // recording check 
//   // const startRecording = async () => {
//   //   setRecording(true);
//   //   setRecordMessage(false)
//   //   setTimer(0);
//   //   audioChunksRef.current = [];
//   //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//   //   mediaRecorderRef.current = new MediaRecorder(stream);
//   //   mediaRecorderRef.current.ondataavailable = (event) => {
//   //     if (event.data.size > 0) {
//   //       audioChunksRef.current.push(event.data);
//   //     }
//   //   };
//   //   mediaRecorderRef.current.onstop = () => {
//   //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//   //     setAudioBlob(blob);
//   //   };
//   //   mediaRecorderRef.current.start();
//   //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
//   // };
//   // const stopRecording = () => {
//   //   setRecordMessage(true)
//   //   setRecording(false);
//   //   if (mediaRecorderRef.current) {
//   //     mediaRecorderRef.current.stop();
//   //   }
//   //   clearInterval(timerRef.current);
//   // };
//   useEffect(() => {
//     if (audioBlob) {
//       sendAudioToApi(audioBlob);
//     }
//   }, [audioBlob]);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setRecordMessage(false);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, [recordMessage]);
//   // const sendAudioToApi = async (blob) => {
//   //   try {
//   //     const base64Audio = await convertBlobToBase64(blob);
//   //     const fileExtension = blob.type.split('/')[1];
//   //     const formData = new FormData();
//   //     formData.append('audio_file', base64Audio.split(',')[1]);
//   //     formData.append('file_extension', fileExtension);
//   //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //       method: 'POST',
//   //       body: formData
//   //     });
//   //     const data = await response.json();
//   //     setAudioToText(data.response)
//   //     if (data.response.length > 0) {
//   //       setCheckAudio(false)
//   //     }
//   //     // if (data.response) {
//   //     //   setTimeout(() => {
//   //     //     setRecordMessage(false)
//   //     //     }, 880);
//   //     //   // }, 6200);
//   //     // }
//   //   } catch (error) {
//   //     console.error('Error sending audio:', error);
//   //   }
//   //   finally {
//   //     setCheckAudio(true)
//   //   }
//   // };
//   const convertBlobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };
//   useEffect(() => {
//     if (videoRef.current) {
//       setVideoLoading(true);
//       videoRef.current.load();
//       videoRef.current.play().finally(() => {
//         setVideoLoading(false);
//       });
//     }
//   }, [videoUrl]);
//   const toggleSound = () => {
//     if (audioRef.current) {
//       audioRef.current.muted = isSoundOn;
//       setIsSoundOn(!isSoundOn);
//     }
//   };
//   // const toggleSound = () => {
//   //   if (videoRef.current && audioRef.current) {
//   //     if (isSoundOn) {
//   //       // Mute both video and external audio
//   //       videoRef.current.muted = true;
//   //       audioRef.current.muted = true; // Mute external audio
//   //     } else {
//   //       // Unmute both video and external audio
//   //       videoRef.current.muted = false;
//   //       audioRef.current.muted = false; // Unmute external audio
//   //     }
//   //     // Toggle sound state
//   //     setIsSoundOn(!isSoundOn);
//   //   }
//   // };
//   const handleChatBotOpen = () => {
//     setShowChatBot(!showChatBot);
//   };
//   useEffect(() => {
//     setShowChatBot(true);
//   }, []);
//   useEffect(() => {
//     handleSendMessage()
//   }, [audioToText])
//   const handleVideoEnd = () => {
//     setVideoUrl(staticApiVideo)
//   }
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       setTimeout(() => {
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       }, 500);
//     }
//   }, [messages, showChatBot]);
//   // audio functionality for android
//   // const sendAudioToApi = async () => {
//   //   if (!isRecordingTemp) {
//   //     try {
//   //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//   //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
//   //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
//   //         if (event.data.size > 0) {
//   //           recordedChunksRefTemp.current.push(event.data);
//   //         }
//   //       };
//   //       mediaRecorderRefTemp.current.onstop = async () => {
//   //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
//   //         recordedChunksRefTemp.current = [];
//   //         // Convert blob to Base64
//   //         const readerTemp = new FileReader();
//   //         readerTemp.readAsDataURL(blobTemp);
//   //         readerTemp.onloadend = async () => {
//   //           const base64AudioTemp = readerTemp.result.split(',')[1];
//   //           // Display audio for playback
//   //           const audioUrlTemp = URL.createObjectURL(blobTemp);
//   //           setAudioUrlTemp(audioUrlTemp);
//   //           // Prepare the form data
//   //           const formDataTemp = new FormData();
//   //           formDataTemp.append('audio_file', base64AudioTemp);
//   //           formDataTemp.append('file_extension', 'webm');
//   //           // Call the API
//   //           try {
//   //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //               method: 'POST',
//   //               body: formDataTemp,
//   //             });
//   //             const resultTemp = await responseTemp.json();
//   //             console.log('pppppppppppp', resultTemp.response);
//   //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//   //             setAudioToText(resultTemp.response)
//   //             if (resultTemp.response.length > 0) {
//   //               setCheckAudio(false)
//   //             }
//   //           } catch (error) {
//   //             console.error('Error calling the API:', error);
//   //             setApiResponseTemp(`Error: ${error.message}`);
//   //           }
//   //         };
//   //       };
//   //       mediaRecorderRefTemp.current.start();
//   //       setIsRecordingTemp(true);
//   //     } catch (error) {
//   //       console.error('Error accessing microphone: ', error);
//   //     }
//   //   } else {
//   //     // Stop the recording
//   //     mediaRecorderRefTemp.current.stop();
//   //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//   //     setIsRecordingTemp(false);
//   //   }
//   // };
//   // audio functionality for ios 
//   const sendAudioToApi = async () => {
//     if (!isRecordingTemp) {
//       try {
//         mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//         // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
//         const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
//         mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
//         mediaRecorderRefTemp.current.ondataavailable = (event) => {
//           if (event.data.size > 0) {
//             recordedChunksRefTemp.current.push(event.data);
//           }
//         };
//         mediaRecorderRefTemp.current.onstop = async () => {
//           const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
//           recordedChunksRefTemp.current = [];
//           // Convert blob to Base64
//           const readerTemp = new FileReader();
//           readerTemp.readAsDataURL(blobTemp);
//           readerTemp.onloadend = async () => {
//             const base64AudioTemp = readerTemp.result.split(',')[1];
//             // Display audio for playback
//             const audioUrlTemp = URL.createObjectURL(blobTemp);
//             setAudioUrlTemp(audioUrlTemp);
//             // Prepare the form data
//             const formDataTemp = new FormData();
//             formDataTemp.append('audio_file', base64AudioTemp);
//             formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
//             // Call the API
//             try {
//               const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//                 method: 'POST',
//                 body: formDataTemp,
//               });
//               const resultTemp = await responseTemp.json();
//               console.log('API Response:', resultTemp.response);
//               setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//               setAudioToText(resultTemp.response);
//               if (resultTemp.response.length > 0) {
//                 setCheckAudio(false);
//               }
//             } catch (error) {
//               console.error('Error calling the API:', error);
//               setApiResponseTemp(`Error: ${error.message}`);
//             }
//           };
//         };
//         mediaRecorderRefTemp.current.start();
//         setIsRecordingTemp(true);
//       } catch (error) {
//         console.error('Error accessing microphone: ', error);
//       }
//     } else {
//       // Stop the recording
//       mediaRecorderRefTemp.current.stop();
//       mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//       setIsRecordingTemp(false);
//     }
//   };
//   // Helper function to check if the user is on iOS
//   const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
//   return (
//     <>
//       {
//         !showChatBot ?
//           <div className="videochartvalue ">
//             <div className='container'>
//               <div className='headAndOutput'>
//                 <div className='chatHead'>
//                   <div className='headIcontext'>
//                     <div className='group-2'></div>
//                     <div className='iconHeadChat'>
//                       <img src="/img/chatAvatarIcon3.png" alt="Avatar" />
//                       <div className='headTextClass'>
//                         <div className="text-wrapper miniHead">Chat with</div>
//                         <div className="text-wrapper-2">AI Assistant</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className='headMinClose'>
//                     <div className='languagesDivBoth'>
//                       <div className='languagesDiv' onClick={handleAvatarToggle} ref={dropdownAvatarRef} >
//                         <div className='avatarNameImgClass'>
//                           {selectedAvatar.name}
//                         </div>
//                         <span className={`arrow ${showAvatar ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showAvatar && (
//                           <ul className='languageDropdown'>
//                             {avatarList
//                               .filter(avatar => avatar !== selectedAvatar)
//                               .map((avatar, index) => (
//                                 <li key={index} onClick={() => handleAvatarSelect(avatar)} className='avatarNameImgClass'>
//                                   {avatar.name}
//                                 </li>
//                               ))}
//                           </ul>
//                         )}
//                       </div>
//                       <div ref={dropdownLanguageRef} className='languagesDiv' onClick={handleLanguageToggle}>
//                         {selectedLanguage}
//                         <span className={`arrow ${showLanguages ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showLanguages && (
//                           <ul className='languageDropdown'>
//                             <input
//                               ref={searchInputRef}
//                               type="text"
//                               value={searchTerm}
//                               onChange={handleSearchChange}
//                               onKeyDown={handleKeyDown}
//                               placeholder="Search"
//                               className='searchLanguageInput'
//                             />
//                           </ul>
//                         )}
//                         {showLanguages && (
//                           <ul className='languageDropdown languageSearchDropdown'>
//                             {filteredLanguages.map((language, index) => (
//                               <li key={index} onClick={() => handleLanguageSelect(language)} className='languageOption'>
//                                 <p>
//                                   {language.language}
//                                 </p>
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div>
//                     </div>
//                     <div className=' speakerIconButton' >
//                       {isSoundOn ? (
//                         <img src={chatSoundIconWhite} alt="Speaker" onClick={toggleSound} />
//                       ) : (
//                         <img src={chatSpeakerMuteIcon} alt="Speaker" onClick={toggleSound} />
//                       )}
//                       {/* <img src="/img/minimizeChatWhite.png" alt="Line" onClick={handleChatBotOpen} /> */}
//                       <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={handleChatBotOpen} />
//                     </div>
//                   </div>
//                 </div>
//                 <div id="output-container">
//                   <div className="messages-container">
//                     {
//                       showWelcomeMsg ?
//                         <div className='message-item receiver'>
//                           <div className='senderIconText'>
//                             <div className='message'>
//                               <div className="chat-bubble">
//                                 <div className="typing">
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                 </div>
//                               </div>
//                             </div>
//                             <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           </div>
//                         </div>
//                         :
//                         <div className='receiverIconText'>
//                           <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           <div className="success-status">
//                             {welcomeApiMsg}
//                           </div>
//                         </div>
//                     }
//                     {messages.map((item, index) => (
//                       <div key={index} className={`message-item ${item.type === 'user' ? 'sender' : 'receiver'}`}>
//                         <div className='senderIconText'>
//                           <div className="message">
//                             {
//                               item.audioUrl ?
//                                 recordMessage && index === recentBotIndex ? (
//                                   <div className="chat-bubble-audio">
//                                     <div className="typing">
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                     </div>
//                                   </div>
//                                 )
//                                   : (
//                                     <p>{item.audioUrl}</p>
//                                   )
//                                 :
//                                 //  (
//                                 //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
//                                 //     <div className="chat-bubble">
//                                 //       <div className="typing">
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //       </div>
//                                 //     </div>
//                                 //   ) : (
//                                 //     <p>{item.message}</p>
//                                 //   )
//                                 // )
//                                 <p>{item.message}</p>
//                             }
//                           </div>
//                           {item.type === 'user' && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
//                           {item.type === 'bot' && <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />}
//                         </div>
//                         <div ref={messagesEndRef} /> {/* Auto-scroll target */}
//                       </div>
//                     ))}
//                     {/* {recordMessage ?
//                     <div className="senderIconText">
//                       <div className="message">
//                         <div className="typing">
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                         </div>
//                       </div>
//                       <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />
//                     </div>
//                     : ""} */}
//                     <div ref={messagesEndRef} />
//                   </div>
//                   <div className="hello-container">
//                     {showWelcomeVideo && welcomeApiVideo ? (
//                       // If welcome video is available and should be shown
//                       <video
//                         ref={videoRef}
//                         width="100%"
//                         autoPlay
//                         muted={!isSoundOn}
//                         onEnded={handleWelcomeVideoEnd}
//                       >
//                         <source src={welcomeApiVideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     ) : (
//                       <div>
//                         {/* Fallback to static video if no API welcome video is available */}
//                         {!isApiCalled || !videoUrl ? (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             loop
//                             muted
//                           >
//                             <source src={staticApiVideo} type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         ) : (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             // muted={!isSoundOn}
//                             onEnded={handleVideoEnd}
//                             muted
//                           >
//                             {/* <source src={videoUrl} type="video/mp4" muted/> */}
//                             <source src={videoUrl} type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className='outputHelpfulClass'>
//                 <div className="input-container">
//                   <input
//                     type="text"
//                     value={inputValue}
//                     onChange={(e) => setInputValue(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     placeholder="Enter your message"
//                     disabled={loading || recording}
//                     ref={inputRef}
//                   />
//                   {/* {recording ? ( */}
//                   {isRecordingTemp ? (
//                     <div className="recording-indicator">
//                       <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
//                         <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
//                       <img src="/img/chatMicIcon.png" alt="Mic" />
//                     </div>
//                   )}
//                   <div className='iconButton' onClick={handleSendMessage} disabled={loading || recording}>
//                     <img src="/img/chatSendIcon.png" alt="Send" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           :
//           <div className='chatBoxImageClass' >
//             <img src={chatBoxImage} alt="" onClick={handleChatBotOpen} />
//             {/* <div style={{ fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
//               <button onClick={handleRecordTemp} style={{ padding: '10px 20px', fontSize: '16px', marginBottom: '20px', cursor: 'pointer' }}>
//                 {isRecordingTemp ? 'Stop Recording' : 'Start Recording'}
//               </button>
//               <audio controls src={audioUrlTemp} style={{ marginTop: '20px' }} />
//               <pre style={{ backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '5px', maxWidth: '80%', whiteSpace: 'pre-wrap' }}>
//                 {apiResponseTemp}
//               </pre>
//             </div> */}
//           </div>
//       }
//     </>
//   );
// };
// export default MessageInput;
// audio from api , iphone compatibilty
// import React, { useState, useRef, useEffect } from 'react';
// import Picker from 'emoji-picker-react';
// import './frameNew.css';
// import chatBoxImage from '../../../static/img/chatBoxImageCrop1.png'
// import arrowDown from '../../../static/img/arrowDownConvert.png'
// import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
// import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
// import { useFetcher, useLocation, useParams } from 'react-router-dom';
// const MessageInput = () => {
//   // const avatarList = [
//   //   { name: 'Shweta', image: '/img/avatar/woman.png' },
//   //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Aman', image: '/img/avatar/man.png' },
//   //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Alex', image: '/img/avatar/man.png' },
//   //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
//   // ];
//   const languages = [
//     {
//       "language": "Afrikaans",
//       "code": "af"
//     },
//     {
//       "language": "Albanian",
//       "code": "sq"
//     },
//     {
//       "language": "Amharic",
//       "code": "am"
//     },
//     {
//       "language": "Arabic",
//       "code": "ar"
//     },
//     {
//       "language": "Armenian",
//       "code": "hy"
//     },
//     {
//       "language": "Azerbaijani",
//       "code": "az"
//     },
//     {
//       "language": "Basque",
//       "code": "eu"
//     },
//     {
//       "language": "Belarusian",
//       "code": "be"
//     },
//     {
//       "language": "Bengali",
//       "code": "bn"
//     },
//     {
//       "language": "Bosnian",
//       "code": "bs"
//     },
//     {
//       "language": "Bulgarian",
//       "code": "bg"
//     },
//     {
//       "language": "Catalan",
//       "code": "ca"
//     },
//     {
//       "language": "Cebuano",
//       "code": "ceb"
//     },
//     {
//       "language": "Chinese (Simplified)",
//       "code": "zh-CN"
//     },
//     {
//       "language": "Chinese (Traditional)",
//       "code": "zh-TW"
//     },
//     {
//       "language": "Corsican",
//       "code": "co"
//     },
//     {
//       "language": "Croatian",
//       "code": "hr"
//     },
//     {
//       "language": "Czech",
//       "code": "cs"
//     },
//     {
//       "language": "Danish",
//       "code": "da"
//     },
//     {
//       "language": "Dutch",
//       "code": "nl"
//     },
//     {
//       "language": "English",
//       "code": "en"
//     },
//     {
//       "language": "Esperanto",
//       "code": "eo"
//     },
//     {
//       "language": "Estonian",
//       "code": "et"
//     },
//     {
//       "language": "Finnish",
//       "code": "fi"
//     },
//     {
//       "language": "French",
//       "code": "fr"
//     },
//     {
//       "language": "Frisian",
//       "code": "fy"
//     },
//     {
//       "language": "Galician",
//       "code": "gl"
//     },
//     {
//       "language": "Georgian",
//       "code": "ka"
//     },
//     {
//       "language": "German",
//       "code": "de"
//     },
//     {
//       "language": "Greek",
//       "code": "el"
//     },
//     {
//       "language": "Gujarati",
//       "code": "gu"
//     },
//     {
//       "language": "Haitian Creole",
//       "code": "ht"
//     },
//     {
//       "language": "Hausa",
//       "code": "ha"
//     },
//     {
//       "language": "Hawaiian",
//       "code": "haw"
//     },
//     {
//       "language": "Hebrew",
//       "code": "iw"
//     },
//     {
//       "language": "Hindi",
//       "code": "hi"
//     },
//     {
//       "language": "Hmong",
//       "code": "hmn"
//     },
//     {
//       "language": "Hungarian",
//       "code": "hu"
//     },
//     {
//       "language": "Icelandic",
//       "code": "is"
//     },
//     {
//       "language": "Igbo",
//       "code": "ig"
//     },
//     {
//       "language": "Indonesian",
//       "code": "id"
//     },
//     {
//       "language": "Irish",
//       "code": "ga"
//     },
//     {
//       "language": "Italian",
//       "code": "it"
//     },
//     {
//       "language": "Japanese",
//       "code": "ja"
//     },
//     {
//       "language": "Javanese",
//       "code": "jw"
//     },
//     {
//       "language": "Kannada",
//       "code": "kn"
//     },
//     {
//       "language": "Kazakh",
//       "code": "kk"
//     },
//     {
//       "language": "Khmer",
//       "code": "km"
//     },
//     {
//       "language": "Korean",
//       "code": "ko"
//     },
//     {
//       "language": "Kurdish",
//       "code": "ku"
//     },
//     {
//       "language": "Kyrgyz",
//       "code": "ky"
//     },
//     {
//       "language": "Lao",
//       "code": "lo"
//     },
//     {
//       "language": "Latin",
//       "code": "la"
//     },
//     {
//       "language": "Latvian",
//       "code": "lv"
//     },
//     {
//       "language": "Lithuanian",
//       "code": "lt"
//     },
//     {
//       "language": "Luxembourgish",
//       "code": "lb"
//     },
//     {
//       "language": "Macedonian",
//       "code": "mk"
//     },
//     {
//       "language": "Malagasy",
//       "code": "mg"
//     },
//     {
//       "language": "Malay",
//       "code": "ms"
//     },
//     {
//       "language": "Malayalam",
//       "code": "ml"
//     },
//     {
//       "language": "Maltese",
//       "code": "mt"
//     },
//     {
//       "language": "Maori",
//       "code": "mi"
//     },
//     {
//       "language": "Marathi",
//       "code": "mr"
//     },
//     {
//       "language": "Mongolian",
//       "code": "mn"
//     },
//     {
//       "language": "Myanmar (Burmese)",
//       "code": "my"
//     },
//     {
//       "language": "Nepali",
//       "code": "ne"
//     },
//     {
//       "language": "Norwegian",
//       "code": "no"
//     },
//     {
//       "language": "Nyanja (Chichewa)",
//       "code": "ny"
//     },
//     {
//       "language": "Pashto",
//       "code": "ps"
//     },
//     {
//       "language": "Persian",
//       "code": "fa"
//     },
//     {
//       "language": "Polish",
//       "code": "pl"
//     },
//     {
//       "language": "Portuguese (Portugal, Brazil)",
//       "code": "pt"
//     },
//     {
//       "language": "Punjabi",
//       "code": "pa"
//     },
//     {
//       "language": "Romanian",
//       "code": "ro"
//     },
//     {
//       "language": "Russian",
//       "code": "ru"
//     },
//     {
//       "language": "Samoan",
//       "code": "sm"
//     },
//     {
//       "language": "Scots Gaelic",
//       "code": "gd"
//     },
//     {
//       "language": "Serbian",
//       "code": "sr"
//     },
//     {
//       "language": "Sesotho",
//       "code": "st"
//     },
//     {
//       "language": "Shona",
//       "code": "sn"
//     },
//     {
//       "language": "Sindhi",
//       "code": "sd"
//     },
//     {
//       "language": "Sinhala (Sinhalese)",
//       "code": "si"
//     },
//     {
//       "language": "Slovak",
//       "code": "sk"
//     },
//     {
//       "language": "Slovenian",
//       "code": "sl"
//     },
//     {
//       "language": "Somali",
//       "code": "so"
//     },
//     {
//       "language": "Spanish",
//       "code": "es"
//     },
//     {
//       "language": "Sundanese",
//       "code": "su"
//     },
//     {
//       "language": "Swahili",
//       "code": "sw"
//     },
//     {
//       "language": "Swedish",
//       "code": "sv"
//     },
//     {
//       "language": "Tagalog (Filipino)",
//       "code": "tl"
//     },
//     {
//       "language": "Tajik",
//       "code": "tg"
//     },
//     {
//       "language": "Tamil",
//       "code": "ta"
//     },
//     {
//       "language": "Telugu",
//       "code": "te"
//     },
//     {
//       "language": "Thai",
//       "code": "th"
//     },
//     {
//       "language": "Turkish",
//       "code": "tr"
//     },
//     {
//       "language": "Ukrainian",
//       "code": "uk"
//     },
//     {
//       "language": "Urdu",
//       "code": "ur"
//     },
//     {
//       "language": "Uzbek",
//       "code": "uz"
//     },
//     {
//       "language": "Vietnamese",
//       "code": "vi"
//     },
//     {
//       "language": "Welsh",
//       "code": "cy"
//     },
//     {
//       "language": "Xhosa",
//       "code": "xh"
//     },
//     {
//       "language": "Yiddish",
//       "code": "yi"
//     },
//     {
//       "language": "Yoruba",
//       "code": "yo"
//     },
//     {
//       "language": "Zulu",
//       "code": "zu"
//     }
//   ]
//   const [inputValue, setInputValue] = useState('');
//   const [welcomeApiMsg, setWelcomeApiMsg] = useState('');
//   const [staticApiVideo, setStaticApiVideo] = useState('');
//   const [welcomeApiVideo, setWelcomeApiVideo] = useState('');
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [videoUrl, setVideoUrl] = useState('');
//   const [audioToText, setAudioToText] = useState('');
//   const [recording, setRecording] = useState(false);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [timer, setTimer] = useState(0);
//   const [isSoundOn, setIsSoundOn] = useState(true);
//   const [videoLoading, setVideoLoading] = useState(true);
//   const [showChatBot, setShowChatBot] = useState(false);
//   const [recordMessage, setRecordMessage] = useState(false);
//   const [isApiCalled, setIsApiCalled] = useState(false);
//   const videoRef = useRef(null);
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const timerRef = useRef(null);
//   const chatHeadRef = useRef(null);
//   const messagesEndRef = useRef(null); // Ref for the autoscroll
//   const inputRef = useRef(null);
//   const dropdownAvatarRef = useRef(null);
//   const dropdownLanguageRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const [showInitialText, setShowInitialText] = useState(true);
//   const [recentBotIndex, setRecentBotIndex] = useState(null);
//   const [showWelcomeMsg, setShowWelcomeMsg] = useState(false);
//   const [checkAudio, setCheckAudio] = useState(false);
//   const [showWelcomeVideo, setShowWelcomeVideo] = useState(true);
//   const [showLanguages, setShowLanguages] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredLanguages, setFilteredLanguages] = useState(languages);
//   const [showAvatar, setShowAvatar] = useState(false);
//   const [selectedLanguage, setSelectedLanguage] = useState('English');
//   const [languageCode, setLanguageCode] = useState('en');
//   const [isRecordingTemp, setIsRecordingTemp] = useState(false);
//   const [audioUrlTemp, setAudioUrlTemp] = useState(null);
//   const [apiResponseTemp, setApiResponseTemp] = useState('');
//   const mediaRecorderRefTemp = useRef(null);
//   const recordedChunksRefTemp = useRef([]);
//   const mediaStreamRefTemp = useRef(null);
//   const audioRef = useRef(null);
//   const audioConstraintsTemp = {
//     audio: {
//       sampleRate: 16000,
//       channelCount: 1,
//       echoCancellation: false,
//       noiseSuppression: false,
//       autoGainControl: false,
//     },
//   };
//   // taking params from parent app and passing in iframe api
//   // const [params, setParams] = useState({
//   //   companyName: '',
//   //   moduleName: '',
//   //   avatarName: ''
//   // });
//   // useEffect(() => {
//   //   const receiveMessage = (event) => {
//   //     const { companyName, moduleName, avatarName } = event.data;
//   //     setParams({ companyName, moduleName, avatarName });
//   //   };
//   //   window.addEventListener('message', receiveMessage, false);
//   //   return () => {
//   //     window.removeEventListener('message', receiveMessage);
//   //   };
//   // }, []);
//   // taking params from iframe url only and passing in iframe api
//   const params = useLocation();
//   const pathSegments = params.pathname.split('/').filter(segment => segment);
//   const companyName = pathSegments[pathSegments.length - 3];
//   const moduleName = pathSegments[pathSegments.length - 2];
//   const avatarName = pathSegments[pathSegments.length - 1];
//   const avatarList = [
//     { name: 'Natasha', image: 'image1.png' },
//     // { name: 'Avatar2', image: 'image2.png' },
//   ];
//   const defaultAvatar = avatarList[0];
//   const [selectedAvatar, setSelectedAvatar] = useState({
//     name: defaultAvatar.name,
//     image: defaultAvatar.image,
//   });
//   useEffect(() => {
//     if (avatarName) {
//       const foundAvatar = avatarList.find(avatar => avatar.name.toLowerCase() === avatarName.toLowerCase());
//       if (foundAvatar) {
//         setSelectedAvatar({
//           name: foundAvatar.name,
//           image: foundAvatar.image,
//         });
//       } else {
//         setSelectedAvatar(defaultAvatar);
//       }
//     } else {
//       setSelectedAvatar(defaultAvatar);
//     }
//   }, [avatarName]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) {
//         setShowAvatar(false);
//       }
//     };
//     if (showAvatar) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showAvatar]);
//   const handleAvatarToggle = () => {
//     setShowAvatar(!showAvatar);
//   };
//   const handleLanguageToggle = () => {
//     setShowLanguages(!showLanguages);
//     if (!showLanguages) {
//       setFilteredLanguages(languages);
//       setSearchTerm('');
//     }
//   };
//   const handleLanguageSelect = (language) => {
//     setSelectedLanguage(language.language);
//     setSearchTerm('');
//     setFilteredLanguages(languages);
//     setShowLanguages(false);
//     setLanguageCode(language.code)
//   };
//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//     const filtered = languages.filter((language) =>
//       language.language.toLowerCase().includes(event.target.value.toLowerCase())
//     );
//     setFilteredLanguages(filtered);
//   };
//   useEffect(() => {
//     if (showLanguages) {
//       searchInputRef.current.focus();
//     }
//   }, [showLanguages]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) {
//         setShowLanguages(false);
//       }
//     };
//     if (showLanguages) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showLanguages]);
//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter' && filteredLanguages.length > 0) {
//       handleLanguageSelect(filteredLanguages[0]);
//     }
//   };
//   const handleAvatarSelect = (avatar) => {
//     setSelectedAvatar(avatar);
//     setShowAvatar(false);
//   };
//   const handleWelcomeVideoEnd = () => {
//     setShowWelcomeVideo(false);
//   };
//   useEffect(() => {
//     const showTimeout = setTimeout(() => {
//       setShowWelcomeMsg(true);
//     }, 1);
//     const hideTimeout = setTimeout(() => {
//       setShowWelcomeMsg(false);
//     }, 3000);
//     return () => {
//       clearTimeout(showTimeout);
//       clearTimeout(hideTimeout);
//     };
//   }, []);
//   useEffect(() => {
//     const callApiOnPageLoad = async () => {
//       const payload = { user_input: 'hi' };
//       try {
//         const response = await fetch(
//           `https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`,
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(payload),
//           }
//         );
//         if (response.ok) {
//           const data = await response.json();
//           setWelcomeApiMsg(data.responses[0])
//           setStaticApiVideo(data.static_video)
//           setWelcomeApiVideo(data.video_path)
//         } else {
//           console.error('API error:', response.statusText);
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//       }
//     };
//     callApiOnPageLoad();
//   }, [companyName, moduleName, selectedAvatar]);
//   useEffect(() => {
//     const latestBotIndex = messages
//       .map((item, index) => (item.type === 'bot' ? index : null))
//       .filter(index => index !== null)
//       .pop();
//     if (latestBotIndex !== null) {
//       setRecentBotIndex(latestBotIndex);
//       const timer = setTimeout(() => {
//         setShowInitialText(false);
//       }, 1300);
//       setShowInitialText(true);
//       return () => clearTimeout(timer);
//     }
//   }, [messages]);
//   const handleKeyPress = (event) => {
//     if (event.key === 'Enter') {
//       handleSendMessage();
//     }
//   };
//   const handleSendMessage = async () => {
//     setInputValue(''); // Clear the input field at the start
//     if (inputValue.trim() || audioToText) {
//       setLoading(true);
//       setIsApiCalled(true);
//       const userMessage = {
//         message: audioToText || inputValue.trim() || '',
//         type: 'user',
//         audioUrl: audioToText,
//         isActive: true,
//       };
//       setMessages((prevMessages) => [...prevMessages, userMessage]);
//       const payload = {
//         user_input: audioToText ? audioToText : inputValue.trim() || '',
//         lang: languageCode,
//         companyName: companyName,
//         moduleName: moduleName,
//         avatarName: selectedAvatar.name,
//       };
//       if (messagesEndRef.current) {
//         messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//       }
//       try {
//         const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(payload),
//         });
//         const data = await response.json();
//         setAudioToText('');
//         setAudioBlob(null);
//         setTimer(0);
//         handleResponse(data); // Call handleResponse to play audio and video
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       } catch (error) {
//         console.error('Error:', error);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };
//   // const handleResponse = (data) => {
//   //   // Check if there are bot responses
//   //   if (data.responses && data.responses.length > 0) {
//   //     const botMessage = data.responses.join(' ');
//   //     setMessages((prevMessages) => [
//   //       ...prevMessages,
//   //       {
//   //         message: botMessage,
//   //         type: 'bot',
//   //       },
//   //     ]);
//   //   } else {
//   //     setMessages((prevMessages) => [
//   //       ...prevMessages,
//   //       {
//   //         message: "Could you please repeat?",
//   //         type: 'bot',
//   //       },
//   //     ]);
//   //   }
//   //   // Check if there is a video path in the response
//   //   if (data.video_path) {
//   //     const fullVideoUrl = data.video_path;
//   //     setVideoUrl(fullVideoUrl);
//   //     // If there is audio data in base64 format, handle the audio
//   //     if (data.audio_data) {
//   //       // Convert the base64 audio data to a Blob
//   //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
//   //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
//   //       // Create audio and video elements
//   //       const videoElement = document.createElement('video');
//   //       videoElement.src = fullVideoUrl;
//   //       videoElement.controls = true;
//   //       videoElement.autoplay = true;
//   //       videoElement.muted = true; // Mute the video to avoid overlapping sound
//   //       const audioElement = document.createElement('audio');
//   //       audioElement.src = audioUrl;
//   //       audioElement.autoplay = true;
//   //       // const audioElement = new Audio(audioUrl);
//   //     audioRef.current = audioElement; 
//   //       // Sync the audio and video playback
//   //       videoElement.addEventListener('play', () => {
//   //         audioElement.play();
//   //       });
//   //       videoElement.addEventListener('pause', () => {
//   //         audioElement.pause();
//   //       });
//   //       // Append the video element to a container (assuming there is a container for the video)
//   //       const videoContainer = document.getElementById('video-container');
//   //       videoContainer.innerHTML = ''; // Clear any previous video
//   //       videoContainer.appendChild(videoElement);
//   //     } else {
//   //       console.log('No audio data received.');
//   //     }
//   //   } else {
//   //     setVideoUrl(''); // Clear the video if no path is provided
//   //   }
//   // };
//   // Utility function to convert base64 to Blob
//   const handleResponse = (data) => {
//     if (data.responses && data.responses.length > 0) {
//       const botMessage = data.responses.join(' ');
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: botMessage,
//           type: 'bot',
//         },
//       ]);
//     } else {
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: "Could you please repeat?",
//           type: 'bot',
//         },
//       ]);
//     }
//     if (data.video_path) {
//       const fullVideoUrl = data.video_path;
//       setVideoUrl(fullVideoUrl);
//       if (data.audio_data) {
//         if (audioRef.current) {
//           audioRef.current.pause(); 
//           audioRef.current.currentTime = 0; 
//           audioRef.current.src = ''; 
//         }
//         const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); 
//         const audioUrl = URL.createObjectURL(audioBlob); 
//         const audioElement = new Audio(audioUrl);
//         audioElement.autoplay = true;
//         audioRef.current = audioElement;
//         audioElement.play();
//         if (videoRef.current) {
//           videoRef.current.muted = true;
//           videoRef.current.src = fullVideoUrl; 
//           videoRef.current.autoplay = true;
//           videoRef.current.playsInline = true; 
//           videoRef.current.removeEventListener('play', handleVideoPlay);
//           videoRef.current.removeEventListener('pause', handleVideoPause);
//           videoRef.current.removeEventListener('ended', handleVideoEnd);
//           const handleVideoPlay = () => {
//             audioElement.play();
//           };
//           const handleVideoPause = () => {
//             audioElement.pause(); 
//           };
//           const handleVideoEnd = () => {
//             audioElement.pause();
//             audioElement.currentTime = 0; 
//             videoRef.current.currentTime = 0; 
//           };
//           videoRef.current.addEventListener('play', handleVideoPlay);
//           videoRef.current.addEventListener('pause', handleVideoPause);
//           videoRef.current.addEventListener('ended', handleVideoEnd);
//         }
//       } else {
//         console.log('No audio data received.');
//       }
//     } else {
//       setVideoUrl(''); // Clear the video if no path is provided
//     }
//   };
//   const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
//     const byteCharacters = atob(base64Data);
//     const byteArrays = [];
//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//       const slice = byteCharacters.slice(offset, offset + sliceSize);
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) {
//         byteNumbers[i] = slice.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//     }
//     return new Blob(byteArrays, { type: contentType });
//   };
//   useEffect(() => {
//     if (videoUrl) {
//       setVideoLoading(true);
//       const video = videoRef.current;
//       if (video) {
//         video.onloadeddata = () => {
//           setVideoLoading(false);
//           video.onended = () => {
//             setVideoUrl('');
//           };
//         };
//       }
//     }
//   }, [videoUrl]);
//   // useEffect(() => {
//   //   if (!loading && !recording) {
//   //     inputRef.current?.focus();
//   //   }
//   //   if (showWelcomeVideo) {
//   //     inputRef.current?.focus();
//   //   }
//   // }, [loading, recording, inputValue, messages]);
//   // recording check 
//   // const startRecording = async () => {
//   //   setRecording(true);
//   //   setRecordMessage(false)
//   //   setTimer(0);
//   //   audioChunksRef.current = [];
//   //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//   //   mediaRecorderRef.current = new MediaRecorder(stream);
//   //   mediaRecorderRef.current.ondataavailable = (event) => {
//   //     if (event.data.size > 0) {
//   //       audioChunksRef.current.push(event.data);
//   //     }
//   //   };
//   //   mediaRecorderRef.current.onstop = () => {
//   //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//   //     setAudioBlob(blob);
//   //   };
//   //   mediaRecorderRef.current.start();
//   //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
//   // };
//   // const stopRecording = () => {
//   //   setRecordMessage(true)
//   //   setRecording(false);
//   //   if (mediaRecorderRef.current) {
//   //     mediaRecorderRef.current.stop();
//   //   }
//   //   clearInterval(timerRef.current);
//   // };
//   useEffect(() => {
//     if (audioBlob) {
//       sendAudioToApi(audioBlob);
//     }
//   }, [audioBlob]);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setRecordMessage(false);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, [recordMessage]);
//   // const sendAudioToApi = async (blob) => {
//   //   try {
//   //     const base64Audio = await convertBlobToBase64(blob);
//   //     const fileExtension = blob.type.split('/')[1];
//   //     const formData = new FormData();
//   //     formData.append('audio_file', base64Audio.split(',')[1]);
//   //     formData.append('file_extension', fileExtension);
//   //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //       method: 'POST',
//   //       body: formData
//   //     });
//   //     const data = await response.json();
//   //     setAudioToText(data.response)
//   //     if (data.response.length > 0) {
//   //       setCheckAudio(false)
//   //     }
//   //     // if (data.response) {
//   //     //   setTimeout(() => {
//   //     //     setRecordMessage(false)
//   //     //     }, 880);
//   //     //   // }, 6200);
//   //     // }
//   //   } catch (error) {
//   //     console.error('Error sending audio:', error);
//   //   }
//   //   finally {
//   //     setCheckAudio(true)
//   //   }
//   // };
//   const convertBlobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };
//   useEffect(() => {
//     if (videoRef.current) {
//       setVideoLoading(true);
//       videoRef.current.load();
//       videoRef.current.play().finally(() => {
//         setVideoLoading(false);
//       });
//     }
//   }, [videoUrl]);
//   const toggleSound = () => {
//     if (audioRef.current) {
//       audioRef.current.muted = isSoundOn;
//       setIsSoundOn(!isSoundOn);
//     }
//   };
//   // const toggleSound = () => {
//   //   if (videoRef.current && audioRef.current) {
//   //     if (isSoundOn) {
//   //       // Mute both video and external audio
//   //       videoRef.current.muted = true;
//   //       audioRef.current.muted = true; // Mute external audio
//   //     } else {
//   //       // Unmute both video and external audio
//   //       videoRef.current.muted = false;
//   //       audioRef.current.muted = false; // Unmute external audio
//   //     }
//   //     // Toggle sound state
//   //     setIsSoundOn(!isSoundOn);
//   //   }
//   // };
//   const handleChatBotOpen = () => {
//     setShowChatBot(!showChatBot);
//   };
//   useEffect(() => {
//     setShowChatBot(true);
//   }, []);
//   useEffect(() => {
//     handleSendMessage()
//   }, [audioToText])
//   const handleVideoEnd = () => {
//     setVideoUrl(staticApiVideo)
//   }
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       setTimeout(() => {
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       }, 500);
//     }
//   }, [messages, showChatBot]);
//   // audio functionality for android
//   // const sendAudioToApi = async () => {
//   //   if (!isRecordingTemp) {
//   //     try {
//   //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//   //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
//   //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
//   //         if (event.data.size > 0) {
//   //           recordedChunksRefTemp.current.push(event.data);
//   //         }
//   //       };
//   //       mediaRecorderRefTemp.current.onstop = async () => {
//   //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
//   //         recordedChunksRefTemp.current = [];
//   //         // Convert blob to Base64
//   //         const readerTemp = new FileReader();
//   //         readerTemp.readAsDataURL(blobTemp);
//   //         readerTemp.onloadend = async () => {
//   //           const base64AudioTemp = readerTemp.result.split(',')[1];
//   //           // Display audio for playback
//   //           const audioUrlTemp = URL.createObjectURL(blobTemp);
//   //           setAudioUrlTemp(audioUrlTemp);
//   //           // Prepare the form data
//   //           const formDataTemp = new FormData();
//   //           formDataTemp.append('audio_file', base64AudioTemp);
//   //           formDataTemp.append('file_extension', 'webm');
//   //           // Call the API
//   //           try {
//   //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //               method: 'POST',
//   //               body: formDataTemp,
//   //             });
//   //             const resultTemp = await responseTemp.json();
//   //             console.log('pppppppppppp', resultTemp.response);
//   //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//   //             setAudioToText(resultTemp.response)
//   //             if (resultTemp.response.length > 0) {
//   //               setCheckAudio(false)
//   //             }
//   //           } catch (error) {
//   //             console.error('Error calling the API:', error);
//   //             setApiResponseTemp(`Error: ${error.message}`);
//   //           }
//   //         };
//   //       };
//   //       mediaRecorderRefTemp.current.start();
//   //       setIsRecordingTemp(true);
//   //     } catch (error) {
//   //       console.error('Error accessing microphone: ', error);
//   //     }
//   //   } else {
//   //     // Stop the recording
//   //     mediaRecorderRefTemp.current.stop();
//   //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//   //     setIsRecordingTemp(false);
//   //   }
//   // };
//   // audio functionality for ios 
//   const sendAudioToApi = async () => {
//     if (!isRecordingTemp) {
//       try {
//         mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//         // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
//         const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
//         mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
//         mediaRecorderRefTemp.current.ondataavailable = (event) => {
//           if (event.data.size > 0) {
//             recordedChunksRefTemp.current.push(event.data);
//           }
//         };
//         mediaRecorderRefTemp.current.onstop = async () => {
//           const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
//           recordedChunksRefTemp.current = [];
//           // Convert blob to Base64
//           const readerTemp = new FileReader();
//           readerTemp.readAsDataURL(blobTemp);
//           readerTemp.onloadend = async () => {
//             const base64AudioTemp = readerTemp.result.split(',')[1];
//             // Display audio for playback
//             const audioUrlTemp = URL.createObjectURL(blobTemp);
//             setAudioUrlTemp(audioUrlTemp);
//             // Prepare the form data
//             const formDataTemp = new FormData();
//             formDataTemp.append('audio_file', base64AudioTemp);
//             formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
//             // Call the API
//             try {
//               const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//                 method: 'POST',
//                 body: formDataTemp,
//               });
//               const resultTemp = await responseTemp.json();
//               console.log('API Response:', resultTemp.response);
//               setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//               setAudioToText(resultTemp.response);
//               if (resultTemp.response.length > 0) {
//                 setCheckAudio(false);
//               }
//             } catch (error) {
//               console.error('Error calling the API:', error);
//               setApiResponseTemp(`Error: ${error.message}`);
//             }
//           };
//         };
//         mediaRecorderRefTemp.current.start();
//         setIsRecordingTemp(true);
//       } catch (error) {
//         console.error('Error accessing microphone: ', error);
//       }
//     } else {
//       // Stop the recording
//       mediaRecorderRefTemp.current.stop();
//       mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//       setIsRecordingTemp(false);
//     }
//   };
//   // Helper function to check if the user is on iOS
//   const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
//   return (
//     <>
//       {
//         !showChatBot ?
//           <div className="videochartvalue ">
//             <div className='container'>
//               <div className='headAndOutput'>
//                 <div className='chatHead'>
//                   <div className='headIcontext'>
//                     <div className='group-2'></div>
//                     <div className='iconHeadChat'>
//                       <img src="/img/chatAvatarIcon3.png" alt="Avatar" />
//                       <div className='headTextClass'>
//                         <div className="text-wrapper miniHead">Chat with</div>
//                         <div className="text-wrapper-2">AI Assistant</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className='headMinClose'>
//                     <div className='languagesDivBoth'>
//                       <div className='languagesDiv' onClick={handleAvatarToggle} ref={dropdownAvatarRef} >
//                         <div className='avatarNameImgClass'>
//                           {selectedAvatar.name}
//                         </div>
//                         <span className={`arrow ${showAvatar ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showAvatar && (
//                           <ul className='languageDropdown'>
//                             {avatarList
//                               .filter(avatar => avatar !== selectedAvatar)
//                               .map((avatar, index) => (
//                                 <li key={index} onClick={() => handleAvatarSelect(avatar)} className='avatarNameImgClass'>
//                                   {avatar.name}
//                                 </li>
//                               ))}
//                           </ul>
//                         )}
//                       </div>
//                       <div ref={dropdownLanguageRef} className='languagesDiv' onClick={handleLanguageToggle}>
//                         {selectedLanguage}
//                         <span className={`arrow ${showLanguages ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showLanguages && (
//                           <ul className='languageDropdown'>
//                             <input
//                               ref={searchInputRef}
//                               type="text"
//                               value={searchTerm}
//                               onChange={handleSearchChange}
//                               onKeyDown={handleKeyDown}
//                               placeholder="Search"
//                               className='searchLanguageInput'
//                             />
//                           </ul>
//                         )}
//                         {showLanguages && (
//                           <ul className='languageDropdown languageSearchDropdown'>
//                             {filteredLanguages.map((language, index) => (
//                               <li key={index} onClick={() => handleLanguageSelect(language)} className='languageOption'>
//                                 <p>
//                                   {language.language}
//                                 </p>
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div>
//                     </div>
//                     <div className=' speakerIconButton' >
//                       {isSoundOn ? (
//                         <img src={chatSoundIconWhite} alt="Speaker" onClick={toggleSound} />
//                       ) : (
//                         <img src={chatSpeakerMuteIcon} alt="Speaker" onClick={toggleSound} />
//                       )}
//                       {/* <img src="/img/minimizeChatWhite.png" alt="Line" onClick={handleChatBotOpen} /> */}
//                       <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={handleChatBotOpen} />
//                     </div>
//                   </div>
//                 </div>
//                 <div id="output-container">
//                   <div className="messages-container">
//                     {
//                       showWelcomeMsg ?
//                         <div className='message-item receiver'>
//                           <div className='senderIconText'>
//                             <div className='message'>
//                               <div className="chat-bubble">
//                                 <div className="typing">
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                 </div>
//                               </div>
//                             </div>
//                             <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           </div>
//                         </div>
//                         :
//                         <div className='receiverIconText'>
//                           <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           <div className="success-status">
//                             {welcomeApiMsg}
//                           </div>
//                         </div>
//                     }
//                     {messages.map((item, index) => (
//                       <div key={index} className={`message-item ${item.type === 'user' ? 'sender' : 'receiver'}`}>
//                         <div className='senderIconText'>
//                           <div className="message">
//                             {
//                               item.audioUrl ?
//                                 recordMessage && index === recentBotIndex ? (
//                                   <div className="chat-bubble-audio">
//                                     <div className="typing">
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                     </div>
//                                   </div>
//                                 )
//                                   : (
//                                     <p>{item.audioUrl}</p>
//                                   )
//                                 :
//                                 //  (
//                                 //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
//                                 //     <div className="chat-bubble">
//                                 //       <div className="typing">
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //       </div>
//                                 //     </div>
//                                 //   ) : (
//                                 //     <p>{item.message}</p>
//                                 //   )
//                                 // )
//                                 <p>{item.message}</p>
//                             }
//                           </div>
//                           {item.type === 'user' && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
//                           {item.type === 'bot' && <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />}
//                         </div>
//                         <div ref={messagesEndRef} /> {/* Auto-scroll target */}
//                       </div>
//                     ))}
//                     {/* {recordMessage ?
//                     <div className="senderIconText">
//                       <div className="message">
//                         <div className="typing">
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                         </div>
//                       </div>
//                       <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />
//                     </div>
//                     : ""} */}
//                     <div ref={messagesEndRef} />
//                   </div>
//                   <div className="hello-container" >
//                     {showWelcomeVideo && welcomeApiVideo ? (
//                       <video
//                         ref={videoRef}
//                         width="100%"
//                         autoPlay
//                         muted={!isSoundOn}
//                         onEnded={handleWelcomeVideoEnd}
//                         playsInline
//                       >
//                         <source src={welcomeApiVideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     ) : (
//                       <div>
//                         {!isApiCalled || !videoUrl ? (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             loop
//                             muted
//                             playsInline
//                           >
//                             <source src={staticApiVideo} type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         ) : (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             // muted={!isSoundOn}
//                             onEnded={handleVideoEnd}
//                             muted
//                             playsInline
//                           >
//                             <source
//                               src={videoUrl}
//                               type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         )}
//                       </div>
//                     )}
//                     {/* <video
//                       ref={videoRef}
//                       width="100%"
//                     height="auto"
//                     objectFit="cover" 
//                       autoPlay
//                       muted={showWelcomeVideo && welcomeApiVideo ? !isSoundOn : true} 
//                       loop={!showWelcomeVideo && (!isApiCalled || !videoUrl)} 
//                       onEnded={showWelcomeVideo && welcomeApiVideo ? handleWelcomeVideoEnd : handleVideoEnd} 
//                       playsInline
//                     >
//                       <source
//                         src={
//                           showWelcomeVideo && welcomeApiVideo
//                             ? welcomeApiVideo 
//                             : !isApiCalled || !videoUrl
//                               ? staticApiVideo 
//                               : videoUrl 
//                         }
//                         type="video/mp4"
//                       />
//                       Your browser does not support the video tag.
//                     </video> */}
//                   </div>
//                 </div>
//               </div>
//               <div className='outputHelpfulClass'>
//                 <div className="input-container">
//                   <input
//                     type="text"
//                     value={inputValue}
//                     onChange={(e) => setInputValue(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     placeholder="Enter your message"
//                     disabled={loading || recording}
//                     ref={inputRef}
//                   />
//                   {/* {recording ? ( */}
//                   {isRecordingTemp ? (
//                     <div className="recording-indicator">
//                       <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
//                         <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
//                       <img src="/img/chatMicIcon.png" alt="Mic" />
//                     </div>
//                   )}
//                   <div className='iconButton' onClick={handleSendMessage} disabled={loading || recording}>
//                     <img src="/img/chatSendIcon.png" alt="Send" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           :
//           <div className='chatBoxImageClass' >
//             <img src={chatBoxImage} alt="" onClick={handleChatBotOpen} />
//           </div>
//       }
//     </>
//   );
// };
// export default MessageInput;
// fixed audio and video merge and iphone compatibility final wala
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emojiPickerReact = require("emoji-picker-react");
var _emojiPickerReactDefault = parcelHelpers.interopDefault(_emojiPickerReact);
var _frameNewCss = require("./frameNew.css");
var _chatBoxImageCrop1Png = require("../../../static/img/chatBoxImageCrop1.png");
var _chatBoxImageCrop1PngDefault = parcelHelpers.interopDefault(_chatBoxImageCrop1Png);
var _arrowDownConvertPng = require("../../../static/img/arrowDownConvert.png");
var _arrowDownConvertPngDefault = parcelHelpers.interopDefault(_arrowDownConvertPng);
var _chatSoundSpeakerPng = require("../../../static/img/chatSoundSpeaker.png");
var _chatSoundSpeakerPngDefault = parcelHelpers.interopDefault(_chatSoundSpeakerPng);
var _chatMuteSpeakerPng = require("../../../static/img/chatMuteSpeaker.png");
var _chatMuteSpeakerPngDefault = parcelHelpers.interopDefault(_chatMuteSpeakerPng);
var _reactRouterDom = require("react-router-dom");
const MessageInput = ()=>{
    // const avatarList = [
    //   { name: 'Shweta', image: '/img/avatar/woman.png' },
    //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
    //   { name: 'Aman', image: '/img/avatar/man.png' },
    //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
    //   { name: 'Alex', image: '/img/avatar/man.png' },
    //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
    // ];
    const languages = [
        {
            "language": "Afrikaans",
            "code": "af"
        },
        {
            "language": "Albanian",
            "code": "sq"
        },
        {
            "language": "Amharic",
            "code": "am"
        },
        {
            "language": "Arabic",
            "code": "ar"
        },
        {
            "language": "Armenian",
            "code": "hy"
        },
        {
            "language": "Azerbaijani",
            "code": "az"
        },
        {
            "language": "Basque",
            "code": "eu"
        },
        {
            "language": "Belarusian",
            "code": "be"
        },
        {
            "language": "Bengali",
            "code": "bn"
        },
        {
            "language": "Bosnian",
            "code": "bs"
        },
        {
            "language": "Bulgarian",
            "code": "bg"
        },
        {
            "language": "Catalan",
            "code": "ca"
        },
        {
            "language": "Cebuano",
            "code": "ceb"
        },
        {
            "language": "Chinese (Simplified)",
            "code": "zh-CN"
        },
        {
            "language": "Chinese (Traditional)",
            "code": "zh-TW"
        },
        {
            "language": "Corsican",
            "code": "co"
        },
        {
            "language": "Croatian",
            "code": "hr"
        },
        {
            "language": "Czech",
            "code": "cs"
        },
        {
            "language": "Danish",
            "code": "da"
        },
        {
            "language": "Dutch",
            "code": "nl"
        },
        {
            "language": "English",
            "code": "en"
        },
        {
            "language": "Esperanto",
            "code": "eo"
        },
        {
            "language": "Estonian",
            "code": "et"
        },
        {
            "language": "Finnish",
            "code": "fi"
        },
        {
            "language": "French",
            "code": "fr"
        },
        {
            "language": "Frisian",
            "code": "fy"
        },
        {
            "language": "Galician",
            "code": "gl"
        },
        {
            "language": "Georgian",
            "code": "ka"
        },
        {
            "language": "German",
            "code": "de"
        },
        {
            "language": "Greek",
            "code": "el"
        },
        {
            "language": "Gujarati",
            "code": "gu"
        },
        {
            "language": "Haitian Creole",
            "code": "ht"
        },
        {
            "language": "Hausa",
            "code": "ha"
        },
        {
            "language": "Hawaiian",
            "code": "haw"
        },
        {
            "language": "Hebrew",
            "code": "iw"
        },
        {
            "language": "Hindi",
            "code": "hi"
        },
        {
            "language": "Hmong",
            "code": "hmn"
        },
        {
            "language": "Hungarian",
            "code": "hu"
        },
        {
            "language": "Icelandic",
            "code": "is"
        },
        {
            "language": "Igbo",
            "code": "ig"
        },
        {
            "language": "Indonesian",
            "code": "id"
        },
        {
            "language": "Irish",
            "code": "ga"
        },
        {
            "language": "Italian",
            "code": "it"
        },
        {
            "language": "Japanese",
            "code": "ja"
        },
        {
            "language": "Javanese",
            "code": "jw"
        },
        {
            "language": "Kannada",
            "code": "kn"
        },
        {
            "language": "Kazakh",
            "code": "kk"
        },
        {
            "language": "Khmer",
            "code": "km"
        },
        {
            "language": "Korean",
            "code": "ko"
        },
        {
            "language": "Kurdish",
            "code": "ku"
        },
        {
            "language": "Kyrgyz",
            "code": "ky"
        },
        {
            "language": "Lao",
            "code": "lo"
        },
        {
            "language": "Latin",
            "code": "la"
        },
        {
            "language": "Latvian",
            "code": "lv"
        },
        {
            "language": "Lithuanian",
            "code": "lt"
        },
        {
            "language": "Luxembourgish",
            "code": "lb"
        },
        {
            "language": "Macedonian",
            "code": "mk"
        },
        {
            "language": "Malagasy",
            "code": "mg"
        },
        {
            "language": "Malay",
            "code": "ms"
        },
        {
            "language": "Malayalam",
            "code": "ml"
        },
        {
            "language": "Maltese",
            "code": "mt"
        },
        {
            "language": "Maori",
            "code": "mi"
        },
        {
            "language": "Marathi",
            "code": "mr"
        },
        {
            "language": "Mongolian",
            "code": "mn"
        },
        {
            "language": "Myanmar (Burmese)",
            "code": "my"
        },
        {
            "language": "Nepali",
            "code": "ne"
        },
        {
            "language": "Norwegian",
            "code": "no"
        },
        {
            "language": "Nyanja (Chichewa)",
            "code": "ny"
        },
        {
            "language": "Pashto",
            "code": "ps"
        },
        {
            "language": "Persian",
            "code": "fa"
        },
        {
            "language": "Polish",
            "code": "pl"
        },
        {
            "language": "Portuguese (Portugal, Brazil)",
            "code": "pt"
        },
        {
            "language": "Punjabi",
            "code": "pa"
        },
        {
            "language": "Romanian",
            "code": "ro"
        },
        {
            "language": "Russian",
            "code": "ru"
        },
        {
            "language": "Samoan",
            "code": "sm"
        },
        {
            "language": "Scots Gaelic",
            "code": "gd"
        },
        {
            "language": "Serbian",
            "code": "sr"
        },
        {
            "language": "Sesotho",
            "code": "st"
        },
        {
            "language": "Shona",
            "code": "sn"
        },
        {
            "language": "Sindhi",
            "code": "sd"
        },
        {
            "language": "Sinhala (Sinhalese)",
            "code": "si"
        },
        {
            "language": "Slovak",
            "code": "sk"
        },
        {
            "language": "Slovenian",
            "code": "sl"
        },
        {
            "language": "Somali",
            "code": "so"
        },
        {
            "language": "Spanish",
            "code": "es"
        },
        {
            "language": "Sundanese",
            "code": "su"
        },
        {
            "language": "Swahili",
            "code": "sw"
        },
        {
            "language": "Swedish",
            "code": "sv"
        },
        {
            "language": "Tagalog (Filipino)",
            "code": "tl"
        },
        {
            "language": "Tajik",
            "code": "tg"
        },
        {
            "language": "Tamil",
            "code": "ta"
        },
        {
            "language": "Telugu",
            "code": "te"
        },
        {
            "language": "Thai",
            "code": "th"
        },
        {
            "language": "Turkish",
            "code": "tr"
        },
        {
            "language": "Ukrainian",
            "code": "uk"
        },
        {
            "language": "Urdu",
            "code": "ur"
        },
        {
            "language": "Uzbek",
            "code": "uz"
        },
        {
            "language": "Vietnamese",
            "code": "vi"
        },
        {
            "language": "Welsh",
            "code": "cy"
        },
        {
            "language": "Xhosa",
            "code": "xh"
        },
        {
            "language": "Yiddish",
            "code": "yi"
        },
        {
            "language": "Yoruba",
            "code": "yo"
        },
        {
            "language": "Zulu",
            "code": "zu"
        }
    ];
    const [inputValue, setInputValue] = (0, _react.useState)("");
    const [welcomeApiMsg, setWelcomeApiMsg] = (0, _react.useState)("");
    const [staticApiVideo, setStaticApiVideo] = (0, _react.useState)("");
    const [welcomeApiVideo, setWelcomeApiVideo] = (0, _react.useState)("");
    const [messages, setMessages] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [videoUrl, setVideoUrl] = (0, _react.useState)("");
    const [audioToText, setAudioToText] = (0, _react.useState)("");
    const [recording, setRecording] = (0, _react.useState)(false);
    const [audioBlob, setAudioBlob] = (0, _react.useState)(null);
    const [timer, setTimer] = (0, _react.useState)(0);
    const [isSoundOn, setIsSoundOn] = (0, _react.useState)(true);
    const [videoLoading, setVideoLoading] = (0, _react.useState)(true);
    const [showChatBot, setShowChatBot] = (0, _react.useState)(false);
    const [recordMessage, setRecordMessage] = (0, _react.useState)(false);
    const [isApiCalled, setIsApiCalled] = (0, _react.useState)(false);
    const videoRef = (0, _react.useRef)(null);
    const mediaRecorderRef = (0, _react.useRef)(null);
    const audioChunksRef = (0, _react.useRef)([]);
    const timerRef = (0, _react.useRef)(null);
    const chatHeadRef = (0, _react.useRef)(null);
    const messagesEndRef = (0, _react.useRef)(null); // Ref for the autoscroll
    const inputRef = (0, _react.useRef)(null);
    const dropdownAvatarRef = (0, _react.useRef)(null);
    const dropdownLanguageRef = (0, _react.useRef)(null);
    const searchInputRef = (0, _react.useRef)(null);
    const [showInitialText, setShowInitialText] = (0, _react.useState)(true);
    const [recentBotIndex, setRecentBotIndex] = (0, _react.useState)(null);
    const [showWelcomeMsg, setShowWelcomeMsg] = (0, _react.useState)(false);
    const [checkAudio, setCheckAudio] = (0, _react.useState)(false);
    const [showWelcomeVideo, setShowWelcomeVideo] = (0, _react.useState)(true);
    const [showLanguages, setShowLanguages] = (0, _react.useState)(false);
    const [searchTerm, setSearchTerm] = (0, _react.useState)("");
    const [filteredLanguages, setFilteredLanguages] = (0, _react.useState)(languages);
    const [showAvatar, setShowAvatar] = (0, _react.useState)(false);
    const [selectedLanguage, setSelectedLanguage] = (0, _react.useState)("English");
    const [languageCode, setLanguageCode] = (0, _react.useState)("en");
    const [isRecordingTemp, setIsRecordingTemp] = (0, _react.useState)(false);
    const [audioUrlTemp, setAudioUrlTemp] = (0, _react.useState)(null);
    const [apiResponseTemp, setApiResponseTemp] = (0, _react.useState)("");
    const mediaRecorderRefTemp = (0, _react.useRef)(null);
    const recordedChunksRefTemp = (0, _react.useRef)([]);
    const mediaStreamRefTemp = (0, _react.useRef)(null);
    const audioRef = (0, _react.useRef)(null);
    const audioConstraintsTemp = {
        audio: {
            sampleRate: 16000,
            channelCount: 1,
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false
        }
    };
    // taking params from parent app and passing in iframe api
    // const [params, setParams] = useState({
    //   companyName: '',
    //   moduleName: '',
    //   avatarName: ''
    // });
    // useEffect(() => {
    //   const receiveMessage = (event) => {
    //     const { companyName, moduleName, avatarName } = event.data;
    //     setParams({ companyName, moduleName, avatarName });
    //   };
    //   window.addEventListener('message', receiveMessage, false);
    //   return () => {
    //     window.removeEventListener('message', receiveMessage);
    //   };
    // }, []);
    // taking params from iframe url only and passing in iframe api
    const params = (0, _reactRouterDom.useLocation)();
    const pathSegments = params.pathname.split("/").filter((segment)=>segment);
    const companyName = pathSegments[pathSegments.length - 3];
    const moduleName = pathSegments[pathSegments.length - 2];
    const avatarName = pathSegments[pathSegments.length - 1];
    const avatarList = [
        {
            name: "Natasha",
            image: "image1.png"
        }
    ];
    const defaultAvatar = avatarList[0];
    const [selectedAvatar, setSelectedAvatar] = (0, _react.useState)({
        name: defaultAvatar.name,
        image: defaultAvatar.image
    });
    (0, _react.useEffect)(()=>{
        if (avatarName) {
            const foundAvatar = avatarList.find((avatar)=>avatar.name.toLowerCase() === avatarName.toLowerCase());
            if (foundAvatar) setSelectedAvatar({
                name: foundAvatar.name,
                image: foundAvatar.image
            });
            else setSelectedAvatar(defaultAvatar);
        } else setSelectedAvatar(defaultAvatar);
    }, [
        avatarName
    ]);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) setShowAvatar(false);
        };
        if (showAvatar) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showAvatar
    ]);
    const handleAvatarToggle = ()=>{
        setShowAvatar(!showAvatar);
    };
    const handleLanguageToggle = ()=>{
        setShowLanguages(!showLanguages);
        if (!showLanguages) {
            setFilteredLanguages(languages);
            setSearchTerm("");
        }
    };
    const handleLanguageSelect = (language)=>{
        setSelectedLanguage(language.language);
        setSearchTerm("");
        setFilteredLanguages(languages);
        setShowLanguages(false);
        setLanguageCode(language.code);
    };
    const handleSearchChange = (event)=>{
        setSearchTerm(event.target.value);
        const filtered = languages.filter((language)=>language.language.toLowerCase().includes(event.target.value.toLowerCase()));
        setFilteredLanguages(filtered);
    };
    (0, _react.useEffect)(()=>{
        if (showLanguages) searchInputRef.current.focus();
    }, [
        showLanguages
    ]);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) setShowLanguages(false);
        };
        if (showLanguages) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showLanguages
    ]);
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" && filteredLanguages.length > 0) handleLanguageSelect(filteredLanguages[0]);
    };
    const handleAvatarSelect = (avatar)=>{
        setSelectedAvatar(avatar);
        setShowAvatar(false);
    };
    const handleWelcomeVideoEnd = ()=>{
        setShowWelcomeVideo(false);
    };
    (0, _react.useEffect)(()=>{
        const showTimeout = setTimeout(()=>{
            setShowWelcomeMsg(true);
        }, 1);
        const hideTimeout = setTimeout(()=>{
            setShowWelcomeMsg(false);
        }, 3000);
        return ()=>{
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        const callApiOnPageLoad = async ()=>{
            const payload = {
                user_input: "hi"
            };
            try {
                const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                if (response.ok) {
                    const data = await response.json();
                    setWelcomeApiMsg(data.responses[0]);
                    setStaticApiVideo(data.static_video);
                    setWelcomeApiVideo(data.video_path);
                } else console.error("API error:", response.statusText);
            } catch (error) {
                console.error("Fetch error:", error);
            }
        };
        callApiOnPageLoad();
    }, [
        companyName,
        moduleName,
        selectedAvatar
    ]);
    (0, _react.useEffect)(()=>{
        const latestBotIndex = messages.map((item, index)=>item.type === "bot" ? index : null).filter((index)=>index !== null).pop();
        if (latestBotIndex !== null) {
            setRecentBotIndex(latestBotIndex);
            // const timer = setTimeout(() => {
            //   setShowInitialText(false);
            // }, 1300);
            setShowInitialText(true);
        // return () => clearTimeout(timer);
        }
    }, [
        messages
    ]);
    const handleKeyPress = (event)=>{
        if (event.key === "Enter") handleSendMessage();
    };
    const handleSendMessage = async ()=>{
        setInputValue(""); // Clear the input field at the start
        if (inputValue.trim() || audioToText) {
            setLoading(true);
            setIsApiCalled(true);
            const userMessage = {
                message: audioToText || inputValue.trim() || "",
                type: "user",
                audioUrl: audioToText,
                isActive: true
            };
            setMessages((prevMessages)=>[
                    ...prevMessages,
                    userMessage
                ]);
            const payload = {
                user_input: audioToText ? audioToText : inputValue.trim() || "",
                lang: languageCode,
                companyName: companyName,
                moduleName: moduleName,
                avatarName: selectedAvatar.name
            };
            if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                behavior: "smooth"
            });
            try {
                const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                const data = await response.json();
                setAudioToText("");
                setAudioBlob(null);
                setTimer(0);
                handleResponse(data); // Call handleResponse to play audio and video
                if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            } catch (error) {
                console.error("Error:", error);
            } finally{
                setLoading(false);
            }
        }
    };
    // const handleResponse = (data) => {
    //   // Check if there are bot responses
    //   if (data.responses && data.responses.length > 0) {
    //     const botMessage = data.responses.join(' ');
    //     setMessages((prevMessages) => [
    //       ...prevMessages,
    //       {
    //         message: botMessage,
    //         type: 'bot',
    //       },
    //     ]);
    //   } else {
    //     setMessages((prevMessages) => [
    //       ...prevMessages,
    //       {
    //         message: "Could you please repeat?",
    //         type: 'bot',
    //       },
    //     ]);
    //   }
    //   // Check if there is a video path in the response
    //   if (data.video_path) {
    //     const fullVideoUrl = data.video_path;
    //     setVideoUrl(fullVideoUrl);
    //     // If there is audio data in base64 format, handle the audio
    //     if (data.audio_data) {
    //       // Convert the base64 audio data to a Blob
    //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
    //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
    //       // Create audio and video elements
    //       const videoElement = document.createElement('video');
    //       videoElement.src = fullVideoUrl;
    //       videoElement.controls = true;
    //       videoElement.autoplay = true;
    //       videoElement.muted = true; // Mute the video to avoid overlapping sound
    //       const audioElement = document.createElement('audio');
    //       audioElement.src = audioUrl;
    //       audioElement.autoplay = true;
    //       // const audioElement = new Audio(audioUrl);
    //     audioRef.current = audioElement; 
    //       // Sync the audio and video playback
    //       videoElement.addEventListener('play', () => {
    //         audioElement.play();
    //       });
    //       videoElement.addEventListener('pause', () => {
    //         audioElement.pause();
    //       });
    //       // Append the video element to a container (assuming there is a container for the video)
    //       const videoContainer = document.getElementById('video-container');
    //       videoContainer.innerHTML = ''; // Clear any previous video
    //       videoContainer.appendChild(videoElement);
    //     } else {
    //       console.log('No audio data received.');
    //     }
    //   } else {
    //     setVideoUrl(''); // Clear the video if no path is provided
    //   }
    // };
    // Utility function to convert base64 to Blob
    const handleResponse = (data)=>{
        if (data.responses && data.responses.length > 0) {
            const botMessage = data.responses.join(" ");
            setMessages((prevMessages)=>[
                    ...prevMessages,
                    {
                        message: botMessage,
                        type: "bot"
                    }
                ]);
        } else setMessages((prevMessages)=>[
                ...prevMessages,
                {
                    message: "Could you please repeat?",
                    type: "bot"
                }
            ]);
        if (data.video_path) {
            const fullVideoUrl = data.video_path;
            setVideoUrl(fullVideoUrl);
            if (data.audio_data) {
                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                    audioRef.current.src = "";
                }
                const audioBlob = base64ToBlob(data.audio_data, "audio/mp3");
                const audioUrl = URL.createObjectURL(audioBlob);
                const audioElement = new Audio(audioUrl);
                audioElement.autoplay = true;
                audioRef.current = audioElement;
                audioElement.play();
                if (videoRef.current) {
                    videoRef.current.muted = true;
                    videoRef.current.src = fullVideoUrl;
                    videoRef.current.autoplay = true;
                    videoRef.current.playsInline = true;
                    videoRef.current.removeEventListener("play", handleVideoPlay);
                    videoRef.current.removeEventListener("pause", handleVideoPause);
                    videoRef.current.removeEventListener("ended", handleVideoEnd);
                    const handleVideoPlay = ()=>{
                        audioElement.play();
                    };
                    const handleVideoPause = ()=>{
                        audioElement.pause();
                    };
                    const handleVideoEnd = ()=>{
                        audioElement.pause();
                        audioElement.currentTime = 0;
                        videoRef.current.currentTime = 0;
                    };
                    videoRef.current.addEventListener("play", handleVideoPlay);
                    videoRef.current.addEventListener("pause", handleVideoPause);
                    videoRef.current.addEventListener("ended", handleVideoEnd);
                }
            } else console.log("No audio data received.");
        } else setVideoUrl(""); // Clear the video if no path is provided
    };
    const base64ToBlob = (base64Data, contentType = "", sliceSize = 512)=>{
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for(let i = 0; i < slice.length; i++)byteNumbers[i] = slice.charCodeAt(i);
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: contentType
        });
    };
    (0, _react.useEffect)(()=>{
        if (videoUrl) {
            setVideoLoading(true);
            const video = videoRef.current;
            if (video) video.onloadeddata = ()=>{
                setVideoLoading(false);
                video.onended = ()=>{
                    setVideoUrl("");
                };
            };
        }
    }, [
        videoUrl
    ]);
    // useEffect(() => {
    //   if (!loading && !recording) {
    //     inputRef.current?.focus();
    //   }
    //   if (showWelcomeVideo) {
    //     inputRef.current?.focus();
    //   }
    // }, [loading, recording, inputValue, messages]);
    // recording check 
    // const startRecording = async () => {
    //   setRecording(true);
    //   setRecordMessage(false)
    //   setTimer(0);
    //   audioChunksRef.current = [];
    //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //   mediaRecorderRef.current = new MediaRecorder(stream);
    //   mediaRecorderRef.current.ondataavailable = (event) => {
    //     if (event.data.size > 0) {
    //       audioChunksRef.current.push(event.data);
    //     }
    //   };
    //   mediaRecorderRef.current.onstop = () => {
    //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    //     setAudioBlob(blob);
    //   };
    //   mediaRecorderRef.current.start();
    //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
    // };
    // const stopRecording = () => {
    //   setRecordMessage(true)
    //   setRecording(false);
    //   if (mediaRecorderRef.current) {
    //     mediaRecorderRef.current.stop();
    //   }
    //   clearInterval(timerRef.current);
    // };
    (0, _react.useEffect)(()=>{
        if (audioBlob) sendAudioToApi(audioBlob);
    }, [
        audioBlob
    ]);
    (0, _react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setRecordMessage(false);
        }, 3000);
        return ()=>clearTimeout(timer);
    }, [
        recordMessage
    ]);
    // const sendAudioToApi = async (blob) => {
    //   try {
    //     const base64Audio = await convertBlobToBase64(blob);
    //     const fileExtension = blob.type.split('/')[1];
    //     const formData = new FormData();
    //     formData.append('audio_file', base64Audio.split(',')[1]);
    //     formData.append('file_extension', fileExtension);
    //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
    //       method: 'POST',
    //       body: formData
    //     });
    //     const data = await response.json();
    //     setAudioToText(data.response)
    //     if (data.response.length > 0) {
    //       setCheckAudio(false)
    //     }
    //     // if (data.response) {
    //     //   setTimeout(() => {
    //     //     setRecordMessage(false)
    //     //     }, 880);
    //     //   // }, 6200);
    //     // }
    //   } catch (error) {
    //     console.error('Error sending audio:', error);
    //   }
    //   finally {
    //     setCheckAudio(true)
    //   }
    // };
    const convertBlobToBase64 = (blob)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };
    (0, _react.useEffect)(()=>{
        if (videoRef.current) {
            setVideoLoading(true);
            videoRef.current.load();
            videoRef.current.play().finally(()=>{
                setVideoLoading(false);
            });
        }
    }, [
        videoUrl
    ]);
    const toggleSound = ()=>{
        if (audioRef.current) {
            audioRef.current.muted = isSoundOn;
            setIsSoundOn(!isSoundOn);
        }
    };
    // const toggleSound = () => {
    //   if (videoRef.current && audioRef.current) {
    //     if (isSoundOn) {
    //       // Mute both video and external audio
    //       videoRef.current.muted = true;
    //       audioRef.current.muted = true; // Mute external audio
    //     } else {
    //       // Unmute both video and external audio
    //       videoRef.current.muted = false;
    //       audioRef.current.muted = false; // Unmute external audio
    //     }
    //     // Toggle sound state
    //     setIsSoundOn(!isSoundOn);
    //   }
    // };
    const handleChatBotOpen = ()=>{
        setShowChatBot(!showChatBot);
    };
    (0, _react.useEffect)(()=>{
        setShowChatBot(true);
    }, []);
    (0, _react.useEffect)(()=>{
        handleSendMessage();
    }, [
        audioToText
    ]);
    const handleVideoEnd = ()=>{
        setVideoUrl(staticApiVideo);
    };
    (0, _react.useEffect)(()=>{
        if (messagesEndRef.current) setTimeout(()=>{
            if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }, 500);
    }, [
        messages,
        showChatBot
    ]);
    // audio functionality for android
    // const sendAudioToApi = async () => {
    //   if (!isRecordingTemp) {
    //     try {
    //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
    //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
    //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
    //         if (event.data.size > 0) {
    //           recordedChunksRefTemp.current.push(event.data);
    //         }
    //       };
    //       mediaRecorderRefTemp.current.onstop = async () => {
    //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
    //         recordedChunksRefTemp.current = [];
    //         // Convert blob to Base64
    //         const readerTemp = new FileReader();
    //         readerTemp.readAsDataURL(blobTemp);
    //         readerTemp.onloadend = async () => {
    //           const base64AudioTemp = readerTemp.result.split(',')[1];
    //           // Display audio for playback
    //           const audioUrlTemp = URL.createObjectURL(blobTemp);
    //           setAudioUrlTemp(audioUrlTemp);
    //           // Prepare the form data
    //           const formDataTemp = new FormData();
    //           formDataTemp.append('audio_file', base64AudioTemp);
    //           formDataTemp.append('file_extension', 'webm');
    //           // Call the API
    //           try {
    //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
    //               method: 'POST',
    //               body: formDataTemp,
    //             });
    //             const resultTemp = await responseTemp.json();
    //             console.log('pppppppppppp', resultTemp.response);
    //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
    //             setAudioToText(resultTemp.response)
    //             if (resultTemp.response.length > 0) {
    //               setCheckAudio(false)
    //             }
    //           } catch (error) {
    //             console.error('Error calling the API:', error);
    //             setApiResponseTemp(`Error: ${error.message}`);
    //           }
    //         };
    //       };
    //       mediaRecorderRefTemp.current.start();
    //       setIsRecordingTemp(true);
    //     } catch (error) {
    //       console.error('Error accessing microphone: ', error);
    //     }
    //   } else {
    //     // Stop the recording
    //     mediaRecorderRefTemp.current.stop();
    //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
    //     setIsRecordingTemp(false);
    //   }
    // };
    // audio functionality for ios 
    const sendAudioToApi = async ()=>{
        if (!isRecordingTemp) try {
            mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
            // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
            const mimeType = isIOS() ? "audio/mp4" : "audio/webm";
            mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, {
                mimeType
            });
            mediaRecorderRefTemp.current.ondataavailable = (event)=>{
                if (event.data.size > 0) recordedChunksRefTemp.current.push(event.data);
            };
            mediaRecorderRefTemp.current.onstop = async ()=>{
                const blobTemp = new Blob(recordedChunksRefTemp.current, {
                    type: mimeType
                });
                recordedChunksRefTemp.current = [];
                // Convert blob to Base64
                const readerTemp = new FileReader();
                readerTemp.readAsDataURL(blobTemp);
                readerTemp.onloadend = async ()=>{
                    const base64AudioTemp = readerTemp.result.split(",")[1];
                    // Display audio for playback
                    const audioUrlTemp = URL.createObjectURL(blobTemp);
                    setAudioUrlTemp(audioUrlTemp);
                    // Prepare the form data
                    const formDataTemp = new FormData();
                    formDataTemp.append("audio_file", base64AudioTemp);
                    formDataTemp.append("file_extension", mimeType === "audio/mp4" ? "mp4" : "webm");
                    // Call the API
                    try {
                        const responseTemp = await fetch("https://speech.pranathiss.com/api/vad-base64-speech-to-text/", {
                            method: "POST",
                            body: formDataTemp
                        });
                        const resultTemp = await responseTemp.json();
                        console.log("API Response:", resultTemp.response);
                        setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
                        setAudioToText(resultTemp.response);
                        if (resultTemp.response.length > 0) setCheckAudio(false);
                    } catch (error) {
                        console.error("Error calling the API:", error);
                        setApiResponseTemp(`Error: ${error.message}`);
                    }
                };
            };
            mediaRecorderRefTemp.current.start();
            setIsRecordingTemp(true);
        } catch (error) {
            console.error("Error accessing microphone: ", error);
        }
        else {
            // Stop the recording
            mediaRecorderRefTemp.current.stop();
            mediaStreamRefTemp.current.getTracks().forEach((track)=>track.stop());
            setIsRecordingTemp(false);
        }
    };
    // Helper function to check if the user is on iOS
    const isIOS = ()=>/iPhone|iPad|iPod/i.test(navigator.userAgent);
    const handleInputSearch = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: !showChatBot ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "videochartvalue ",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "headAndOutput",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chatHead",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "headIcontext",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "iconHeadChat",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/chatAvatarIcon3.png",
                                                        alt: "Avatar"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "headTextClass",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper miniHead",
                                                                children: "Chat with"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-2",
                                                                children: "AI Assistant"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "headMinClose",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "languagesDivBoth",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "languagesDiv",
                                                        onClick: handleAvatarToggle,
                                                        ref: dropdownAvatarRef,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "avatarNameImgClass",
                                                                children: selectedAvatar.name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `arrow ${showAvatar ? "open" : ""}`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: (0, _arrowDownConvertPngDefault.default),
                                                                    alt: "",
                                                                    className: "downArrowClass"
                                                                })
                                                            }),
                                                            showAvatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown",
                                                                children: avatarList.filter((avatar)=>avatar !== selectedAvatar).map((avatar, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                                        onClick: ()=>handleAvatarSelect(avatar),
                                                                        className: "avatarNameImgClass",
                                                                        children: avatar.name
                                                                    }, index))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        ref: dropdownLanguageRef,
                                                        className: "languagesDiv",
                                                        onClick: handleLanguageToggle,
                                                        children: [
                                                            selectedLanguage,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `arrow ${showLanguages ? "open" : ""}`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: (0, _arrowDownConvertPngDefault.default),
                                                                    alt: "",
                                                                    className: "downArrowClass"
                                                                })
                                                            }),
                                                            showLanguages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    ref: searchInputRef,
                                                                    type: "text",
                                                                    value: searchTerm,
                                                                    onChange: handleSearchChange,
                                                                    onKeyDown: handleKeyDown,
                                                                    onClick: handleInputSearch,
                                                                    placeholder: "Search",
                                                                    className: "searchLanguageInput"
                                                                })
                                                            }),
                                                            showLanguages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown languageSearchDropdown",
                                                                children: filteredLanguages.map((language, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                                        onClick: ()=>handleLanguageSelect(language),
                                                                        className: "languageOption",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            children: language.language
                                                                        })
                                                                    }, index))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: " speakerIconButton",
                                                children: [
                                                    isSoundOn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _chatSoundSpeakerPngDefault.default),
                                                        alt: "Speaker",
                                                        onClick: toggleSound
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _chatMuteSpeakerPngDefault.default),
                                                        alt: "Speaker",
                                                        onClick: toggleSound
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/minimizeIcon/minimize1.png",
                                                        alt: "Line",
                                                        onClick: handleChatBotOpen
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                id: "output-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "messages-container",
                                        children: [
                                            showWelcomeMsg ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-item receiver",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "senderIconText",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "message",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "chat-bubble",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "typing",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: "/img/chatAvatarIcon3.png",
                                                            alt: "Receiver Avatar"
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "receiverIconText",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/chatAvatarIcon3.png",
                                                        alt: "Receiver Avatar"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "success-status",
                                                        children: welcomeApiMsg
                                                    })
                                                ]
                                            }),
                                            messages.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: `message-item ${item.type === "user" ? "sender" : "receiver"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "senderIconText",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "message",
                                                                    children: item.audioUrl ? recordMessage && index === recentBotIndex ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "chat-bubble-audio",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "typing",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        children: item.audioUrl
                                                                    }) : //  (
                                                                    //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
                                                                    //     <div className="chat-bubble">
                                                                    //       <div className="typing">
                                                                    //         <div className="dot"></div>
                                                                    //         <div className="dot"></div>
                                                                    //         <div className="dot"></div>
                                                                    //       </div>
                                                                    //     </div>
                                                                    //   ) : (
                                                                    //     <p>{item.message}</p>
                                                                    //   )
                                                                    // )
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        children: item.message
                                                                    })
                                                                }),
                                                                item.type === "user" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/chatSenderIcon.png",
                                                                    alt: "Sender Avatar"
                                                                }),
                                                                item.type === "bot" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/chatAvatarIcon3.png",
                                                                    alt: "Receiver Avatar"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            ref: messagesEndRef
                                                        }),
                                                        " "
                                                    ]
                                                }, index)),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                ref: messagesEndRef
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "hello-container",
                                        children: showWelcomeVideo && welcomeApiVideo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                            ref: videoRef,
                                            width: "100%",
                                            autoPlay: true,
                                            muted: !isSoundOn,
                                            onEnded: handleWelcomeVideoEnd,
                                            playsInline: true,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                    src: welcomeApiVideo,
                                                    type: "video/mp4"
                                                }),
                                                "Your browser does not support the video tag."
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: !isApiCalled || !videoUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                                ref: videoRef,
                                                width: "100%",
                                                autoPlay: true,
                                                loop: true,
                                                muted: true,
                                                playsInline: true,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                        src: staticApiVideo,
                                                        type: "video/mp4"
                                                    }),
                                                    "Your browser does not support the video tag."
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                                ref: videoRef,
                                                width: "100%",
                                                autoPlay: true,
                                                // muted={!isSoundOn}
                                                onEnded: handleVideoEnd,
                                                muted: true,
                                                playsInline: true,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                        src: videoUrl,
                                                        type: "video/mp4"
                                                    }),
                                                    "Your browser does not support the video tag."
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "outputHelpfulClass",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    value: inputValue,
                                    onChange: (e)=>setInputValue(e.target.value),
                                    onKeyPress: handleKeyPress,
                                    placeholder: "Enter your message",
                                    disabled: loading || recording,
                                    ref: inputRef
                                }),
                                isRecordingTemp ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "recording-indicator",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        onClick: sendAudioToApi,
                                        disabled: loading,
                                        className: "iconButton",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: "/img/chatMicSpeakIcon.png",
                                            alt: "Mic"
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "iconButton",
                                    onClick: sendAudioToApi,
                                    disabled: loading,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "/img/chatMicIcon.png",
                                        alt: "Mic"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "iconButton",
                                    onClick: handleSendMessage,
                                    disabled: loading || recording,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "/img/chatSendIcon.png",
                                        alt: "Send"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "chatBoxImageClass",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _chatBoxImageCrop1PngDefault.default),
                alt: "",
                onClick: handleChatBotOpen
            })
        })
    });
};
exports.default = MessageInput; // this is better than previous , static video is playing after api response 
 // import React, { useState, useRef, useEffect } from 'react';
 // import Picker from 'emoji-picker-react';
 // import './frameNew.css';
 // import chatBoxImage from '../../../static/img/chatBoxImageCrop1.png'
 // import arrowDown from '../../../static/img/arrowDownConvert.png'
 // import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
 // import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
 // import { useFetcher, useLocation, useParams } from 'react-router-dom';
 // const MessageInput = () => {
 //   // const avatarList = [
 //   //   { name: 'Shweta', image: '/img/avatar/woman.png' },
 //   //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
 //   //   { name: 'Aman', image: '/img/avatar/man.png' },
 //   //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
 //   //   { name: 'Alex', image: '/img/avatar/man.png' },
 //   //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
 //   // ];
 //   const languages = [
 //     {
 //       "language": "Afrikaans",
 //       "code": "af"
 //     },
 //     {
 //       "language": "Albanian",
 //       "code": "sq"
 //     },
 //     {
 //       "language": "Amharic",
 //       "code": "am"
 //     },
 //     {
 //       "language": "Arabic",
 //       "code": "ar"
 //     },
 //     {
 //       "language": "Armenian",
 //       "code": "hy"
 //     },
 //     {
 //       "language": "Azerbaijani",
 //       "code": "az"
 //     },
 //     {
 //       "language": "Basque",
 //       "code": "eu"
 //     },
 //     {
 //       "language": "Belarusian",
 //       "code": "be"
 //     },
 //     {
 //       "language": "Bengali",
 //       "code": "bn"
 //     },
 //     {
 //       "language": "Bosnian",
 //       "code": "bs"
 //     },
 //     {
 //       "language": "Bulgarian",
 //       "code": "bg"
 //     },
 //     {
 //       "language": "Catalan",
 //       "code": "ca"
 //     },
 //     {
 //       "language": "Cebuano",
 //       "code": "ceb"
 //     },
 //     {
 //       "language": "Chinese (Simplified)",
 //       "code": "zh-CN"
 //     },
 //     {
 //       "language": "Chinese (Traditional)",
 //       "code": "zh-TW"
 //     },
 //     {
 //       "language": "Corsican",
 //       "code": "co"
 //     },
 //     {
 //       "language": "Croatian",
 //       "code": "hr"
 //     },
 //     {
 //       "language": "Czech",
 //       "code": "cs"
 //     },
 //     {
 //       "language": "Danish",
 //       "code": "da"
 //     },
 //     {
 //       "language": "Dutch",
 //       "code": "nl"
 //     },
 //     {
 //       "language": "English",
 //       "code": "en"
 //     },
 //     {
 //       "language": "Esperanto",
 //       "code": "eo"
 //     },
 //     {
 //       "language": "Estonian",
 //       "code": "et"
 //     },
 //     {
 //       "language": "Finnish",
 //       "code": "fi"
 //     },
 //     {
 //       "language": "French",
 //       "code": "fr"
 //     },
 //     {
 //       "language": "Frisian",
 //       "code": "fy"
 //     },
 //     {
 //       "language": "Galician",
 //       "code": "gl"
 //     },
 //     {
 //       "language": "Georgian",
 //       "code": "ka"
 //     },
 //     {
 //       "language": "German",
 //       "code": "de"
 //     },
 //     {
 //       "language": "Greek",
 //       "code": "el"
 //     },
 //     {
 //       "language": "Gujarati",
 //       "code": "gu"
 //     },
 //     {
 //       "language": "Haitian Creole",
 //       "code": "ht"
 //     },
 //     {
 //       "language": "Hausa",
 //       "code": "ha"
 //     },
 //     {
 //       "language": "Hawaiian",
 //       "code": "haw"
 //     },
 //     {
 //       "language": "Hebrew",
 //       "code": "iw"
 //     },
 //     {
 //       "language": "Hindi",
 //       "code": "hi"
 //     },
 //     {
 //       "language": "Hmong",
 //       "code": "hmn"
 //     },
 //     {
 //       "language": "Hungarian",
 //       "code": "hu"
 //     },
 //     {
 //       "language": "Icelandic",
 //       "code": "is"
 //     },
 //     {
 //       "language": "Igbo",
 //       "code": "ig"
 //     },
 //     {
 //       "language": "Indonesian",
 //       "code": "id"
 //     },
 //     {
 //       "language": "Irish",
 //       "code": "ga"
 //     },
 //     {
 //       "language": "Italian",
 //       "code": "it"
 //     },
 //     {
 //       "language": "Japanese",
 //       "code": "ja"
 //     },
 //     {
 //       "language": "Javanese",
 //       "code": "jw"
 //     },
 //     {
 //       "language": "Kannada",
 //       "code": "kn"
 //     },
 //     {
 //       "language": "Kazakh",
 //       "code": "kk"
 //     },
 //     {
 //       "language": "Khmer",
 //       "code": "km"
 //     },
 //     {
 //       "language": "Korean",
 //       "code": "ko"
 //     },
 //     {
 //       "language": "Kurdish",
 //       "code": "ku"
 //     },
 //     {
 //       "language": "Kyrgyz",
 //       "code": "ky"
 //     },
 //     {
 //       "language": "Lao",
 //       "code": "lo"
 //     },
 //     {
 //       "language": "Latin",
 //       "code": "la"
 //     },
 //     {
 //       "language": "Latvian",
 //       "code": "lv"
 //     },
 //     {
 //       "language": "Lithuanian",
 //       "code": "lt"
 //     },
 //     {
 //       "language": "Luxembourgish",
 //       "code": "lb"
 //     },
 //     {
 //       "language": "Macedonian",
 //       "code": "mk"
 //     },
 //     {
 //       "language": "Malagasy",
 //       "code": "mg"
 //     },
 //     {
 //       "language": "Malay",
 //       "code": "ms"
 //     },
 //     {
 //       "language": "Malayalam",
 //       "code": "ml"
 //     },
 //     {
 //       "language": "Maltese",
 //       "code": "mt"
 //     },
 //     {
 //       "language": "Maori",
 //       "code": "mi"
 //     },
 //     {
 //       "language": "Marathi",
 //       "code": "mr"
 //     },
 //     {
 //       "language": "Mongolian",
 //       "code": "mn"
 //     },
 //     {
 //       "language": "Myanmar (Burmese)",
 //       "code": "my"
 //     },
 //     {
 //       "language": "Nepali",
 //       "code": "ne"
 //     },
 //     {
 //       "language": "Norwegian",
 //       "code": "no"
 //     },
 //     {
 //       "language": "Nyanja (Chichewa)",
 //       "code": "ny"
 //     },
 //     {
 //       "language": "Pashto",
 //       "code": "ps"
 //     },
 //     {
 //       "language": "Persian",
 //       "code": "fa"
 //     },
 //     {
 //       "language": "Polish",
 //       "code": "pl"
 //     },
 //     {
 //       "language": "Portuguese (Portugal, Brazil)",
 //       "code": "pt"
 //     },
 //     {
 //       "language": "Punjabi",
 //       "code": "pa"
 //     },
 //     {
 //       "language": "Romanian",
 //       "code": "ro"
 //     },
 //     {
 //       "language": "Russian",
 //       "code": "ru"
 //     },
 //     {
 //       "language": "Samoan",
 //       "code": "sm"
 //     },
 //     {
 //       "language": "Scots Gaelic",
 //       "code": "gd"
 //     },
 //     {
 //       "language": "Serbian",
 //       "code": "sr"
 //     },
 //     {
 //       "language": "Sesotho",
 //       "code": "st"
 //     },
 //     {
 //       "language": "Shona",
 //       "code": "sn"
 //     },
 //     {
 //       "language": "Sindhi",
 //       "code": "sd"
 //     },
 //     {
 //       "language": "Sinhala (Sinhalese)",
 //       "code": "si"
 //     },
 //     {
 //       "language": "Slovak",
 //       "code": "sk"
 //     },
 //     {
 //       "language": "Slovenian",
 //       "code": "sl"
 //     },
 //     {
 //       "language": "Somali",
 //       "code": "so"
 //     },
 //     {
 //       "language": "Spanish",
 //       "code": "es"
 //     },
 //     {
 //       "language": "Sundanese",
 //       "code": "su"
 //     },
 //     {
 //       "language": "Swahili",
 //       "code": "sw"
 //     },
 //     {
 //       "language": "Swedish",
 //       "code": "sv"
 //     },
 //     {
 //       "language": "Tagalog (Filipino)",
 //       "code": "tl"
 //     },
 //     {
 //       "language": "Tajik",
 //       "code": "tg"
 //     },
 //     {
 //       "language": "Tamil",
 //       "code": "ta"
 //     },
 //     {
 //       "language": "Telugu",
 //       "code": "te"
 //     },
 //     {
 //       "language": "Thai",
 //       "code": "th"
 //     },
 //     {
 //       "language": "Turkish",
 //       "code": "tr"
 //     },
 //     {
 //       "language": "Ukrainian",
 //       "code": "uk"
 //     },
 //     {
 //       "language": "Urdu",
 //       "code": "ur"
 //     },
 //     {
 //       "language": "Uzbek",
 //       "code": "uz"
 //     },
 //     {
 //       "language": "Vietnamese",
 //       "code": "vi"
 //     },
 //     {
 //       "language": "Welsh",
 //       "code": "cy"
 //     },
 //     {
 //       "language": "Xhosa",
 //       "code": "xh"
 //     },
 //     {
 //       "language": "Yiddish",
 //       "code": "yi"
 //     },
 //     {
 //       "language": "Yoruba",
 //       "code": "yo"
 //     },
 //     {
 //       "language": "Zulu",
 //       "code": "zu"
 //     }
 //   ]
 //   const [inputValue, setInputValue] = useState('');
 //   const [welcomeApiMsg, setWelcomeApiMsg] = useState('');
 //   const [staticApiVideo, setStaticApiVideo] = useState('');
 //   const [welcomeApiVideo, setWelcomeApiVideo] = useState('');
 //   const [messages, setMessages] = useState([]);
 //   const [loading, setLoading] = useState(false);
 //   const [videoUrl, setVideoUrl] = useState('');
 //   const [audioToText, setAudioToText] = useState('');
 //   const [recording, setRecording] = useState(false);
 //   const [audioBlob, setAudioBlob] = useState(null);
 //   const [timer, setTimer] = useState(0);
 //   const [isSoundOn, setIsSoundOn] = useState(true);
 //   const [videoLoading, setVideoLoading] = useState(true);
 //   const [showChatBot, setShowChatBot] = useState(false);
 //   const [recordMessage, setRecordMessage] = useState(false);
 //   const [isApiCalled, setIsApiCalled] = useState(false);
 //   const videoRef = useRef(null);
 //   const mediaRecorderRef = useRef(null);
 //   const audioChunksRef = useRef([]);
 //   const timerRef = useRef(null);
 //   const chatHeadRef = useRef(null);
 //   const messagesEndRef = useRef(null); // Ref for the autoscroll
 //   const inputRef = useRef(null);
 //   const dropdownAvatarRef = useRef(null);
 //   const dropdownLanguageRef = useRef(null);
 //   const searchInputRef = useRef(null);
 //   const [showInitialText, setShowInitialText] = useState(true);
 //   const [recentBotIndex, setRecentBotIndex] = useState(null);
 //   const [showWelcomeMsg, setShowWelcomeMsg] = useState(false);
 //   const [checkAudio, setCheckAudio] = useState(false);
 //   const [showWelcomeVideo, setShowWelcomeVideo] = useState(true);
 //   const [showLanguages, setShowLanguages] = useState(false);
 //   const [searchTerm, setSearchTerm] = useState('');
 //   const [filteredLanguages, setFilteredLanguages] = useState(languages);
 //   const [showAvatar, setShowAvatar] = useState(false);
 //   const [selectedLanguage, setSelectedLanguage] = useState('English');
 //   const [languageCode, setLanguageCode] = useState('en');
 //   const [isAudioFinished, setIsAudioFinished] = useState(false);
 //   const [isAudioPlaying, setIsAudioPlaying] = useState(false);
 //   const [isRecordingTemp, setIsRecordingTemp] = useState(false);
 //   const [audioUrlTemp, setAudioUrlTemp] = useState(null);
 //   const [apiResponseTemp, setApiResponseTemp] = useState('');
 //   const mediaRecorderRefTemp = useRef(null);
 //   const recordedChunksRefTemp = useRef([]);
 //   const mediaStreamRefTemp = useRef(null);
 //   const audioRef = useRef(null);
 //   const audioConstraintsTemp = {
 //     audio: {
 //       sampleRate: 16000,
 //       channelCount: 1,
 //       echoCancellation: false,
 //       noiseSuppression: false,
 //       autoGainControl: false,
 //     },
 //   };
 //   // taking params from parent app and passing in iframe api
 //   // const [params, setParams] = useState({
 //   //   companyName: '',
 //   //   moduleName: '',
 //   //   avatarName: ''
 //   // });
 //   // useEffect(() => {
 //   //   const receiveMessage = (event) => {
 //   //     const { companyName, moduleName, avatarName } = event.data;
 //   //     setParams({ companyName, moduleName, avatarName });
 //   //   };
 //   //   window.addEventListener('message', receiveMessage, false);
 //   //   return () => {
 //   //     window.removeEventListener('message', receiveMessage);
 //   //   };
 //   // }, []);
 //   // taking params from iframe url only and passing in iframe api
 //   const params = useLocation();
 //   const pathSegments = params.pathname.split('/').filter(segment => segment);
 //   const companyName = pathSegments[pathSegments.length - 3];
 //   const moduleName = pathSegments[pathSegments.length - 2];
 //   const avatarName = pathSegments[pathSegments.length - 1];
 //   const avatarList = [
 //     { name: 'Natasha', image: 'image1.png' },
 //     // { name: 'Avatar2', image: 'image2.png' },
 //   ];
 //   const defaultAvatar = avatarList[0];
 //   const [selectedAvatar, setSelectedAvatar] = useState({
 //     name: defaultAvatar.name,
 //     image: defaultAvatar.image,
 //   });
 //   useEffect(() => {
 //     if (avatarName) {
 //       const foundAvatar = avatarList.find(avatar => avatar.name.toLowerCase() === avatarName.toLowerCase());
 //       if (foundAvatar) {
 //         setSelectedAvatar({
 //           name: foundAvatar.name,
 //           image: foundAvatar.image,
 //         });
 //       } else {
 //         setSelectedAvatar(defaultAvatar);
 //       }
 //     } else {
 //       setSelectedAvatar(defaultAvatar);
 //     }
 //   }, [avatarName]);
 //   useEffect(() => {
 //     const handleClickOutside = (event) => {
 //       if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) {
 //         setShowAvatar(false);
 //       }
 //     };
 //     if (showAvatar) {
 //       document.addEventListener('mousedown', handleClickOutside);
 //     }
 //     return () => {
 //       document.removeEventListener('mousedown', handleClickOutside);
 //     };
 //   }, [showAvatar]);
 //   const handleAvatarToggle = () => {
 //     setShowAvatar(!showAvatar);
 //   };
 //   const handleLanguageToggle = () => {
 //     setShowLanguages(!showLanguages);
 //     if (!showLanguages) {
 //       setFilteredLanguages(languages);
 //       setSearchTerm('');
 //     }
 //   };
 //   const handleLanguageSelect = (language) => {
 //     setSelectedLanguage(language.language);
 //     setSearchTerm('');
 //     setFilteredLanguages(languages);
 //     setShowLanguages(false);
 //     setLanguageCode(language.code)
 //   };
 //   const handleSearchChange = (event) => {
 //     setSearchTerm(event.target.value);
 //     const filtered = languages.filter((language) =>
 //       language.language.toLowerCase().includes(event.target.value.toLowerCase())
 //     );
 //     setFilteredLanguages(filtered);
 //   };
 //   useEffect(() => {
 //     if (showLanguages) {
 //       searchInputRef.current.focus();
 //     }
 //   }, [showLanguages]);
 //   useEffect(() => {
 //     const handleClickOutside = (event) => {
 //       if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) {
 //         setShowLanguages(false);
 //       }
 //     };
 //     if (showLanguages) {
 //       document.addEventListener('mousedown', handleClickOutside);
 //     }
 //     return () => {
 //       document.removeEventListener('mousedown', handleClickOutside);
 //     };
 //   }, [showLanguages]);
 //   const handleKeyDown = (event) => {
 //     if (event.key === 'Enter' && filteredLanguages.length > 0) {
 //       handleLanguageSelect(filteredLanguages[0]);
 //     }
 //   };
 //   const handleAvatarSelect = (avatar) => {
 //     setSelectedAvatar(avatar);
 //     setShowAvatar(false);
 //   };
 //   const handleWelcomeVideoEnd = () => {
 //     // This function can be customized for the welcome video if needed
 //     if (videoRef.current) {
 //       videoRef.current.pause(); // Pause the welcome video
 //       // You can decide whether to play a static video or do something else
 //       videoRef.current.src = staticApiVideo; // Set the source to the static video
 //       videoRef.current.muted = false; // Unmute if you want sound
 //       videoRef.current.play(); // Play the static video
 //     }
 //   };
 //   useEffect(() => {
 //     const showTimeout = setTimeout(() => {
 //       setShowWelcomeMsg(true);
 //     }, 1);
 //     const hideTimeout = setTimeout(() => {
 //       setShowWelcomeMsg(false);
 //     }, 3000);
 //     return () => {
 //       clearTimeout(showTimeout);
 //       clearTimeout(hideTimeout);
 //     };
 //   }, []);
 //   useEffect(() => {
 //     const callApiOnPageLoad = async () => {
 //       const payload = { user_input: 'hi' };
 //       try {
 //         const response = await fetch(
 //           `https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`,
 //           {
 //             method: 'POST',
 //             headers: {
 //               'Content-Type': 'application/json',
 //             },
 //             body: JSON.stringify(payload),
 //           }
 //         );
 //         if (response.ok) {
 //           const data = await response.json();
 //           setWelcomeApiMsg(data.responses[0])
 //           setStaticApiVideo(data.static_video)
 //           setWelcomeApiVideo(data.video_path)
 //         } else {
 //           console.error('API error:', response.statusText);
 //         }
 //       } catch (error) {
 //         console.error('Fetch error:', error);
 //       }
 //     };
 //     callApiOnPageLoad();
 //   }, [companyName, moduleName, selectedAvatar]);
 //   useEffect(() => {
 //     const latestBotIndex = messages
 //       .map((item, index) => (item.type === 'bot' ? index : null))
 //       .filter(index => index !== null)
 //       .pop();
 //     if (latestBotIndex !== null) {
 //       setRecentBotIndex(latestBotIndex);
 //       // const timer = setTimeout(() => {
 //       //   setShowInitialText(false);
 //       // }, 1300);
 //       setShowInitialText(true);
 //       // return () => clearTimeout(timer);
 //     }
 //   }, [messages]);
 //   const handleKeyPress = (event) => {
 //     if (event.key === 'Enter') {
 //       handleSendMessage();
 //     }
 //   };
 //   const handleSendMessage = async () => {
 //     setInputValue(''); // Clear the input field at the start
 //     if (inputValue.trim() || audioToText) {
 //       setLoading(true);
 //       setIsApiCalled(true);
 //       const userMessage = {
 //         message: audioToText || inputValue.trim() || '',
 //         type: 'user',
 //         audioUrl: audioToText,
 //         isActive: true,
 //       };
 //       setMessages((prevMessages) => [...prevMessages, userMessage]);
 //       const payload = {
 //         user_input: audioToText ? audioToText : inputValue.trim() || '',
 //         lang: languageCode,
 //         companyName: companyName,
 //         moduleName: moduleName,
 //         avatarName: selectedAvatar.name,
 //       };
 //       if (messagesEndRef.current) {
 //         messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
 //       }
 //       try {
 //         const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
 //           method: 'POST',
 //           headers: {
 //             'Content-Type': 'application/json',
 //           },
 //           body: JSON.stringify(payload),
 //         });
 //         const data = await response.json();
 //         setAudioToText(''); // Reset audio to text input
 //         setAudioBlob(null); // Clear audio blob
 //         setTimer(0); // Reset timer
 //         handleResponse(data); // Call handleResponse to play audio and video
 //         if (messagesEndRef.current) {
 //           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
 //         }
 //       } catch (error) {
 //         console.error('Error:', error);
 //       } finally {
 //         setLoading(false); // Reset loading state
 //       }
 //     }
 //   };
 //   // const handleResponse = (data) => {
 //   //   // Check if there are bot responses
 //   //   if (data.responses && data.responses.length > 0) {
 //   //     const botMessage = data.responses.join(' ');
 //   //     setMessages((prevMessages) => [
 //   //       ...prevMessages,
 //   //       {
 //   //         message: botMessage,
 //   //         type: 'bot',
 //   //       },
 //   //     ]);
 //   //   } else {
 //   //     setMessages((prevMessages) => [
 //   //       ...prevMessages,
 //   //       {
 //   //         message: "Could you please repeat?",
 //   //         type: 'bot',
 //   //       },
 //   //     ]);
 //   //   }
 //   //   // Check if there is a video path in the response
 //   //   if (data.video_path) {
 //   //     const fullVideoUrl = data.video_path;
 //   //     setVideoUrl(fullVideoUrl);
 //   //     // If there is audio data in base64 format, handle the audio
 //   //     if (data.audio_data) {
 //   //       // Convert the base64 audio data to a Blob
 //   //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
 //   //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
 //   //       // Create audio and video elements
 //   //       const videoElement = document.createElement('video');
 //   //       videoElement.src = fullVideoUrl;
 //   //       videoElement.controls = true;
 //   //       videoElement.autoplay = true;
 //   //       videoElement.muted = true; // Mute the video to avoid overlapping sound
 //   //       const audioElement = document.createElement('audio');
 //   //       audioElement.src = audioUrl;
 //   //       audioElement.autoplay = true;
 //   //       // const audioElement = new Audio(audioUrl);
 //   //     audioRef.current = audioElement; 
 //   //       // Sync the audio and video playback
 //   //       videoElement.addEventListener('play', () => {
 //   //         audioElement.play();
 //   //       });
 //   //       videoElement.addEventListener('pause', () => {
 //   //         audioElement.pause();
 //   //       });
 //   //       // Append the video element to a container (assuming there is a container for the video)
 //   //       const videoContainer = document.getElementById('video-container');
 //   //       videoContainer.innerHTML = ''; // Clear any previous video
 //   //       videoContainer.appendChild(videoElement);
 //   //     } else {
 //   //       console.log('No audio data received.');
 //   //     }
 //   //   } else {
 //   //     setVideoUrl(''); // Clear the video if no path is provided
 //   //   }
 //   // };
 //   // Utility function to convert base64 to Blob
 //   const handleResponse = (data) => {
 //     if (data.responses && data.responses.length > 0) {
 //       const botMessage = data.responses.join(' ');
 //       setMessages((prevMessages) => [
 //         ...prevMessages,
 //         {
 //           message: botMessage,
 //           type: 'bot',
 //         },
 //       ]);
 //     } else {
 //       setMessages((prevMessages) => [
 //         ...prevMessages,
 //         {
 //           message: "Could you please repeat?",
 //           type: 'bot',
 //         },
 //       ]);
 //     }
 //     if (data.video_path) {
 //       const fullVideoUrl = data.video_path;
 //       setVideoUrl(fullVideoUrl);
 //       if (data.audio_data) {
 //         if (audioRef.current) {
 //           audioRef.current.pause();
 //           audioRef.current.currentTime = 0; // Reset previous audio
 //         }
 //         const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3');
 //         const audioUrl = URL.createObjectURL(audioBlob);
 //         const audioElement = new Audio(audioUrl);
 //         audioRef.current = audioElement;
 //         audioElement.play();
 //         if (videoRef.current) {
 //           videoRef.current.src = fullVideoUrl;
 //           videoRef.current.muted = true; // Always mute video
 //           videoRef.current.play();
 //           videoRef.current.removeEventListener('ended', handleVideoEnd);
 //           const handleVideoEnd = () => {
 //             audioElement.pause(); // Pause audio
 //             audioElement.currentTime = 0; // Reset audio
 //             playStaticVideo(); // Play static video
 //           };
 //           videoRef.current.addEventListener('ended', handleVideoEnd);
 //         }
 //         // Ensure that audio plays when the sound is turned on
 //         audioElement.addEventListener('ended', () => {
 //           if (videoRef.current) {
 //             videoRef.current.pause();
 //             playStaticVideo();
 //           }
 //         });
 //       } else {
 //         console.log('No audio data received.');
 //       }
 //     } else {
 //       setVideoUrl(''); // Clear video if no path provided
 //     }
 //   };
 //   // Function to play the static video
 //   const playStaticVideo = () => {
 //     if (videoRef.current) {
 //       videoRef.current.src = staticApiVideo; // Set the source to the static video
 //       videoRef.current.muted = false; // Unmute if you want sound with the static video
 //       videoRef.current.play(); // Start playing the static video
 //     }
 //   };
 //   const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
 //     const byteCharacters = atob(base64Data);
 //     const byteArrays = [];
 //     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
 //       const slice = byteCharacters.slice(offset, offset + sliceSize);
 //       const byteNumbers = new Array(slice.length);
 //       for (let i = 0; i < slice.length; i++) {
 //         byteNumbers[i] = slice.charCodeAt(i);
 //       }
 //       const byteArray = new Uint8Array(byteNumbers);
 //       byteArrays.push(byteArray);
 //     }
 //     return new Blob(byteArrays, { type: contentType });
 //   };
 //   useEffect(() => {
 //     if (videoUrl) {
 //       setVideoLoading(true);
 //       const video = videoRef.current;
 //       if (video) {
 //         video.onloadeddata = () => {
 //           setVideoLoading(false);
 //           video.onended = () => {
 //             setVideoUrl('');
 //           };
 //         };
 //       }
 //     }
 //   }, [videoUrl]);
 //   // useEffect(() => {
 //   //   if (!loading && !recording) {
 //   //     inputRef.current?.focus();
 //   //   }
 //   //   if (showWelcomeVideo) {
 //   //     inputRef.current?.focus();
 //   //   }
 //   // }, [loading, recording, inputValue, messages]);
 //   // recording check 
 //   // const startRecording = async () => {
 //   //   setRecording(true);
 //   //   setRecordMessage(false)
 //   //   setTimer(0);
 //   //   audioChunksRef.current = [];
 //   //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
 //   //   mediaRecorderRef.current = new MediaRecorder(stream);
 //   //   mediaRecorderRef.current.ondataavailable = (event) => {
 //   //     if (event.data.size > 0) {
 //   //       audioChunksRef.current.push(event.data);
 //   //     }
 //   //   };
 //   //   mediaRecorderRef.current.onstop = () => {
 //   //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
 //   //     setAudioBlob(blob);
 //   //   };
 //   //   mediaRecorderRef.current.start();
 //   //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
 //   // };
 //   // const stopRecording = () => {
 //   //   setRecordMessage(true)
 //   //   setRecording(false);
 //   //   if (mediaRecorderRef.current) {
 //   //     mediaRecorderRef.current.stop();
 //   //   }
 //   //   clearInterval(timerRef.current);
 //   // };
 //   useEffect(() => {
 //     if (audioBlob) {
 //       sendAudioToApi(audioBlob);
 //     }
 //   }, [audioBlob]);
 //   useEffect(() => {
 //     const timer = setTimeout(() => {
 //       setRecordMessage(false);
 //     }, 3000);
 //     return () => clearTimeout(timer);
 //   }, [recordMessage]);
 //   // const sendAudioToApi = async (blob) => {
 //   //   try {
 //   //     const base64Audio = await convertBlobToBase64(blob);
 //   //     const fileExtension = blob.type.split('/')[1];
 //   //     const formData = new FormData();
 //   //     formData.append('audio_file', base64Audio.split(',')[1]);
 //   //     formData.append('file_extension', fileExtension);
 //   //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
 //   //       method: 'POST',
 //   //       body: formData
 //   //     });
 //   //     const data = await response.json();
 //   //     setAudioToText(data.response)
 //   //     if (data.response.length > 0) {
 //   //       setCheckAudio(false)
 //   //     }
 //   //     // if (data.response) {
 //   //     //   setTimeout(() => {
 //   //     //     setRecordMessage(false)
 //   //     //     }, 880);
 //   //     //   // }, 6200);
 //   //     // }
 //   //   } catch (error) {
 //   //     console.error('Error sending audio:', error);
 //   //   }
 //   //   finally {
 //   //     setCheckAudio(true)
 //   //   }
 //   // };
 //   const convertBlobToBase64 = (blob) => {
 //     return new Promise((resolve, reject) => {
 //       const reader = new FileReader();
 //       reader.onloadend = () => resolve(reader.result);
 //       reader.onerror = reject;
 //       reader.readAsDataURL(blob);
 //     });
 //   };
 //   useEffect(() => {
 //     if (videoRef.current) {
 //       setVideoLoading(true);
 //       videoRef.current.load();
 //       videoRef.current.play().finally(() => {
 //         setVideoLoading(false);
 //       });
 //     }
 //   }, [videoUrl]);
 //   const toggleSound = () => {
 //     if (audioRef.current) {
 //       audioRef.current.muted = isSoundOn;
 //       setIsSoundOn(!isSoundOn);
 //     }
 //   };
 //   // const toggleSound = () => {
 //   //   setIsSoundOn((prev) => {
 //   //     const newSoundState = !prev; 
 //   //     if (newSoundState && audioRef.current) {
 //   //       audioRef.current.play(); 
 //   //     } 
 //   //     else {
 //   //       if (audioRef.current) {
 //   //         audioRef.current.pause();
 //   //         audioRef.current.currentTime = 0; 
 //   //       }
 //   //     }
 //   //     return newSoundState; // Update sound state
 //   //   });
 //   // };
 //   const handleChatBotOpen = () => {
 //     setShowChatBot(!showChatBot);
 //   };
 //   useEffect(() => {
 //     setShowChatBot(true);
 //   }, []);
 //   useEffect(() => {
 //     handleSendMessage()
 //   }, [audioToText])
 //   const handleVideoEnd = () => {
 //     // This function is called when the main API video ends
 //     if (videoRef.current) {
 //       videoRef.current.pause(); // Pause the current video
 //       videoRef.current.src = staticApiVideo; // Set the source to the static video
 //       videoRef.current.muted = false; // Unmute if you want sound
 //       videoRef.current.play(); // Play the static video
 //     }
 //   };
 //   useEffect(() => {
 //     if (messagesEndRef.current) {
 //       setTimeout(() => {
 //         if (messagesEndRef.current) {
 //           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
 //         }
 //       }, 500);
 //     }
 //   }, [messages, showChatBot]);
 //   // audio functionality for android
 //   // const sendAudioToApi = async () => {
 //   //   if (!isRecordingTemp) {
 //   //     try {
 //   //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
 //   //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
 //   //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
 //   //         if (event.data.size > 0) {
 //   //           recordedChunksRefTemp.current.push(event.data);
 //   //         }
 //   //       };
 //   //       mediaRecorderRefTemp.current.onstop = async () => {
 //   //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
 //   //         recordedChunksRefTemp.current = [];
 //   //         // Convert blob to Base64
 //   //         const readerTemp = new FileReader();
 //   //         readerTemp.readAsDataURL(blobTemp);
 //   //         readerTemp.onloadend = async () => {
 //   //           const base64AudioTemp = readerTemp.result.split(',')[1];
 //   //           // Display audio for playback
 //   //           const audioUrlTemp = URL.createObjectURL(blobTemp);
 //   //           setAudioUrlTemp(audioUrlTemp);
 //   //           // Prepare the form data
 //   //           const formDataTemp = new FormData();
 //   //           formDataTemp.append('audio_file', base64AudioTemp);
 //   //           formDataTemp.append('file_extension', 'webm');
 //   //           // Call the API
 //   //           try {
 //   //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
 //   //               method: 'POST',
 //   //               body: formDataTemp,
 //   //             });
 //   //             const resultTemp = await responseTemp.json();
 //   //             console.log('pppppppppppp', resultTemp.response);
 //   //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
 //   //             setAudioToText(resultTemp.response)
 //   //             if (resultTemp.response.length > 0) {
 //   //               setCheckAudio(false)
 //   //             }
 //   //           } catch (error) {
 //   //             console.error('Error calling the API:', error);
 //   //             setApiResponseTemp(`Error: ${error.message}`);
 //   //           }
 //   //         };
 //   //       };
 //   //       mediaRecorderRefTemp.current.start();
 //   //       setIsRecordingTemp(true);
 //   //     } catch (error) {
 //   //       console.error('Error accessing microphone: ', error);
 //   //     }
 //   //   } else {
 //   //     // Stop the recording
 //   //     mediaRecorderRefTemp.current.stop();
 //   //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
 //   //     setIsRecordingTemp(false);
 //   //   }
 //   // };
 //   // audio functionality for ios 
 //   const sendAudioToApi = async () => {
 //     if (!isRecordingTemp) {
 //       try {
 //         mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
 //         // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
 //         const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
 //         mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
 //         mediaRecorderRefTemp.current.ondataavailable = (event) => {
 //           if (event.data.size > 0) {
 //             recordedChunksRefTemp.current.push(event.data);
 //           }
 //         };
 //         mediaRecorderRefTemp.current.onstop = async () => {
 //           const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
 //           recordedChunksRefTemp.current = [];
 //           // Convert blob to Base64
 //           const readerTemp = new FileReader();
 //           readerTemp.readAsDataURL(blobTemp);
 //           readerTemp.onloadend = async () => {
 //             const base64AudioTemp = readerTemp.result.split(',')[1];
 //             // Display audio for playback
 //             const audioUrlTemp = URL.createObjectURL(blobTemp);
 //             setAudioUrlTemp(audioUrlTemp);
 //             // Prepare the form data
 //             const formDataTemp = new FormData();
 //             formDataTemp.append('audio_file', base64AudioTemp);
 //             formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
 //             // Call the API
 //             try {
 //               const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
 //                 method: 'POST',
 //                 body: formDataTemp,
 //               });
 //               const resultTemp = await responseTemp.json();
 //               console.log('API Response:', resultTemp.response);
 //               setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
 //               setAudioToText(resultTemp.response);
 //               if (resultTemp.response.length > 0) {
 //                 setCheckAudio(false);
 //               }
 //             } catch (error) {
 //               console.error('Error calling the API:', error);
 //               setApiResponseTemp(`Error: ${error.message}`);
 //             }
 //           };
 //         };
 //         mediaRecorderRefTemp.current.start();
 //         setIsRecordingTemp(true);
 //       } catch (error) {
 //         console.error('Error accessing microphone: ', error);
 //       }
 //     } else {
 //       // Stop the recording
 //       mediaRecorderRefTemp.current.stop();
 //       mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
 //       setIsRecordingTemp(false);
 //     }
 //   };
 //   // Helper function to check if the user is on iOS
 //   const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
 //   const handleInputSearch = (e) => {
 //     e.stopPropagation()
 //   }
 //   return (
 //     <>
 //       {
 //         !showChatBot ?
 //           <div className="videochartvalue ">
 //             <div className='container'>
 //               <div className='headAndOutput'>
 //                 <div className='chatHead'>
 //                   <div className='headIcontext'>
 //                     <div className='group-2'></div>
 //                     <div className='iconHeadChat'>
 //                       <img src="/img/chatAvatarIcon3.png" alt="Avatar" />
 //                       <div className='headTextClass'>
 //                         <div className="text-wrapper miniHead">Chat with</div>
 //                         <div className="text-wrapper-2">AI Assistant</div>
 //                       </div>
 //                     </div>
 //                   </div>
 //                   <div className='headMinClose'>
 //                     <div className='languagesDivBoth'>
 //                       <div className='languagesDiv' onClick={handleAvatarToggle} ref={dropdownAvatarRef} >
 //                         <div className='avatarNameImgClass'>
 //                           {selectedAvatar.name}
 //                         </div>
 //                         <span className={`arrow ${showAvatar ? 'open' : ''}`}>
 //                           <img src={arrowDown} alt="" className='downArrowClass' />
 //                         </span>
 //                         {showAvatar && (
 //                           <ul className='languageDropdown'>
 //                             {avatarList
 //                               .filter(avatar => avatar !== selectedAvatar)
 //                               .map((avatar, index) => (
 //                                 <li key={index} onClick={() => handleAvatarSelect(avatar)} className='avatarNameImgClass'>
 //                                   {avatar.name}
 //                                 </li>
 //                               ))}
 //                           </ul>
 //                         )}
 //                       </div>
 //                       <div ref={dropdownLanguageRef} className='languagesDiv' onClick={handleLanguageToggle}>
 //                         {selectedLanguage}
 //                         <span className={`arrow ${showLanguages ? 'open' : ''}`}>
 //                           <img src={arrowDown} alt="" className='downArrowClass' />
 //                         </span>
 //                         {showLanguages && (
 //                           <ul className='languageDropdown'>
 //                             <input
 //                               ref={searchInputRef}
 //                               type="text"
 //                               value={searchTerm}
 //                               onChange={handleSearchChange}
 //                               onKeyDown={handleKeyDown}
 //                               onClick={handleInputSearch}
 //                               placeholder="Search"
 //                               className='searchLanguageInput'
 //                             />
 //                           </ul>
 //                         )}
 //                         {showLanguages && (
 //                           <ul className='languageDropdown languageSearchDropdown'>
 //                             {filteredLanguages.map((language, index) => (
 //                               <li key={index} onClick={() => handleLanguageSelect(language)} className='languageOption'>
 //                                 <p>
 //                                   {language.language}
 //                                 </p>
 //                               </li>
 //                             ))}
 //                           </ul>
 //                         )}
 //                       </div>
 //                     </div>
 //                     <div className=' speakerIconButton' >
 //                       {/* <button > */}
 //                       {isSoundOn ? <img src={chatSoundIconWhite} alt="Sound On" onClick={toggleSound} /> : <img src={chatSpeakerMuteIcon} alt="Sound Off" onClick={toggleSound} />}
 //                       {/* </button> */}
 //                       {/* <img src="/img/minimizeChatWhite.png" alt="Line" onClick={handleChatBotOpen} /> */}
 //                       <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={handleChatBotOpen} />
 //                     </div>
 //                   </div>
 //                 </div>
 //                 <div id="output-container">
 //                   <div className="messages-container">
 //                     {
 //                       showWelcomeMsg ?
 //                         <div className='message-item receiver'>
 //                           <div className='senderIconText'>
 //                             <div className='message'>
 //                               <div className="chat-bubble">
 //                                 <div className="typing">
 //                                   <div className="dot"></div>
 //                                   <div className="dot"></div>
 //                                   <div className="dot"></div>
 //                                 </div>
 //                               </div>
 //                             </div>
 //                             <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
 //                           </div>
 //                         </div>
 //                         :
 //                         <div className='receiverIconText'>
 //                           <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
 //                           <div className="success-status">
 //                             {welcomeApiMsg}
 //                           </div>
 //                         </div>
 //                     }
 //                     {messages.map((item, index) => (
 //                       <div key={index} className={`message-item ${item.type === 'user' ? 'sender' : 'receiver'}`}>
 //                         <div className='senderIconText'>
 //                           <div className="message">
 //                             {
 //                               item.audioUrl ?
 //                                 recordMessage && index === recentBotIndex ? (
 //                                   <div className="chat-bubble-audio">
 //                                     <div className="typing">
 //                                       <div className="dot"></div>
 //                                       <div className="dot"></div>
 //                                       <div className="dot"></div>
 //                                     </div>
 //                                   </div>
 //                                 )
 //                                   : (
 //                                     <p>{item.audioUrl}</p>
 //                                   )
 //                                 :
 //                                 //  (
 //                                 //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
 //                                 //     <div className="chat-bubble">
 //                                 //       <div className="typing">
 //                                 //         <div className="dot"></div>
 //                                 //         <div className="dot"></div>
 //                                 //         <div className="dot"></div>
 //                                 //       </div>
 //                                 //     </div>
 //                                 //   ) : (
 //                                 //     <p>{item.message}</p>
 //                                 //   )
 //                                 // )
 //                                 <p>{item.message}</p>
 //                             }
 //                           </div>
 //                           {item.type === 'user' && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
 //                           {item.type === 'bot' && <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />}
 //                         </div>
 //                         <div ref={messagesEndRef} /> {/* Auto-scroll target */}
 //                       </div>
 //                     ))}
 //                     {/* {recordMessage ?
 //                     <div className="senderIconText">
 //                       <div className="message">
 //                         <div className="typing">
 //                           <div className="dot"></div>
 //                           <div className="dot"></div>
 //                           <div className="dot"></div>
 //                         </div>
 //                       </div>
 //                       <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />
 //                     </div>
 //                     : ""} */}
 //                     <div ref={messagesEndRef} />
 //                   </div>
 //                   <div className="hello-container" >
 //                     {showWelcomeVideo && welcomeApiVideo ? (
 //                       <video
 //                         ref={videoRef}
 //                         width="100%"
 //                         autoPlay
 //                         onEnded={handleWelcomeVideoEnd}
 //                         playsInline
 //                       >
 //                         <source src={welcomeApiVideo} type="video/mp4" />
 //                         Your browser does not support the video tag.
 //                       </video>
 //                     ) : (
 //                       <div>
 //                         {!isApiCalled || !videoUrl ? (
 //                           <video
 //                             ref={videoRef}
 //                             width="100%"
 //                             autoPlay
 //                             loop
 //                             muted
 //                             playsInline
 //                           >
 //                             <source src={staticApiVideo} type="video/mp4" />
 //                             Your browser does not support the video tag.
 //                           </video>
 //                         ) : (
 //                           <video
 //                             ref={videoRef}
 //                             width="100%"
 //                             autoPlay
 //                             onEnded={handleVideoEnd}
 //                             muted
 //                             playsInline
 //                           >
 //                             <source
 //                               src={videoUrl}
 //                               type="video/mp4" />
 //                             Your browser does not support the video tag.
 //                           </video>
 //                         )}
 //                       </div>
 //                     )}
 //                     {/* <video
 //                       ref={videoRef}
 //                       width="100%"
 //                       height="auto"
 //                       autoPlay
 //                       muted={!isSoundOn} 
 //                       loop={!showWelcomeVideo && (!isApiCalled || !videoUrl)}
 //                       onEnded={showWelcomeVideo && welcomeApiVideo ? handleWelcomeVideoEnd : handleVideoEnd}
 //                       playsInline
 //                     >
 //                       <source
 //                         src={
 //                           showWelcomeVideo && welcomeApiVideo
 //                             ? welcomeApiVideo
 //                             : !isApiCalled || !videoUrl
 //                               ? staticApiVideo
 //                               : videoUrl
 //                         }
 //                         type="video/mp4"
 //                       />
 //                       Your browser does not support the video tag.
 //                     </video> */}
 //                   </div>
 //                 </div>
 //               </div>
 //               <div className='outputHelpfulClass'>
 //                 <div className="input-container">
 //                   <input
 //                     type="text"
 //                     value={inputValue}
 //                     onChange={(e) => setInputValue(e.target.value)}
 //                     onKeyPress={handleKeyPress}
 //                     placeholder="Enter your message"
 //                     disabled={loading || recording}
 //                     ref={inputRef}
 //                   />
 //                   {/* {recording ? ( */}
 //                   {isRecordingTemp ? (
 //                     <div className="recording-indicator">
 //                       <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
 //                         <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
 //                       </div>
 //                     </div>
 //                   ) : (
 //                     <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
 //                       <img src="/img/chatMicIcon.png" alt="Mic" />
 //                     </div>
 //                   )}
 //                   <div className='iconButton' onClick={handleSendMessage} disabled={loading || recording}>
 //                     <img src="/img/chatSendIcon.png" alt="Send" />
 //                   </div>
 //                 </div>
 //               </div>
 //             </div>
 //           </div>
 //           :
 //           <div className='chatBoxImageClass' >
 //             <img src={chatBoxImage} alt="" onClick={handleChatBotOpen} />
 //           </div>
 //       }
 //     </>
 //   );
 // };
 // export default MessageInput;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","emoji-picker-react":"4s16w","./frameNew.css":"iQA0X","../../../static/img/chatBoxImageCrop1.png":"gBFnl","../../../static/img/arrowDownConvert.png":"gulDC","../../../static/img/chatSoundSpeaker.png":"1uqOf","../../../static/img/chatMuteSpeaker.png":"9MSx0","react-router-dom":"l6ORY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4s16w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Categories", ()=>Categories);
parcelHelpers.export(exports, "Emoji", ()=>ExportedEmoji);
parcelHelpers.export(exports, "EmojiStyle", ()=>EmojiStyle);
parcelHelpers.export(exports, "SkinTonePickerLocation", ()=>SkinTonePickerLocation);
parcelHelpers.export(exports, "SkinTones", ()=>SkinTones);
parcelHelpers.export(exports, "SuggestionMode", ()=>SuggestionMode);
parcelHelpers.export(exports, "Theme", ()=>Theme);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flairup = require("flairup");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var ClassNames;
(function(ClassNames) {
    ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
    ClassNames["searchActive"] = "epr-search-active";
    ClassNames["hidden"] = "epr-hidden";
    ClassNames["visible"] = "epr-visible";
    ClassNames["active"] = "epr-active";
    ClassNames["emoji"] = "epr-emoji";
    ClassNames["category"] = "epr-emoji-category";
    ClassNames["label"] = "epr-emoji-category-label";
    ClassNames["categoryContent"] = "epr-emoji-category-content";
    ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
    ClassNames["scrollBody"] = "epr-body";
    ClassNames["emojiList"] = "epr-emoji-list";
    ClassNames["external"] = "__EmojiPicker__";
    ClassNames["emojiPicker"] = "EmojiPickerReact";
    ClassNames["open"] = "epr-open";
    ClassNames["vertical"] = "epr-vertical";
    ClassNames["horizontal"] = "epr-horizontal";
    ClassNames["variationPicker"] = "epr-emoji-variation-picker";
    ClassNames["darkTheme"] = "epr-dark-theme";
    ClassNames["autoTheme"] = "epr-auto-theme";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.map(function(c) {
        return "." + c;
    }).join("");
}
var stylesheet = /*#__PURE__*/ (0, _flairup.createSheet)("epr", null);
var hidden = {
    display: "none",
    opacity: "0",
    pointerEvents: "none",
    visibility: "hidden",
    overflow: "hidden"
};
var commonStyles = /*#__PURE__*/ stylesheet.create({
    hidden: /*#__PURE__*/ _extends({
        ".": ClassNames.hidden
    }, hidden)
});
var PickerStyleTag = /*#__PURE__*/ (0, _react.memo)(function PickerStyleTag() {
    return (0, _react.createElement)("style", {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: stylesheet.getStyle()
        }
    });
});
var commonInteractionStyles = /*#__PURE__*/ stylesheet.create({
    ".epr-main": {
        ":has(input:not(:placeholder-shown))": {
            categoryBtn: {
                ":hover": {
                    opacity: "1",
                    backgroundPositionY: "var(--epr-category-navigation-button-size)"
                }
            },
            hiddenOnSearch: /*#__PURE__*/ _extends({
                ".": ClassNames.hiddenOnSearch
            }, hidden)
        },
        ":has(input(:placeholder-shown))": {
            visibleOnSearchOnly: hidden
        }
    },
    hiddenOnReactions: {
        transition: "all 0.5s ease-in-out"
    },
    ".epr-reactions": {
        hiddenOnReactions: {
            height: "0px",
            width: "0px",
            opacity: "0",
            pointerEvents: "none",
            overflow: "hidden"
        }
    },
    ".EmojiPickerReact:not(.epr-search-active)": {
        categoryBtn: {
            ":hover": {
                opacity: "1",
                backgroundPositionY: "var(--epr-category-navigation-button-size)"
            },
            "&.epr-active": {
                opacity: "1",
                backgroundPositionY: "var(--epr-category-navigation-button-size)"
            }
        },
        visibleOnSearchOnly: /*#__PURE__*/ _extends({
            ".": "epr-visible-on-search-only"
        }, hidden)
    }
});
function darkMode(key, value) {
    var _eprDarkTheme, _eprAutoTheme;
    return {
        ".epr-dark-theme": (_eprDarkTheme = {}, _eprDarkTheme[key] = value, _eprDarkTheme),
        ".epr-auto-theme": (_eprAutoTheme = {}, _eprAutoTheme[key] = {
            "@media (prefers-color-scheme: dark)": value
        }, _eprAutoTheme)
    };
}
// eslint-disable-next-line complexity
function compareConfig(prev, next) {
    var _prev$customEmojis, _next$customEmojis;
    var prevCustomEmojis = (_prev$customEmojis = prev.customEmojis) != null ? _prev$customEmojis : [];
    var nextCustomEmojis = (_next$customEmojis = next.customEmojis) != null ? _next$customEmojis : [];
    return prev.open === next.open && prev.emojiVersion === next.emojiVersion && prev.reactionsDefaultOpen === next.reactionsDefaultOpen && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.className === next.className && prev.height === next.height && prev.width === next.width && prev.style === next.style && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation && prevCustomEmojis.length === nextCustomEmojis.length;
}
var DEFAULT_REACTIONS = [
    "1f44d",
    "2764-fe0f",
    "1f603",
    "1f622",
    "1f64f",
    "1f44e",
    "1f621" // 😡
];
var SuggestionMode;
(function(SuggestionMode) {
    SuggestionMode["RECENT"] = "recent";
    SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function(EmojiStyle) {
    EmojiStyle["NATIVE"] = "native";
    EmojiStyle["APPLE"] = "apple";
    EmojiStyle["TWITTER"] = "twitter";
    EmojiStyle["GOOGLE"] = "google";
    EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function(Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
    Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function(SkinTones) {
    SkinTones["NEUTRAL"] = "neutral";
    SkinTones["LIGHT"] = "1f3fb";
    SkinTones["MEDIUM_LIGHT"] = "1f3fc";
    SkinTones["MEDIUM"] = "1f3fd";
    SkinTones["MEDIUM_DARK"] = "1f3fe";
    SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function(Categories) {
    Categories["SUGGESTED"] = "suggested";
    Categories["CUSTOM"] = "custom";
    Categories["SMILEYS_PEOPLE"] = "smileys_people";
    Categories["ANIMALS_NATURE"] = "animals_nature";
    Categories["FOOD_DRINK"] = "food_drink";
    Categories["TRAVEL_PLACES"] = "travel_places";
    Categories["ACTIVITIES"] = "activities";
    Categories["OBJECTS"] = "objects";
    Categories["SYMBOLS"] = "symbols";
    Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function(SkinTonePickerLocation) {
    SkinTonePickerLocation["SEARCH"] = "SEARCH";
    SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));
var _configByCategory;
var categoriesOrdered = [
    Categories.SUGGESTED,
    Categories.CUSTOM,
    Categories.SMILEYS_PEOPLE,
    Categories.ANIMALS_NATURE,
    Categories.FOOD_DRINK,
    Categories.TRAVEL_PLACES,
    Categories.ACTIVITIES,
    Categories.OBJECTS,
    Categories.SYMBOLS,
    Categories.FLAGS
];
var SuggestedRecent = {
    name: "Recently Used",
    category: Categories.SUGGESTED
};
var configByCategory = (_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
    category: Categories.SUGGESTED,
    name: "Frequently Used"
}, _configByCategory[Categories.CUSTOM] = {
    category: Categories.CUSTOM,
    name: "Custom Emojis"
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
    category: Categories.SMILEYS_PEOPLE,
    name: "Smileys & People"
}, _configByCategory[Categories.ANIMALS_NATURE] = {
    category: Categories.ANIMALS_NATURE,
    name: "Animals & Nature"
}, _configByCategory[Categories.FOOD_DRINK] = {
    category: Categories.FOOD_DRINK,
    name: "Food & Drink"
}, _configByCategory[Categories.TRAVEL_PLACES] = {
    category: Categories.TRAVEL_PLACES,
    name: "Travel & Places"
}, _configByCategory[Categories.ACTIVITIES] = {
    category: Categories.ACTIVITIES,
    name: "Activities"
}, _configByCategory[Categories.OBJECTS] = {
    category: Categories.OBJECTS,
    name: "Objects"
}, _configByCategory[Categories.SYMBOLS] = {
    category: Categories.SYMBOLS,
    name: "Symbols"
}, _configByCategory[Categories.FLAGS] = {
    category: Categories.FLAGS,
    name: "Flags"
}, _configByCategory);
function baseCategoriesConfig(modifiers) {
    return categoriesOrdered.map(function(category) {
        return _extends({}, configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
    });
}
function categoryFromCategoryConfig(category) {
    return category.category;
}
function categoryNameFromCategoryConfig(category) {
    return category.name;
}
function mergeCategoriesConfig(userCategoriesConfig, modifiers) {
    var _userCategoriesConfig;
    if (userCategoriesConfig === void 0) userCategoriesConfig = [];
    if (modifiers === void 0) modifiers = {};
    var extra = {};
    if (modifiers.suggestionMode === SuggestionMode.RECENT) extra[Categories.SUGGESTED] = SuggestedRecent;
    var base = baseCategoriesConfig(extra);
    if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) return base;
    return userCategoriesConfig.map(function(category) {
        if (typeof category === "string") return getBaseConfigByCategory(category, extra[category]);
        return _extends({}, getBaseConfigByCategory(category.category, extra[category.category]), category);
    });
}
function getBaseConfigByCategory(category, modifier) {
    if (modifier === void 0) modifier = {};
    return Object.assign(configByCategory[category], modifier);
}
var CDN_URL_APPLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/";
var CDN_URL_FACEBOOK = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/";
var CDN_URL_TWITTER = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/";
var CDN_URL_GOOGLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function cdnUrl(emojiStyle) {
    switch(emojiStyle){
        case EmojiStyle.TWITTER:
            return CDN_URL_TWITTER;
        case EmojiStyle.GOOGLE:
            return CDN_URL_GOOGLE;
        case EmojiStyle.FACEBOOK:
            return CDN_URL_FACEBOOK;
        case EmojiStyle.APPLE:
        default:
            return CDN_URL_APPLE;
    }
}
var custom = [];
var smileys_people = [
    {
        n: [
            "grinning",
            "grinning face"
        ],
        u: "1f600",
        a: "1.0"
    },
    {
        n: [
            "smiley",
            "smiling face with open mouth"
        ],
        u: "1f603",
        a: "0.6"
    },
    {
        n: [
            "smile",
            "smiling face with open mouth and smiling eyes"
        ],
        u: "1f604",
        a: "0.6"
    },
    {
        n: [
            "grin",
            "grinning face with smiling eyes"
        ],
        u: "1f601",
        a: "0.6"
    },
    {
        n: [
            "laughing",
            "satisfied",
            "smiling face with open mouth and tightly-closed eyes"
        ],
        u: "1f606",
        a: "0.6"
    },
    {
        n: [
            "sweat smile",
            "smiling face with open mouth and cold sweat"
        ],
        u: "1f605",
        a: "0.6"
    },
    {
        n: [
            "rolling on the floor laughing"
        ],
        u: "1f923",
        a: "3.0"
    },
    {
        n: [
            "joy",
            "face with tears of joy"
        ],
        u: "1f602",
        a: "0.6"
    },
    {
        n: [
            "slightly smiling face"
        ],
        u: "1f642",
        a: "1.0"
    },
    {
        n: [
            "upside-down face",
            "upside down face"
        ],
        u: "1f643",
        a: "1.0"
    },
    {
        n: [
            "melting face"
        ],
        u: "1fae0",
        a: "14.0"
    },
    {
        n: [
            "wink",
            "winking face"
        ],
        u: "1f609",
        a: "0.6"
    },
    {
        n: [
            "blush",
            "smiling face with smiling eyes"
        ],
        u: "1f60a",
        a: "0.6"
    },
    {
        n: [
            "innocent",
            "smiling face with halo"
        ],
        u: "1f607",
        a: "1.0"
    },
    {
        n: [
            "smiling face with 3 hearts",
            "smiling face with smiling eyes and three hearts"
        ],
        u: "1f970",
        a: "11.0"
    },
    {
        n: [
            "heart eyes",
            "smiling face with heart-shaped eyes"
        ],
        u: "1f60d",
        a: "0.6"
    },
    {
        n: [
            "star-struck",
            "grinning face with star eyes"
        ],
        u: "1f929",
        a: "5.0"
    },
    {
        n: [
            "kissing heart",
            "face throwing a kiss"
        ],
        u: "1f618",
        a: "0.6"
    },
    {
        n: [
            "kissing",
            "kissing face"
        ],
        u: "1f617",
        a: "1.0"
    },
    {
        n: [
            "relaxed",
            "white smiling face"
        ],
        u: "263a-fe0f",
        a: "0.6"
    },
    {
        n: [
            "kissing closed eyes",
            "kissing face with closed eyes"
        ],
        u: "1f61a",
        a: "0.6"
    },
    {
        n: [
            "kissing smiling eyes",
            "kissing face with smiling eyes"
        ],
        u: "1f619",
        a: "1.0"
    },
    {
        n: [
            "smiling face with tear"
        ],
        u: "1f972",
        a: "13.0"
    },
    {
        n: [
            "yum",
            "face savouring delicious food"
        ],
        u: "1f60b",
        a: "0.6"
    },
    {
        n: [
            "stuck out tongue",
            "face with stuck-out tongue"
        ],
        u: "1f61b",
        a: "1.0"
    },
    {
        n: [
            "stuck out tongue winking eye",
            "face with stuck-out tongue and winking eye"
        ],
        u: "1f61c",
        a: "0.6"
    },
    {
        n: [
            "zany face",
            "grinning face with one large and one small eye"
        ],
        u: "1f92a",
        a: "5.0"
    },
    {
        n: [
            "stuck out tongue closed eyes",
            "face with stuck-out tongue and tightly-closed eyes"
        ],
        u: "1f61d",
        a: "0.6"
    },
    {
        n: [
            "money-mouth face",
            "money mouth face"
        ],
        u: "1f911",
        a: "1.0"
    },
    {
        n: [
            "hugging face"
        ],
        u: "1f917",
        a: "1.0"
    },
    {
        n: [
            "face with hand over mouth",
            "smiling face with smiling eyes and hand covering mouth"
        ],
        u: "1f92d",
        a: "5.0"
    },
    {
        n: [
            "face with open eyes and hand over mouth"
        ],
        u: "1fae2",
        a: "14.0"
    },
    {
        n: [
            "face with peeking eye"
        ],
        u: "1fae3",
        a: "14.0"
    },
    {
        n: [
            "shushing face",
            "face with finger covering closed lips"
        ],
        u: "1f92b",
        a: "5.0"
    },
    {
        n: [
            "thinking face"
        ],
        u: "1f914",
        a: "1.0"
    },
    {
        n: [
            "saluting face"
        ],
        u: "1fae1",
        a: "14.0"
    },
    {
        n: [
            "zipper-mouth face",
            "zipper mouth face"
        ],
        u: "1f910",
        a: "1.0"
    },
    {
        n: [
            "face with raised eyebrow",
            "face with one eyebrow raised"
        ],
        u: "1f928",
        a: "5.0"
    },
    {
        n: [
            "neutral face"
        ],
        u: "1f610",
        a: "0.7"
    },
    {
        n: [
            "expressionless",
            "expressionless face"
        ],
        u: "1f611",
        a: "1.0"
    },
    {
        n: [
            "no mouth",
            "face without mouth"
        ],
        u: "1f636",
        a: "1.0"
    },
    {
        n: [
            "dotted line face"
        ],
        u: "1fae5",
        a: "14.0"
    },
    {
        n: [
            "face in clouds"
        ],
        u: "1f636-200d-1f32b-fe0f",
        a: "13.1"
    },
    {
        n: [
            "smirk",
            "smirking face"
        ],
        u: "1f60f",
        a: "0.6"
    },
    {
        n: [
            "unamused",
            "unamused face"
        ],
        u: "1f612",
        a: "0.6"
    },
    {
        n: [
            "face with rolling eyes"
        ],
        u: "1f644",
        a: "1.0"
    },
    {
        n: [
            "grimacing",
            "grimacing face"
        ],
        u: "1f62c",
        a: "1.0"
    },
    {
        n: [
            "face exhaling"
        ],
        u: "1f62e-200d-1f4a8",
        a: "13.1"
    },
    {
        n: [
            "lying face"
        ],
        u: "1f925",
        a: "3.0"
    },
    {
        n: [
            "relieved",
            "relieved face"
        ],
        u: "1f60c",
        a: "0.6"
    },
    {
        n: [
            "pensive",
            "pensive face"
        ],
        u: "1f614",
        a: "0.6"
    },
    {
        n: [
            "sleepy",
            "sleepy face"
        ],
        u: "1f62a",
        a: "0.6"
    },
    {
        n: [
            "drooling face"
        ],
        u: "1f924",
        a: "3.0"
    },
    {
        n: [
            "sleeping",
            "sleeping face"
        ],
        u: "1f634",
        a: "1.0"
    },
    {
        n: [
            "mask",
            "face with medical mask"
        ],
        u: "1f637",
        a: "0.6"
    },
    {
        n: [
            "face with thermometer"
        ],
        u: "1f912",
        a: "1.0"
    },
    {
        n: [
            "face with head-bandage",
            "face with head bandage"
        ],
        u: "1f915",
        a: "1.0"
    },
    {
        n: [
            "nauseated face"
        ],
        u: "1f922",
        a: "3.0"
    },
    {
        n: [
            "face vomiting",
            "face with open mouth vomiting"
        ],
        u: "1f92e",
        a: "5.0"
    },
    {
        n: [
            "sneezing face"
        ],
        u: "1f927",
        a: "3.0"
    },
    {
        n: [
            "hot face",
            "overheated face"
        ],
        u: "1f975",
        a: "11.0"
    },
    {
        n: [
            "cold face",
            "freezing face"
        ],
        u: "1f976",
        a: "11.0"
    },
    {
        n: [
            "woozy face",
            "face with uneven eyes and wavy mouth"
        ],
        u: "1f974",
        a: "11.0"
    },
    {
        n: [
            "dizzy face"
        ],
        u: "1f635",
        a: "0.6"
    },
    {
        n: [
            "face with spiral eyes"
        ],
        u: "1f635-200d-1f4ab",
        a: "13.1"
    },
    {
        n: [
            "exploding head",
            "shocked face with exploding head"
        ],
        u: "1f92f",
        a: "5.0"
    },
    {
        n: [
            "face with cowboy hat"
        ],
        u: "1f920",
        a: "3.0"
    },
    {
        n: [
            "partying face",
            "face with party horn and party hat"
        ],
        u: "1f973",
        a: "11.0"
    },
    {
        n: [
            "disguised face"
        ],
        u: "1f978",
        a: "13.0"
    },
    {
        n: [
            "sunglasses",
            "smiling face with sunglasses"
        ],
        u: "1f60e",
        a: "1.0"
    },
    {
        n: [
            "nerd face"
        ],
        u: "1f913",
        a: "1.0"
    },
    {
        n: [
            "face with monocle"
        ],
        u: "1f9d0",
        a: "5.0"
    },
    {
        n: [
            "confused",
            "confused face"
        ],
        u: "1f615",
        a: "1.0"
    },
    {
        n: [
            "face with diagonal mouth"
        ],
        u: "1fae4",
        a: "14.0"
    },
    {
        n: [
            "worried",
            "worried face"
        ],
        u: "1f61f",
        a: "1.0"
    },
    {
        n: [
            "slightly frowning face"
        ],
        u: "1f641",
        a: "1.0"
    },
    {
        n: [
            "frowning face",
            "white frowning face"
        ],
        u: "2639-fe0f",
        a: "0.7"
    },
    {
        n: [
            "open mouth",
            "face with open mouth"
        ],
        u: "1f62e",
        a: "1.0"
    },
    {
        n: [
            "hushed",
            "hushed face"
        ],
        u: "1f62f",
        a: "1.0"
    },
    {
        n: [
            "astonished",
            "astonished face"
        ],
        u: "1f632",
        a: "0.6"
    },
    {
        n: [
            "flushed",
            "flushed face"
        ],
        u: "1f633",
        a: "0.6"
    },
    {
        n: [
            "pleading face",
            "face with pleading eyes"
        ],
        u: "1f97a",
        a: "11.0"
    },
    {
        n: [
            "face holding back tears"
        ],
        u: "1f979",
        a: "14.0"
    },
    {
        n: [
            "frowning",
            "frowning face with open mouth"
        ],
        u: "1f626",
        a: "1.0"
    },
    {
        n: [
            "anguished",
            "anguished face"
        ],
        u: "1f627",
        a: "1.0"
    },
    {
        n: [
            "fearful",
            "fearful face"
        ],
        u: "1f628",
        a: "0.6"
    },
    {
        n: [
            "cold sweat",
            "face with open mouth and cold sweat"
        ],
        u: "1f630",
        a: "0.6"
    },
    {
        n: [
            "disappointed relieved",
            "disappointed but relieved face"
        ],
        u: "1f625",
        a: "0.6"
    },
    {
        n: [
            "cry",
            "crying face"
        ],
        u: "1f622",
        a: "0.6"
    },
    {
        n: [
            "sob",
            "loudly crying face"
        ],
        u: "1f62d",
        a: "0.6"
    },
    {
        n: [
            "scream",
            "face screaming in fear"
        ],
        u: "1f631",
        a: "0.6"
    },
    {
        n: [
            "confounded",
            "confounded face"
        ],
        u: "1f616",
        a: "0.6"
    },
    {
        n: [
            "persevere",
            "persevering face"
        ],
        u: "1f623",
        a: "0.6"
    },
    {
        n: [
            "disappointed",
            "disappointed face"
        ],
        u: "1f61e",
        a: "0.6"
    },
    {
        n: [
            "sweat",
            "face with cold sweat"
        ],
        u: "1f613",
        a: "0.6"
    },
    {
        n: [
            "weary",
            "weary face"
        ],
        u: "1f629",
        a: "0.6"
    },
    {
        n: [
            "tired face"
        ],
        u: "1f62b",
        a: "0.6"
    },
    {
        n: [
            "yawning face"
        ],
        u: "1f971",
        a: "12.0"
    },
    {
        n: [
            "triumph",
            "face with look of triumph"
        ],
        u: "1f624",
        a: "0.6"
    },
    {
        n: [
            "rage",
            "pouting face"
        ],
        u: "1f621",
        a: "0.6"
    },
    {
        n: [
            "angry",
            "angry face"
        ],
        u: "1f620",
        a: "0.6"
    },
    {
        n: [
            "face with symbols on mouth",
            "serious face with symbols covering mouth"
        ],
        u: "1f92c",
        a: "5.0"
    },
    {
        n: [
            "smiling imp",
            "smiling face with horns"
        ],
        u: "1f608",
        a: "1.0"
    },
    {
        n: [
            "imp"
        ],
        u: "1f47f",
        a: "0.6"
    },
    {
        n: [
            "skull"
        ],
        u: "1f480",
        a: "0.6"
    },
    {
        n: [
            "skull and crossbones"
        ],
        u: "2620-fe0f",
        a: "1.0"
    },
    {
        n: [
            "poop",
            "shit",
            "hankey",
            "pile of poo"
        ],
        u: "1f4a9",
        a: "0.6"
    },
    {
        n: [
            "clown face"
        ],
        u: "1f921",
        a: "3.0"
    },
    {
        n: [
            "japanese ogre"
        ],
        u: "1f479",
        a: "0.6"
    },
    {
        n: [
            "japanese goblin"
        ],
        u: "1f47a",
        a: "0.6"
    },
    {
        n: [
            "ghost"
        ],
        u: "1f47b",
        a: "0.6"
    },
    {
        n: [
            "alien",
            "extraterrestrial alien"
        ],
        u: "1f47d",
        a: "0.6"
    },
    {
        n: [
            "alien monster",
            "space invader"
        ],
        u: "1f47e",
        a: "0.6"
    },
    {
        n: [
            "robot face"
        ],
        u: "1f916",
        a: "1.0"
    },
    {
        n: [
            "smiley cat",
            "smiling cat face with open mouth"
        ],
        u: "1f63a",
        a: "0.6"
    },
    {
        n: [
            "smile cat",
            "grinning cat face with smiling eyes"
        ],
        u: "1f638",
        a: "0.6"
    },
    {
        n: [
            "joy cat",
            "cat face with tears of joy"
        ],
        u: "1f639",
        a: "0.6"
    },
    {
        n: [
            "heart eyes cat",
            "smiling cat face with heart-shaped eyes"
        ],
        u: "1f63b",
        a: "0.6"
    },
    {
        n: [
            "smirk cat",
            "cat face with wry smile"
        ],
        u: "1f63c",
        a: "0.6"
    },
    {
        n: [
            "kissing cat",
            "kissing cat face with closed eyes"
        ],
        u: "1f63d",
        a: "0.6"
    },
    {
        n: [
            "scream cat",
            "weary cat face"
        ],
        u: "1f640",
        a: "0.6"
    },
    {
        n: [
            "crying cat face"
        ],
        u: "1f63f",
        a: "0.6"
    },
    {
        n: [
            "pouting cat",
            "pouting cat face"
        ],
        u: "1f63e",
        a: "0.6"
    },
    {
        n: [
            "see no evil",
            "see-no-evil monkey"
        ],
        u: "1f648",
        a: "0.6"
    },
    {
        n: [
            "hear no evil",
            "hear-no-evil monkey"
        ],
        u: "1f649",
        a: "0.6"
    },
    {
        n: [
            "speak no evil",
            "speak-no-evil monkey"
        ],
        u: "1f64a",
        a: "0.6"
    },
    {
        n: [
            "kiss",
            "kiss mark"
        ],
        u: "1f48b",
        a: "0.6"
    },
    {
        n: [
            "love letter"
        ],
        u: "1f48c",
        a: "0.6"
    },
    {
        n: [
            "cupid",
            "heart with arrow"
        ],
        u: "1f498",
        a: "0.6"
    },
    {
        n: [
            "gift heart",
            "heart with ribbon"
        ],
        u: "1f49d",
        a: "0.6"
    },
    {
        n: [
            "sparkling heart"
        ],
        u: "1f496",
        a: "0.6"
    },
    {
        n: [
            "heartpulse",
            "growing heart"
        ],
        u: "1f497",
        a: "0.6"
    },
    {
        n: [
            "heartbeat",
            "beating heart"
        ],
        u: "1f493",
        a: "0.6"
    },
    {
        n: [
            "revolving hearts"
        ],
        u: "1f49e",
        a: "0.6"
    },
    {
        n: [
            "two hearts"
        ],
        u: "1f495",
        a: "0.6"
    },
    {
        n: [
            "heart decoration"
        ],
        u: "1f49f",
        a: "0.6"
    },
    {
        n: [
            "heart exclamation",
            "heavy heart exclamation mark ornament"
        ],
        u: "2763-fe0f",
        a: "1.0"
    },
    {
        n: [
            "broken heart"
        ],
        u: "1f494",
        a: "0.6"
    },
    {
        n: [
            "heart on fire"
        ],
        u: "2764-fe0f-200d-1f525",
        a: "13.1"
    },
    {
        n: [
            "mending heart"
        ],
        u: "2764-fe0f-200d-1fa79",
        a: "13.1"
    },
    {
        n: [
            "heart",
            "heavy black heart"
        ],
        u: "2764-fe0f",
        a: "0.6"
    },
    {
        n: [
            "orange heart"
        ],
        u: "1f9e1",
        a: "5.0"
    },
    {
        n: [
            "yellow heart"
        ],
        u: "1f49b",
        a: "0.6"
    },
    {
        n: [
            "green heart"
        ],
        u: "1f49a",
        a: "0.6"
    },
    {
        n: [
            "blue heart"
        ],
        u: "1f499",
        a: "0.6"
    },
    {
        n: [
            "purple heart"
        ],
        u: "1f49c",
        a: "0.6"
    },
    {
        n: [
            "brown heart"
        ],
        u: "1f90e",
        a: "12.0"
    },
    {
        n: [
            "black heart"
        ],
        u: "1f5a4",
        a: "3.0"
    },
    {
        n: [
            "white heart"
        ],
        u: "1f90d",
        a: "12.0"
    },
    {
        n: [
            "100",
            "hundred points symbol"
        ],
        u: "1f4af",
        a: "0.6"
    },
    {
        n: [
            "anger",
            "anger symbol"
        ],
        u: "1f4a2",
        a: "0.6"
    },
    {
        n: [
            "boom",
            "collision",
            "collision symbol"
        ],
        u: "1f4a5",
        a: "0.6"
    },
    {
        n: [
            "dizzy",
            "dizzy symbol"
        ],
        u: "1f4ab",
        a: "0.6"
    },
    {
        n: [
            "sweat drops",
            "splashing sweat symbol"
        ],
        u: "1f4a6",
        a: "0.6"
    },
    {
        n: [
            "dash",
            "dash symbol"
        ],
        u: "1f4a8",
        a: "0.6"
    },
    {
        n: [
            "hole"
        ],
        u: "1f573-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bomb"
        ],
        u: "1f4a3",
        a: "0.6"
    },
    {
        n: [
            "speech balloon"
        ],
        u: "1f4ac",
        a: "0.6"
    },
    {
        n: [
            "eye in speech bubble",
            "eye-in-speech-bubble"
        ],
        u: "1f441-fe0f-200d-1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "left speech bubble"
        ],
        u: "1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "right anger bubble"
        ],
        u: "1f5ef-fe0f",
        a: "0.7"
    },
    {
        n: [
            "thought balloon"
        ],
        u: "1f4ad",
        a: "1.0"
    },
    {
        n: [
            "zzz",
            "sleeping symbol"
        ],
        u: "1f4a4",
        a: "0.6"
    },
    {
        n: [
            "wave",
            "waving hand sign"
        ],
        u: "1f44b",
        v: [
            "1f44b-1f3fb",
            "1f44b-1f3fc",
            "1f44b-1f3fd",
            "1f44b-1f3fe",
            "1f44b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised back of hand"
        ],
        u: "1f91a",
        v: [
            "1f91a-1f3fb",
            "1f91a-1f3fc",
            "1f91a-1f3fd",
            "1f91a-1f3fe",
            "1f91a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with fingers splayed",
            "raised hand with fingers splayed"
        ],
        u: "1f590-fe0f",
        v: [
            "1f590-1f3fb",
            "1f590-1f3fc",
            "1f590-1f3fd",
            "1f590-1f3fe",
            "1f590-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "hand",
            "raised hand"
        ],
        u: "270b",
        v: [
            "270b-1f3fb",
            "270b-1f3fc",
            "270b-1f3fd",
            "270b-1f3fe",
            "270b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "spock-hand",
            "raised hand with part between middle and ring fingers"
        ],
        u: "1f596",
        v: [
            "1f596-1f3fb",
            "1f596-1f3fc",
            "1f596-1f3fd",
            "1f596-1f3fe",
            "1f596-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "rightwards hand"
        ],
        u: "1faf1",
        v: [
            "1faf1-1f3fb",
            "1faf1-1f3fc",
            "1faf1-1f3fd",
            "1faf1-1f3fe",
            "1faf1-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "leftwards hand"
        ],
        u: "1faf2",
        v: [
            "1faf2-1f3fb",
            "1faf2-1f3fc",
            "1faf2-1f3fd",
            "1faf2-1f3fe",
            "1faf2-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm down hand"
        ],
        u: "1faf3",
        v: [
            "1faf3-1f3fb",
            "1faf3-1f3fc",
            "1faf3-1f3fd",
            "1faf3-1f3fe",
            "1faf3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm up hand"
        ],
        u: "1faf4",
        v: [
            "1faf4-1f3fb",
            "1faf4-1f3fc",
            "1faf4-1f3fd",
            "1faf4-1f3fe",
            "1faf4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "ok hand",
            "ok hand sign"
        ],
        u: "1f44c",
        v: [
            "1f44c-1f3fb",
            "1f44c-1f3fc",
            "1f44c-1f3fd",
            "1f44c-1f3fe",
            "1f44c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "pinched fingers"
        ],
        u: "1f90c",
        v: [
            "1f90c-1f3fb",
            "1f90c-1f3fc",
            "1f90c-1f3fd",
            "1f90c-1f3fe",
            "1f90c-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "pinching hand"
        ],
        u: "1f90f",
        v: [
            "1f90f-1f3fb",
            "1f90f-1f3fc",
            "1f90f-1f3fd",
            "1f90f-1f3fe",
            "1f90f-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "v",
            "victory hand"
        ],
        u: "270c-fe0f",
        v: [
            "270c-1f3fb",
            "270c-1f3fc",
            "270c-1f3fd",
            "270c-1f3fe",
            "270c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "crossed fingers",
            "hand with index and middle fingers crossed"
        ],
        u: "1f91e",
        v: [
            "1f91e-1f3fb",
            "1f91e-1f3fc",
            "1f91e-1f3fd",
            "1f91e-1f3fe",
            "1f91e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with index finger and thumb crossed"
        ],
        u: "1faf0",
        v: [
            "1faf0-1f3fb",
            "1faf0-1f3fc",
            "1faf0-1f3fd",
            "1faf0-1f3fe",
            "1faf0-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "i love you hand sign"
        ],
        u: "1f91f",
        v: [
            "1f91f-1f3fb",
            "1f91f-1f3fc",
            "1f91f-1f3fd",
            "1f91f-1f3fe",
            "1f91f-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "the horns",
            "sign of the horns"
        ],
        u: "1f918",
        v: [
            "1f918-1f3fb",
            "1f918-1f3fc",
            "1f918-1f3fd",
            "1f918-1f3fe",
            "1f918-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "call me hand"
        ],
        u: "1f919",
        v: [
            "1f919-1f3fb",
            "1f919-1f3fc",
            "1f919-1f3fd",
            "1f919-1f3fe",
            "1f919-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "point left",
            "white left pointing backhand index"
        ],
        u: "1f448",
        v: [
            "1f448-1f3fb",
            "1f448-1f3fc",
            "1f448-1f3fd",
            "1f448-1f3fe",
            "1f448-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point right",
            "white right pointing backhand index"
        ],
        u: "1f449",
        v: [
            "1f449-1f3fb",
            "1f449-1f3fc",
            "1f449-1f3fd",
            "1f449-1f3fe",
            "1f449-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up 2",
            "white up pointing backhand index"
        ],
        u: "1f446",
        v: [
            "1f446-1f3fb",
            "1f446-1f3fc",
            "1f446-1f3fd",
            "1f446-1f3fe",
            "1f446-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "middle finger",
            "reversed hand with middle finger extended"
        ],
        u: "1f595",
        v: [
            "1f595-1f3fb",
            "1f595-1f3fc",
            "1f595-1f3fd",
            "1f595-1f3fe",
            "1f595-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "point down",
            "white down pointing backhand index"
        ],
        u: "1f447",
        v: [
            "1f447-1f3fb",
            "1f447-1f3fc",
            "1f447-1f3fd",
            "1f447-1f3fe",
            "1f447-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up",
            "white up pointing index"
        ],
        u: "261d-fe0f",
        v: [
            "261d-1f3fb",
            "261d-1f3fc",
            "261d-1f3fd",
            "261d-1f3fe",
            "261d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "index pointing at the viewer"
        ],
        u: "1faf5",
        v: [
            "1faf5-1f3fb",
            "1faf5-1f3fc",
            "1faf5-1f3fd",
            "1faf5-1f3fe",
            "1faf5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "+1",
            "thumbsup",
            "thumbs up sign"
        ],
        u: "1f44d",
        v: [
            "1f44d-1f3fb",
            "1f44d-1f3fc",
            "1f44d-1f3fd",
            "1f44d-1f3fe",
            "1f44d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "-1",
            "thumbsdown",
            "thumbs down sign"
        ],
        u: "1f44e",
        v: [
            "1f44e-1f3fb",
            "1f44e-1f3fc",
            "1f44e-1f3fd",
            "1f44e-1f3fe",
            "1f44e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "fist",
            "raised fist"
        ],
        u: "270a",
        v: [
            "270a-1f3fb",
            "270a-1f3fc",
            "270a-1f3fd",
            "270a-1f3fe",
            "270a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "punch",
            "facepunch",
            "fisted hand sign"
        ],
        u: "1f44a",
        v: [
            "1f44a-1f3fb",
            "1f44a-1f3fc",
            "1f44a-1f3fd",
            "1f44a-1f3fe",
            "1f44a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "left-facing fist"
        ],
        u: "1f91b",
        v: [
            "1f91b-1f3fb",
            "1f91b-1f3fc",
            "1f91b-1f3fd",
            "1f91b-1f3fe",
            "1f91b-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "right-facing fist"
        ],
        u: "1f91c",
        v: [
            "1f91c-1f3fb",
            "1f91c-1f3fc",
            "1f91c-1f3fd",
            "1f91c-1f3fe",
            "1f91c-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "clap",
            "clapping hands sign"
        ],
        u: "1f44f",
        v: [
            "1f44f-1f3fb",
            "1f44f-1f3fc",
            "1f44f-1f3fd",
            "1f44f-1f3fe",
            "1f44f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised hands",
            "person raising both hands in celebration"
        ],
        u: "1f64c",
        v: [
            "1f64c-1f3fb",
            "1f64c-1f3fc",
            "1f64c-1f3fd",
            "1f64c-1f3fe",
            "1f64c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "heart hands"
        ],
        u: "1faf6",
        v: [
            "1faf6-1f3fb",
            "1faf6-1f3fc",
            "1faf6-1f3fd",
            "1faf6-1f3fe",
            "1faf6-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "open hands",
            "open hands sign"
        ],
        u: "1f450",
        v: [
            "1f450-1f3fb",
            "1f450-1f3fc",
            "1f450-1f3fd",
            "1f450-1f3fe",
            "1f450-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "palms up together"
        ],
        u: "1f932",
        v: [
            "1f932-1f3fb",
            "1f932-1f3fc",
            "1f932-1f3fd",
            "1f932-1f3fe",
            "1f932-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "handshake"
        ],
        u: "1f91d",
        v: [
            "1f91d-1f3fb",
            "1f91d-1f3fc",
            "1f91d-1f3fd",
            "1f91d-1f3fe",
            "1f91d-1f3ff",
            "1faf1-1f3fb-200d-1faf2-1f3fc",
            "1faf1-1f3fb-200d-1faf2-1f3fd",
            "1faf1-1f3fb-200d-1faf2-1f3fe",
            "1faf1-1f3fb-200d-1faf2-1f3ff",
            "1faf1-1f3fc-200d-1faf2-1f3fb",
            "1faf1-1f3fc-200d-1faf2-1f3fd",
            "1faf1-1f3fc-200d-1faf2-1f3fe",
            "1faf1-1f3fc-200d-1faf2-1f3ff",
            "1faf1-1f3fd-200d-1faf2-1f3fb",
            "1faf1-1f3fd-200d-1faf2-1f3fc",
            "1faf1-1f3fd-200d-1faf2-1f3fe",
            "1faf1-1f3fd-200d-1faf2-1f3ff",
            "1faf1-1f3fe-200d-1faf2-1f3fb",
            "1faf1-1f3fe-200d-1faf2-1f3fc",
            "1faf1-1f3fe-200d-1faf2-1f3fd",
            "1faf1-1f3fe-200d-1faf2-1f3ff",
            "1faf1-1f3ff-200d-1faf2-1f3fb",
            "1faf1-1f3ff-200d-1faf2-1f3fc",
            "1faf1-1f3ff-200d-1faf2-1f3fd",
            "1faf1-1f3ff-200d-1faf2-1f3fe"
        ],
        a: "3.0"
    },
    {
        n: [
            "pray",
            "person with folded hands"
        ],
        u: "1f64f",
        v: [
            "1f64f-1f3fb",
            "1f64f-1f3fc",
            "1f64f-1f3fd",
            "1f64f-1f3fe",
            "1f64f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "writing hand"
        ],
        u: "270d-fe0f",
        v: [
            "270d-1f3fb",
            "270d-1f3fc",
            "270d-1f3fd",
            "270d-1f3fe",
            "270d-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "nail care",
            "nail polish"
        ],
        u: "1f485",
        v: [
            "1f485-1f3fb",
            "1f485-1f3fc",
            "1f485-1f3fd",
            "1f485-1f3fe",
            "1f485-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "selfie"
        ],
        u: "1f933",
        v: [
            "1f933-1f3fb",
            "1f933-1f3fc",
            "1f933-1f3fd",
            "1f933-1f3fe",
            "1f933-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "muscle",
            "flexed biceps"
        ],
        u: "1f4aa",
        v: [
            "1f4aa-1f3fb",
            "1f4aa-1f3fc",
            "1f4aa-1f3fd",
            "1f4aa-1f3fe",
            "1f4aa-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mechanical arm"
        ],
        u: "1f9be",
        a: "12.0"
    },
    {
        n: [
            "mechanical leg"
        ],
        u: "1f9bf",
        a: "12.0"
    },
    {
        n: [
            "leg"
        ],
        u: "1f9b5",
        v: [
            "1f9b5-1f3fb",
            "1f9b5-1f3fc",
            "1f9b5-1f3fd",
            "1f9b5-1f3fe",
            "1f9b5-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "foot"
        ],
        u: "1f9b6",
        v: [
            "1f9b6-1f3fb",
            "1f9b6-1f3fc",
            "1f9b6-1f3fd",
            "1f9b6-1f3fe",
            "1f9b6-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "ear"
        ],
        u: "1f442",
        v: [
            "1f442-1f3fb",
            "1f442-1f3fc",
            "1f442-1f3fd",
            "1f442-1f3fe",
            "1f442-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "ear with hearing aid"
        ],
        u: "1f9bb",
        v: [
            "1f9bb-1f3fb",
            "1f9bb-1f3fc",
            "1f9bb-1f3fd",
            "1f9bb-1f3fe",
            "1f9bb-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "nose"
        ],
        u: "1f443",
        v: [
            "1f443-1f3fb",
            "1f443-1f3fc",
            "1f443-1f3fd",
            "1f443-1f3fe",
            "1f443-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "brain"
        ],
        u: "1f9e0",
        a: "5.0"
    },
    {
        n: [
            "anatomical heart"
        ],
        u: "1fac0",
        a: "13.0"
    },
    {
        n: [
            "lungs"
        ],
        u: "1fac1",
        a: "13.0"
    },
    {
        n: [
            "tooth"
        ],
        u: "1f9b7",
        a: "11.0"
    },
    {
        n: [
            "bone"
        ],
        u: "1f9b4",
        a: "11.0"
    },
    {
        n: [
            "eyes"
        ],
        u: "1f440",
        a: "0.6"
    },
    {
        n: [
            "eye"
        ],
        u: "1f441-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tongue"
        ],
        u: "1f445",
        a: "0.6"
    },
    {
        n: [
            "lips",
            "mouth"
        ],
        u: "1f444",
        a: "0.6"
    },
    {
        n: [
            "biting lip"
        ],
        u: "1fae6",
        a: "14.0"
    },
    {
        n: [
            "baby"
        ],
        u: "1f476",
        v: [
            "1f476-1f3fb",
            "1f476-1f3fc",
            "1f476-1f3fd",
            "1f476-1f3fe",
            "1f476-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "child"
        ],
        u: "1f9d2",
        v: [
            "1f9d2-1f3fb",
            "1f9d2-1f3fc",
            "1f9d2-1f3fd",
            "1f9d2-1f3fe",
            "1f9d2-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "boy"
        ],
        u: "1f466",
        v: [
            "1f466-1f3fb",
            "1f466-1f3fc",
            "1f466-1f3fd",
            "1f466-1f3fe",
            "1f466-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "girl"
        ],
        u: "1f467",
        v: [
            "1f467-1f3fb",
            "1f467-1f3fc",
            "1f467-1f3fd",
            "1f467-1f3fe",
            "1f467-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "adult"
        ],
        u: "1f9d1",
        v: [
            "1f9d1-1f3fb",
            "1f9d1-1f3fc",
            "1f9d1-1f3fd",
            "1f9d1-1f3fe",
            "1f9d1-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "person with blond hair"
        ],
        u: "1f471",
        v: [
            "1f471-1f3fb",
            "1f471-1f3fc",
            "1f471-1f3fd",
            "1f471-1f3fe",
            "1f471-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man"
        ],
        u: "1f468",
        v: [
            "1f468-1f3fb",
            "1f468-1f3fc",
            "1f468-1f3fd",
            "1f468-1f3fe",
            "1f468-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "bearded person"
        ],
        u: "1f9d4",
        v: [
            "1f9d4-1f3fb",
            "1f9d4-1f3fc",
            "1f9d4-1f3fd",
            "1f9d4-1f3fe",
            "1f9d4-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man: beard",
            "man with beard"
        ],
        u: "1f9d4-200d-2642-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2642-fe0f",
            "1f9d4-1f3fc-200d-2642-fe0f",
            "1f9d4-1f3fd-200d-2642-fe0f",
            "1f9d4-1f3fe-200d-2642-fe0f",
            "1f9d4-1f3ff-200d-2642-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "woman: beard",
            "woman with beard"
        ],
        u: "1f9d4-200d-2640-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2640-fe0f",
            "1f9d4-1f3fc-200d-2640-fe0f",
            "1f9d4-1f3fd-200d-2640-fe0f",
            "1f9d4-1f3fe-200d-2640-fe0f",
            "1f9d4-1f3ff-200d-2640-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "man: red hair",
            "red haired man"
        ],
        u: "1f468-200d-1f9b0",
        v: [
            "1f468-1f3fb-200d-1f9b0",
            "1f468-1f3fc-200d-1f9b0",
            "1f468-1f3fd-200d-1f9b0",
            "1f468-1f3fe-200d-1f9b0",
            "1f468-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: curly hair",
            "curly haired man"
        ],
        u: "1f468-200d-1f9b1",
        v: [
            "1f468-1f3fb-200d-1f9b1",
            "1f468-1f3fc-200d-1f9b1",
            "1f468-1f3fd-200d-1f9b1",
            "1f468-1f3fe-200d-1f9b1",
            "1f468-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: white hair",
            "white haired man"
        ],
        u: "1f468-200d-1f9b3",
        v: [
            "1f468-1f3fb-200d-1f9b3",
            "1f468-1f3fc-200d-1f9b3",
            "1f468-1f3fd-200d-1f9b3",
            "1f468-1f3fe-200d-1f9b3",
            "1f468-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald man",
            "man: bald"
        ],
        u: "1f468-200d-1f9b2",
        v: [
            "1f468-1f3fb-200d-1f9b2",
            "1f468-1f3fc-200d-1f9b2",
            "1f468-1f3fd-200d-1f9b2",
            "1f468-1f3fe-200d-1f9b2",
            "1f468-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman"
        ],
        u: "1f469",
        v: [
            "1f469-1f3fb",
            "1f469-1f3fc",
            "1f469-1f3fd",
            "1f469-1f3fe",
            "1f469-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman: red hair",
            "red haired woman"
        ],
        u: "1f469-200d-1f9b0",
        v: [
            "1f469-1f3fb-200d-1f9b0",
            "1f469-1f3fc-200d-1f9b0",
            "1f469-1f3fd-200d-1f9b0",
            "1f469-1f3fe-200d-1f9b0",
            "1f469-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: red hair",
            "red haired person"
        ],
        u: "1f9d1-200d-1f9b0",
        v: [
            "1f9d1-1f3fb-200d-1f9b0",
            "1f9d1-1f3fc-200d-1f9b0",
            "1f9d1-1f3fd-200d-1f9b0",
            "1f9d1-1f3fe-200d-1f9b0",
            "1f9d1-1f3ff-200d-1f9b0"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: curly hair",
            "curly haired woman"
        ],
        u: "1f469-200d-1f9b1",
        v: [
            "1f469-1f3fb-200d-1f9b1",
            "1f469-1f3fc-200d-1f9b1",
            "1f469-1f3fd-200d-1f9b1",
            "1f469-1f3fe-200d-1f9b1",
            "1f469-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: curly hair",
            "curly haired person"
        ],
        u: "1f9d1-200d-1f9b1",
        v: [
            "1f9d1-1f3fb-200d-1f9b1",
            "1f9d1-1f3fc-200d-1f9b1",
            "1f9d1-1f3fd-200d-1f9b1",
            "1f9d1-1f3fe-200d-1f9b1",
            "1f9d1-1f3ff-200d-1f9b1"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: white hair",
            "white haired woman"
        ],
        u: "1f469-200d-1f9b3",
        v: [
            "1f469-1f3fb-200d-1f9b3",
            "1f469-1f3fc-200d-1f9b3",
            "1f469-1f3fd-200d-1f9b3",
            "1f469-1f3fe-200d-1f9b3",
            "1f469-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: white hair",
            "white haired person"
        ],
        u: "1f9d1-200d-1f9b3",
        v: [
            "1f9d1-1f3fb-200d-1f9b3",
            "1f9d1-1f3fc-200d-1f9b3",
            "1f9d1-1f3fd-200d-1f9b3",
            "1f9d1-1f3fe-200d-1f9b3",
            "1f9d1-1f3ff-200d-1f9b3"
        ],
        a: "12.1"
    },
    {
        n: [
            "bald woman",
            "woman: bald"
        ],
        u: "1f469-200d-1f9b2",
        v: [
            "1f469-1f3fb-200d-1f9b2",
            "1f469-1f3fc-200d-1f9b2",
            "1f469-1f3fd-200d-1f9b2",
            "1f469-1f3fe-200d-1f9b2",
            "1f469-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald person",
            "person: bald"
        ],
        u: "1f9d1-200d-1f9b2",
        v: [
            "1f9d1-1f3fb-200d-1f9b2",
            "1f9d1-1f3fc-200d-1f9b2",
            "1f9d1-1f3fd-200d-1f9b2",
            "1f9d1-1f3fe-200d-1f9b2",
            "1f9d1-1f3ff-200d-1f9b2"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: blond hair",
            "blond-haired-woman"
        ],
        u: "1f471-200d-2640-fe0f",
        v: [
            "1f471-1f3fb-200d-2640-fe0f",
            "1f471-1f3fc-200d-2640-fe0f",
            "1f471-1f3fd-200d-2640-fe0f",
            "1f471-1f3fe-200d-2640-fe0f",
            "1f471-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man: blond hair",
            "blond-haired-man"
        ],
        u: "1f471-200d-2642-fe0f",
        v: [
            "1f471-1f3fb-200d-2642-fe0f",
            "1f471-1f3fc-200d-2642-fe0f",
            "1f471-1f3fd-200d-2642-fe0f",
            "1f471-1f3fe-200d-2642-fe0f",
            "1f471-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "older adult"
        ],
        u: "1f9d3",
        v: [
            "1f9d3-1f3fb",
            "1f9d3-1f3fc",
            "1f9d3-1f3fd",
            "1f9d3-1f3fe",
            "1f9d3-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "older man"
        ],
        u: "1f474",
        v: [
            "1f474-1f3fb",
            "1f474-1f3fc",
            "1f474-1f3fd",
            "1f474-1f3fe",
            "1f474-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "older woman"
        ],
        u: "1f475",
        v: [
            "1f475-1f3fb",
            "1f475-1f3fc",
            "1f475-1f3fd",
            "1f475-1f3fe",
            "1f475-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person frowning"
        ],
        u: "1f64d",
        v: [
            "1f64d-1f3fb",
            "1f64d-1f3fc",
            "1f64d-1f3fd",
            "1f64d-1f3fe",
            "1f64d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man frowning",
            "man-frowning"
        ],
        u: "1f64d-200d-2642-fe0f",
        v: [
            "1f64d-1f3fb-200d-2642-fe0f",
            "1f64d-1f3fc-200d-2642-fe0f",
            "1f64d-1f3fd-200d-2642-fe0f",
            "1f64d-1f3fe-200d-2642-fe0f",
            "1f64d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman frowning",
            "woman-frowning"
        ],
        u: "1f64d-200d-2640-fe0f",
        v: [
            "1f64d-1f3fb-200d-2640-fe0f",
            "1f64d-1f3fc-200d-2640-fe0f",
            "1f64d-1f3fd-200d-2640-fe0f",
            "1f64d-1f3fe-200d-2640-fe0f",
            "1f64d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with pouting face"
        ],
        u: "1f64e",
        v: [
            "1f64e-1f3fb",
            "1f64e-1f3fc",
            "1f64e-1f3fd",
            "1f64e-1f3fe",
            "1f64e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man pouting",
            "man-pouting"
        ],
        u: "1f64e-200d-2642-fe0f",
        v: [
            "1f64e-1f3fb-200d-2642-fe0f",
            "1f64e-1f3fc-200d-2642-fe0f",
            "1f64e-1f3fd-200d-2642-fe0f",
            "1f64e-1f3fe-200d-2642-fe0f",
            "1f64e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pouting",
            "woman-pouting"
        ],
        u: "1f64e-200d-2640-fe0f",
        v: [
            "1f64e-1f3fb-200d-2640-fe0f",
            "1f64e-1f3fc-200d-2640-fe0f",
            "1f64e-1f3fd-200d-2640-fe0f",
            "1f64e-1f3fe-200d-2640-fe0f",
            "1f64e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "no good",
            "face with no good gesture"
        ],
        u: "1f645",
        v: [
            "1f645-1f3fb",
            "1f645-1f3fc",
            "1f645-1f3fd",
            "1f645-1f3fe",
            "1f645-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing no",
            "man-gesturing-no"
        ],
        u: "1f645-200d-2642-fe0f",
        v: [
            "1f645-1f3fb-200d-2642-fe0f",
            "1f645-1f3fc-200d-2642-fe0f",
            "1f645-1f3fd-200d-2642-fe0f",
            "1f645-1f3fe-200d-2642-fe0f",
            "1f645-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing no",
            "woman-gesturing-no"
        ],
        u: "1f645-200d-2640-fe0f",
        v: [
            "1f645-1f3fb-200d-2640-fe0f",
            "1f645-1f3fc-200d-2640-fe0f",
            "1f645-1f3fd-200d-2640-fe0f",
            "1f645-1f3fe-200d-2640-fe0f",
            "1f645-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ok woman",
            "face with ok gesture"
        ],
        u: "1f646",
        v: [
            "1f646-1f3fb",
            "1f646-1f3fc",
            "1f646-1f3fd",
            "1f646-1f3fe",
            "1f646-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing ok",
            "man-gesturing-ok"
        ],
        u: "1f646-200d-2642-fe0f",
        v: [
            "1f646-1f3fb-200d-2642-fe0f",
            "1f646-1f3fc-200d-2642-fe0f",
            "1f646-1f3fd-200d-2642-fe0f",
            "1f646-1f3fe-200d-2642-fe0f",
            "1f646-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing ok",
            "woman-gesturing-ok"
        ],
        u: "1f646-200d-2640-fe0f",
        v: [
            "1f646-1f3fb-200d-2640-fe0f",
            "1f646-1f3fc-200d-2640-fe0f",
            "1f646-1f3fd-200d-2640-fe0f",
            "1f646-1f3fe-200d-2640-fe0f",
            "1f646-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "information desk person"
        ],
        u: "1f481",
        v: [
            "1f481-1f3fb",
            "1f481-1f3fc",
            "1f481-1f3fd",
            "1f481-1f3fe",
            "1f481-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man tipping hand",
            "man-tipping-hand"
        ],
        u: "1f481-200d-2642-fe0f",
        v: [
            "1f481-1f3fb-200d-2642-fe0f",
            "1f481-1f3fc-200d-2642-fe0f",
            "1f481-1f3fd-200d-2642-fe0f",
            "1f481-1f3fe-200d-2642-fe0f",
            "1f481-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman tipping hand",
            "woman-tipping-hand"
        ],
        u: "1f481-200d-2640-fe0f",
        v: [
            "1f481-1f3fb-200d-2640-fe0f",
            "1f481-1f3fc-200d-2640-fe0f",
            "1f481-1f3fd-200d-2640-fe0f",
            "1f481-1f3fe-200d-2640-fe0f",
            "1f481-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "raising hand",
            "happy person raising one hand"
        ],
        u: "1f64b",
        v: [
            "1f64b-1f3fb",
            "1f64b-1f3fc",
            "1f64b-1f3fd",
            "1f64b-1f3fe",
            "1f64b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man raising hand",
            "man-raising-hand"
        ],
        u: "1f64b-200d-2642-fe0f",
        v: [
            "1f64b-1f3fb-200d-2642-fe0f",
            "1f64b-1f3fc-200d-2642-fe0f",
            "1f64b-1f3fd-200d-2642-fe0f",
            "1f64b-1f3fe-200d-2642-fe0f",
            "1f64b-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman raising hand",
            "woman-raising-hand"
        ],
        u: "1f64b-200d-2640-fe0f",
        v: [
            "1f64b-1f3fb-200d-2640-fe0f",
            "1f64b-1f3fc-200d-2640-fe0f",
            "1f64b-1f3fd-200d-2640-fe0f",
            "1f64b-1f3fe-200d-2640-fe0f",
            "1f64b-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "deaf person"
        ],
        u: "1f9cf",
        v: [
            "1f9cf-1f3fb",
            "1f9cf-1f3fc",
            "1f9cf-1f3fd",
            "1f9cf-1f3fe",
            "1f9cf-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf man"
        ],
        u: "1f9cf-200d-2642-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2642-fe0f",
            "1f9cf-1f3fc-200d-2642-fe0f",
            "1f9cf-1f3fd-200d-2642-fe0f",
            "1f9cf-1f3fe-200d-2642-fe0f",
            "1f9cf-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf woman"
        ],
        u: "1f9cf-200d-2640-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2640-fe0f",
            "1f9cf-1f3fc-200d-2640-fe0f",
            "1f9cf-1f3fd-200d-2640-fe0f",
            "1f9cf-1f3fe-200d-2640-fe0f",
            "1f9cf-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "bow",
            "person bowing deeply"
        ],
        u: "1f647",
        v: [
            "1f647-1f3fb",
            "1f647-1f3fc",
            "1f647-1f3fd",
            "1f647-1f3fe",
            "1f647-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man bowing",
            "man-bowing"
        ],
        u: "1f647-200d-2642-fe0f",
        v: [
            "1f647-1f3fb-200d-2642-fe0f",
            "1f647-1f3fc-200d-2642-fe0f",
            "1f647-1f3fd-200d-2642-fe0f",
            "1f647-1f3fe-200d-2642-fe0f",
            "1f647-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bowing",
            "woman-bowing"
        ],
        u: "1f647-200d-2640-fe0f",
        v: [
            "1f647-1f3fb-200d-2640-fe0f",
            "1f647-1f3fc-200d-2640-fe0f",
            "1f647-1f3fd-200d-2640-fe0f",
            "1f647-1f3fe-200d-2640-fe0f",
            "1f647-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "face palm"
        ],
        u: "1f926",
        v: [
            "1f926-1f3fb",
            "1f926-1f3fc",
            "1f926-1f3fd",
            "1f926-1f3fe",
            "1f926-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man facepalming",
            "man-facepalming"
        ],
        u: "1f926-200d-2642-fe0f",
        v: [
            "1f926-1f3fb-200d-2642-fe0f",
            "1f926-1f3fc-200d-2642-fe0f",
            "1f926-1f3fd-200d-2642-fe0f",
            "1f926-1f3fe-200d-2642-fe0f",
            "1f926-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman facepalming",
            "woman-facepalming"
        ],
        u: "1f926-200d-2640-fe0f",
        v: [
            "1f926-1f3fb-200d-2640-fe0f",
            "1f926-1f3fc-200d-2640-fe0f",
            "1f926-1f3fd-200d-2640-fe0f",
            "1f926-1f3fe-200d-2640-fe0f",
            "1f926-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "shrug"
        ],
        u: "1f937",
        v: [
            "1f937-1f3fb",
            "1f937-1f3fc",
            "1f937-1f3fd",
            "1f937-1f3fe",
            "1f937-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man shrugging",
            "man-shrugging"
        ],
        u: "1f937-200d-2642-fe0f",
        v: [
            "1f937-1f3fb-200d-2642-fe0f",
            "1f937-1f3fc-200d-2642-fe0f",
            "1f937-1f3fd-200d-2642-fe0f",
            "1f937-1f3fe-200d-2642-fe0f",
            "1f937-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman shrugging",
            "woman-shrugging"
        ],
        u: "1f937-200d-2640-fe0f",
        v: [
            "1f937-1f3fb-200d-2640-fe0f",
            "1f937-1f3fc-200d-2640-fe0f",
            "1f937-1f3fd-200d-2640-fe0f",
            "1f937-1f3fe-200d-2640-fe0f",
            "1f937-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "health worker"
        ],
        u: "1f9d1-200d-2695-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2695-fe0f",
            "1f9d1-1f3fc-200d-2695-fe0f",
            "1f9d1-1f3fd-200d-2695-fe0f",
            "1f9d1-1f3fe-200d-2695-fe0f",
            "1f9d1-1f3ff-200d-2695-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "male-doctor",
            "man health worker"
        ],
        u: "1f468-200d-2695-fe0f",
        v: [
            "1f468-1f3fb-200d-2695-fe0f",
            "1f468-1f3fc-200d-2695-fe0f",
            "1f468-1f3fd-200d-2695-fe0f",
            "1f468-1f3fe-200d-2695-fe0f",
            "1f468-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "female-doctor",
            "woman health worker"
        ],
        u: "1f469-200d-2695-fe0f",
        v: [
            "1f469-1f3fb-200d-2695-fe0f",
            "1f469-1f3fc-200d-2695-fe0f",
            "1f469-1f3fd-200d-2695-fe0f",
            "1f469-1f3fe-200d-2695-fe0f",
            "1f469-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "student"
        ],
        u: "1f9d1-200d-1f393",
        v: [
            "1f9d1-1f3fb-200d-1f393",
            "1f9d1-1f3fc-200d-1f393",
            "1f9d1-1f3fd-200d-1f393",
            "1f9d1-1f3fe-200d-1f393",
            "1f9d1-1f3ff-200d-1f393"
        ],
        a: "12.1"
    },
    {
        n: [
            "man student",
            "male-student"
        ],
        u: "1f468-200d-1f393",
        v: [
            "1f468-1f3fb-200d-1f393",
            "1f468-1f3fc-200d-1f393",
            "1f468-1f3fd-200d-1f393",
            "1f468-1f3fe-200d-1f393",
            "1f468-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman student",
            "female-student"
        ],
        u: "1f469-200d-1f393",
        v: [
            "1f469-1f3fb-200d-1f393",
            "1f469-1f3fc-200d-1f393",
            "1f469-1f3fd-200d-1f393",
            "1f469-1f3fe-200d-1f393",
            "1f469-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "teacher"
        ],
        u: "1f9d1-200d-1f3eb",
        v: [
            "1f9d1-1f3fb-200d-1f3eb",
            "1f9d1-1f3fc-200d-1f3eb",
            "1f9d1-1f3fd-200d-1f3eb",
            "1f9d1-1f3fe-200d-1f3eb",
            "1f9d1-1f3ff-200d-1f3eb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man teacher",
            "male-teacher"
        ],
        u: "1f468-200d-1f3eb",
        v: [
            "1f468-1f3fb-200d-1f3eb",
            "1f468-1f3fc-200d-1f3eb",
            "1f468-1f3fd-200d-1f3eb",
            "1f468-1f3fe-200d-1f3eb",
            "1f468-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman teacher",
            "female-teacher"
        ],
        u: "1f469-200d-1f3eb",
        v: [
            "1f469-1f3fb-200d-1f3eb",
            "1f469-1f3fc-200d-1f3eb",
            "1f469-1f3fd-200d-1f3eb",
            "1f469-1f3fe-200d-1f3eb",
            "1f469-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "judge"
        ],
        u: "1f9d1-200d-2696-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2696-fe0f",
            "1f9d1-1f3fc-200d-2696-fe0f",
            "1f9d1-1f3fd-200d-2696-fe0f",
            "1f9d1-1f3fe-200d-2696-fe0f",
            "1f9d1-1f3ff-200d-2696-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man judge",
            "male-judge"
        ],
        u: "1f468-200d-2696-fe0f",
        v: [
            "1f468-1f3fb-200d-2696-fe0f",
            "1f468-1f3fc-200d-2696-fe0f",
            "1f468-1f3fd-200d-2696-fe0f",
            "1f468-1f3fe-200d-2696-fe0f",
            "1f468-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman judge",
            "female-judge"
        ],
        u: "1f469-200d-2696-fe0f",
        v: [
            "1f469-1f3fb-200d-2696-fe0f",
            "1f469-1f3fc-200d-2696-fe0f",
            "1f469-1f3fd-200d-2696-fe0f",
            "1f469-1f3fe-200d-2696-fe0f",
            "1f469-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "farmer"
        ],
        u: "1f9d1-200d-1f33e",
        v: [
            "1f9d1-1f3fb-200d-1f33e",
            "1f9d1-1f3fc-200d-1f33e",
            "1f9d1-1f3fd-200d-1f33e",
            "1f9d1-1f3fe-200d-1f33e",
            "1f9d1-1f3ff-200d-1f33e"
        ],
        a: "12.1"
    },
    {
        n: [
            "man farmer",
            "male-farmer"
        ],
        u: "1f468-200d-1f33e",
        v: [
            "1f468-1f3fb-200d-1f33e",
            "1f468-1f3fc-200d-1f33e",
            "1f468-1f3fd-200d-1f33e",
            "1f468-1f3fe-200d-1f33e",
            "1f468-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman farmer",
            "female-farmer"
        ],
        u: "1f469-200d-1f33e",
        v: [
            "1f469-1f3fb-200d-1f33e",
            "1f469-1f3fc-200d-1f33e",
            "1f469-1f3fd-200d-1f33e",
            "1f469-1f3fe-200d-1f33e",
            "1f469-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "cook"
        ],
        u: "1f9d1-200d-1f373",
        v: [
            "1f9d1-1f3fb-200d-1f373",
            "1f9d1-1f3fc-200d-1f373",
            "1f9d1-1f3fd-200d-1f373",
            "1f9d1-1f3fe-200d-1f373",
            "1f9d1-1f3ff-200d-1f373"
        ],
        a: "12.1"
    },
    {
        n: [
            "man cook",
            "male-cook"
        ],
        u: "1f468-200d-1f373",
        v: [
            "1f468-1f3fb-200d-1f373",
            "1f468-1f3fc-200d-1f373",
            "1f468-1f3fd-200d-1f373",
            "1f468-1f3fe-200d-1f373",
            "1f468-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cook",
            "female-cook"
        ],
        u: "1f469-200d-1f373",
        v: [
            "1f469-1f3fb-200d-1f373",
            "1f469-1f3fc-200d-1f373",
            "1f469-1f3fd-200d-1f373",
            "1f469-1f3fe-200d-1f373",
            "1f469-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "mechanic"
        ],
        u: "1f9d1-200d-1f527",
        v: [
            "1f9d1-1f3fb-200d-1f527",
            "1f9d1-1f3fc-200d-1f527",
            "1f9d1-1f3fd-200d-1f527",
            "1f9d1-1f3fe-200d-1f527",
            "1f9d1-1f3ff-200d-1f527"
        ],
        a: "12.1"
    },
    {
        n: [
            "man mechanic",
            "male-mechanic"
        ],
        u: "1f468-200d-1f527",
        v: [
            "1f468-1f3fb-200d-1f527",
            "1f468-1f3fc-200d-1f527",
            "1f468-1f3fd-200d-1f527",
            "1f468-1f3fe-200d-1f527",
            "1f468-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mechanic",
            "female-mechanic"
        ],
        u: "1f469-200d-1f527",
        v: [
            "1f469-1f3fb-200d-1f527",
            "1f469-1f3fc-200d-1f527",
            "1f469-1f3fd-200d-1f527",
            "1f469-1f3fe-200d-1f527",
            "1f469-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "factory worker"
        ],
        u: "1f9d1-200d-1f3ed",
        v: [
            "1f9d1-1f3fb-200d-1f3ed",
            "1f9d1-1f3fc-200d-1f3ed",
            "1f9d1-1f3fd-200d-1f3ed",
            "1f9d1-1f3fe-200d-1f3ed",
            "1f9d1-1f3ff-200d-1f3ed"
        ],
        a: "12.1"
    },
    {
        n: [
            "man factory worker",
            "male-factory-worker"
        ],
        u: "1f468-200d-1f3ed",
        v: [
            "1f468-1f3fb-200d-1f3ed",
            "1f468-1f3fc-200d-1f3ed",
            "1f468-1f3fd-200d-1f3ed",
            "1f468-1f3fe-200d-1f3ed",
            "1f468-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman factory worker",
            "female-factory-worker"
        ],
        u: "1f469-200d-1f3ed",
        v: [
            "1f469-1f3fb-200d-1f3ed",
            "1f469-1f3fc-200d-1f3ed",
            "1f469-1f3fd-200d-1f3ed",
            "1f469-1f3fe-200d-1f3ed",
            "1f469-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "office worker"
        ],
        u: "1f9d1-200d-1f4bc",
        v: [
            "1f9d1-1f3fb-200d-1f4bc",
            "1f9d1-1f3fc-200d-1f4bc",
            "1f9d1-1f3fd-200d-1f4bc",
            "1f9d1-1f3fe-200d-1f4bc",
            "1f9d1-1f3ff-200d-1f4bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man office worker",
            "male-office-worker"
        ],
        u: "1f468-200d-1f4bc",
        v: [
            "1f468-1f3fb-200d-1f4bc",
            "1f468-1f3fc-200d-1f4bc",
            "1f468-1f3fd-200d-1f4bc",
            "1f468-1f3fe-200d-1f4bc",
            "1f468-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman office worker",
            "female-office-worker"
        ],
        u: "1f469-200d-1f4bc",
        v: [
            "1f469-1f3fb-200d-1f4bc",
            "1f469-1f3fc-200d-1f4bc",
            "1f469-1f3fd-200d-1f4bc",
            "1f469-1f3fe-200d-1f4bc",
            "1f469-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "scientist"
        ],
        u: "1f9d1-200d-1f52c",
        v: [
            "1f9d1-1f3fb-200d-1f52c",
            "1f9d1-1f3fc-200d-1f52c",
            "1f9d1-1f3fd-200d-1f52c",
            "1f9d1-1f3fe-200d-1f52c",
            "1f9d1-1f3ff-200d-1f52c"
        ],
        a: "12.1"
    },
    {
        n: [
            "man scientist",
            "male-scientist"
        ],
        u: "1f468-200d-1f52c",
        v: [
            "1f468-1f3fb-200d-1f52c",
            "1f468-1f3fc-200d-1f52c",
            "1f468-1f3fd-200d-1f52c",
            "1f468-1f3fe-200d-1f52c",
            "1f468-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman scientist",
            "female-scientist"
        ],
        u: "1f469-200d-1f52c",
        v: [
            "1f469-1f3fb-200d-1f52c",
            "1f469-1f3fc-200d-1f52c",
            "1f469-1f3fd-200d-1f52c",
            "1f469-1f3fe-200d-1f52c",
            "1f469-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "technologist"
        ],
        u: "1f9d1-200d-1f4bb",
        v: [
            "1f9d1-1f3fb-200d-1f4bb",
            "1f9d1-1f3fc-200d-1f4bb",
            "1f9d1-1f3fd-200d-1f4bb",
            "1f9d1-1f3fe-200d-1f4bb",
            "1f9d1-1f3ff-200d-1f4bb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man technologist",
            "male-technologist"
        ],
        u: "1f468-200d-1f4bb",
        v: [
            "1f468-1f3fb-200d-1f4bb",
            "1f468-1f3fc-200d-1f4bb",
            "1f468-1f3fd-200d-1f4bb",
            "1f468-1f3fe-200d-1f4bb",
            "1f468-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman technologist",
            "female-technologist"
        ],
        u: "1f469-200d-1f4bb",
        v: [
            "1f469-1f3fb-200d-1f4bb",
            "1f469-1f3fc-200d-1f4bb",
            "1f469-1f3fd-200d-1f4bb",
            "1f469-1f3fe-200d-1f4bb",
            "1f469-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "singer"
        ],
        u: "1f9d1-200d-1f3a4",
        v: [
            "1f9d1-1f3fb-200d-1f3a4",
            "1f9d1-1f3fc-200d-1f3a4",
            "1f9d1-1f3fd-200d-1f3a4",
            "1f9d1-1f3fe-200d-1f3a4",
            "1f9d1-1f3ff-200d-1f3a4"
        ],
        a: "12.1"
    },
    {
        n: [
            "man singer",
            "male-singer"
        ],
        u: "1f468-200d-1f3a4",
        v: [
            "1f468-1f3fb-200d-1f3a4",
            "1f468-1f3fc-200d-1f3a4",
            "1f468-1f3fd-200d-1f3a4",
            "1f468-1f3fe-200d-1f3a4",
            "1f468-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman singer",
            "female-singer"
        ],
        u: "1f469-200d-1f3a4",
        v: [
            "1f469-1f3fb-200d-1f3a4",
            "1f469-1f3fc-200d-1f3a4",
            "1f469-1f3fd-200d-1f3a4",
            "1f469-1f3fe-200d-1f3a4",
            "1f469-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "artist"
        ],
        u: "1f9d1-200d-1f3a8",
        v: [
            "1f9d1-1f3fb-200d-1f3a8",
            "1f9d1-1f3fc-200d-1f3a8",
            "1f9d1-1f3fd-200d-1f3a8",
            "1f9d1-1f3fe-200d-1f3a8",
            "1f9d1-1f3ff-200d-1f3a8"
        ],
        a: "12.1"
    },
    {
        n: [
            "man artist",
            "male-artist"
        ],
        u: "1f468-200d-1f3a8",
        v: [
            "1f468-1f3fb-200d-1f3a8",
            "1f468-1f3fc-200d-1f3a8",
            "1f468-1f3fd-200d-1f3a8",
            "1f468-1f3fe-200d-1f3a8",
            "1f468-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman artist",
            "female-artist"
        ],
        u: "1f469-200d-1f3a8",
        v: [
            "1f469-1f3fb-200d-1f3a8",
            "1f469-1f3fc-200d-1f3a8",
            "1f469-1f3fd-200d-1f3a8",
            "1f469-1f3fe-200d-1f3a8",
            "1f469-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "pilot"
        ],
        u: "1f9d1-200d-2708-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2708-fe0f",
            "1f9d1-1f3fc-200d-2708-fe0f",
            "1f9d1-1f3fd-200d-2708-fe0f",
            "1f9d1-1f3fe-200d-2708-fe0f",
            "1f9d1-1f3ff-200d-2708-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man pilot",
            "male-pilot"
        ],
        u: "1f468-200d-2708-fe0f",
        v: [
            "1f468-1f3fb-200d-2708-fe0f",
            "1f468-1f3fc-200d-2708-fe0f",
            "1f468-1f3fd-200d-2708-fe0f",
            "1f468-1f3fe-200d-2708-fe0f",
            "1f468-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pilot",
            "female-pilot"
        ],
        u: "1f469-200d-2708-fe0f",
        v: [
            "1f469-1f3fb-200d-2708-fe0f",
            "1f469-1f3fc-200d-2708-fe0f",
            "1f469-1f3fd-200d-2708-fe0f",
            "1f469-1f3fe-200d-2708-fe0f",
            "1f469-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "astronaut"
        ],
        u: "1f9d1-200d-1f680",
        v: [
            "1f9d1-1f3fb-200d-1f680",
            "1f9d1-1f3fc-200d-1f680",
            "1f9d1-1f3fd-200d-1f680",
            "1f9d1-1f3fe-200d-1f680",
            "1f9d1-1f3ff-200d-1f680"
        ],
        a: "12.1"
    },
    {
        n: [
            "man astronaut",
            "male-astronaut"
        ],
        u: "1f468-200d-1f680",
        v: [
            "1f468-1f3fb-200d-1f680",
            "1f468-1f3fc-200d-1f680",
            "1f468-1f3fd-200d-1f680",
            "1f468-1f3fe-200d-1f680",
            "1f468-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman astronaut",
            "female-astronaut"
        ],
        u: "1f469-200d-1f680",
        v: [
            "1f469-1f3fb-200d-1f680",
            "1f469-1f3fc-200d-1f680",
            "1f469-1f3fd-200d-1f680",
            "1f469-1f3fe-200d-1f680",
            "1f469-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "firefighter"
        ],
        u: "1f9d1-200d-1f692",
        v: [
            "1f9d1-1f3fb-200d-1f692",
            "1f9d1-1f3fc-200d-1f692",
            "1f9d1-1f3fd-200d-1f692",
            "1f9d1-1f3fe-200d-1f692",
            "1f9d1-1f3ff-200d-1f692"
        ],
        a: "12.1"
    },
    {
        n: [
            "man firefighter",
            "male-firefighter"
        ],
        u: "1f468-200d-1f692",
        v: [
            "1f468-1f3fb-200d-1f692",
            "1f468-1f3fc-200d-1f692",
            "1f468-1f3fd-200d-1f692",
            "1f468-1f3fe-200d-1f692",
            "1f468-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman firefighter",
            "female-firefighter"
        ],
        u: "1f469-200d-1f692",
        v: [
            "1f469-1f3fb-200d-1f692",
            "1f469-1f3fc-200d-1f692",
            "1f469-1f3fd-200d-1f692",
            "1f469-1f3fe-200d-1f692",
            "1f469-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "cop",
            "police officer"
        ],
        u: "1f46e",
        v: [
            "1f46e-1f3fb",
            "1f46e-1f3fc",
            "1f46e-1f3fd",
            "1f46e-1f3fe",
            "1f46e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man police officer",
            "male-police-officer"
        ],
        u: "1f46e-200d-2642-fe0f",
        v: [
            "1f46e-1f3fb-200d-2642-fe0f",
            "1f46e-1f3fc-200d-2642-fe0f",
            "1f46e-1f3fd-200d-2642-fe0f",
            "1f46e-1f3fe-200d-2642-fe0f",
            "1f46e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman police officer",
            "female-police-officer"
        ],
        u: "1f46e-200d-2640-fe0f",
        v: [
            "1f46e-1f3fb-200d-2640-fe0f",
            "1f46e-1f3fc-200d-2640-fe0f",
            "1f46e-1f3fd-200d-2640-fe0f",
            "1f46e-1f3fe-200d-2640-fe0f",
            "1f46e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "detective",
            "sleuth or spy"
        ],
        u: "1f575-fe0f",
        v: [
            "1f575-1f3fb",
            "1f575-1f3fc",
            "1f575-1f3fd",
            "1f575-1f3fe",
            "1f575-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man detective",
            "male-detective"
        ],
        u: "1f575-fe0f-200d-2642-fe0f",
        v: [
            "1f575-1f3fb-200d-2642-fe0f",
            "1f575-1f3fc-200d-2642-fe0f",
            "1f575-1f3fd-200d-2642-fe0f",
            "1f575-1f3fe-200d-2642-fe0f",
            "1f575-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman detective",
            "female-detective"
        ],
        u: "1f575-fe0f-200d-2640-fe0f",
        v: [
            "1f575-1f3fb-200d-2640-fe0f",
            "1f575-1f3fc-200d-2640-fe0f",
            "1f575-1f3fd-200d-2640-fe0f",
            "1f575-1f3fe-200d-2640-fe0f",
            "1f575-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "guardsman"
        ],
        u: "1f482",
        v: [
            "1f482-1f3fb",
            "1f482-1f3fc",
            "1f482-1f3fd",
            "1f482-1f3fe",
            "1f482-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man guard",
            "male-guard"
        ],
        u: "1f482-200d-2642-fe0f",
        v: [
            "1f482-1f3fb-200d-2642-fe0f",
            "1f482-1f3fc-200d-2642-fe0f",
            "1f482-1f3fd-200d-2642-fe0f",
            "1f482-1f3fe-200d-2642-fe0f",
            "1f482-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman guard",
            "female-guard"
        ],
        u: "1f482-200d-2640-fe0f",
        v: [
            "1f482-1f3fb-200d-2640-fe0f",
            "1f482-1f3fc-200d-2640-fe0f",
            "1f482-1f3fd-200d-2640-fe0f",
            "1f482-1f3fe-200d-2640-fe0f",
            "1f482-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ninja"
        ],
        u: "1f977",
        v: [
            "1f977-1f3fb",
            "1f977-1f3fc",
            "1f977-1f3fd",
            "1f977-1f3fe",
            "1f977-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "construction worker"
        ],
        u: "1f477",
        v: [
            "1f477-1f3fb",
            "1f477-1f3fc",
            "1f477-1f3fd",
            "1f477-1f3fe",
            "1f477-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man construction worker",
            "male-construction-worker"
        ],
        u: "1f477-200d-2642-fe0f",
        v: [
            "1f477-1f3fb-200d-2642-fe0f",
            "1f477-1f3fc-200d-2642-fe0f",
            "1f477-1f3fd-200d-2642-fe0f",
            "1f477-1f3fe-200d-2642-fe0f",
            "1f477-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman construction worker",
            "female-construction-worker"
        ],
        u: "1f477-200d-2640-fe0f",
        v: [
            "1f477-1f3fb-200d-2640-fe0f",
            "1f477-1f3fc-200d-2640-fe0f",
            "1f477-1f3fd-200d-2640-fe0f",
            "1f477-1f3fe-200d-2640-fe0f",
            "1f477-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with crown"
        ],
        u: "1fac5",
        v: [
            "1fac5-1f3fb",
            "1fac5-1f3fc",
            "1fac5-1f3fd",
            "1fac5-1f3fe",
            "1fac5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "prince"
        ],
        u: "1f934",
        v: [
            "1f934-1f3fb",
            "1f934-1f3fc",
            "1f934-1f3fd",
            "1f934-1f3fe",
            "1f934-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "princess"
        ],
        u: "1f478",
        v: [
            "1f478-1f3fb",
            "1f478-1f3fc",
            "1f478-1f3fd",
            "1f478-1f3fe",
            "1f478-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with turban"
        ],
        u: "1f473",
        v: [
            "1f473-1f3fb",
            "1f473-1f3fc",
            "1f473-1f3fd",
            "1f473-1f3fe",
            "1f473-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man wearing turban",
            "man-wearing-turban"
        ],
        u: "1f473-200d-2642-fe0f",
        v: [
            "1f473-1f3fb-200d-2642-fe0f",
            "1f473-1f3fc-200d-2642-fe0f",
            "1f473-1f3fd-200d-2642-fe0f",
            "1f473-1f3fe-200d-2642-fe0f",
            "1f473-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman wearing turban",
            "woman-wearing-turban"
        ],
        u: "1f473-200d-2640-fe0f",
        v: [
            "1f473-1f3fb-200d-2640-fe0f",
            "1f473-1f3fc-200d-2640-fe0f",
            "1f473-1f3fd-200d-2640-fe0f",
            "1f473-1f3fe-200d-2640-fe0f",
            "1f473-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man with gua pi mao"
        ],
        u: "1f472",
        v: [
            "1f472-1f3fb",
            "1f472-1f3fc",
            "1f472-1f3fd",
            "1f472-1f3fe",
            "1f472-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person with headscarf"
        ],
        u: "1f9d5",
        v: [
            "1f9d5-1f3fb",
            "1f9d5-1f3fc",
            "1f9d5-1f3fd",
            "1f9d5-1f3fe",
            "1f9d5-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in tuxedo",
            "person in tuxedo"
        ],
        u: "1f935",
        v: [
            "1f935-1f3fb",
            "1f935-1f3fc",
            "1f935-1f3fd",
            "1f935-1f3fe",
            "1f935-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man in tuxedo"
        ],
        u: "1f935-200d-2642-fe0f",
        v: [
            "1f935-1f3fb-200d-2642-fe0f",
            "1f935-1f3fc-200d-2642-fe0f",
            "1f935-1f3fd-200d-2642-fe0f",
            "1f935-1f3fe-200d-2642-fe0f",
            "1f935-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman in tuxedo"
        ],
        u: "1f935-200d-2640-fe0f",
        v: [
            "1f935-1f3fb-200d-2640-fe0f",
            "1f935-1f3fc-200d-2640-fe0f",
            "1f935-1f3fd-200d-2640-fe0f",
            "1f935-1f3fe-200d-2640-fe0f",
            "1f935-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "bride with veil"
        ],
        u: "1f470",
        v: [
            "1f470-1f3fb",
            "1f470-1f3fc",
            "1f470-1f3fd",
            "1f470-1f3fe",
            "1f470-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with veil"
        ],
        u: "1f470-200d-2642-fe0f",
        v: [
            "1f470-1f3fb-200d-2642-fe0f",
            "1f470-1f3fc-200d-2642-fe0f",
            "1f470-1f3fd-200d-2642-fe0f",
            "1f470-1f3fe-200d-2642-fe0f",
            "1f470-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman with veil"
        ],
        u: "1f470-200d-2640-fe0f",
        v: [
            "1f470-1f3fb-200d-2640-fe0f",
            "1f470-1f3fc-200d-2640-fe0f",
            "1f470-1f3fd-200d-2640-fe0f",
            "1f470-1f3fe-200d-2640-fe0f",
            "1f470-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "pregnant woman"
        ],
        u: "1f930",
        v: [
            "1f930-1f3fb",
            "1f930-1f3fc",
            "1f930-1f3fd",
            "1f930-1f3fe",
            "1f930-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "pregnant man"
        ],
        u: "1fac3",
        v: [
            "1fac3-1f3fb",
            "1fac3-1f3fc",
            "1fac3-1f3fd",
            "1fac3-1f3fe",
            "1fac3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "pregnant person"
        ],
        u: "1fac4",
        v: [
            "1fac4-1f3fb",
            "1fac4-1f3fc",
            "1fac4-1f3fd",
            "1fac4-1f3fe",
            "1fac4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "breast-feeding"
        ],
        u: "1f931",
        v: [
            "1f931-1f3fb",
            "1f931-1f3fc",
            "1f931-1f3fd",
            "1f931-1f3fe",
            "1f931-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman feeding baby"
        ],
        u: "1f469-200d-1f37c",
        v: [
            "1f469-1f3fb-200d-1f37c",
            "1f469-1f3fc-200d-1f37c",
            "1f469-1f3fd-200d-1f37c",
            "1f469-1f3fe-200d-1f37c",
            "1f469-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "man feeding baby"
        ],
        u: "1f468-200d-1f37c",
        v: [
            "1f468-1f3fb-200d-1f37c",
            "1f468-1f3fc-200d-1f37c",
            "1f468-1f3fd-200d-1f37c",
            "1f468-1f3fe-200d-1f37c",
            "1f468-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "person feeding baby"
        ],
        u: "1f9d1-200d-1f37c",
        v: [
            "1f9d1-1f3fb-200d-1f37c",
            "1f9d1-1f3fc-200d-1f37c",
            "1f9d1-1f3fd-200d-1f37c",
            "1f9d1-1f3fe-200d-1f37c",
            "1f9d1-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "angel",
            "baby angel"
        ],
        u: "1f47c",
        v: [
            "1f47c-1f3fb",
            "1f47c-1f3fc",
            "1f47c-1f3fd",
            "1f47c-1f3fe",
            "1f47c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "santa",
            "father christmas"
        ],
        u: "1f385",
        v: [
            "1f385-1f3fb",
            "1f385-1f3fc",
            "1f385-1f3fd",
            "1f385-1f3fe",
            "1f385-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mrs claus",
            "mother christmas"
        ],
        u: "1f936",
        v: [
            "1f936-1f3fb",
            "1f936-1f3fc",
            "1f936-1f3fd",
            "1f936-1f3fe",
            "1f936-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "mx claus"
        ],
        u: "1f9d1-200d-1f384",
        v: [
            "1f9d1-1f3fb-200d-1f384",
            "1f9d1-1f3fc-200d-1f384",
            "1f9d1-1f3fd-200d-1f384",
            "1f9d1-1f3fe-200d-1f384",
            "1f9d1-1f3ff-200d-1f384"
        ],
        a: "13.0"
    },
    {
        n: [
            "superhero"
        ],
        u: "1f9b8",
        v: [
            "1f9b8-1f3fb",
            "1f9b8-1f3fc",
            "1f9b8-1f3fd",
            "1f9b8-1f3fe",
            "1f9b8-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man superhero",
            "male superhero"
        ],
        u: "1f9b8-200d-2642-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2642-fe0f",
            "1f9b8-1f3fc-200d-2642-fe0f",
            "1f9b8-1f3fd-200d-2642-fe0f",
            "1f9b8-1f3fe-200d-2642-fe0f",
            "1f9b8-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman superhero",
            "female superhero"
        ],
        u: "1f9b8-200d-2640-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2640-fe0f",
            "1f9b8-1f3fc-200d-2640-fe0f",
            "1f9b8-1f3fd-200d-2640-fe0f",
            "1f9b8-1f3fe-200d-2640-fe0f",
            "1f9b8-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "supervillain"
        ],
        u: "1f9b9",
        v: [
            "1f9b9-1f3fb",
            "1f9b9-1f3fc",
            "1f9b9-1f3fd",
            "1f9b9-1f3fe",
            "1f9b9-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man supervillain",
            "male supervillain"
        ],
        u: "1f9b9-200d-2642-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2642-fe0f",
            "1f9b9-1f3fc-200d-2642-fe0f",
            "1f9b9-1f3fd-200d-2642-fe0f",
            "1f9b9-1f3fe-200d-2642-fe0f",
            "1f9b9-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman supervillain",
            "female supervillain"
        ],
        u: "1f9b9-200d-2640-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2640-fe0f",
            "1f9b9-1f3fc-200d-2640-fe0f",
            "1f9b9-1f3fd-200d-2640-fe0f",
            "1f9b9-1f3fe-200d-2640-fe0f",
            "1f9b9-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "mage"
        ],
        u: "1f9d9",
        v: [
            "1f9d9-1f3fb",
            "1f9d9-1f3fc",
            "1f9d9-1f3fd",
            "1f9d9-1f3fe",
            "1f9d9-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man mage",
            "male mage"
        ],
        u: "1f9d9-200d-2642-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2642-fe0f",
            "1f9d9-1f3fc-200d-2642-fe0f",
            "1f9d9-1f3fd-200d-2642-fe0f",
            "1f9d9-1f3fe-200d-2642-fe0f",
            "1f9d9-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman mage",
            "female mage"
        ],
        u: "1f9d9-200d-2640-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2640-fe0f",
            "1f9d9-1f3fc-200d-2640-fe0f",
            "1f9d9-1f3fd-200d-2640-fe0f",
            "1f9d9-1f3fe-200d-2640-fe0f",
            "1f9d9-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fairy"
        ],
        u: "1f9da",
        v: [
            "1f9da-1f3fb",
            "1f9da-1f3fc",
            "1f9da-1f3fd",
            "1f9da-1f3fe",
            "1f9da-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man fairy",
            "male fairy"
        ],
        u: "1f9da-200d-2642-fe0f",
        v: [
            "1f9da-1f3fb-200d-2642-fe0f",
            "1f9da-1f3fc-200d-2642-fe0f",
            "1f9da-1f3fd-200d-2642-fe0f",
            "1f9da-1f3fe-200d-2642-fe0f",
            "1f9da-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman fairy",
            "female fairy"
        ],
        u: "1f9da-200d-2640-fe0f",
        v: [
            "1f9da-1f3fb-200d-2640-fe0f",
            "1f9da-1f3fc-200d-2640-fe0f",
            "1f9da-1f3fd-200d-2640-fe0f",
            "1f9da-1f3fe-200d-2640-fe0f",
            "1f9da-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "vampire"
        ],
        u: "1f9db",
        v: [
            "1f9db-1f3fb",
            "1f9db-1f3fc",
            "1f9db-1f3fd",
            "1f9db-1f3fe",
            "1f9db-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man vampire",
            "male vampire"
        ],
        u: "1f9db-200d-2642-fe0f",
        v: [
            "1f9db-1f3fb-200d-2642-fe0f",
            "1f9db-1f3fc-200d-2642-fe0f",
            "1f9db-1f3fd-200d-2642-fe0f",
            "1f9db-1f3fe-200d-2642-fe0f",
            "1f9db-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman vampire",
            "female vampire"
        ],
        u: "1f9db-200d-2640-fe0f",
        v: [
            "1f9db-1f3fb-200d-2640-fe0f",
            "1f9db-1f3fc-200d-2640-fe0f",
            "1f9db-1f3fd-200d-2640-fe0f",
            "1f9db-1f3fe-200d-2640-fe0f",
            "1f9db-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "merperson"
        ],
        u: "1f9dc",
        v: [
            "1f9dc-1f3fb",
            "1f9dc-1f3fc",
            "1f9dc-1f3fd",
            "1f9dc-1f3fe",
            "1f9dc-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "merman"
        ],
        u: "1f9dc-200d-2642-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2642-fe0f",
            "1f9dc-1f3fc-200d-2642-fe0f",
            "1f9dc-1f3fd-200d-2642-fe0f",
            "1f9dc-1f3fe-200d-2642-fe0f",
            "1f9dc-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "mermaid"
        ],
        u: "1f9dc-200d-2640-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2640-fe0f",
            "1f9dc-1f3fc-200d-2640-fe0f",
            "1f9dc-1f3fd-200d-2640-fe0f",
            "1f9dc-1f3fe-200d-2640-fe0f",
            "1f9dc-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "elf"
        ],
        u: "1f9dd",
        v: [
            "1f9dd-1f3fb",
            "1f9dd-1f3fc",
            "1f9dd-1f3fd",
            "1f9dd-1f3fe",
            "1f9dd-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man elf",
            "male elf"
        ],
        u: "1f9dd-200d-2642-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2642-fe0f",
            "1f9dd-1f3fc-200d-2642-fe0f",
            "1f9dd-1f3fd-200d-2642-fe0f",
            "1f9dd-1f3fe-200d-2642-fe0f",
            "1f9dd-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman elf",
            "female elf"
        ],
        u: "1f9dd-200d-2640-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2640-fe0f",
            "1f9dd-1f3fc-200d-2640-fe0f",
            "1f9dd-1f3fd-200d-2640-fe0f",
            "1f9dd-1f3fe-200d-2640-fe0f",
            "1f9dd-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "genie"
        ],
        u: "1f9de",
        a: "5.0"
    },
    {
        n: [
            "man genie",
            "male genie"
        ],
        u: "1f9de-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman genie",
            "female genie"
        ],
        u: "1f9de-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "zombie"
        ],
        u: "1f9df",
        a: "5.0"
    },
    {
        n: [
            "man zombie",
            "male zombie"
        ],
        u: "1f9df-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman zombie",
            "female zombie"
        ],
        u: "1f9df-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "troll"
        ],
        u: "1f9cc",
        a: "14.0"
    },
    {
        n: [
            "massage",
            "face massage"
        ],
        u: "1f486",
        v: [
            "1f486-1f3fb",
            "1f486-1f3fc",
            "1f486-1f3fd",
            "1f486-1f3fe",
            "1f486-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting massage",
            "man-getting-massage"
        ],
        u: "1f486-200d-2642-fe0f",
        v: [
            "1f486-1f3fb-200d-2642-fe0f",
            "1f486-1f3fc-200d-2642-fe0f",
            "1f486-1f3fd-200d-2642-fe0f",
            "1f486-1f3fe-200d-2642-fe0f",
            "1f486-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting massage",
            "woman-getting-massage"
        ],
        u: "1f486-200d-2640-fe0f",
        v: [
            "1f486-1f3fb-200d-2640-fe0f",
            "1f486-1f3fc-200d-2640-fe0f",
            "1f486-1f3fd-200d-2640-fe0f",
            "1f486-1f3fe-200d-2640-fe0f",
            "1f486-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "haircut"
        ],
        u: "1f487",
        v: [
            "1f487-1f3fb",
            "1f487-1f3fc",
            "1f487-1f3fd",
            "1f487-1f3fe",
            "1f487-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting haircut",
            "man-getting-haircut"
        ],
        u: "1f487-200d-2642-fe0f",
        v: [
            "1f487-1f3fb-200d-2642-fe0f",
            "1f487-1f3fc-200d-2642-fe0f",
            "1f487-1f3fd-200d-2642-fe0f",
            "1f487-1f3fe-200d-2642-fe0f",
            "1f487-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting haircut",
            "woman-getting-haircut"
        ],
        u: "1f487-200d-2640-fe0f",
        v: [
            "1f487-1f3fb-200d-2640-fe0f",
            "1f487-1f3fc-200d-2640-fe0f",
            "1f487-1f3fd-200d-2640-fe0f",
            "1f487-1f3fe-200d-2640-fe0f",
            "1f487-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "walking",
            "pedestrian"
        ],
        u: "1f6b6",
        v: [
            "1f6b6-1f3fb",
            "1f6b6-1f3fc",
            "1f6b6-1f3fd",
            "1f6b6-1f3fe",
            "1f6b6-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man walking",
            "man-walking"
        ],
        u: "1f6b6-200d-2642-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2642-fe0f",
            "1f6b6-1f3fc-200d-2642-fe0f",
            "1f6b6-1f3fd-200d-2642-fe0f",
            "1f6b6-1f3fe-200d-2642-fe0f",
            "1f6b6-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman walking",
            "woman-walking"
        ],
        u: "1f6b6-200d-2640-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2640-fe0f",
            "1f6b6-1f3fc-200d-2640-fe0f",
            "1f6b6-1f3fd-200d-2640-fe0f",
            "1f6b6-1f3fe-200d-2640-fe0f",
            "1f6b6-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "standing person"
        ],
        u: "1f9cd",
        v: [
            "1f9cd-1f3fb",
            "1f9cd-1f3fc",
            "1f9cd-1f3fd",
            "1f9cd-1f3fe",
            "1f9cd-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man standing"
        ],
        u: "1f9cd-200d-2642-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2642-fe0f",
            "1f9cd-1f3fc-200d-2642-fe0f",
            "1f9cd-1f3fd-200d-2642-fe0f",
            "1f9cd-1f3fe-200d-2642-fe0f",
            "1f9cd-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman standing"
        ],
        u: "1f9cd-200d-2640-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2640-fe0f",
            "1f9cd-1f3fc-200d-2640-fe0f",
            "1f9cd-1f3fd-200d-2640-fe0f",
            "1f9cd-1f3fe-200d-2640-fe0f",
            "1f9cd-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "kneeling person"
        ],
        u: "1f9ce",
        v: [
            "1f9ce-1f3fb",
            "1f9ce-1f3fc",
            "1f9ce-1f3fd",
            "1f9ce-1f3fe",
            "1f9ce-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man kneeling"
        ],
        u: "1f9ce-200d-2642-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2642-fe0f",
            "1f9ce-1f3fc-200d-2642-fe0f",
            "1f9ce-1f3fd-200d-2642-fe0f",
            "1f9ce-1f3fe-200d-2642-fe0f",
            "1f9ce-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman kneeling"
        ],
        u: "1f9ce-200d-2640-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2640-fe0f",
            "1f9ce-1f3fc-200d-2640-fe0f",
            "1f9ce-1f3fd-200d-2640-fe0f",
            "1f9ce-1f3fe-200d-2640-fe0f",
            "1f9ce-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "person with white cane",
            "person with probing cane"
        ],
        u: "1f9d1-200d-1f9af",
        v: [
            "1f9d1-1f3fb-200d-1f9af",
            "1f9d1-1f3fc-200d-1f9af",
            "1f9d1-1f3fd-200d-1f9af",
            "1f9d1-1f3fe-200d-1f9af",
            "1f9d1-1f3ff-200d-1f9af"
        ],
        a: "12.1"
    },
    {
        n: [
            "man with white cane",
            "man with probing cane"
        ],
        u: "1f468-200d-1f9af",
        v: [
            "1f468-1f3fb-200d-1f9af",
            "1f468-1f3fc-200d-1f9af",
            "1f468-1f3fd-200d-1f9af",
            "1f468-1f3fe-200d-1f9af",
            "1f468-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman with white cane",
            "woman with probing cane"
        ],
        u: "1f469-200d-1f9af",
        v: [
            "1f469-1f3fb-200d-1f9af",
            "1f469-1f3fc-200d-1f9af",
            "1f469-1f3fd-200d-1f9af",
            "1f469-1f3fe-200d-1f9af",
            "1f469-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in motorized wheelchair"
        ],
        u: "1f9d1-200d-1f9bc",
        v: [
            "1f9d1-1f3fb-200d-1f9bc",
            "1f9d1-1f3fc-200d-1f9bc",
            "1f9d1-1f3fd-200d-1f9bc",
            "1f9d1-1f3fe-200d-1f9bc",
            "1f9d1-1f3ff-200d-1f9bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in motorized wheelchair"
        ],
        u: "1f468-200d-1f9bc",
        v: [
            "1f468-1f3fb-200d-1f9bc",
            "1f468-1f3fc-200d-1f9bc",
            "1f468-1f3fd-200d-1f9bc",
            "1f468-1f3fe-200d-1f9bc",
            "1f468-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in motorized wheelchair"
        ],
        u: "1f469-200d-1f9bc",
        v: [
            "1f469-1f3fb-200d-1f9bc",
            "1f469-1f3fc-200d-1f9bc",
            "1f469-1f3fd-200d-1f9bc",
            "1f469-1f3fe-200d-1f9bc",
            "1f469-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in manual wheelchair"
        ],
        u: "1f9d1-200d-1f9bd",
        v: [
            "1f9d1-1f3fb-200d-1f9bd",
            "1f9d1-1f3fc-200d-1f9bd",
            "1f9d1-1f3fd-200d-1f9bd",
            "1f9d1-1f3fe-200d-1f9bd",
            "1f9d1-1f3ff-200d-1f9bd"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in manual wheelchair"
        ],
        u: "1f468-200d-1f9bd",
        v: [
            "1f468-1f3fb-200d-1f9bd",
            "1f468-1f3fc-200d-1f9bd",
            "1f468-1f3fd-200d-1f9bd",
            "1f468-1f3fe-200d-1f9bd",
            "1f468-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in manual wheelchair"
        ],
        u: "1f469-200d-1f9bd",
        v: [
            "1f469-1f3fb-200d-1f9bd",
            "1f469-1f3fc-200d-1f9bd",
            "1f469-1f3fd-200d-1f9bd",
            "1f469-1f3fe-200d-1f9bd",
            "1f469-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "runner",
            "running"
        ],
        u: "1f3c3",
        v: [
            "1f3c3-1f3fb",
            "1f3c3-1f3fc",
            "1f3c3-1f3fd",
            "1f3c3-1f3fe",
            "1f3c3-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man running",
            "man-running"
        ],
        u: "1f3c3-200d-2642-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2642-fe0f",
            "1f3c3-1f3fc-200d-2642-fe0f",
            "1f3c3-1f3fd-200d-2642-fe0f",
            "1f3c3-1f3fe-200d-2642-fe0f",
            "1f3c3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman running",
            "woman-running"
        ],
        u: "1f3c3-200d-2640-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2640-fe0f",
            "1f3c3-1f3fc-200d-2640-fe0f",
            "1f3c3-1f3fd-200d-2640-fe0f",
            "1f3c3-1f3fe-200d-2640-fe0f",
            "1f3c3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "dancer"
        ],
        u: "1f483",
        v: [
            "1f483-1f3fb",
            "1f483-1f3fc",
            "1f483-1f3fd",
            "1f483-1f3fe",
            "1f483-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man dancing"
        ],
        u: "1f57a",
        v: [
            "1f57a-1f3fb",
            "1f57a-1f3fc",
            "1f57a-1f3fd",
            "1f57a-1f3fe",
            "1f57a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "person in suit levitating",
            "man in business suit levitating"
        ],
        u: "1f574-fe0f",
        v: [
            "1f574-1f3fb",
            "1f574-1f3fc",
            "1f574-1f3fd",
            "1f574-1f3fe",
            "1f574-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "dancers",
            "woman with bunny ears"
        ],
        u: "1f46f",
        a: "0.6"
    },
    {
        n: [
            "men with bunny ears",
            "men-with-bunny-ears-partying",
            "man-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women with bunny ears",
            "women-with-bunny-ears-partying",
            "woman-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "person in steamy room"
        ],
        u: "1f9d6",
        v: [
            "1f9d6-1f3fb",
            "1f9d6-1f3fc",
            "1f9d6-1f3fd",
            "1f9d6-1f3fe",
            "1f9d6-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in steamy room"
        ],
        u: "1f9d6-200d-2642-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2642-fe0f",
            "1f9d6-1f3fc-200d-2642-fe0f",
            "1f9d6-1f3fd-200d-2642-fe0f",
            "1f9d6-1f3fe-200d-2642-fe0f",
            "1f9d6-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in steamy room"
        ],
        u: "1f9d6-200d-2640-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2640-fe0f",
            "1f9d6-1f3fc-200d-2640-fe0f",
            "1f9d6-1f3fd-200d-2640-fe0f",
            "1f9d6-1f3fe-200d-2640-fe0f",
            "1f9d6-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "person climbing"
        ],
        u: "1f9d7",
        v: [
            "1f9d7-1f3fb",
            "1f9d7-1f3fc",
            "1f9d7-1f3fd",
            "1f9d7-1f3fe",
            "1f9d7-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man climbing"
        ],
        u: "1f9d7-200d-2642-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2642-fe0f",
            "1f9d7-1f3fc-200d-2642-fe0f",
            "1f9d7-1f3fd-200d-2642-fe0f",
            "1f9d7-1f3fe-200d-2642-fe0f",
            "1f9d7-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman climbing"
        ],
        u: "1f9d7-200d-2640-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2640-fe0f",
            "1f9d7-1f3fc-200d-2640-fe0f",
            "1f9d7-1f3fd-200d-2640-fe0f",
            "1f9d7-1f3fe-200d-2640-fe0f",
            "1f9d7-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fencer"
        ],
        u: "1f93a",
        a: "3.0"
    },
    {
        n: [
            "horse racing"
        ],
        u: "1f3c7",
        v: [
            "1f3c7-1f3fb",
            "1f3c7-1f3fc",
            "1f3c7-1f3fd",
            "1f3c7-1f3fe",
            "1f3c7-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "skier"
        ],
        u: "26f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowboarder"
        ],
        u: "1f3c2",
        v: [
            "1f3c2-1f3fb",
            "1f3c2-1f3fc",
            "1f3c2-1f3fd",
            "1f3c2-1f3fe",
            "1f3c2-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "golfer",
            "person golfing"
        ],
        u: "1f3cc-fe0f",
        v: [
            "1f3cc-1f3fb",
            "1f3cc-1f3fc",
            "1f3cc-1f3fd",
            "1f3cc-1f3fe",
            "1f3cc-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man golfing",
            "man-golfing"
        ],
        u: "1f3cc-fe0f-200d-2642-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2642-fe0f",
            "1f3cc-1f3fc-200d-2642-fe0f",
            "1f3cc-1f3fd-200d-2642-fe0f",
            "1f3cc-1f3fe-200d-2642-fe0f",
            "1f3cc-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman golfing",
            "woman-golfing"
        ],
        u: "1f3cc-fe0f-200d-2640-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2640-fe0f",
            "1f3cc-1f3fc-200d-2640-fe0f",
            "1f3cc-1f3fd-200d-2640-fe0f",
            "1f3cc-1f3fe-200d-2640-fe0f",
            "1f3cc-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "surfer"
        ],
        u: "1f3c4",
        v: [
            "1f3c4-1f3fb",
            "1f3c4-1f3fc",
            "1f3c4-1f3fd",
            "1f3c4-1f3fe",
            "1f3c4-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man surfing",
            "man-surfing"
        ],
        u: "1f3c4-200d-2642-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2642-fe0f",
            "1f3c4-1f3fc-200d-2642-fe0f",
            "1f3c4-1f3fd-200d-2642-fe0f",
            "1f3c4-1f3fe-200d-2642-fe0f",
            "1f3c4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman surfing",
            "woman-surfing"
        ],
        u: "1f3c4-200d-2640-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2640-fe0f",
            "1f3c4-1f3fc-200d-2640-fe0f",
            "1f3c4-1f3fd-200d-2640-fe0f",
            "1f3c4-1f3fe-200d-2640-fe0f",
            "1f3c4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "rowboat"
        ],
        u: "1f6a3",
        v: [
            "1f6a3-1f3fb",
            "1f6a3-1f3fc",
            "1f6a3-1f3fd",
            "1f6a3-1f3fe",
            "1f6a3-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man rowing boat",
            "man-rowing-boat"
        ],
        u: "1f6a3-200d-2642-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2642-fe0f",
            "1f6a3-1f3fc-200d-2642-fe0f",
            "1f6a3-1f3fd-200d-2642-fe0f",
            "1f6a3-1f3fe-200d-2642-fe0f",
            "1f6a3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman rowing boat",
            "woman-rowing-boat"
        ],
        u: "1f6a3-200d-2640-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2640-fe0f",
            "1f6a3-1f3fc-200d-2640-fe0f",
            "1f6a3-1f3fd-200d-2640-fe0f",
            "1f6a3-1f3fe-200d-2640-fe0f",
            "1f6a3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "swimmer"
        ],
        u: "1f3ca",
        v: [
            "1f3ca-1f3fb",
            "1f3ca-1f3fc",
            "1f3ca-1f3fd",
            "1f3ca-1f3fe",
            "1f3ca-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man swimming",
            "man-swimming"
        ],
        u: "1f3ca-200d-2642-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2642-fe0f",
            "1f3ca-1f3fc-200d-2642-fe0f",
            "1f3ca-1f3fd-200d-2642-fe0f",
            "1f3ca-1f3fe-200d-2642-fe0f",
            "1f3ca-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman swimming",
            "woman-swimming"
        ],
        u: "1f3ca-200d-2640-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2640-fe0f",
            "1f3ca-1f3fc-200d-2640-fe0f",
            "1f3ca-1f3fd-200d-2640-fe0f",
            "1f3ca-1f3fe-200d-2640-fe0f",
            "1f3ca-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with ball",
            "person bouncing ball"
        ],
        u: "26f9-fe0f",
        v: [
            "26f9-1f3fb",
            "26f9-1f3fc",
            "26f9-1f3fd",
            "26f9-1f3fe",
            "26f9-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man bouncing ball",
            "man-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2642-fe0f",
        v: [
            "26f9-1f3fb-200d-2642-fe0f",
            "26f9-1f3fc-200d-2642-fe0f",
            "26f9-1f3fd-200d-2642-fe0f",
            "26f9-1f3fe-200d-2642-fe0f",
            "26f9-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bouncing ball",
            "woman-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2640-fe0f",
        v: [
            "26f9-1f3fb-200d-2640-fe0f",
            "26f9-1f3fc-200d-2640-fe0f",
            "26f9-1f3fd-200d-2640-fe0f",
            "26f9-1f3fe-200d-2640-fe0f",
            "26f9-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "weight lifter",
            "person lifting weights"
        ],
        u: "1f3cb-fe0f",
        v: [
            "1f3cb-1f3fb",
            "1f3cb-1f3fc",
            "1f3cb-1f3fd",
            "1f3cb-1f3fe",
            "1f3cb-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man lifting weights",
            "man-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2642-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2642-fe0f",
            "1f3cb-1f3fc-200d-2642-fe0f",
            "1f3cb-1f3fd-200d-2642-fe0f",
            "1f3cb-1f3fe-200d-2642-fe0f",
            "1f3cb-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman lifting weights",
            "woman-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2640-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2640-fe0f",
            "1f3cb-1f3fc-200d-2640-fe0f",
            "1f3cb-1f3fd-200d-2640-fe0f",
            "1f3cb-1f3fe-200d-2640-fe0f",
            "1f3cb-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "bicyclist"
        ],
        u: "1f6b4",
        v: [
            "1f6b4-1f3fb",
            "1f6b4-1f3fc",
            "1f6b4-1f3fd",
            "1f6b4-1f3fe",
            "1f6b4-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man biking",
            "man-biking"
        ],
        u: "1f6b4-200d-2642-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2642-fe0f",
            "1f6b4-1f3fc-200d-2642-fe0f",
            "1f6b4-1f3fd-200d-2642-fe0f",
            "1f6b4-1f3fe-200d-2642-fe0f",
            "1f6b4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman biking",
            "woman-biking"
        ],
        u: "1f6b4-200d-2640-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2640-fe0f",
            "1f6b4-1f3fc-200d-2640-fe0f",
            "1f6b4-1f3fd-200d-2640-fe0f",
            "1f6b4-1f3fe-200d-2640-fe0f",
            "1f6b4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "mountain bicyclist"
        ],
        u: "1f6b5",
        v: [
            "1f6b5-1f3fb",
            "1f6b5-1f3fc",
            "1f6b5-1f3fd",
            "1f6b5-1f3fe",
            "1f6b5-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man mountain biking",
            "man-mountain-biking"
        ],
        u: "1f6b5-200d-2642-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2642-fe0f",
            "1f6b5-1f3fc-200d-2642-fe0f",
            "1f6b5-1f3fd-200d-2642-fe0f",
            "1f6b5-1f3fe-200d-2642-fe0f",
            "1f6b5-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mountain biking",
            "woman-mountain-biking"
        ],
        u: "1f6b5-200d-2640-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2640-fe0f",
            "1f6b5-1f3fc-200d-2640-fe0f",
            "1f6b5-1f3fd-200d-2640-fe0f",
            "1f6b5-1f3fe-200d-2640-fe0f",
            "1f6b5-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person doing cartwheel"
        ],
        u: "1f938",
        v: [
            "1f938-1f3fb",
            "1f938-1f3fc",
            "1f938-1f3fd",
            "1f938-1f3fe",
            "1f938-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man cartwheeling",
            "man-cartwheeling"
        ],
        u: "1f938-200d-2642-fe0f",
        v: [
            "1f938-1f3fb-200d-2642-fe0f",
            "1f938-1f3fc-200d-2642-fe0f",
            "1f938-1f3fd-200d-2642-fe0f",
            "1f938-1f3fe-200d-2642-fe0f",
            "1f938-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cartwheeling",
            "woman-cartwheeling"
        ],
        u: "1f938-200d-2640-fe0f",
        v: [
            "1f938-1f3fb-200d-2640-fe0f",
            "1f938-1f3fc-200d-2640-fe0f",
            "1f938-1f3fd-200d-2640-fe0f",
            "1f938-1f3fe-200d-2640-fe0f",
            "1f938-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "wrestlers"
        ],
        u: "1f93c",
        a: "3.0"
    },
    {
        n: [
            "men wrestling",
            "man-wrestling"
        ],
        u: "1f93c-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women wrestling",
            "woman-wrestling"
        ],
        u: "1f93c-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "water polo"
        ],
        u: "1f93d",
        v: [
            "1f93d-1f3fb",
            "1f93d-1f3fc",
            "1f93d-1f3fd",
            "1f93d-1f3fe",
            "1f93d-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing water polo",
            "man-playing-water-polo"
        ],
        u: "1f93d-200d-2642-fe0f",
        v: [
            "1f93d-1f3fb-200d-2642-fe0f",
            "1f93d-1f3fc-200d-2642-fe0f",
            "1f93d-1f3fd-200d-2642-fe0f",
            "1f93d-1f3fe-200d-2642-fe0f",
            "1f93d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing water polo",
            "woman-playing-water-polo"
        ],
        u: "1f93d-200d-2640-fe0f",
        v: [
            "1f93d-1f3fb-200d-2640-fe0f",
            "1f93d-1f3fc-200d-2640-fe0f",
            "1f93d-1f3fd-200d-2640-fe0f",
            "1f93d-1f3fe-200d-2640-fe0f",
            "1f93d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "handball"
        ],
        u: "1f93e",
        v: [
            "1f93e-1f3fb",
            "1f93e-1f3fc",
            "1f93e-1f3fd",
            "1f93e-1f3fe",
            "1f93e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing handball",
            "man-playing-handball"
        ],
        u: "1f93e-200d-2642-fe0f",
        v: [
            "1f93e-1f3fb-200d-2642-fe0f",
            "1f93e-1f3fc-200d-2642-fe0f",
            "1f93e-1f3fd-200d-2642-fe0f",
            "1f93e-1f3fe-200d-2642-fe0f",
            "1f93e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing handball",
            "woman-playing-handball"
        ],
        u: "1f93e-200d-2640-fe0f",
        v: [
            "1f93e-1f3fb-200d-2640-fe0f",
            "1f93e-1f3fc-200d-2640-fe0f",
            "1f93e-1f3fd-200d-2640-fe0f",
            "1f93e-1f3fe-200d-2640-fe0f",
            "1f93e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "juggling"
        ],
        u: "1f939",
        v: [
            "1f939-1f3fb",
            "1f939-1f3fc",
            "1f939-1f3fd",
            "1f939-1f3fe",
            "1f939-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man juggling",
            "man-juggling"
        ],
        u: "1f939-200d-2642-fe0f",
        v: [
            "1f939-1f3fb-200d-2642-fe0f",
            "1f939-1f3fc-200d-2642-fe0f",
            "1f939-1f3fd-200d-2642-fe0f",
            "1f939-1f3fe-200d-2642-fe0f",
            "1f939-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman juggling",
            "woman-juggling"
        ],
        u: "1f939-200d-2640-fe0f",
        v: [
            "1f939-1f3fb-200d-2640-fe0f",
            "1f939-1f3fc-200d-2640-fe0f",
            "1f939-1f3fd-200d-2640-fe0f",
            "1f939-1f3fe-200d-2640-fe0f",
            "1f939-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person in lotus position"
        ],
        u: "1f9d8",
        v: [
            "1f9d8-1f3fb",
            "1f9d8-1f3fc",
            "1f9d8-1f3fd",
            "1f9d8-1f3fe",
            "1f9d8-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in lotus position"
        ],
        u: "1f9d8-200d-2642-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2642-fe0f",
            "1f9d8-1f3fc-200d-2642-fe0f",
            "1f9d8-1f3fd-200d-2642-fe0f",
            "1f9d8-1f3fe-200d-2642-fe0f",
            "1f9d8-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in lotus position"
        ],
        u: "1f9d8-200d-2640-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2640-fe0f",
            "1f9d8-1f3fc-200d-2640-fe0f",
            "1f9d8-1f3fd-200d-2640-fe0f",
            "1f9d8-1f3fe-200d-2640-fe0f",
            "1f9d8-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "bath"
        ],
        u: "1f6c0",
        v: [
            "1f6c0-1f3fb",
            "1f6c0-1f3fc",
            "1f6c0-1f3fd",
            "1f6c0-1f3fe",
            "1f6c0-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "sleeping accommodation"
        ],
        u: "1f6cc",
        v: [
            "1f6cc-1f3fb",
            "1f6cc-1f3fc",
            "1f6cc-1f3fd",
            "1f6cc-1f3fe",
            "1f6cc-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "people holding hands"
        ],
        u: "1f9d1-200d-1f91d-200d-1f9d1",
        v: [
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "women holding hands",
            "two women holding hands"
        ],
        u: "1f46d",
        v: [
            "1f46d-1f3fb",
            "1f46d-1f3fc",
            "1f46d-1f3fd",
            "1f46d-1f3fe",
            "1f46d-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "couple",
            "man and woman holding hands",
            "woman and man holding hands"
        ],
        u: "1f46b",
        v: [
            "1f46b-1f3fb",
            "1f46b-1f3fc",
            "1f46b-1f3fd",
            "1f46b-1f3fe",
            "1f46b-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "men holding hands",
            "two men holding hands"
        ],
        u: "1f46c",
        v: [
            "1f46c-1f3fb",
            "1f46c-1f3fc",
            "1f46c-1f3fd",
            "1f46c-1f3fe",
            "1f46c-1f3ff",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "kiss",
            "couplekiss"
        ],
        u: "1f48f",
        v: [
            "1f48f-1f3fb",
            "1f48f-1f3fc",
            "1f48f-1f3fd",
            "1f48f-1f3fe",
            "1f48f-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-kiss-man",
            "kiss: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-kiss-man",
            "kiss: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-kiss-woman",
            "kiss: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "couple with heart"
        ],
        u: "1f491",
        v: [
            "1f491-1f3fb",
            "1f491-1f3fc",
            "1f491-1f3fd",
            "1f491-1f3fe",
            "1f491-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-heart-man",
            "couple with heart: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-heart-man",
            "couple with heart: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-heart-woman",
            "couple with heart: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "family"
        ],
        u: "1f46a",
        a: "0.6"
    },
    {
        n: [
            "man-woman-boy",
            "family: man, woman, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl",
            "family: man, woman, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-boy",
            "family: man, woman, girl, boy"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-boy-boy",
            "family: man, woman, boy, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-girl",
            "family: man, woman, girl, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy",
            "family: man, man, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl",
            "family: man, man, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-boy",
            "family: man, man, girl, boy"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy-boy",
            "family: man, man, boy, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-girl",
            "family: man, man, girl, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy",
            "family: woman, woman, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl",
            "family: woman, woman, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-boy",
            "family: woman, woman, girl, boy"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy-boy",
            "family: woman, woman, boy, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-girl",
            "family: woman, woman, girl, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-boy",
            "family: man, boy"
        ],
        u: "1f468-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-boy-boy",
            "family: man, boy, boy"
        ],
        u: "1f468-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl",
            "family: man, girl"
        ],
        u: "1f468-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "man-girl-boy",
            "family: man, girl, boy"
        ],
        u: "1f468-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl-girl",
            "family: man, girl, girl"
        ],
        u: "1f468-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-boy",
            "family: woman, boy"
        ],
        u: "1f469-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-boy-boy",
            "family: woman, boy, boy"
        ],
        u: "1f469-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl",
            "family: woman, girl"
        ],
        u: "1f469-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-boy",
            "family: woman, girl, boy"
        ],
        u: "1f469-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-girl",
            "family: woman, girl, girl"
        ],
        u: "1f469-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "speaking head",
            "speaking head in silhouette"
        ],
        u: "1f5e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bust in silhouette"
        ],
        u: "1f464",
        a: "0.6"
    },
    {
        n: [
            "busts in silhouette"
        ],
        u: "1f465",
        a: "1.0"
    },
    {
        n: [
            "people hugging"
        ],
        u: "1fac2",
        a: "13.0"
    },
    {
        n: [
            "footprints"
        ],
        u: "1f463",
        a: "0.6"
    }
];
var animals_nature = [
    {
        n: [
            "monkey face"
        ],
        u: "1f435",
        a: "0.6"
    },
    {
        n: [
            "monkey"
        ],
        u: "1f412",
        a: "0.6"
    },
    {
        n: [
            "gorilla"
        ],
        u: "1f98d",
        a: "3.0"
    },
    {
        n: [
            "orangutan"
        ],
        u: "1f9a7",
        a: "12.0"
    },
    {
        n: [
            "dog",
            "dog face"
        ],
        u: "1f436",
        a: "0.6"
    },
    {
        n: [
            "dog",
            "dog2"
        ],
        u: "1f415",
        a: "0.7"
    },
    {
        n: [
            "guide dog"
        ],
        u: "1f9ae",
        a: "12.0"
    },
    {
        n: [
            "service dog"
        ],
        u: "1f415-200d-1f9ba",
        a: "12.0"
    },
    {
        n: [
            "poodle"
        ],
        u: "1f429",
        a: "0.6"
    },
    {
        n: [
            "wolf",
            "wolf face"
        ],
        u: "1f43a",
        a: "0.6"
    },
    {
        n: [
            "fox face"
        ],
        u: "1f98a",
        a: "3.0"
    },
    {
        n: [
            "raccoon"
        ],
        u: "1f99d",
        a: "11.0"
    },
    {
        n: [
            "cat",
            "cat face"
        ],
        u: "1f431",
        a: "0.6"
    },
    {
        n: [
            "cat",
            "cat2"
        ],
        u: "1f408",
        a: "0.7"
    },
    {
        n: [
            "black cat"
        ],
        u: "1f408-200d-2b1b",
        a: "13.0"
    },
    {
        n: [
            "lion face"
        ],
        u: "1f981",
        a: "1.0"
    },
    {
        n: [
            "tiger",
            "tiger face"
        ],
        u: "1f42f",
        a: "0.6"
    },
    {
        n: [
            "tiger",
            "tiger2"
        ],
        u: "1f405",
        a: "1.0"
    },
    {
        n: [
            "leopard"
        ],
        u: "1f406",
        a: "1.0"
    },
    {
        n: [
            "horse",
            "horse face"
        ],
        u: "1f434",
        a: "0.6"
    },
    {
        n: [
            "horse",
            "racehorse"
        ],
        u: "1f40e",
        a: "0.6"
    },
    {
        n: [
            "unicorn face"
        ],
        u: "1f984",
        a: "1.0"
    },
    {
        n: [
            "zebra face"
        ],
        u: "1f993",
        a: "5.0"
    },
    {
        n: [
            "deer"
        ],
        u: "1f98c",
        a: "3.0"
    },
    {
        n: [
            "bison"
        ],
        u: "1f9ac",
        a: "13.0"
    },
    {
        n: [
            "cow",
            "cow face"
        ],
        u: "1f42e",
        a: "0.6"
    },
    {
        n: [
            "ox"
        ],
        u: "1f402",
        a: "1.0"
    },
    {
        n: [
            "water buffalo"
        ],
        u: "1f403",
        a: "1.0"
    },
    {
        n: [
            "cow",
            "cow2"
        ],
        u: "1f404",
        a: "1.0"
    },
    {
        n: [
            "pig",
            "pig face"
        ],
        u: "1f437",
        a: "0.6"
    },
    {
        n: [
            "pig",
            "pig2"
        ],
        u: "1f416",
        a: "1.0"
    },
    {
        n: [
            "boar"
        ],
        u: "1f417",
        a: "0.6"
    },
    {
        n: [
            "pig nose"
        ],
        u: "1f43d",
        a: "0.6"
    },
    {
        n: [
            "ram"
        ],
        u: "1f40f",
        a: "1.0"
    },
    {
        n: [
            "sheep"
        ],
        u: "1f411",
        a: "0.6"
    },
    {
        n: [
            "goat"
        ],
        u: "1f410",
        a: "1.0"
    },
    {
        n: [
            "dromedary camel"
        ],
        u: "1f42a",
        a: "1.0"
    },
    {
        n: [
            "camel",
            "bactrian camel"
        ],
        u: "1f42b",
        a: "0.6"
    },
    {
        n: [
            "llama"
        ],
        u: "1f999",
        a: "11.0"
    },
    {
        n: [
            "giraffe face"
        ],
        u: "1f992",
        a: "5.0"
    },
    {
        n: [
            "elephant"
        ],
        u: "1f418",
        a: "0.6"
    },
    {
        n: [
            "mammoth"
        ],
        u: "1f9a3",
        a: "13.0"
    },
    {
        n: [
            "rhinoceros"
        ],
        u: "1f98f",
        a: "3.0"
    },
    {
        n: [
            "hippopotamus"
        ],
        u: "1f99b",
        a: "11.0"
    },
    {
        n: [
            "mouse",
            "mouse face"
        ],
        u: "1f42d",
        a: "0.6"
    },
    {
        n: [
            "mouse",
            "mouse2"
        ],
        u: "1f401",
        a: "1.0"
    },
    {
        n: [
            "rat"
        ],
        u: "1f400",
        a: "1.0"
    },
    {
        n: [
            "hamster",
            "hamster face"
        ],
        u: "1f439",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit face"
        ],
        u: "1f430",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit2"
        ],
        u: "1f407",
        a: "1.0"
    },
    {
        n: [
            "chipmunk"
        ],
        u: "1f43f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beaver"
        ],
        u: "1f9ab",
        a: "13.0"
    },
    {
        n: [
            "hedgehog"
        ],
        u: "1f994",
        a: "5.0"
    },
    {
        n: [
            "bat"
        ],
        u: "1f987",
        a: "3.0"
    },
    {
        n: [
            "bear",
            "bear face"
        ],
        u: "1f43b",
        a: "0.6"
    },
    {
        n: [
            "polar bear"
        ],
        u: "1f43b-200d-2744-fe0f",
        a: "13.0"
    },
    {
        n: [
            "koala"
        ],
        u: "1f428",
        a: "0.6"
    },
    {
        n: [
            "panda face"
        ],
        u: "1f43c",
        a: "0.6"
    },
    {
        n: [
            "sloth"
        ],
        u: "1f9a5",
        a: "12.0"
    },
    {
        n: [
            "otter"
        ],
        u: "1f9a6",
        a: "12.0"
    },
    {
        n: [
            "skunk"
        ],
        u: "1f9a8",
        a: "12.0"
    },
    {
        n: [
            "kangaroo"
        ],
        u: "1f998",
        a: "11.0"
    },
    {
        n: [
            "badger"
        ],
        u: "1f9a1",
        a: "11.0"
    },
    {
        n: [
            "feet",
            "paw prints"
        ],
        u: "1f43e",
        a: "0.6"
    },
    {
        n: [
            "turkey"
        ],
        u: "1f983",
        a: "1.0"
    },
    {
        n: [
            "chicken"
        ],
        u: "1f414",
        a: "0.6"
    },
    {
        n: [
            "rooster"
        ],
        u: "1f413",
        a: "1.0"
    },
    {
        n: [
            "hatching chick"
        ],
        u: "1f423",
        a: "0.6"
    },
    {
        n: [
            "baby chick"
        ],
        u: "1f424",
        a: "0.6"
    },
    {
        n: [
            "hatched chick",
            "front-facing baby chick"
        ],
        u: "1f425",
        a: "0.6"
    },
    {
        n: [
            "bird"
        ],
        u: "1f426",
        a: "0.6"
    },
    {
        n: [
            "penguin"
        ],
        u: "1f427",
        a: "0.6"
    },
    {
        n: [
            "dove",
            "dove of peace"
        ],
        u: "1f54a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eagle"
        ],
        u: "1f985",
        a: "3.0"
    },
    {
        n: [
            "duck"
        ],
        u: "1f986",
        a: "3.0"
    },
    {
        n: [
            "swan"
        ],
        u: "1f9a2",
        a: "11.0"
    },
    {
        n: [
            "owl"
        ],
        u: "1f989",
        a: "3.0"
    },
    {
        n: [
            "dodo"
        ],
        u: "1f9a4",
        a: "13.0"
    },
    {
        n: [
            "feather"
        ],
        u: "1fab6",
        a: "13.0"
    },
    {
        n: [
            "flamingo"
        ],
        u: "1f9a9",
        a: "12.0"
    },
    {
        n: [
            "peacock"
        ],
        u: "1f99a",
        a: "11.0"
    },
    {
        n: [
            "parrot"
        ],
        u: "1f99c",
        a: "11.0"
    },
    {
        n: [
            "frog",
            "frog face"
        ],
        u: "1f438",
        a: "0.6"
    },
    {
        n: [
            "crocodile"
        ],
        u: "1f40a",
        a: "1.0"
    },
    {
        n: [
            "turtle"
        ],
        u: "1f422",
        a: "0.6"
    },
    {
        n: [
            "lizard"
        ],
        u: "1f98e",
        a: "3.0"
    },
    {
        n: [
            "snake"
        ],
        u: "1f40d",
        a: "0.6"
    },
    {
        n: [
            "dragon face"
        ],
        u: "1f432",
        a: "0.6"
    },
    {
        n: [
            "dragon"
        ],
        u: "1f409",
        a: "1.0"
    },
    {
        n: [
            "sauropod"
        ],
        u: "1f995",
        a: "5.0"
    },
    {
        n: [
            "t-rex"
        ],
        u: "1f996",
        a: "5.0"
    },
    {
        n: [
            "whale",
            "spouting whale"
        ],
        u: "1f433",
        a: "0.6"
    },
    {
        n: [
            "whale",
            "whale2"
        ],
        u: "1f40b",
        a: "1.0"
    },
    {
        n: [
            "dolphin",
            "flipper"
        ],
        u: "1f42c",
        a: "0.6"
    },
    {
        n: [
            "seal"
        ],
        u: "1f9ad",
        a: "13.0"
    },
    {
        n: [
            "fish"
        ],
        u: "1f41f",
        a: "0.6"
    },
    {
        n: [
            "tropical fish"
        ],
        u: "1f420",
        a: "0.6"
    },
    {
        n: [
            "blowfish"
        ],
        u: "1f421",
        a: "0.6"
    },
    {
        n: [
            "shark"
        ],
        u: "1f988",
        a: "3.0"
    },
    {
        n: [
            "octopus"
        ],
        u: "1f419",
        a: "0.6"
    },
    {
        n: [
            "shell",
            "spiral shell"
        ],
        u: "1f41a",
        a: "0.6"
    },
    {
        n: [
            "coral"
        ],
        u: "1fab8",
        a: "14.0"
    },
    {
        n: [
            "snail"
        ],
        u: "1f40c",
        a: "0.6"
    },
    {
        n: [
            "butterfly"
        ],
        u: "1f98b",
        a: "3.0"
    },
    {
        n: [
            "bug"
        ],
        u: "1f41b",
        a: "0.6"
    },
    {
        n: [
            "ant"
        ],
        u: "1f41c",
        a: "0.6"
    },
    {
        n: [
            "bee",
            "honeybee"
        ],
        u: "1f41d",
        a: "0.6"
    },
    {
        n: [
            "beetle"
        ],
        u: "1fab2",
        a: "13.0"
    },
    {
        n: [
            "ladybug",
            "lady beetle"
        ],
        u: "1f41e",
        a: "0.6"
    },
    {
        n: [
            "cricket"
        ],
        u: "1f997",
        a: "5.0"
    },
    {
        n: [
            "cockroach"
        ],
        u: "1fab3",
        a: "13.0"
    },
    {
        n: [
            "spider"
        ],
        u: "1f577-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spider web"
        ],
        u: "1f578-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scorpion"
        ],
        u: "1f982",
        a: "1.0"
    },
    {
        n: [
            "mosquito"
        ],
        u: "1f99f",
        a: "11.0"
    },
    {
        n: [
            "fly"
        ],
        u: "1fab0",
        a: "13.0"
    },
    {
        n: [
            "worm"
        ],
        u: "1fab1",
        a: "13.0"
    },
    {
        n: [
            "microbe"
        ],
        u: "1f9a0",
        a: "11.0"
    },
    {
        n: [
            "bouquet"
        ],
        u: "1f490",
        a: "0.6"
    },
    {
        n: [
            "cherry blossom"
        ],
        u: "1f338",
        a: "0.6"
    },
    {
        n: [
            "white flower"
        ],
        u: "1f4ae",
        a: "0.6"
    },
    {
        n: [
            "lotus"
        ],
        u: "1fab7",
        a: "14.0"
    },
    {
        n: [
            "rosette"
        ],
        u: "1f3f5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rose"
        ],
        u: "1f339",
        a: "0.6"
    },
    {
        n: [
            "wilted flower"
        ],
        u: "1f940",
        a: "3.0"
    },
    {
        n: [
            "hibiscus"
        ],
        u: "1f33a",
        a: "0.6"
    },
    {
        n: [
            "sunflower"
        ],
        u: "1f33b",
        a: "0.6"
    },
    {
        n: [
            "blossom"
        ],
        u: "1f33c",
        a: "0.6"
    },
    {
        n: [
            "tulip"
        ],
        u: "1f337",
        a: "0.6"
    },
    {
        n: [
            "seedling"
        ],
        u: "1f331",
        a: "0.6"
    },
    {
        n: [
            "potted plant"
        ],
        u: "1fab4",
        a: "13.0"
    },
    {
        n: [
            "evergreen tree"
        ],
        u: "1f332",
        a: "1.0"
    },
    {
        n: [
            "deciduous tree"
        ],
        u: "1f333",
        a: "1.0"
    },
    {
        n: [
            "palm tree"
        ],
        u: "1f334",
        a: "0.6"
    },
    {
        n: [
            "cactus"
        ],
        u: "1f335",
        a: "0.6"
    },
    {
        n: [
            "ear of rice"
        ],
        u: "1f33e",
        a: "0.6"
    },
    {
        n: [
            "herb"
        ],
        u: "1f33f",
        a: "0.6"
    },
    {
        n: [
            "shamrock"
        ],
        u: "2618-fe0f",
        a: "1.0"
    },
    {
        n: [
            "four leaf clover"
        ],
        u: "1f340",
        a: "0.6"
    },
    {
        n: [
            "maple leaf"
        ],
        u: "1f341",
        a: "0.6"
    },
    {
        n: [
            "fallen leaf"
        ],
        u: "1f342",
        a: "0.6"
    },
    {
        n: [
            "leaves",
            "leaf fluttering in wind"
        ],
        u: "1f343",
        a: "0.6"
    },
    {
        n: [
            "empty nest"
        ],
        u: "1fab9",
        a: "14.0"
    },
    {
        n: [
            "nest with eggs"
        ],
        u: "1faba",
        a: "14.0"
    }
];
var food_drink = [
    {
        n: [
            "grapes"
        ],
        u: "1f347",
        a: "0.6"
    },
    {
        n: [
            "melon"
        ],
        u: "1f348",
        a: "0.6"
    },
    {
        n: [
            "watermelon"
        ],
        u: "1f349",
        a: "0.6"
    },
    {
        n: [
            "tangerine"
        ],
        u: "1f34a",
        a: "0.6"
    },
    {
        n: [
            "lemon"
        ],
        u: "1f34b",
        a: "1.0"
    },
    {
        n: [
            "banana"
        ],
        u: "1f34c",
        a: "0.6"
    },
    {
        n: [
            "pineapple"
        ],
        u: "1f34d",
        a: "0.6"
    },
    {
        n: [
            "mango"
        ],
        u: "1f96d",
        a: "11.0"
    },
    {
        n: [
            "apple",
            "red apple"
        ],
        u: "1f34e",
        a: "0.6"
    },
    {
        n: [
            "green apple"
        ],
        u: "1f34f",
        a: "0.6"
    },
    {
        n: [
            "pear"
        ],
        u: "1f350",
        a: "1.0"
    },
    {
        n: [
            "peach"
        ],
        u: "1f351",
        a: "0.6"
    },
    {
        n: [
            "cherries"
        ],
        u: "1f352",
        a: "0.6"
    },
    {
        n: [
            "strawberry"
        ],
        u: "1f353",
        a: "0.6"
    },
    {
        n: [
            "blueberries"
        ],
        u: "1fad0",
        a: "13.0"
    },
    {
        n: [
            "kiwifruit"
        ],
        u: "1f95d",
        a: "3.0"
    },
    {
        n: [
            "tomato"
        ],
        u: "1f345",
        a: "0.6"
    },
    {
        n: [
            "olive"
        ],
        u: "1fad2",
        a: "13.0"
    },
    {
        n: [
            "coconut"
        ],
        u: "1f965",
        a: "5.0"
    },
    {
        n: [
            "avocado"
        ],
        u: "1f951",
        a: "3.0"
    },
    {
        n: [
            "eggplant",
            "aubergine"
        ],
        u: "1f346",
        a: "0.6"
    },
    {
        n: [
            "potato"
        ],
        u: "1f954",
        a: "3.0"
    },
    {
        n: [
            "carrot"
        ],
        u: "1f955",
        a: "3.0"
    },
    {
        n: [
            "corn",
            "ear of maize"
        ],
        u: "1f33d",
        a: "0.6"
    },
    {
        n: [
            "hot pepper"
        ],
        u: "1f336-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bell pepper"
        ],
        u: "1fad1",
        a: "13.0"
    },
    {
        n: [
            "cucumber"
        ],
        u: "1f952",
        a: "3.0"
    },
    {
        n: [
            "leafy green"
        ],
        u: "1f96c",
        a: "11.0"
    },
    {
        n: [
            "broccoli"
        ],
        u: "1f966",
        a: "5.0"
    },
    {
        n: [
            "garlic"
        ],
        u: "1f9c4",
        a: "12.0"
    },
    {
        n: [
            "onion"
        ],
        u: "1f9c5",
        a: "12.0"
    },
    {
        n: [
            "mushroom"
        ],
        u: "1f344",
        a: "0.6"
    },
    {
        n: [
            "peanuts"
        ],
        u: "1f95c",
        a: "3.0"
    },
    {
        n: [
            "beans"
        ],
        u: "1fad8",
        a: "14.0"
    },
    {
        n: [
            "chestnut"
        ],
        u: "1f330",
        a: "0.6"
    },
    {
        n: [
            "bread"
        ],
        u: "1f35e",
        a: "0.6"
    },
    {
        n: [
            "croissant"
        ],
        u: "1f950",
        a: "3.0"
    },
    {
        n: [
            "baguette bread"
        ],
        u: "1f956",
        a: "3.0"
    },
    {
        n: [
            "flatbread"
        ],
        u: "1fad3",
        a: "13.0"
    },
    {
        n: [
            "pretzel"
        ],
        u: "1f968",
        a: "5.0"
    },
    {
        n: [
            "bagel"
        ],
        u: "1f96f",
        a: "11.0"
    },
    {
        n: [
            "pancakes"
        ],
        u: "1f95e",
        a: "3.0"
    },
    {
        n: [
            "waffle"
        ],
        u: "1f9c7",
        a: "12.0"
    },
    {
        n: [
            "cheese wedge"
        ],
        u: "1f9c0",
        a: "1.0"
    },
    {
        n: [
            "meat on bone"
        ],
        u: "1f356",
        a: "0.6"
    },
    {
        n: [
            "poultry leg"
        ],
        u: "1f357",
        a: "0.6"
    },
    {
        n: [
            "cut of meat"
        ],
        u: "1f969",
        a: "5.0"
    },
    {
        n: [
            "bacon"
        ],
        u: "1f953",
        a: "3.0"
    },
    {
        n: [
            "hamburger"
        ],
        u: "1f354",
        a: "0.6"
    },
    {
        n: [
            "fries",
            "french fries"
        ],
        u: "1f35f",
        a: "0.6"
    },
    {
        n: [
            "pizza",
            "slice of pizza"
        ],
        u: "1f355",
        a: "0.6"
    },
    {
        n: [
            "hotdog",
            "hot dog"
        ],
        u: "1f32d",
        a: "1.0"
    },
    {
        n: [
            "sandwich"
        ],
        u: "1f96a",
        a: "5.0"
    },
    {
        n: [
            "taco"
        ],
        u: "1f32e",
        a: "1.0"
    },
    {
        n: [
            "burrito"
        ],
        u: "1f32f",
        a: "1.0"
    },
    {
        n: [
            "tamale"
        ],
        u: "1fad4",
        a: "13.0"
    },
    {
        n: [
            "stuffed flatbread"
        ],
        u: "1f959",
        a: "3.0"
    },
    {
        n: [
            "falafel"
        ],
        u: "1f9c6",
        a: "12.0"
    },
    {
        n: [
            "egg"
        ],
        u: "1f95a",
        a: "3.0"
    },
    {
        n: [
            "cooking",
            "fried egg"
        ],
        u: "1f373",
        a: "0.6"
    },
    {
        n: [
            "shallow pan of food"
        ],
        u: "1f958",
        a: "3.0"
    },
    {
        n: [
            "stew",
            "pot of food"
        ],
        u: "1f372",
        a: "0.6"
    },
    {
        n: [
            "fondue"
        ],
        u: "1fad5",
        a: "13.0"
    },
    {
        n: [
            "bowl with spoon"
        ],
        u: "1f963",
        a: "5.0"
    },
    {
        n: [
            "green salad"
        ],
        u: "1f957",
        a: "3.0"
    },
    {
        n: [
            "popcorn"
        ],
        u: "1f37f",
        a: "1.0"
    },
    {
        n: [
            "butter"
        ],
        u: "1f9c8",
        a: "12.0"
    },
    {
        n: [
            "salt",
            "salt shaker"
        ],
        u: "1f9c2",
        a: "11.0"
    },
    {
        n: [
            "canned food"
        ],
        u: "1f96b",
        a: "5.0"
    },
    {
        n: [
            "bento",
            "bento box"
        ],
        u: "1f371",
        a: "0.6"
    },
    {
        n: [
            "rice cracker"
        ],
        u: "1f358",
        a: "0.6"
    },
    {
        n: [
            "rice ball"
        ],
        u: "1f359",
        a: "0.6"
    },
    {
        n: [
            "rice",
            "cooked rice"
        ],
        u: "1f35a",
        a: "0.6"
    },
    {
        n: [
            "curry",
            "curry and rice"
        ],
        u: "1f35b",
        a: "0.6"
    },
    {
        n: [
            "ramen",
            "steaming bowl"
        ],
        u: "1f35c",
        a: "0.6"
    },
    {
        n: [
            "spaghetti"
        ],
        u: "1f35d",
        a: "0.6"
    },
    {
        n: [
            "sweet potato",
            "roasted sweet potato"
        ],
        u: "1f360",
        a: "0.6"
    },
    {
        n: [
            "oden"
        ],
        u: "1f362",
        a: "0.6"
    },
    {
        n: [
            "sushi"
        ],
        u: "1f363",
        a: "0.6"
    },
    {
        n: [
            "fried shrimp"
        ],
        u: "1f364",
        a: "0.6"
    },
    {
        n: [
            "fish cake",
            "fish cake with swirl design"
        ],
        u: "1f365",
        a: "0.6"
    },
    {
        n: [
            "moon cake"
        ],
        u: "1f96e",
        a: "11.0"
    },
    {
        n: [
            "dango"
        ],
        u: "1f361",
        a: "0.6"
    },
    {
        n: [
            "dumpling"
        ],
        u: "1f95f",
        a: "5.0"
    },
    {
        n: [
            "fortune cookie"
        ],
        u: "1f960",
        a: "5.0"
    },
    {
        n: [
            "takeout box"
        ],
        u: "1f961",
        a: "5.0"
    },
    {
        n: [
            "crab"
        ],
        u: "1f980",
        a: "1.0"
    },
    {
        n: [
            "lobster"
        ],
        u: "1f99e",
        a: "11.0"
    },
    {
        n: [
            "shrimp"
        ],
        u: "1f990",
        a: "3.0"
    },
    {
        n: [
            "squid"
        ],
        u: "1f991",
        a: "3.0"
    },
    {
        n: [
            "oyster"
        ],
        u: "1f9aa",
        a: "12.0"
    },
    {
        n: [
            "icecream",
            "soft ice cream"
        ],
        u: "1f366",
        a: "0.6"
    },
    {
        n: [
            "shaved ice"
        ],
        u: "1f367",
        a: "0.6"
    },
    {
        n: [
            "ice cream"
        ],
        u: "1f368",
        a: "0.6"
    },
    {
        n: [
            "doughnut"
        ],
        u: "1f369",
        a: "0.6"
    },
    {
        n: [
            "cookie"
        ],
        u: "1f36a",
        a: "0.6"
    },
    {
        n: [
            "birthday",
            "birthday cake"
        ],
        u: "1f382",
        a: "0.6"
    },
    {
        n: [
            "cake",
            "shortcake"
        ],
        u: "1f370",
        a: "0.6"
    },
    {
        n: [
            "cupcake"
        ],
        u: "1f9c1",
        a: "11.0"
    },
    {
        n: [
            "pie"
        ],
        u: "1f967",
        a: "5.0"
    },
    {
        n: [
            "chocolate bar"
        ],
        u: "1f36b",
        a: "0.6"
    },
    {
        n: [
            "candy"
        ],
        u: "1f36c",
        a: "0.6"
    },
    {
        n: [
            "lollipop"
        ],
        u: "1f36d",
        a: "0.6"
    },
    {
        n: [
            "custard"
        ],
        u: "1f36e",
        a: "0.6"
    },
    {
        n: [
            "honey pot"
        ],
        u: "1f36f",
        a: "0.6"
    },
    {
        n: [
            "baby bottle"
        ],
        u: "1f37c",
        a: "1.0"
    },
    {
        n: [
            "glass of milk"
        ],
        u: "1f95b",
        a: "3.0"
    },
    {
        n: [
            "coffee",
            "hot beverage"
        ],
        u: "2615",
        a: "0.6"
    },
    {
        n: [
            "teapot"
        ],
        u: "1fad6",
        a: "13.0"
    },
    {
        n: [
            "tea",
            "teacup without handle"
        ],
        u: "1f375",
        a: "0.6"
    },
    {
        n: [
            "sake",
            "sake bottle and cup"
        ],
        u: "1f376",
        a: "0.6"
    },
    {
        n: [
            "champagne",
            "bottle with popping cork"
        ],
        u: "1f37e",
        a: "1.0"
    },
    {
        n: [
            "wine glass"
        ],
        u: "1f377",
        a: "0.6"
    },
    {
        n: [
            "cocktail",
            "cocktail glass"
        ],
        u: "1f378",
        a: "0.6"
    },
    {
        n: [
            "tropical drink"
        ],
        u: "1f379",
        a: "0.6"
    },
    {
        n: [
            "beer",
            "beer mug"
        ],
        u: "1f37a",
        a: "0.6"
    },
    {
        n: [
            "beers",
            "clinking beer mugs"
        ],
        u: "1f37b",
        a: "0.6"
    },
    {
        n: [
            "clinking glasses"
        ],
        u: "1f942",
        a: "3.0"
    },
    {
        n: [
            "tumbler glass"
        ],
        u: "1f943",
        a: "3.0"
    },
    {
        n: [
            "pouring liquid"
        ],
        u: "1fad7",
        a: "14.0"
    },
    {
        n: [
            "cup with straw"
        ],
        u: "1f964",
        a: "5.0"
    },
    {
        n: [
            "bubble tea"
        ],
        u: "1f9cb",
        a: "13.0"
    },
    {
        n: [
            "beverage box"
        ],
        u: "1f9c3",
        a: "12.0"
    },
    {
        n: [
            "mate drink"
        ],
        u: "1f9c9",
        a: "12.0"
    },
    {
        n: [
            "ice cube"
        ],
        u: "1f9ca",
        a: "12.0"
    },
    {
        n: [
            "chopsticks"
        ],
        u: "1f962",
        a: "5.0"
    },
    {
        n: [
            "knife fork plate",
            "fork and knife with plate"
        ],
        u: "1f37d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fork and knife"
        ],
        u: "1f374",
        a: "0.6"
    },
    {
        n: [
            "spoon"
        ],
        u: "1f944",
        a: "3.0"
    },
    {
        n: [
            "hocho",
            "knife"
        ],
        u: "1f52a",
        a: "0.6"
    },
    {
        n: [
            "jar"
        ],
        u: "1fad9",
        a: "14.0"
    },
    {
        n: [
            "amphora"
        ],
        u: "1f3fa",
        a: "1.0"
    }
];
var travel_places = [
    {
        n: [
            "earth africa",
            "earth globe europe-africa"
        ],
        u: "1f30d",
        a: "0.7"
    },
    {
        n: [
            "earth americas",
            "earth globe americas"
        ],
        u: "1f30e",
        a: "0.7"
    },
    {
        n: [
            "earth asia",
            "earth globe asia-australia"
        ],
        u: "1f30f",
        a: "0.6"
    },
    {
        n: [
            "globe with meridians"
        ],
        u: "1f310",
        a: "1.0"
    },
    {
        n: [
            "world map"
        ],
        u: "1f5fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "japan",
            "silhouette of japan"
        ],
        u: "1f5fe",
        a: "0.6"
    },
    {
        n: [
            "compass"
        ],
        u: "1f9ed",
        a: "11.0"
    },
    {
        n: [
            "snow-capped mountain",
            "snow capped mountain"
        ],
        u: "1f3d4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mountain"
        ],
        u: "26f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "volcano"
        ],
        u: "1f30b",
        a: "0.6"
    },
    {
        n: [
            "mount fuji"
        ],
        u: "1f5fb",
        a: "0.6"
    },
    {
        n: [
            "camping"
        ],
        u: "1f3d5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beach with umbrella"
        ],
        u: "1f3d6-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert"
        ],
        u: "1f3dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert island"
        ],
        u: "1f3dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "national park"
        ],
        u: "1f3de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stadium"
        ],
        u: "1f3df-fe0f",
        a: "0.7"
    },
    {
        n: [
            "classical building"
        ],
        u: "1f3db-fe0f",
        a: "0.7"
    },
    {
        n: [
            "building construction"
        ],
        u: "1f3d7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "brick",
            "bricks"
        ],
        u: "1f9f1",
        a: "11.0"
    },
    {
        n: [
            "rock"
        ],
        u: "1faa8",
        a: "13.0"
    },
    {
        n: [
            "wood"
        ],
        u: "1fab5",
        a: "13.0"
    },
    {
        n: [
            "hut"
        ],
        u: "1f6d6",
        a: "13.0"
    },
    {
        n: [
            "houses",
            "house buildings"
        ],
        u: "1f3d8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "derelict house",
            "derelict house building"
        ],
        u: "1f3da-fe0f",
        a: "0.7"
    },
    {
        n: [
            "house",
            "house building"
        ],
        u: "1f3e0",
        a: "0.6"
    },
    {
        n: [
            "house with garden"
        ],
        u: "1f3e1",
        a: "0.6"
    },
    {
        n: [
            "office",
            "office building"
        ],
        u: "1f3e2",
        a: "0.6"
    },
    {
        n: [
            "post office",
            "japanese post office"
        ],
        u: "1f3e3",
        a: "0.6"
    },
    {
        n: [
            "european post office"
        ],
        u: "1f3e4",
        a: "1.0"
    },
    {
        n: [
            "hospital"
        ],
        u: "1f3e5",
        a: "0.6"
    },
    {
        n: [
            "bank"
        ],
        u: "1f3e6",
        a: "0.6"
    },
    {
        n: [
            "hotel"
        ],
        u: "1f3e8",
        a: "0.6"
    },
    {
        n: [
            "love hotel"
        ],
        u: "1f3e9",
        a: "0.6"
    },
    {
        n: [
            "convenience store"
        ],
        u: "1f3ea",
        a: "0.6"
    },
    {
        n: [
            "school"
        ],
        u: "1f3eb",
        a: "0.6"
    },
    {
        n: [
            "department store"
        ],
        u: "1f3ec",
        a: "0.6"
    },
    {
        n: [
            "factory"
        ],
        u: "1f3ed",
        a: "0.6"
    },
    {
        n: [
            "japanese castle"
        ],
        u: "1f3ef",
        a: "0.6"
    },
    {
        n: [
            "european castle"
        ],
        u: "1f3f0",
        a: "0.6"
    },
    {
        n: [
            "wedding"
        ],
        u: "1f492",
        a: "0.6"
    },
    {
        n: [
            "tokyo tower"
        ],
        u: "1f5fc",
        a: "0.6"
    },
    {
        n: [
            "statue of liberty"
        ],
        u: "1f5fd",
        a: "0.6"
    },
    {
        n: [
            "church"
        ],
        u: "26ea",
        a: "0.6"
    },
    {
        n: [
            "mosque"
        ],
        u: "1f54c",
        a: "1.0"
    },
    {
        n: [
            "hindu temple"
        ],
        u: "1f6d5",
        a: "12.0"
    },
    {
        n: [
            "synagogue"
        ],
        u: "1f54d",
        a: "1.0"
    },
    {
        n: [
            "shinto shrine"
        ],
        u: "26e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "kaaba"
        ],
        u: "1f54b",
        a: "1.0"
    },
    {
        n: [
            "fountain"
        ],
        u: "26f2",
        a: "0.6"
    },
    {
        n: [
            "tent"
        ],
        u: "26fa",
        a: "0.6"
    },
    {
        n: [
            "foggy"
        ],
        u: "1f301",
        a: "0.6"
    },
    {
        n: [
            "night with stars"
        ],
        u: "1f303",
        a: "0.6"
    },
    {
        n: [
            "cityscape"
        ],
        u: "1f3d9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunrise over mountains"
        ],
        u: "1f304",
        a: "0.6"
    },
    {
        n: [
            "sunrise"
        ],
        u: "1f305",
        a: "0.6"
    },
    {
        n: [
            "city sunset",
            "cityscape at dusk"
        ],
        u: "1f306",
        a: "0.6"
    },
    {
        n: [
            "city sunrise",
            "sunset over buildings"
        ],
        u: "1f307",
        a: "0.6"
    },
    {
        n: [
            "bridge at night"
        ],
        u: "1f309",
        a: "0.6"
    },
    {
        n: [
            "hotsprings",
            "hot springs"
        ],
        u: "2668-fe0f",
        a: "0.6"
    },
    {
        n: [
            "carousel horse"
        ],
        u: "1f3a0",
        a: "0.6"
    },
    {
        n: [
            "playground slide"
        ],
        u: "1f6dd",
        a: "14.0"
    },
    {
        n: [
            "ferris wheel"
        ],
        u: "1f3a1",
        a: "0.6"
    },
    {
        n: [
            "roller coaster"
        ],
        u: "1f3a2",
        a: "0.6"
    },
    {
        n: [
            "barber",
            "barber pole"
        ],
        u: "1f488",
        a: "0.6"
    },
    {
        n: [
            "circus tent"
        ],
        u: "1f3aa",
        a: "0.6"
    },
    {
        n: [
            "steam locomotive"
        ],
        u: "1f682",
        a: "1.0"
    },
    {
        n: [
            "railway car"
        ],
        u: "1f683",
        a: "0.6"
    },
    {
        n: [
            "high-speed train",
            "bullettrain side"
        ],
        u: "1f684",
        a: "0.6"
    },
    {
        n: [
            "bullettrain front",
            "high-speed train with bullet nose"
        ],
        u: "1f685",
        a: "0.6"
    },
    {
        n: [
            "train",
            "train2"
        ],
        u: "1f686",
        a: "1.0"
    },
    {
        n: [
            "metro"
        ],
        u: "1f687",
        a: "0.6"
    },
    {
        n: [
            "light rail"
        ],
        u: "1f688",
        a: "1.0"
    },
    {
        n: [
            "station"
        ],
        u: "1f689",
        a: "0.6"
    },
    {
        n: [
            "tram"
        ],
        u: "1f68a",
        a: "1.0"
    },
    {
        n: [
            "monorail"
        ],
        u: "1f69d",
        a: "1.0"
    },
    {
        n: [
            "mountain railway"
        ],
        u: "1f69e",
        a: "1.0"
    },
    {
        n: [
            "train",
            "tram car"
        ],
        u: "1f68b",
        a: "1.0"
    },
    {
        n: [
            "bus"
        ],
        u: "1f68c",
        a: "0.6"
    },
    {
        n: [
            "oncoming bus"
        ],
        u: "1f68d",
        a: "0.7"
    },
    {
        n: [
            "trolleybus"
        ],
        u: "1f68e",
        a: "1.0"
    },
    {
        n: [
            "minibus"
        ],
        u: "1f690",
        a: "1.0"
    },
    {
        n: [
            "ambulance"
        ],
        u: "1f691",
        a: "0.6"
    },
    {
        n: [
            "fire engine"
        ],
        u: "1f692",
        a: "0.6"
    },
    {
        n: [
            "police car"
        ],
        u: "1f693",
        a: "0.6"
    },
    {
        n: [
            "oncoming police car"
        ],
        u: "1f694",
        a: "0.7"
    },
    {
        n: [
            "taxi"
        ],
        u: "1f695",
        a: "0.6"
    },
    {
        n: [
            "oncoming taxi"
        ],
        u: "1f696",
        a: "1.0"
    },
    {
        n: [
            "car",
            "red car",
            "automobile"
        ],
        u: "1f697",
        a: "0.6"
    },
    {
        n: [
            "oncoming automobile"
        ],
        u: "1f698",
        a: "0.7"
    },
    {
        n: [
            "blue car",
            "recreational vehicle"
        ],
        u: "1f699",
        a: "0.6"
    },
    {
        n: [
            "pickup truck"
        ],
        u: "1f6fb",
        a: "13.0"
    },
    {
        n: [
            "truck",
            "delivery truck"
        ],
        u: "1f69a",
        a: "0.6"
    },
    {
        n: [
            "articulated lorry"
        ],
        u: "1f69b",
        a: "1.0"
    },
    {
        n: [
            "tractor"
        ],
        u: "1f69c",
        a: "1.0"
    },
    {
        n: [
            "racing car"
        ],
        u: "1f3ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motorcycle",
            "racing motorcycle"
        ],
        u: "1f3cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor scooter"
        ],
        u: "1f6f5",
        a: "3.0"
    },
    {
        n: [
            "manual wheelchair"
        ],
        u: "1f9bd",
        a: "12.0"
    },
    {
        n: [
            "motorized wheelchair"
        ],
        u: "1f9bc",
        a: "12.0"
    },
    {
        n: [
            "auto rickshaw"
        ],
        u: "1f6fa",
        a: "12.0"
    },
    {
        n: [
            "bike",
            "bicycle"
        ],
        u: "1f6b2",
        a: "0.6"
    },
    {
        n: [
            "scooter"
        ],
        u: "1f6f4",
        a: "3.0"
    },
    {
        n: [
            "skateboard"
        ],
        u: "1f6f9",
        a: "11.0"
    },
    {
        n: [
            "roller skate"
        ],
        u: "1f6fc",
        a: "13.0"
    },
    {
        n: [
            "busstop",
            "bus stop"
        ],
        u: "1f68f",
        a: "0.6"
    },
    {
        n: [
            "motorway"
        ],
        u: "1f6e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "railway track"
        ],
        u: "1f6e4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "oil drum"
        ],
        u: "1f6e2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fuelpump",
            "fuel pump"
        ],
        u: "26fd",
        a: "0.6"
    },
    {
        n: [
            "wheel"
        ],
        u: "1f6de",
        a: "14.0"
    },
    {
        n: [
            "rotating light",
            "police cars revolving light"
        ],
        u: "1f6a8",
        a: "0.6"
    },
    {
        n: [
            "traffic light",
            "horizontal traffic light"
        ],
        u: "1f6a5",
        a: "0.6"
    },
    {
        n: [
            "vertical traffic light"
        ],
        u: "1f6a6",
        a: "1.0"
    },
    {
        n: [
            "octagonal sign"
        ],
        u: "1f6d1",
        a: "3.0"
    },
    {
        n: [
            "construction",
            "construction sign"
        ],
        u: "1f6a7",
        a: "0.6"
    },
    {
        n: [
            "anchor"
        ],
        u: "2693",
        a: "0.6"
    },
    {
        n: [
            "ring buoy"
        ],
        u: "1f6df",
        a: "14.0"
    },
    {
        n: [
            "boat",
            "sailboat"
        ],
        u: "26f5",
        a: "0.6"
    },
    {
        n: [
            "canoe"
        ],
        u: "1f6f6",
        a: "3.0"
    },
    {
        n: [
            "speedboat"
        ],
        u: "1f6a4",
        a: "0.6"
    },
    {
        n: [
            "passenger ship"
        ],
        u: "1f6f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ferry"
        ],
        u: "26f4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor boat"
        ],
        u: "1f6e5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ship"
        ],
        u: "1f6a2",
        a: "0.6"
    },
    {
        n: [
            "airplane"
        ],
        u: "2708-fe0f",
        a: "0.6"
    },
    {
        n: [
            "small airplane"
        ],
        u: "1f6e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "airplane departure"
        ],
        u: "1f6eb",
        a: "1.0"
    },
    {
        n: [
            "airplane arriving"
        ],
        u: "1f6ec",
        a: "1.0"
    },
    {
        n: [
            "parachute"
        ],
        u: "1fa82",
        a: "12.0"
    },
    {
        n: [
            "seat"
        ],
        u: "1f4ba",
        a: "0.6"
    },
    {
        n: [
            "helicopter"
        ],
        u: "1f681",
        a: "1.0"
    },
    {
        n: [
            "suspension railway"
        ],
        u: "1f69f",
        a: "1.0"
    },
    {
        n: [
            "mountain cableway"
        ],
        u: "1f6a0",
        a: "1.0"
    },
    {
        n: [
            "aerial tramway"
        ],
        u: "1f6a1",
        a: "1.0"
    },
    {
        n: [
            "satellite"
        ],
        u: "1f6f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rocket"
        ],
        u: "1f680",
        a: "0.6"
    },
    {
        n: [
            "flying saucer"
        ],
        u: "1f6f8",
        a: "5.0"
    },
    {
        n: [
            "bellhop bell"
        ],
        u: "1f6ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "luggage"
        ],
        u: "1f9f3",
        a: "11.0"
    },
    {
        n: [
            "hourglass"
        ],
        u: "231b",
        a: "0.6"
    },
    {
        n: [
            "hourglass flowing sand",
            "hourglass with flowing sand"
        ],
        u: "23f3",
        a: "0.6"
    },
    {
        n: [
            "watch"
        ],
        u: "231a",
        a: "0.6"
    },
    {
        n: [
            "alarm clock"
        ],
        u: "23f0",
        a: "0.6"
    },
    {
        n: [
            "stopwatch"
        ],
        u: "23f1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "timer clock"
        ],
        u: "23f2-fe0f",
        a: "1.0"
    },
    {
        n: [
            "mantelpiece clock"
        ],
        u: "1f570-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clock12",
            "clock face twelve oclock"
        ],
        u: "1f55b",
        a: "0.6"
    },
    {
        n: [
            "clock1230",
            "clock face twelve-thirty"
        ],
        u: "1f567",
        a: "0.7"
    },
    {
        n: [
            "clock1",
            "clock face one oclock"
        ],
        u: "1f550",
        a: "0.6"
    },
    {
        n: [
            "clock130",
            "clock face one-thirty"
        ],
        u: "1f55c",
        a: "0.7"
    },
    {
        n: [
            "clock2",
            "clock face two oclock"
        ],
        u: "1f551",
        a: "0.6"
    },
    {
        n: [
            "clock230",
            "clock face two-thirty"
        ],
        u: "1f55d",
        a: "0.7"
    },
    {
        n: [
            "clock3",
            "clock face three oclock"
        ],
        u: "1f552",
        a: "0.6"
    },
    {
        n: [
            "clock330",
            "clock face three-thirty"
        ],
        u: "1f55e",
        a: "0.7"
    },
    {
        n: [
            "clock4",
            "clock face four oclock"
        ],
        u: "1f553",
        a: "0.6"
    },
    {
        n: [
            "clock430",
            "clock face four-thirty"
        ],
        u: "1f55f",
        a: "0.7"
    },
    {
        n: [
            "clock5",
            "clock face five oclock"
        ],
        u: "1f554",
        a: "0.6"
    },
    {
        n: [
            "clock530",
            "clock face five-thirty"
        ],
        u: "1f560",
        a: "0.7"
    },
    {
        n: [
            "clock6",
            "clock face six oclock"
        ],
        u: "1f555",
        a: "0.6"
    },
    {
        n: [
            "clock630",
            "clock face six-thirty"
        ],
        u: "1f561",
        a: "0.7"
    },
    {
        n: [
            "clock7",
            "clock face seven oclock"
        ],
        u: "1f556",
        a: "0.6"
    },
    {
        n: [
            "clock730",
            "clock face seven-thirty"
        ],
        u: "1f562",
        a: "0.7"
    },
    {
        n: [
            "clock8",
            "clock face eight oclock"
        ],
        u: "1f557",
        a: "0.6"
    },
    {
        n: [
            "clock830",
            "clock face eight-thirty"
        ],
        u: "1f563",
        a: "0.7"
    },
    {
        n: [
            "clock9",
            "clock face nine oclock"
        ],
        u: "1f558",
        a: "0.6"
    },
    {
        n: [
            "clock930",
            "clock face nine-thirty"
        ],
        u: "1f564",
        a: "0.7"
    },
    {
        n: [
            "clock10",
            "clock face ten oclock"
        ],
        u: "1f559",
        a: "0.6"
    },
    {
        n: [
            "clock1030",
            "clock face ten-thirty"
        ],
        u: "1f565",
        a: "0.7"
    },
    {
        n: [
            "clock11",
            "clock face eleven oclock"
        ],
        u: "1f55a",
        a: "0.6"
    },
    {
        n: [
            "clock1130",
            "clock face eleven-thirty"
        ],
        u: "1f566",
        a: "0.7"
    },
    {
        n: [
            "new moon",
            "new moon symbol"
        ],
        u: "1f311",
        a: "0.6"
    },
    {
        n: [
            "waxing crescent moon",
            "waxing crescent moon symbol"
        ],
        u: "1f312",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon",
            "first quarter moon symbol"
        ],
        u: "1f313",
        a: "0.6"
    },
    {
        n: [
            "moon",
            "waxing gibbous moon",
            "waxing gibbous moon symbol"
        ],
        u: "1f314",
        a: "0.6"
    },
    {
        n: [
            "full moon",
            "full moon symbol"
        ],
        u: "1f315",
        a: "0.6"
    },
    {
        n: [
            "waning gibbous moon",
            "waning gibbous moon symbol"
        ],
        u: "1f316",
        a: "1.0"
    },
    {
        n: [
            "last quarter moon",
            "last quarter moon symbol"
        ],
        u: "1f317",
        a: "1.0"
    },
    {
        n: [
            "waning crescent moon",
            "waning crescent moon symbol"
        ],
        u: "1f318",
        a: "1.0"
    },
    {
        n: [
            "crescent moon"
        ],
        u: "1f319",
        a: "0.6"
    },
    {
        n: [
            "new moon with face"
        ],
        u: "1f31a",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon with face"
        ],
        u: "1f31b",
        a: "0.6"
    },
    {
        n: [
            "last quarter moon with face"
        ],
        u: "1f31c",
        a: "0.7"
    },
    {
        n: [
            "thermometer"
        ],
        u: "1f321-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunny",
            "black sun with rays"
        ],
        u: "2600-fe0f",
        a: "0.6"
    },
    {
        n: [
            "full moon with face"
        ],
        u: "1f31d",
        a: "1.0"
    },
    {
        n: [
            "sun with face"
        ],
        u: "1f31e",
        a: "1.0"
    },
    {
        n: [
            "ringed planet"
        ],
        u: "1fa90",
        a: "12.0"
    },
    {
        n: [
            "star",
            "white medium star"
        ],
        u: "2b50",
        a: "0.6"
    },
    {
        n: [
            "star2",
            "glowing star"
        ],
        u: "1f31f",
        a: "0.6"
    },
    {
        n: [
            "stars",
            "shooting star"
        ],
        u: "1f320",
        a: "0.6"
    },
    {
        n: [
            "milky way"
        ],
        u: "1f30c",
        a: "0.6"
    },
    {
        n: [
            "cloud"
        ],
        u: "2601-fe0f",
        a: "0.6"
    },
    {
        n: [
            "partly sunny",
            "sun behind cloud"
        ],
        u: "26c5",
        a: "0.6"
    },
    {
        n: [
            "thunder cloud and rain",
            "cloud with lightning and rain"
        ],
        u: "26c8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mostly sunny",
            "sun small cloud",
            "sun behind small cloud"
        ],
        u: "1f324-fe0f",
        a: "0.7"
    },
    {
        n: [
            "barely sunny",
            "sun behind cloud",
            "sun behind large cloud"
        ],
        u: "1f325-fe0f",
        a: "0.7"
    },
    {
        n: [
            "partly sunny rain",
            "sun behind rain cloud"
        ],
        u: "1f326-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rain cloud",
            "cloud with rain"
        ],
        u: "1f327-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snow cloud",
            "cloud with snow"
        ],
        u: "1f328-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lightning",
            "lightning cloud",
            "cloud with lightning"
        ],
        u: "1f329-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tornado",
            "tornado cloud"
        ],
        u: "1f32a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fog"
        ],
        u: "1f32b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wind face",
            "wind blowing face"
        ],
        u: "1f32c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "cyclone"
        ],
        u: "1f300",
        a: "0.6"
    },
    {
        n: [
            "rainbow"
        ],
        u: "1f308",
        a: "0.6"
    },
    {
        n: [
            "closed umbrella"
        ],
        u: "1f302",
        a: "0.6"
    },
    {
        n: [
            "umbrella"
        ],
        u: "2602-fe0f",
        a: "0.7"
    },
    {
        n: [
            "umbrella with rain drops"
        ],
        u: "2614",
        a: "0.6"
    },
    {
        n: [
            "umbrella on ground"
        ],
        u: "26f1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "zap",
            "high voltage sign"
        ],
        u: "26a1",
        a: "0.6"
    },
    {
        n: [
            "snowflake"
        ],
        u: "2744-fe0f",
        a: "0.6"
    },
    {
        n: [
            "snowman"
        ],
        u: "2603-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowman without snow"
        ],
        u: "26c4",
        a: "0.6"
    },
    {
        n: [
            "comet"
        ],
        u: "2604-fe0f",
        a: "1.0"
    },
    {
        n: [
            "fire"
        ],
        u: "1f525",
        a: "0.6"
    },
    {
        n: [
            "droplet"
        ],
        u: "1f4a7",
        a: "0.6"
    },
    {
        n: [
            "ocean",
            "water wave"
        ],
        u: "1f30a",
        a: "0.6"
    }
];
var activities = [
    {
        n: [
            "jack-o-lantern",
            "jack o lantern"
        ],
        u: "1f383",
        a: "0.6"
    },
    {
        n: [
            "christmas tree"
        ],
        u: "1f384",
        a: "0.6"
    },
    {
        n: [
            "fireworks"
        ],
        u: "1f386",
        a: "0.6"
    },
    {
        n: [
            "sparkler",
            "firework sparkler"
        ],
        u: "1f387",
        a: "0.6"
    },
    {
        n: [
            "firecracker"
        ],
        u: "1f9e8",
        a: "11.0"
    },
    {
        n: [
            "sparkles"
        ],
        u: "2728",
        a: "0.6"
    },
    {
        n: [
            "balloon"
        ],
        u: "1f388",
        a: "0.6"
    },
    {
        n: [
            "tada",
            "party popper"
        ],
        u: "1f389",
        a: "0.6"
    },
    {
        n: [
            "confetti ball"
        ],
        u: "1f38a",
        a: "0.6"
    },
    {
        n: [
            "tanabata tree"
        ],
        u: "1f38b",
        a: "0.6"
    },
    {
        n: [
            "bamboo",
            "pine decoration"
        ],
        u: "1f38d",
        a: "0.6"
    },
    {
        n: [
            "dolls",
            "japanese dolls"
        ],
        u: "1f38e",
        a: "0.6"
    },
    {
        n: [
            "flags",
            "carp streamer"
        ],
        u: "1f38f",
        a: "0.6"
    },
    {
        n: [
            "wind chime"
        ],
        u: "1f390",
        a: "0.6"
    },
    {
        n: [
            "rice scene",
            "moon viewing ceremony"
        ],
        u: "1f391",
        a: "0.6"
    },
    {
        n: [
            "red envelope",
            "red gift envelope"
        ],
        u: "1f9e7",
        a: "11.0"
    },
    {
        n: [
            "ribbon"
        ],
        u: "1f380",
        a: "0.6"
    },
    {
        n: [
            "gift",
            "wrapped present"
        ],
        u: "1f381",
        a: "0.6"
    },
    {
        n: [
            "reminder ribbon"
        ],
        u: "1f397-fe0f",
        a: "0.7"
    },
    {
        n: [
            "admission tickets"
        ],
        u: "1f39f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ticket"
        ],
        u: "1f3ab",
        a: "0.6"
    },
    {
        n: [
            "medal",
            "military medal"
        ],
        u: "1f396-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trophy"
        ],
        u: "1f3c6",
        a: "0.6"
    },
    {
        n: [
            "sports medal"
        ],
        u: "1f3c5",
        a: "1.0"
    },
    {
        n: [
            "first place medal"
        ],
        u: "1f947",
        a: "3.0"
    },
    {
        n: [
            "second place medal"
        ],
        u: "1f948",
        a: "3.0"
    },
    {
        n: [
            "third place medal"
        ],
        u: "1f949",
        a: "3.0"
    },
    {
        n: [
            "soccer",
            "soccer ball"
        ],
        u: "26bd",
        a: "0.6"
    },
    {
        n: [
            "baseball"
        ],
        u: "26be",
        a: "0.6"
    },
    {
        n: [
            "softball"
        ],
        u: "1f94e",
        a: "11.0"
    },
    {
        n: [
            "basketball",
            "basketball and hoop"
        ],
        u: "1f3c0",
        a: "0.6"
    },
    {
        n: [
            "volleyball"
        ],
        u: "1f3d0",
        a: "1.0"
    },
    {
        n: [
            "football",
            "american football"
        ],
        u: "1f3c8",
        a: "0.6"
    },
    {
        n: [
            "rugby football"
        ],
        u: "1f3c9",
        a: "1.0"
    },
    {
        n: [
            "tennis",
            "tennis racquet and ball"
        ],
        u: "1f3be",
        a: "0.6"
    },
    {
        n: [
            "flying disc"
        ],
        u: "1f94f",
        a: "11.0"
    },
    {
        n: [
            "bowling"
        ],
        u: "1f3b3",
        a: "0.6"
    },
    {
        n: [
            "cricket bat and ball"
        ],
        u: "1f3cf",
        a: "1.0"
    },
    {
        n: [
            "field hockey stick and ball"
        ],
        u: "1f3d1",
        a: "1.0"
    },
    {
        n: [
            "ice hockey stick and puck"
        ],
        u: "1f3d2",
        a: "1.0"
    },
    {
        n: [
            "lacrosse",
            "lacrosse stick and ball"
        ],
        u: "1f94d",
        a: "11.0"
    },
    {
        n: [
            "table tennis paddle and ball"
        ],
        u: "1f3d3",
        a: "1.0"
    },
    {
        n: [
            "badminton racquet and shuttlecock"
        ],
        u: "1f3f8",
        a: "1.0"
    },
    {
        n: [
            "boxing glove"
        ],
        u: "1f94a",
        a: "3.0"
    },
    {
        n: [
            "martial arts uniform"
        ],
        u: "1f94b",
        a: "3.0"
    },
    {
        n: [
            "goal net"
        ],
        u: "1f945",
        a: "3.0"
    },
    {
        n: [
            "golf",
            "flag in hole"
        ],
        u: "26f3",
        a: "0.6"
    },
    {
        n: [
            "ice skate"
        ],
        u: "26f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fishing pole and fish"
        ],
        u: "1f3a3",
        a: "0.6"
    },
    {
        n: [
            "diving mask"
        ],
        u: "1f93f",
        a: "12.0"
    },
    {
        n: [
            "running shirt with sash"
        ],
        u: "1f3bd",
        a: "0.6"
    },
    {
        n: [
            "ski",
            "ski and ski boot"
        ],
        u: "1f3bf",
        a: "0.6"
    },
    {
        n: [
            "sled"
        ],
        u: "1f6f7",
        a: "5.0"
    },
    {
        n: [
            "curling stone"
        ],
        u: "1f94c",
        a: "5.0"
    },
    {
        n: [
            "dart",
            "direct hit"
        ],
        u: "1f3af",
        a: "0.6"
    },
    {
        n: [
            "yo-yo"
        ],
        u: "1fa80",
        a: "12.0"
    },
    {
        n: [
            "kite"
        ],
        u: "1fa81",
        a: "12.0"
    },
    {
        n: [
            "8ball",
            "billiards"
        ],
        u: "1f3b1",
        a: "0.6"
    },
    {
        n: [
            "crystal ball"
        ],
        u: "1f52e",
        a: "0.6"
    },
    {
        n: [
            "magic wand"
        ],
        u: "1fa84",
        a: "13.0"
    },
    {
        n: [
            "nazar amulet"
        ],
        u: "1f9ff",
        a: "11.0"
    },
    {
        n: [
            "hamsa"
        ],
        u: "1faac",
        a: "14.0"
    },
    {
        n: [
            "video game"
        ],
        u: "1f3ae",
        a: "0.6"
    },
    {
        n: [
            "joystick"
        ],
        u: "1f579-fe0f",
        a: "0.7"
    },
    {
        n: [
            "slot machine"
        ],
        u: "1f3b0",
        a: "0.6"
    },
    {
        n: [
            "game die"
        ],
        u: "1f3b2",
        a: "0.6"
    },
    {
        n: [
            "jigsaw",
            "jigsaw puzzle piece"
        ],
        u: "1f9e9",
        a: "11.0"
    },
    {
        n: [
            "teddy bear"
        ],
        u: "1f9f8",
        a: "11.0"
    },
    {
        n: [
            "pinata"
        ],
        u: "1fa85",
        a: "13.0"
    },
    {
        n: [
            "mirror ball"
        ],
        u: "1faa9",
        a: "14.0"
    },
    {
        n: [
            "nesting dolls"
        ],
        u: "1fa86",
        a: "13.0"
    },
    {
        n: [
            "spades",
            "black spade suit"
        ],
        u: "2660-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hearts",
            "black heart suit"
        ],
        u: "2665-fe0f",
        a: "0.6"
    },
    {
        n: [
            "diamonds",
            "black diamond suit"
        ],
        u: "2666-fe0f",
        a: "0.6"
    },
    {
        n: [
            "clubs",
            "black club suit"
        ],
        u: "2663-fe0f",
        a: "0.6"
    },
    {
        n: [
            "chess pawn"
        ],
        u: "265f-fe0f",
        a: "11.0"
    },
    {
        n: [
            "black joker",
            "playing card black joker"
        ],
        u: "1f0cf",
        a: "0.6"
    },
    {
        n: [
            "mahjong",
            "mahjong tile red dragon"
        ],
        u: "1f004",
        a: "0.6"
    },
    {
        n: [
            "flower playing cards"
        ],
        u: "1f3b4",
        a: "0.6"
    },
    {
        n: [
            "performing arts"
        ],
        u: "1f3ad",
        a: "0.6"
    },
    {
        n: [
            "framed picture",
            "frame with picture"
        ],
        u: "1f5bc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "art",
            "artist palette"
        ],
        u: "1f3a8",
        a: "0.6"
    },
    {
        n: [
            "thread",
            "spool of thread"
        ],
        u: "1f9f5",
        a: "11.0"
    },
    {
        n: [
            "sewing needle"
        ],
        u: "1faa1",
        a: "13.0"
    },
    {
        n: [
            "yarn",
            "ball of yarn"
        ],
        u: "1f9f6",
        a: "11.0"
    },
    {
        n: [
            "knot"
        ],
        u: "1faa2",
        a: "13.0"
    }
];
var objects = [
    {
        n: [
            "eyeglasses"
        ],
        u: "1f453",
        a: "0.6"
    },
    {
        n: [
            "sunglasses",
            "dark sunglasses"
        ],
        u: "1f576-fe0f",
        a: "0.7"
    },
    {
        n: [
            "goggles"
        ],
        u: "1f97d",
        a: "11.0"
    },
    {
        n: [
            "lab coat"
        ],
        u: "1f97c",
        a: "11.0"
    },
    {
        n: [
            "safety vest"
        ],
        u: "1f9ba",
        a: "12.0"
    },
    {
        n: [
            "necktie"
        ],
        u: "1f454",
        a: "0.6"
    },
    {
        n: [
            "shirt",
            "tshirt",
            "t-shirt"
        ],
        u: "1f455",
        a: "0.6"
    },
    {
        n: [
            "jeans"
        ],
        u: "1f456",
        a: "0.6"
    },
    {
        n: [
            "scarf"
        ],
        u: "1f9e3",
        a: "5.0"
    },
    {
        n: [
            "gloves"
        ],
        u: "1f9e4",
        a: "5.0"
    },
    {
        n: [
            "coat"
        ],
        u: "1f9e5",
        a: "5.0"
    },
    {
        n: [
            "socks"
        ],
        u: "1f9e6",
        a: "5.0"
    },
    {
        n: [
            "dress"
        ],
        u: "1f457",
        a: "0.6"
    },
    {
        n: [
            "kimono"
        ],
        u: "1f458",
        a: "0.6"
    },
    {
        n: [
            "sari"
        ],
        u: "1f97b",
        a: "12.0"
    },
    {
        n: [
            "one-piece swimsuit"
        ],
        u: "1fa71",
        a: "12.0"
    },
    {
        n: [
            "briefs"
        ],
        u: "1fa72",
        a: "12.0"
    },
    {
        n: [
            "shorts"
        ],
        u: "1fa73",
        a: "12.0"
    },
    {
        n: [
            "bikini"
        ],
        u: "1f459",
        a: "0.6"
    },
    {
        n: [
            "womans clothes"
        ],
        u: "1f45a",
        a: "0.6"
    },
    {
        n: [
            "purse"
        ],
        u: "1f45b",
        a: "0.6"
    },
    {
        n: [
            "handbag"
        ],
        u: "1f45c",
        a: "0.6"
    },
    {
        n: [
            "pouch"
        ],
        u: "1f45d",
        a: "0.6"
    },
    {
        n: [
            "shopping bags"
        ],
        u: "1f6cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "school satchel"
        ],
        u: "1f392",
        a: "0.6"
    },
    {
        n: [
            "thong sandal"
        ],
        u: "1fa74",
        a: "13.0"
    },
    {
        n: [
            "shoe",
            "mans shoe"
        ],
        u: "1f45e",
        a: "0.6"
    },
    {
        n: [
            "athletic shoe"
        ],
        u: "1f45f",
        a: "0.6"
    },
    {
        n: [
            "hiking boot"
        ],
        u: "1f97e",
        a: "11.0"
    },
    {
        n: [
            "flat shoe",
            "womans flat shoe"
        ],
        u: "1f97f",
        a: "11.0"
    },
    {
        n: [
            "high heel",
            "high-heeled shoe"
        ],
        u: "1f460",
        a: "0.6"
    },
    {
        n: [
            "sandal",
            "womans sandal"
        ],
        u: "1f461",
        a: "0.6"
    },
    {
        n: [
            "ballet shoes"
        ],
        u: "1fa70",
        a: "12.0"
    },
    {
        n: [
            "boot",
            "womans boots"
        ],
        u: "1f462",
        a: "0.6"
    },
    {
        n: [
            "crown"
        ],
        u: "1f451",
        a: "0.6"
    },
    {
        n: [
            "womans hat"
        ],
        u: "1f452",
        a: "0.6"
    },
    {
        n: [
            "tophat",
            "top hat"
        ],
        u: "1f3a9",
        a: "0.6"
    },
    {
        n: [
            "mortar board",
            "graduation cap"
        ],
        u: "1f393",
        a: "0.6"
    },
    {
        n: [
            "billed cap"
        ],
        u: "1f9e2",
        a: "5.0"
    },
    {
        n: [
            "military helmet"
        ],
        u: "1fa96",
        a: "13.0"
    },
    {
        n: [
            "rescue worker\u2019s helmet",
            "helmet with white cross"
        ],
        u: "26d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "prayer beads"
        ],
        u: "1f4ff",
        a: "1.0"
    },
    {
        n: [
            "lipstick"
        ],
        u: "1f484",
        a: "0.6"
    },
    {
        n: [
            "ring"
        ],
        u: "1f48d",
        a: "0.6"
    },
    {
        n: [
            "gem",
            "gem stone"
        ],
        u: "1f48e",
        a: "0.6"
    },
    {
        n: [
            "mute",
            "speaker with cancellation stroke"
        ],
        u: "1f507",
        a: "1.0"
    },
    {
        n: [
            "speaker"
        ],
        u: "1f508",
        a: "0.7"
    },
    {
        n: [
            "sound",
            "speaker with one sound wave"
        ],
        u: "1f509",
        a: "1.0"
    },
    {
        n: [
            "loud sound",
            "speaker with three sound waves"
        ],
        u: "1f50a",
        a: "0.6"
    },
    {
        n: [
            "loudspeaker",
            "public address loudspeaker"
        ],
        u: "1f4e2",
        a: "0.6"
    },
    {
        n: [
            "mega",
            "cheering megaphone"
        ],
        u: "1f4e3",
        a: "0.6"
    },
    {
        n: [
            "postal horn"
        ],
        u: "1f4ef",
        a: "1.0"
    },
    {
        n: [
            "bell"
        ],
        u: "1f514",
        a: "0.6"
    },
    {
        n: [
            "no bell",
            "bell with cancellation stroke"
        ],
        u: "1f515",
        a: "1.0"
    },
    {
        n: [
            "musical score"
        ],
        u: "1f3bc",
        a: "0.6"
    },
    {
        n: [
            "musical note"
        ],
        u: "1f3b5",
        a: "0.6"
    },
    {
        n: [
            "notes",
            "multiple musical notes"
        ],
        u: "1f3b6",
        a: "0.6"
    },
    {
        n: [
            "studio microphone"
        ],
        u: "1f399-fe0f",
        a: "0.7"
    },
    {
        n: [
            "level slider"
        ],
        u: "1f39a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "control knobs"
        ],
        u: "1f39b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "microphone"
        ],
        u: "1f3a4",
        a: "0.6"
    },
    {
        n: [
            "headphone",
            "headphones"
        ],
        u: "1f3a7",
        a: "0.6"
    },
    {
        n: [
            "radio"
        ],
        u: "1f4fb",
        a: "0.6"
    },
    {
        n: [
            "saxophone"
        ],
        u: "1f3b7",
        a: "0.6"
    },
    {
        n: [
            "accordion"
        ],
        u: "1fa97",
        a: "13.0"
    },
    {
        n: [
            "guitar"
        ],
        u: "1f3b8",
        a: "0.6"
    },
    {
        n: [
            "musical keyboard"
        ],
        u: "1f3b9",
        a: "0.6"
    },
    {
        n: [
            "trumpet"
        ],
        u: "1f3ba",
        a: "0.6"
    },
    {
        n: [
            "violin"
        ],
        u: "1f3bb",
        a: "0.6"
    },
    {
        n: [
            "banjo"
        ],
        u: "1fa95",
        a: "12.0"
    },
    {
        n: [
            "drum with drumsticks"
        ],
        u: "1f941",
        a: "3.0"
    },
    {
        n: [
            "long drum"
        ],
        u: "1fa98",
        a: "13.0"
    },
    {
        n: [
            "iphone",
            "mobile phone"
        ],
        u: "1f4f1",
        a: "0.6"
    },
    {
        n: [
            "calling",
            "mobile phone with rightwards arrow at left"
        ],
        u: "1f4f2",
        a: "0.6"
    },
    {
        n: [
            "phone",
            "telephone",
            "black telephone"
        ],
        u: "260e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "telephone receiver"
        ],
        u: "1f4de",
        a: "0.6"
    },
    {
        n: [
            "pager"
        ],
        u: "1f4df",
        a: "0.6"
    },
    {
        n: [
            "fax",
            "fax machine"
        ],
        u: "1f4e0",
        a: "0.6"
    },
    {
        n: [
            "battery"
        ],
        u: "1f50b",
        a: "0.6"
    },
    {
        n: [
            "low battery"
        ],
        u: "1faab",
        a: "14.0"
    },
    {
        n: [
            "electric plug"
        ],
        u: "1f50c",
        a: "0.6"
    },
    {
        n: [
            "computer",
            "personal computer"
        ],
        u: "1f4bb",
        a: "0.6"
    },
    {
        n: [
            "desktop computer"
        ],
        u: "1f5a5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "printer"
        ],
        u: "1f5a8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "keyboard"
        ],
        u: "2328-fe0f",
        a: "1.0"
    },
    {
        n: [
            "computer mouse",
            "three button mouse"
        ],
        u: "1f5b1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trackball"
        ],
        u: "1f5b2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "minidisc"
        ],
        u: "1f4bd",
        a: "0.6"
    },
    {
        n: [
            "floppy disk"
        ],
        u: "1f4be",
        a: "0.6"
    },
    {
        n: [
            "cd",
            "optical disc"
        ],
        u: "1f4bf",
        a: "0.6"
    },
    {
        n: [
            "dvd"
        ],
        u: "1f4c0",
        a: "0.6"
    },
    {
        n: [
            "abacus"
        ],
        u: "1f9ee",
        a: "11.0"
    },
    {
        n: [
            "movie camera"
        ],
        u: "1f3a5",
        a: "0.6"
    },
    {
        n: [
            "film frames"
        ],
        u: "1f39e-fe0f",
        a: "0.7"
    },
    {
        n: [
            "film projector"
        ],
        u: "1f4fd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clapper",
            "clapper board"
        ],
        u: "1f3ac",
        a: "0.6"
    },
    {
        n: [
            "tv",
            "television"
        ],
        u: "1f4fa",
        a: "0.6"
    },
    {
        n: [
            "camera"
        ],
        u: "1f4f7",
        a: "0.6"
    },
    {
        n: [
            "camera with flash"
        ],
        u: "1f4f8",
        a: "1.0"
    },
    {
        n: [
            "video camera"
        ],
        u: "1f4f9",
        a: "0.6"
    },
    {
        n: [
            "vhs",
            "videocassette"
        ],
        u: "1f4fc",
        a: "0.6"
    },
    {
        n: [
            "mag",
            "left-pointing magnifying glass"
        ],
        u: "1f50d",
        a: "0.6"
    },
    {
        n: [
            "mag right",
            "right-pointing magnifying glass"
        ],
        u: "1f50e",
        a: "0.6"
    },
    {
        n: [
            "candle"
        ],
        u: "1f56f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bulb",
            "electric light bulb"
        ],
        u: "1f4a1",
        a: "0.6"
    },
    {
        n: [
            "flashlight",
            "electric torch"
        ],
        u: "1f526",
        a: "0.6"
    },
    {
        n: [
            "lantern",
            "izakaya lantern"
        ],
        u: "1f3ee",
        a: "0.6"
    },
    {
        n: [
            "diya lamp"
        ],
        u: "1fa94",
        a: "12.0"
    },
    {
        n: [
            "notebook with decorative cover"
        ],
        u: "1f4d4",
        a: "0.6"
    },
    {
        n: [
            "closed book"
        ],
        u: "1f4d5",
        a: "0.6"
    },
    {
        n: [
            "book",
            "open book"
        ],
        u: "1f4d6",
        a: "0.6"
    },
    {
        n: [
            "green book"
        ],
        u: "1f4d7",
        a: "0.6"
    },
    {
        n: [
            "blue book"
        ],
        u: "1f4d8",
        a: "0.6"
    },
    {
        n: [
            "orange book"
        ],
        u: "1f4d9",
        a: "0.6"
    },
    {
        n: [
            "books"
        ],
        u: "1f4da",
        a: "0.6"
    },
    {
        n: [
            "notebook"
        ],
        u: "1f4d3",
        a: "0.6"
    },
    {
        n: [
            "ledger"
        ],
        u: "1f4d2",
        a: "0.6"
    },
    {
        n: [
            "page with curl"
        ],
        u: "1f4c3",
        a: "0.6"
    },
    {
        n: [
            "scroll"
        ],
        u: "1f4dc",
        a: "0.6"
    },
    {
        n: [
            "page facing up"
        ],
        u: "1f4c4",
        a: "0.6"
    },
    {
        n: [
            "newspaper"
        ],
        u: "1f4f0",
        a: "0.6"
    },
    {
        n: [
            "rolled-up newspaper",
            "rolled up newspaper"
        ],
        u: "1f5de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bookmark tabs"
        ],
        u: "1f4d1",
        a: "0.6"
    },
    {
        n: [
            "bookmark"
        ],
        u: "1f516",
        a: "0.6"
    },
    {
        n: [
            "label"
        ],
        u: "1f3f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "moneybag",
            "money bag"
        ],
        u: "1f4b0",
        a: "0.6"
    },
    {
        n: [
            "coin"
        ],
        u: "1fa99",
        a: "13.0"
    },
    {
        n: [
            "yen",
            "banknote with yen sign"
        ],
        u: "1f4b4",
        a: "0.6"
    },
    {
        n: [
            "dollar",
            "banknote with dollar sign"
        ],
        u: "1f4b5",
        a: "0.6"
    },
    {
        n: [
            "euro",
            "banknote with euro sign"
        ],
        u: "1f4b6",
        a: "1.0"
    },
    {
        n: [
            "pound",
            "banknote with pound sign"
        ],
        u: "1f4b7",
        a: "1.0"
    },
    {
        n: [
            "money with wings"
        ],
        u: "1f4b8",
        a: "0.6"
    },
    {
        n: [
            "credit card"
        ],
        u: "1f4b3",
        a: "0.6"
    },
    {
        n: [
            "receipt"
        ],
        u: "1f9fe",
        a: "11.0"
    },
    {
        n: [
            "chart",
            "chart with upwards trend and yen sign"
        ],
        u: "1f4b9",
        a: "0.6"
    },
    {
        n: [
            "email",
            "envelope"
        ],
        u: "2709-fe0f",
        a: "0.6"
    },
    {
        n: [
            "e-mail",
            "e-mail symbol"
        ],
        u: "1f4e7",
        a: "0.6"
    },
    {
        n: [
            "incoming envelope"
        ],
        u: "1f4e8",
        a: "0.6"
    },
    {
        n: [
            "envelope with arrow",
            "envelope with downwards arrow above"
        ],
        u: "1f4e9",
        a: "0.6"
    },
    {
        n: [
            "outbox tray"
        ],
        u: "1f4e4",
        a: "0.6"
    },
    {
        n: [
            "inbox tray"
        ],
        u: "1f4e5",
        a: "0.6"
    },
    {
        n: [
            "package"
        ],
        u: "1f4e6",
        a: "0.6"
    },
    {
        n: [
            "mailbox",
            "closed mailbox with raised flag"
        ],
        u: "1f4eb",
        a: "0.6"
    },
    {
        n: [
            "mailbox closed",
            "closed mailbox with lowered flag"
        ],
        u: "1f4ea",
        a: "0.6"
    },
    {
        n: [
            "mailbox with mail",
            "open mailbox with raised flag"
        ],
        u: "1f4ec",
        a: "0.7"
    },
    {
        n: [
            "mailbox with no mail",
            "open mailbox with lowered flag"
        ],
        u: "1f4ed",
        a: "0.7"
    },
    {
        n: [
            "postbox"
        ],
        u: "1f4ee",
        a: "0.6"
    },
    {
        n: [
            "ballot box with ballot"
        ],
        u: "1f5f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pencil",
            "pencil2"
        ],
        u: "270f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black nib"
        ],
        u: "2712-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fountain pen",
            "lower left fountain pen"
        ],
        u: "1f58b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pen",
            "lower left ballpoint pen"
        ],
        u: "1f58a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "paintbrush",
            "lower left paintbrush"
        ],
        u: "1f58c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crayon",
            "lower left crayon"
        ],
        u: "1f58d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "memo",
            "pencil"
        ],
        u: "1f4dd",
        a: "0.6"
    },
    {
        n: [
            "briefcase"
        ],
        u: "1f4bc",
        a: "0.6"
    },
    {
        n: [
            "file folder"
        ],
        u: "1f4c1",
        a: "0.6"
    },
    {
        n: [
            "open file folder"
        ],
        u: "1f4c2",
        a: "0.6"
    },
    {
        n: [
            "card index dividers"
        ],
        u: "1f5c2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "date",
            "calendar"
        ],
        u: "1f4c5",
        a: "0.6"
    },
    {
        n: [
            "calendar",
            "tear-off calendar"
        ],
        u: "1f4c6",
        a: "0.6"
    },
    {
        n: [
            "spiral notepad",
            "spiral note pad"
        ],
        u: "1f5d2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spiral calendar",
            "spiral calendar pad"
        ],
        u: "1f5d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "card index"
        ],
        u: "1f4c7",
        a: "0.6"
    },
    {
        n: [
            "chart with upwards trend"
        ],
        u: "1f4c8",
        a: "0.6"
    },
    {
        n: [
            "chart with downwards trend"
        ],
        u: "1f4c9",
        a: "0.6"
    },
    {
        n: [
            "bar chart"
        ],
        u: "1f4ca",
        a: "0.6"
    },
    {
        n: [
            "clipboard"
        ],
        u: "1f4cb",
        a: "0.6"
    },
    {
        n: [
            "pushpin"
        ],
        u: "1f4cc",
        a: "0.6"
    },
    {
        n: [
            "round pushpin"
        ],
        u: "1f4cd",
        a: "0.6"
    },
    {
        n: [
            "paperclip"
        ],
        u: "1f4ce",
        a: "0.6"
    },
    {
        n: [
            "linked paperclips"
        ],
        u: "1f587-fe0f",
        a: "0.7"
    },
    {
        n: [
            "straight ruler"
        ],
        u: "1f4cf",
        a: "0.6"
    },
    {
        n: [
            "triangular ruler"
        ],
        u: "1f4d0",
        a: "0.6"
    },
    {
        n: [
            "scissors",
            "black scissors"
        ],
        u: "2702-fe0f",
        a: "0.6"
    },
    {
        n: [
            "card file box"
        ],
        u: "1f5c3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "file cabinet"
        ],
        u: "1f5c4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wastebasket"
        ],
        u: "1f5d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lock"
        ],
        u: "1f512",
        a: "0.6"
    },
    {
        n: [
            "unlock",
            "open lock"
        ],
        u: "1f513",
        a: "0.6"
    },
    {
        n: [
            "lock with ink pen"
        ],
        u: "1f50f",
        a: "0.6"
    },
    {
        n: [
            "closed lock with key"
        ],
        u: "1f510",
        a: "0.6"
    },
    {
        n: [
            "key"
        ],
        u: "1f511",
        a: "0.6"
    },
    {
        n: [
            "old key"
        ],
        u: "1f5dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer"
        ],
        u: "1f528",
        a: "0.6"
    },
    {
        n: [
            "axe"
        ],
        u: "1fa93",
        a: "12.0"
    },
    {
        n: [
            "pick"
        ],
        u: "26cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer and pick"
        ],
        u: "2692-fe0f",
        a: "1.0"
    },
    {
        n: [
            "hammer and wrench"
        ],
        u: "1f6e0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "dagger",
            "dagger knife"
        ],
        u: "1f5e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crossed swords"
        ],
        u: "2694-fe0f",
        a: "1.0"
    },
    {
        n: [
            "gun",
            "pistol"
        ],
        u: "1f52b",
        a: "0.6"
    },
    {
        n: [
            "boomerang"
        ],
        u: "1fa83",
        a: "13.0"
    },
    {
        n: [
            "bow and arrow"
        ],
        u: "1f3f9",
        a: "1.0"
    },
    {
        n: [
            "shield"
        ],
        u: "1f6e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "carpentry saw"
        ],
        u: "1fa9a",
        a: "13.0"
    },
    {
        n: [
            "wrench"
        ],
        u: "1f527",
        a: "0.6"
    },
    {
        n: [
            "screwdriver"
        ],
        u: "1fa9b",
        a: "13.0"
    },
    {
        n: [
            "nut and bolt"
        ],
        u: "1f529",
        a: "0.6"
    },
    {
        n: [
            "gear"
        ],
        u: "2699-fe0f",
        a: "1.0"
    },
    {
        n: [
            "clamp",
            "compression"
        ],
        u: "1f5dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scales",
            "balance scale"
        ],
        u: "2696-fe0f",
        a: "1.0"
    },
    {
        n: [
            "probing cane"
        ],
        u: "1f9af",
        a: "12.0"
    },
    {
        n: [
            "link",
            "link symbol"
        ],
        u: "1f517",
        a: "0.6"
    },
    {
        n: [
            "chains"
        ],
        u: "26d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hook"
        ],
        u: "1fa9d",
        a: "13.0"
    },
    {
        n: [
            "toolbox"
        ],
        u: "1f9f0",
        a: "11.0"
    },
    {
        n: [
            "magnet"
        ],
        u: "1f9f2",
        a: "11.0"
    },
    {
        n: [
            "ladder"
        ],
        u: "1fa9c",
        a: "13.0"
    },
    {
        n: [
            "alembic"
        ],
        u: "2697-fe0f",
        a: "1.0"
    },
    {
        n: [
            "test tube"
        ],
        u: "1f9ea",
        a: "11.0"
    },
    {
        n: [
            "petri dish"
        ],
        u: "1f9eb",
        a: "11.0"
    },
    {
        n: [
            "dna",
            "dna double helix"
        ],
        u: "1f9ec",
        a: "11.0"
    },
    {
        n: [
            "microscope"
        ],
        u: "1f52c",
        a: "1.0"
    },
    {
        n: [
            "telescope"
        ],
        u: "1f52d",
        a: "1.0"
    },
    {
        n: [
            "satellite antenna"
        ],
        u: "1f4e1",
        a: "0.6"
    },
    {
        n: [
            "syringe"
        ],
        u: "1f489",
        a: "0.6"
    },
    {
        n: [
            "drop of blood"
        ],
        u: "1fa78",
        a: "12.0"
    },
    {
        n: [
            "pill"
        ],
        u: "1f48a",
        a: "0.6"
    },
    {
        n: [
            "adhesive bandage"
        ],
        u: "1fa79",
        a: "12.0"
    },
    {
        n: [
            "crutch"
        ],
        u: "1fa7c",
        a: "14.0"
    },
    {
        n: [
            "stethoscope"
        ],
        u: "1fa7a",
        a: "12.0"
    },
    {
        n: [
            "x-ray"
        ],
        u: "1fa7b",
        a: "14.0"
    },
    {
        n: [
            "door"
        ],
        u: "1f6aa",
        a: "0.6"
    },
    {
        n: [
            "elevator"
        ],
        u: "1f6d7",
        a: "13.0"
    },
    {
        n: [
            "mirror"
        ],
        u: "1fa9e",
        a: "13.0"
    },
    {
        n: [
            "window"
        ],
        u: "1fa9f",
        a: "13.0"
    },
    {
        n: [
            "bed"
        ],
        u: "1f6cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "couch and lamp"
        ],
        u: "1f6cb-fe0f",
        a: "0.7"
    },
    {
        n: [
            "chair"
        ],
        u: "1fa91",
        a: "12.0"
    },
    {
        n: [
            "toilet"
        ],
        u: "1f6bd",
        a: "0.6"
    },
    {
        n: [
            "plunger"
        ],
        u: "1faa0",
        a: "13.0"
    },
    {
        n: [
            "shower"
        ],
        u: "1f6bf",
        a: "1.0"
    },
    {
        n: [
            "bathtub"
        ],
        u: "1f6c1",
        a: "1.0"
    },
    {
        n: [
            "mouse trap"
        ],
        u: "1faa4",
        a: "13.0"
    },
    {
        n: [
            "razor"
        ],
        u: "1fa92",
        a: "12.0"
    },
    {
        n: [
            "lotion bottle"
        ],
        u: "1f9f4",
        a: "11.0"
    },
    {
        n: [
            "safety pin"
        ],
        u: "1f9f7",
        a: "11.0"
    },
    {
        n: [
            "broom"
        ],
        u: "1f9f9",
        a: "11.0"
    },
    {
        n: [
            "basket"
        ],
        u: "1f9fa",
        a: "11.0"
    },
    {
        n: [
            "roll of paper"
        ],
        u: "1f9fb",
        a: "11.0"
    },
    {
        n: [
            "bucket"
        ],
        u: "1faa3",
        a: "13.0"
    },
    {
        n: [
            "soap",
            "bar of soap"
        ],
        u: "1f9fc",
        a: "11.0"
    },
    {
        n: [
            "bubbles"
        ],
        u: "1fae7",
        a: "14.0"
    },
    {
        n: [
            "toothbrush"
        ],
        u: "1faa5",
        a: "13.0"
    },
    {
        n: [
            "sponge"
        ],
        u: "1f9fd",
        a: "11.0"
    },
    {
        n: [
            "fire extinguisher"
        ],
        u: "1f9ef",
        a: "11.0"
    },
    {
        n: [
            "shopping trolley"
        ],
        u: "1f6d2",
        a: "3.0"
    },
    {
        n: [
            "smoking",
            "smoking symbol"
        ],
        u: "1f6ac",
        a: "0.6"
    },
    {
        n: [
            "coffin"
        ],
        u: "26b0-fe0f",
        a: "1.0"
    },
    {
        n: [
            "headstone"
        ],
        u: "1faa6",
        a: "13.0"
    },
    {
        n: [
            "funeral urn"
        ],
        u: "26b1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "moyai"
        ],
        u: "1f5ff",
        a: "0.6"
    },
    {
        n: [
            "placard"
        ],
        u: "1faa7",
        a: "13.0"
    },
    {
        n: [
            "identification card"
        ],
        u: "1faaa",
        a: "14.0"
    }
];
var symbols = [
    {
        n: [
            "atm",
            "automated teller machine"
        ],
        u: "1f3e7",
        a: "0.6"
    },
    {
        n: [
            "put litter in its place",
            "put litter in its place symbol"
        ],
        u: "1f6ae",
        a: "1.0"
    },
    {
        n: [
            "potable water",
            "potable water symbol"
        ],
        u: "1f6b0",
        a: "1.0"
    },
    {
        n: [
            "wheelchair",
            "wheelchair symbol"
        ],
        u: "267f",
        a: "0.6"
    },
    {
        n: [
            "mens",
            "mens symbol"
        ],
        u: "1f6b9",
        a: "0.6"
    },
    {
        n: [
            "womens",
            "womens symbol"
        ],
        u: "1f6ba",
        a: "0.6"
    },
    {
        n: [
            "restroom"
        ],
        u: "1f6bb",
        a: "0.6"
    },
    {
        n: [
            "baby symbol"
        ],
        u: "1f6bc",
        a: "0.6"
    },
    {
        n: [
            "wc",
            "water closet"
        ],
        u: "1f6be",
        a: "0.6"
    },
    {
        n: [
            "passport control"
        ],
        u: "1f6c2",
        a: "1.0"
    },
    {
        n: [
            "customs"
        ],
        u: "1f6c3",
        a: "1.0"
    },
    {
        n: [
            "baggage claim"
        ],
        u: "1f6c4",
        a: "1.0"
    },
    {
        n: [
            "left luggage"
        ],
        u: "1f6c5",
        a: "1.0"
    },
    {
        n: [
            "warning",
            "warning sign"
        ],
        u: "26a0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "children crossing"
        ],
        u: "1f6b8",
        a: "1.0"
    },
    {
        n: [
            "no entry"
        ],
        u: "26d4",
        a: "0.6"
    },
    {
        n: [
            "no entry sign"
        ],
        u: "1f6ab",
        a: "0.6"
    },
    {
        n: [
            "no bicycles"
        ],
        u: "1f6b3",
        a: "1.0"
    },
    {
        n: [
            "no smoking",
            "no smoking symbol"
        ],
        u: "1f6ad",
        a: "0.6"
    },
    {
        n: [
            "do not litter",
            "do not litter symbol"
        ],
        u: "1f6af",
        a: "1.0"
    },
    {
        n: [
            "non-potable water",
            "non-potable water symbol"
        ],
        u: "1f6b1",
        a: "1.0"
    },
    {
        n: [
            "no pedestrians"
        ],
        u: "1f6b7",
        a: "1.0"
    },
    {
        n: [
            "no mobile phones"
        ],
        u: "1f4f5",
        a: "1.0"
    },
    {
        n: [
            "underage",
            "no one under eighteen symbol"
        ],
        u: "1f51e",
        a: "0.6"
    },
    {
        n: [
            "radioactive",
            "radioactive sign"
        ],
        u: "2622-fe0f",
        a: "1.0"
    },
    {
        n: [
            "biohazard",
            "biohazard sign"
        ],
        u: "2623-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow up",
            "upwards black arrow"
        ],
        u: "2b06-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north east arrow",
            "arrow upper right"
        ],
        u: "2197-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right",
            "black rightwards arrow"
        ],
        u: "27a1-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south east arrow",
            "arrow lower right"
        ],
        u: "2198-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow down",
            "downwards black arrow"
        ],
        u: "2b07-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south west arrow",
            "arrow lower left"
        ],
        u: "2199-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow left",
            "leftwards black arrow"
        ],
        u: "2b05-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north west arrow",
            "arrow upper left"
        ],
        u: "2196-fe0f",
        a: "0.6"
    },
    {
        n: [
            "up down arrow",
            "arrow up down"
        ],
        u: "2195-fe0f",
        a: "0.6"
    },
    {
        n: [
            "left right arrow"
        ],
        u: "2194-fe0f",
        a: "0.6"
    },
    {
        n: [
            "leftwards arrow with hook"
        ],
        u: "21a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right hook",
            "rightwards arrow with hook"
        ],
        u: "21aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading up",
            "arrow pointing rightwards then curving upwards"
        ],
        u: "2934-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading down",
            "arrow pointing rightwards then curving downwards"
        ],
        u: "2935-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrows clockwise",
            "clockwise downwards and upwards open circle arrows"
        ],
        u: "1f503",
        a: "0.6"
    },
    {
        n: [
            "arrows counterclockwise",
            "anticlockwise downwards and upwards open circle arrows"
        ],
        u: "1f504",
        a: "1.0"
    },
    {
        n: [
            "back",
            "back with leftwards arrow above"
        ],
        u: "1f519",
        a: "0.6"
    },
    {
        n: [
            "end",
            "end with leftwards arrow above"
        ],
        u: "1f51a",
        a: "0.6"
    },
    {
        n: [
            "on",
            "on with exclamation mark with left right arrow above"
        ],
        u: "1f51b",
        a: "0.6"
    },
    {
        n: [
            "soon",
            "soon with rightwards arrow above"
        ],
        u: "1f51c",
        a: "0.6"
    },
    {
        n: [
            "top",
            "top with upwards arrow above"
        ],
        u: "1f51d",
        a: "0.6"
    },
    {
        n: [
            "place of worship"
        ],
        u: "1f6d0",
        a: "1.0"
    },
    {
        n: [
            "atom symbol"
        ],
        u: "269b-fe0f",
        a: "1.0"
    },
    {
        n: [
            "om",
            "om symbol"
        ],
        u: "1f549-fe0f",
        a: "0.7"
    },
    {
        n: [
            "star of david"
        ],
        u: "2721-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wheel of dharma"
        ],
        u: "2638-fe0f",
        a: "0.7"
    },
    {
        n: [
            "yin yang"
        ],
        u: "262f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "latin cross"
        ],
        u: "271d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "orthodox cross"
        ],
        u: "2626-fe0f",
        a: "1.0"
    },
    {
        n: [
            "star and crescent"
        ],
        u: "262a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "peace symbol"
        ],
        u: "262e-fe0f",
        a: "1.0"
    },
    {
        n: [
            "menorah with nine branches"
        ],
        u: "1f54e",
        a: "1.0"
    },
    {
        n: [
            "six pointed star",
            "six pointed star with middle dot"
        ],
        u: "1f52f",
        a: "0.6"
    },
    {
        n: [
            "aries"
        ],
        u: "2648",
        a: "0.6"
    },
    {
        n: [
            "taurus"
        ],
        u: "2649",
        a: "0.6"
    },
    {
        n: [
            "gemini"
        ],
        u: "264a",
        a: "0.6"
    },
    {
        n: [
            "cancer"
        ],
        u: "264b",
        a: "0.6"
    },
    {
        n: [
            "leo"
        ],
        u: "264c",
        a: "0.6"
    },
    {
        n: [
            "virgo"
        ],
        u: "264d",
        a: "0.6"
    },
    {
        n: [
            "libra"
        ],
        u: "264e",
        a: "0.6"
    },
    {
        n: [
            "scorpius"
        ],
        u: "264f",
        a: "0.6"
    },
    {
        n: [
            "sagittarius"
        ],
        u: "2650",
        a: "0.6"
    },
    {
        n: [
            "capricorn"
        ],
        u: "2651",
        a: "0.6"
    },
    {
        n: [
            "aquarius"
        ],
        u: "2652",
        a: "0.6"
    },
    {
        n: [
            "pisces"
        ],
        u: "2653",
        a: "0.6"
    },
    {
        n: [
            "ophiuchus"
        ],
        u: "26ce",
        a: "0.6"
    },
    {
        n: [
            "twisted rightwards arrows"
        ],
        u: "1f500",
        a: "1.0"
    },
    {
        n: [
            "repeat",
            "clockwise rightwards and leftwards open circle arrows"
        ],
        u: "1f501",
        a: "1.0"
    },
    {
        n: [
            "repeat one",
            "clockwise rightwards and leftwards open circle arrows with circled one overlay"
        ],
        u: "1f502",
        a: "1.0"
    },
    {
        n: [
            "arrow forward",
            "black right-pointing triangle"
        ],
        u: "25b6-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fast forward",
            "black right-pointing double triangle"
        ],
        u: "23e9",
        a: "0.6"
    },
    {
        n: [
            "next track button",
            "black right pointing double triangle with vertical bar"
        ],
        u: "23ed-fe0f",
        a: "0.7"
    },
    {
        n: [
            "play or pause button",
            "black right pointing triangle with double vertical bar"
        ],
        u: "23ef-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow backward",
            "black left-pointing triangle"
        ],
        u: "25c0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "rewind",
            "black left-pointing double triangle"
        ],
        u: "23ea",
        a: "0.6"
    },
    {
        n: [
            "last track button",
            "black left pointing double triangle with vertical bar"
        ],
        u: "23ee-fe0f",
        a: "0.7"
    },
    {
        n: [
            "arrow up small",
            "up-pointing small red triangle"
        ],
        u: "1f53c",
        a: "0.6"
    },
    {
        n: [
            "arrow double up",
            "black up-pointing double triangle"
        ],
        u: "23eb",
        a: "0.6"
    },
    {
        n: [
            "arrow down small",
            "down-pointing small red triangle"
        ],
        u: "1f53d",
        a: "0.6"
    },
    {
        n: [
            "arrow double down",
            "black down-pointing double triangle"
        ],
        u: "23ec",
        a: "0.6"
    },
    {
        n: [
            "pause button",
            "double vertical bar"
        ],
        u: "23f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stop button",
            "black square for stop"
        ],
        u: "23f9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "record button",
            "black circle for record"
        ],
        u: "23fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eject",
            "eject button"
        ],
        u: "23cf-fe0f",
        a: "1.0"
    },
    {
        n: [
            "cinema"
        ],
        u: "1f3a6",
        a: "0.6"
    },
    {
        n: [
            "low brightness",
            "low brightness symbol"
        ],
        u: "1f505",
        a: "1.0"
    },
    {
        n: [
            "high brightness",
            "high brightness symbol"
        ],
        u: "1f506",
        a: "1.0"
    },
    {
        n: [
            "signal strength",
            "antenna with bars"
        ],
        u: "1f4f6",
        a: "0.6"
    },
    {
        n: [
            "vibration mode"
        ],
        u: "1f4f3",
        a: "0.6"
    },
    {
        n: [
            "mobile phone off"
        ],
        u: "1f4f4",
        a: "0.6"
    },
    {
        n: [
            "female sign"
        ],
        u: "2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "male sign"
        ],
        u: "2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "transgender symbol"
        ],
        u: "26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "heavy multiplication x"
        ],
        u: "2716-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy plus sign"
        ],
        u: "2795",
        a: "0.6"
    },
    {
        n: [
            "heavy minus sign"
        ],
        u: "2796",
        a: "0.6"
    },
    {
        n: [
            "heavy division sign"
        ],
        u: "2797",
        a: "0.6"
    },
    {
        n: [
            "heavy equals sign"
        ],
        u: "1f7f0",
        a: "14.0"
    },
    {
        n: [
            "infinity"
        ],
        u: "267e-fe0f",
        a: "11.0"
    },
    {
        n: [
            "bangbang",
            "double exclamation mark"
        ],
        u: "203c-fe0f",
        a: "0.6"
    },
    {
        n: [
            "interrobang",
            "exclamation question mark"
        ],
        u: "2049-fe0f",
        a: "0.6"
    },
    {
        n: [
            "question",
            "black question mark ornament"
        ],
        u: "2753",
        a: "0.6"
    },
    {
        n: [
            "grey question",
            "white question mark ornament"
        ],
        u: "2754",
        a: "0.6"
    },
    {
        n: [
            "grey exclamation",
            "white exclamation mark ornament"
        ],
        u: "2755",
        a: "0.6"
    },
    {
        n: [
            "exclamation",
            "heavy exclamation mark",
            "heavy exclamation mark symbol"
        ],
        u: "2757",
        a: "0.6"
    },
    {
        n: [
            "wavy dash"
        ],
        u: "3030-fe0f",
        a: "0.6"
    },
    {
        n: [
            "currency exchange"
        ],
        u: "1f4b1",
        a: "0.6"
    },
    {
        n: [
            "heavy dollar sign"
        ],
        u: "1f4b2",
        a: "0.6"
    },
    {
        n: [
            "medical symbol",
            "staff of aesculapius"
        ],
        u: "2695-fe0f",
        a: "4.0"
    },
    {
        n: [
            "recycle",
            "black universal recycling symbol"
        ],
        u: "267b-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fleur-de-lis",
            "fleur de lis"
        ],
        u: "269c-fe0f",
        a: "1.0"
    },
    {
        n: [
            "trident",
            "trident emblem"
        ],
        u: "1f531",
        a: "0.6"
    },
    {
        n: [
            "name badge"
        ],
        u: "1f4db",
        a: "0.6"
    },
    {
        n: [
            "beginner",
            "japanese symbol for beginner"
        ],
        u: "1f530",
        a: "0.6"
    },
    {
        n: [
            "o",
            "heavy large circle"
        ],
        u: "2b55",
        a: "0.6"
    },
    {
        n: [
            "white check mark",
            "white heavy check mark"
        ],
        u: "2705",
        a: "0.6"
    },
    {
        n: [
            "ballot box with check"
        ],
        u: "2611-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy check mark"
        ],
        u: "2714-fe0f",
        a: "0.6"
    },
    {
        n: [
            "x",
            "cross mark"
        ],
        u: "274c",
        a: "0.6"
    },
    {
        n: [
            "negative squared cross mark"
        ],
        u: "274e",
        a: "0.6"
    },
    {
        n: [
            "curly loop"
        ],
        u: "27b0",
        a: "0.6"
    },
    {
        n: [
            "loop",
            "double curly loop"
        ],
        u: "27bf",
        a: "1.0"
    },
    {
        n: [
            "part alternation mark"
        ],
        u: "303d-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight spoked asterisk"
        ],
        u: "2733-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight pointed black star"
        ],
        u: "2734-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sparkle"
        ],
        u: "2747-fe0f",
        a: "0.6"
    },
    {
        n: [
            "copyright",
            "copyright sign"
        ],
        u: "00a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "registered",
            "registered sign"
        ],
        u: "00ae-fe0f",
        a: "0.6"
    },
    {
        n: [
            "tm",
            "trade mark sign"
        ],
        u: "2122-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hash",
            "hash key"
        ],
        u: "0023-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap: *",
            "keycap star"
        ],
        u: "002a-fe0f-20e3",
        a: "2.0"
    },
    {
        n: [
            "zero",
            "keycap 0"
        ],
        u: "0030-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "one",
            "keycap 1"
        ],
        u: "0031-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "two",
            "keycap 2"
        ],
        u: "0032-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "three",
            "keycap 3"
        ],
        u: "0033-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "four",
            "keycap 4"
        ],
        u: "0034-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "five",
            "keycap 5"
        ],
        u: "0035-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "six",
            "keycap 6"
        ],
        u: "0036-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "seven",
            "keycap 7"
        ],
        u: "0037-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "eight",
            "keycap 8"
        ],
        u: "0038-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "nine",
            "keycap 9"
        ],
        u: "0039-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap ten"
        ],
        u: "1f51f",
        a: "0.6"
    },
    {
        n: [
            "capital abcd",
            "input symbol for latin capital letters"
        ],
        u: "1f520",
        a: "0.6"
    },
    {
        n: [
            "abcd",
            "input symbol for latin small letters"
        ],
        u: "1f521",
        a: "0.6"
    },
    {
        n: [
            "1234",
            "input symbol for numbers"
        ],
        u: "1f522",
        a: "0.6"
    },
    {
        n: [
            "symbols",
            "input symbol for symbols"
        ],
        u: "1f523",
        a: "0.6"
    },
    {
        n: [
            "abc",
            "input symbol for latin letters"
        ],
        u: "1f524",
        a: "0.6"
    },
    {
        n: [
            "a",
            "negative squared latin capital letter a"
        ],
        u: "1f170-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ab",
            "negative squared ab"
        ],
        u: "1f18e",
        a: "0.6"
    },
    {
        n: [
            "b",
            "negative squared latin capital letter b"
        ],
        u: "1f171-fe0f",
        a: "0.6"
    },
    {
        n: [
            "cl",
            "squared cl"
        ],
        u: "1f191",
        a: "0.6"
    },
    {
        n: [
            "cool",
            "squared cool"
        ],
        u: "1f192",
        a: "0.6"
    },
    {
        n: [
            "free",
            "squared free"
        ],
        u: "1f193",
        a: "0.6"
    },
    {
        n: [
            "information source"
        ],
        u: "2139-fe0f",
        a: "0.6"
    },
    {
        n: [
            "id",
            "squared id"
        ],
        u: "1f194",
        a: "0.6"
    },
    {
        n: [
            "m",
            "circled latin capital letter m"
        ],
        u: "24c2-fe0f",
        a: "0.6"
    },
    {
        n: [
            "new",
            "squared new"
        ],
        u: "1f195",
        a: "0.6"
    },
    {
        n: [
            "ng",
            "squared ng"
        ],
        u: "1f196",
        a: "0.6"
    },
    {
        n: [
            "o2",
            "negative squared latin capital letter o"
        ],
        u: "1f17e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ok",
            "squared ok"
        ],
        u: "1f197",
        a: "0.6"
    },
    {
        n: [
            "parking",
            "negative squared latin capital letter p"
        ],
        u: "1f17f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sos",
            "squared sos"
        ],
        u: "1f198",
        a: "0.6"
    },
    {
        n: [
            "up",
            "squared up with exclamation mark"
        ],
        u: "1f199",
        a: "0.6"
    },
    {
        n: [
            "vs",
            "squared vs"
        ],
        u: "1f19a",
        a: "0.6"
    },
    {
        n: [
            "koko",
            "squared katakana koko"
        ],
        u: "1f201",
        a: "0.6"
    },
    {
        n: [
            "sa",
            "squared katakana sa"
        ],
        u: "1f202-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6708",
            "squared cjk unified ideograph-6708"
        ],
        u: "1f237-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6709",
            "squared cjk unified ideograph-6709"
        ],
        u: "1f236",
        a: "0.6"
    },
    {
        n: [
            "u6307",
            "squared cjk unified ideograph-6307"
        ],
        u: "1f22f",
        a: "0.6"
    },
    {
        n: [
            "ideograph advantage",
            "circled ideograph advantage"
        ],
        u: "1f250",
        a: "0.6"
    },
    {
        n: [
            "u5272",
            "squared cjk unified ideograph-5272"
        ],
        u: "1f239",
        a: "0.6"
    },
    {
        n: [
            "u7121",
            "squared cjk unified ideograph-7121"
        ],
        u: "1f21a",
        a: "0.6"
    },
    {
        n: [
            "u7981",
            "squared cjk unified ideograph-7981"
        ],
        u: "1f232",
        a: "0.6"
    },
    {
        n: [
            "accept",
            "circled ideograph accept"
        ],
        u: "1f251",
        a: "0.6"
    },
    {
        n: [
            "u7533",
            "squared cjk unified ideograph-7533"
        ],
        u: "1f238",
        a: "0.6"
    },
    {
        n: [
            "u5408",
            "squared cjk unified ideograph-5408"
        ],
        u: "1f234",
        a: "0.6"
    },
    {
        n: [
            "u7a7a",
            "squared cjk unified ideograph-7a7a"
        ],
        u: "1f233",
        a: "0.6"
    },
    {
        n: [
            "congratulations",
            "circled ideograph congratulation"
        ],
        u: "3297-fe0f",
        a: "0.6"
    },
    {
        n: [
            "secret",
            "circled ideograph secret"
        ],
        u: "3299-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u55b6",
            "squared cjk unified ideograph-55b6"
        ],
        u: "1f23a",
        a: "0.6"
    },
    {
        n: [
            "u6e80",
            "squared cjk unified ideograph-6e80"
        ],
        u: "1f235",
        a: "0.6"
    },
    {
        n: [
            "red circle",
            "large red circle"
        ],
        u: "1f534",
        a: "0.6"
    },
    {
        n: [
            "large orange circle"
        ],
        u: "1f7e0",
        a: "12.0"
    },
    {
        n: [
            "large yellow circle"
        ],
        u: "1f7e1",
        a: "12.0"
    },
    {
        n: [
            "large green circle"
        ],
        u: "1f7e2",
        a: "12.0"
    },
    {
        n: [
            "large blue circle"
        ],
        u: "1f535",
        a: "0.6"
    },
    {
        n: [
            "large purple circle"
        ],
        u: "1f7e3",
        a: "12.0"
    },
    {
        n: [
            "large brown circle"
        ],
        u: "1f7e4",
        a: "12.0"
    },
    {
        n: [
            "black circle",
            "medium black circle"
        ],
        u: "26ab",
        a: "0.6"
    },
    {
        n: [
            "white circle",
            "medium white circle"
        ],
        u: "26aa",
        a: "0.6"
    },
    {
        n: [
            "large red square"
        ],
        u: "1f7e5",
        a: "12.0"
    },
    {
        n: [
            "large orange square"
        ],
        u: "1f7e7",
        a: "12.0"
    },
    {
        n: [
            "large yellow square"
        ],
        u: "1f7e8",
        a: "12.0"
    },
    {
        n: [
            "large green square"
        ],
        u: "1f7e9",
        a: "12.0"
    },
    {
        n: [
            "large blue square"
        ],
        u: "1f7e6",
        a: "12.0"
    },
    {
        n: [
            "large purple square"
        ],
        u: "1f7ea",
        a: "12.0"
    },
    {
        n: [
            "large brown square"
        ],
        u: "1f7eb",
        a: "12.0"
    },
    {
        n: [
            "black large square"
        ],
        u: "2b1b",
        a: "0.6"
    },
    {
        n: [
            "white large square"
        ],
        u: "2b1c",
        a: "0.6"
    },
    {
        n: [
            "black medium square"
        ],
        u: "25fc-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white medium square"
        ],
        u: "25fb-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black medium small square"
        ],
        u: "25fe",
        a: "0.6"
    },
    {
        n: [
            "white medium small square"
        ],
        u: "25fd",
        a: "0.6"
    },
    {
        n: [
            "black small square"
        ],
        u: "25aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white small square"
        ],
        u: "25ab-fe0f",
        a: "0.6"
    },
    {
        n: [
            "large orange diamond"
        ],
        u: "1f536",
        a: "0.6"
    },
    {
        n: [
            "large blue diamond"
        ],
        u: "1f537",
        a: "0.6"
    },
    {
        n: [
            "small orange diamond"
        ],
        u: "1f538",
        a: "0.6"
    },
    {
        n: [
            "small blue diamond"
        ],
        u: "1f539",
        a: "0.6"
    },
    {
        n: [
            "small red triangle",
            "up-pointing red triangle"
        ],
        u: "1f53a",
        a: "0.6"
    },
    {
        n: [
            "small red triangle down",
            "down-pointing red triangle"
        ],
        u: "1f53b",
        a: "0.6"
    },
    {
        n: [
            "diamond shape with a dot inside"
        ],
        u: "1f4a0",
        a: "0.6"
    },
    {
        n: [
            "radio button"
        ],
        u: "1f518",
        a: "0.6"
    },
    {
        n: [
            "white square button"
        ],
        u: "1f533",
        a: "0.6"
    },
    {
        n: [
            "black square button"
        ],
        u: "1f532",
        a: "0.6"
    }
];
var flags = [
    {
        n: [
            "chequered flag",
            "checkered flag"
        ],
        u: "1f3c1",
        a: "0.6"
    },
    {
        n: [
            "triangular flag on post"
        ],
        u: "1f6a9",
        a: "0.6"
    },
    {
        n: [
            "crossed flags"
        ],
        u: "1f38c",
        a: "0.6"
    },
    {
        n: [
            "waving black flag"
        ],
        u: "1f3f4",
        a: "1.0"
    },
    {
        n: [
            "white flag",
            "waving white flag"
        ],
        u: "1f3f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rainbow flag",
            "rainbow-flag"
        ],
        u: "1f3f3-fe0f-200d-1f308",
        a: "4.0"
    },
    {
        n: [
            "transgender flag"
        ],
        u: "1f3f3-fe0f-200d-26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "pirate flag"
        ],
        u: "1f3f4-200d-2620-fe0f",
        a: "11.0"
    },
    {
        n: [
            "flag-ac",
            "ascension island flag"
        ],
        u: "1f1e6-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ad",
            "andorra flag"
        ],
        u: "1f1e6-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ae",
            "united arab emirates flag"
        ],
        u: "1f1e6-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-af",
            "afghanistan flag"
        ],
        u: "1f1e6-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ag",
            "antigua & barbuda flag"
        ],
        u: "1f1e6-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ai",
            "anguilla flag"
        ],
        u: "1f1e6-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-al",
            "albania flag"
        ],
        u: "1f1e6-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-am",
            "armenia flag"
        ],
        u: "1f1e6-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-ao",
            "angola flag"
        ],
        u: "1f1e6-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-aq",
            "antarctica flag"
        ],
        u: "1f1e6-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ar",
            "argentina flag"
        ],
        u: "1f1e6-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-as",
            "american samoa flag"
        ],
        u: "1f1e6-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-at",
            "austria flag"
        ],
        u: "1f1e6-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-au",
            "australia flag"
        ],
        u: "1f1e6-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-aw",
            "aruba flag"
        ],
        u: "1f1e6-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ax",
            "\xe5land islands flag"
        ],
        u: "1f1e6-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-az",
            "azerbaijan flag"
        ],
        u: "1f1e6-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ba",
            "bosnia & herzegovina flag"
        ],
        u: "1f1e7-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-bb",
            "barbados flag"
        ],
        u: "1f1e7-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-bd",
            "bangladesh flag"
        ],
        u: "1f1e7-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-be",
            "belgium flag"
        ],
        u: "1f1e7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-bf",
            "burkina faso flag"
        ],
        u: "1f1e7-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-bg",
            "bulgaria flag"
        ],
        u: "1f1e7-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-bh",
            "bahrain flag"
        ],
        u: "1f1e7-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-bi",
            "burundi flag"
        ],
        u: "1f1e7-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-bj",
            "benin flag"
        ],
        u: "1f1e7-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-bl",
            "st. barth\xe9lemy flag"
        ],
        u: "1f1e7-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-bm",
            "bermuda flag"
        ],
        u: "1f1e7-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-bn",
            "brunei flag"
        ],
        u: "1f1e7-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-bo",
            "bolivia flag"
        ],
        u: "1f1e7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-bq",
            "caribbean netherlands flag"
        ],
        u: "1f1e7-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-br",
            "brazil flag"
        ],
        u: "1f1e7-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-bs",
            "bahamas flag"
        ],
        u: "1f1e7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-bt",
            "bhutan flag"
        ],
        u: "1f1e7-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-bv",
            "bouvet island flag"
        ],
        u: "1f1e7-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-bw",
            "botswana flag"
        ],
        u: "1f1e7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-by",
            "belarus flag"
        ],
        u: "1f1e7-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-bz",
            "belize flag"
        ],
        u: "1f1e7-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ca",
            "canada flag"
        ],
        u: "1f1e8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-cc",
            "cocos (keeling) islands flag"
        ],
        u: "1f1e8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-cd",
            "congo - kinshasa flag"
        ],
        u: "1f1e8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-cf",
            "central african republic flag"
        ],
        u: "1f1e8-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-cg",
            "congo - brazzaville flag"
        ],
        u: "1f1e8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ch",
            "switzerland flag"
        ],
        u: "1f1e8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ci",
            "c\xf4te d\u2019ivoire flag"
        ],
        u: "1f1e8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-ck",
            "cook islands flag"
        ],
        u: "1f1e8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-cl",
            "chile flag"
        ],
        u: "1f1e8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-cm",
            "cameroon flag"
        ],
        u: "1f1e8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "cn",
            "flag-cn",
            "china flag"
        ],
        u: "1f1e8-1f1f3",
        a: "0.6"
    },
    {
        n: [
            "flag-co",
            "colombia flag"
        ],
        u: "1f1e8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-cp",
            "clipperton island flag"
        ],
        u: "1f1e8-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-cr",
            "costa rica flag"
        ],
        u: "1f1e8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-cu",
            "cuba flag"
        ],
        u: "1f1e8-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-cv",
            "cape verde flag"
        ],
        u: "1f1e8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-cw",
            "cura\xe7ao flag"
        ],
        u: "1f1e8-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-cx",
            "christmas island flag"
        ],
        u: "1f1e8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-cy",
            "cyprus flag"
        ],
        u: "1f1e8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-cz",
            "czechia flag"
        ],
        u: "1f1e8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "de",
            "flag-de",
            "germany flag"
        ],
        u: "1f1e9-1f1ea",
        a: "0.6"
    },
    {
        n: [
            "flag-dg",
            "diego garcia flag"
        ],
        u: "1f1e9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-dj",
            "djibouti flag"
        ],
        u: "1f1e9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-dk",
            "denmark flag"
        ],
        u: "1f1e9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-dm",
            "dominica flag"
        ],
        u: "1f1e9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-do",
            "dominican republic flag"
        ],
        u: "1f1e9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-dz",
            "algeria flag"
        ],
        u: "1f1e9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ea",
            "ceuta & melilla flag"
        ],
        u: "1f1ea-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ec",
            "ecuador flag"
        ],
        u: "1f1ea-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ee",
            "estonia flag"
        ],
        u: "1f1ea-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-eg",
            "egypt flag"
        ],
        u: "1f1ea-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-eh",
            "western sahara flag"
        ],
        u: "1f1ea-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-er",
            "eritrea flag"
        ],
        u: "1f1ea-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "es",
            "flag-es",
            "spain flag"
        ],
        u: "1f1ea-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-et",
            "ethiopia flag"
        ],
        u: "1f1ea-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-eu",
            "european union flag"
        ],
        u: "1f1ea-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-fi",
            "finland flag"
        ],
        u: "1f1eb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-fj",
            "fiji flag"
        ],
        u: "1f1eb-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-fk",
            "falkland islands flag"
        ],
        u: "1f1eb-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-fm",
            "micronesia flag"
        ],
        u: "1f1eb-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-fo",
            "faroe islands flag"
        ],
        u: "1f1eb-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "fr",
            "flag-fr",
            "france flag"
        ],
        u: "1f1eb-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-ga",
            "gabon flag"
        ],
        u: "1f1ec-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "gb",
            "uk",
            "flag-gb",
            "united kingdom flag"
        ],
        u: "1f1ec-1f1e7",
        a: "0.6"
    },
    {
        n: [
            "flag-gd",
            "grenada flag"
        ],
        u: "1f1ec-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ge",
            "georgia flag"
        ],
        u: "1f1ec-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-gf",
            "french guiana flag"
        ],
        u: "1f1ec-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-gg",
            "guernsey flag"
        ],
        u: "1f1ec-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-gh",
            "ghana flag"
        ],
        u: "1f1ec-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-gi",
            "gibraltar flag"
        ],
        u: "1f1ec-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-gl",
            "greenland flag"
        ],
        u: "1f1ec-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-gm",
            "gambia flag"
        ],
        u: "1f1ec-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-gn",
            "guinea flag"
        ],
        u: "1f1ec-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-gp",
            "guadeloupe flag"
        ],
        u: "1f1ec-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-gq",
            "equatorial guinea flag"
        ],
        u: "1f1ec-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-gr",
            "greece flag"
        ],
        u: "1f1ec-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-gs",
            "south georgia & south sandwich islands flag"
        ],
        u: "1f1ec-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-gt",
            "guatemala flag"
        ],
        u: "1f1ec-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-gu",
            "guam flag"
        ],
        u: "1f1ec-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-gw",
            "guinea-bissau flag"
        ],
        u: "1f1ec-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-gy",
            "guyana flag"
        ],
        u: "1f1ec-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-hk",
            "hong kong sar china flag"
        ],
        u: "1f1ed-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-hm",
            "heard & mcdonald islands flag"
        ],
        u: "1f1ed-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-hn",
            "honduras flag"
        ],
        u: "1f1ed-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-hr",
            "croatia flag"
        ],
        u: "1f1ed-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ht",
            "haiti flag"
        ],
        u: "1f1ed-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-hu",
            "hungary flag"
        ],
        u: "1f1ed-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-ic",
            "canary islands flag"
        ],
        u: "1f1ee-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-id",
            "indonesia flag"
        ],
        u: "1f1ee-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ie",
            "ireland flag"
        ],
        u: "1f1ee-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-il",
            "israel flag"
        ],
        u: "1f1ee-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-im",
            "isle of man flag"
        ],
        u: "1f1ee-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-in",
            "india flag"
        ],
        u: "1f1ee-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-io",
            "british indian ocean territory flag"
        ],
        u: "1f1ee-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-iq",
            "iraq flag"
        ],
        u: "1f1ee-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ir",
            "iran flag"
        ],
        u: "1f1ee-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-is",
            "iceland flag"
        ],
        u: "1f1ee-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "it",
            "flag-it",
            "italy flag"
        ],
        u: "1f1ee-1f1f9",
        a: "0.6"
    },
    {
        n: [
            "flag-je",
            "jersey flag"
        ],
        u: "1f1ef-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-jm",
            "jamaica flag"
        ],
        u: "1f1ef-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-jo",
            "jordan flag"
        ],
        u: "1f1ef-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "jp",
            "flag-jp",
            "japan flag"
        ],
        u: "1f1ef-1f1f5",
        a: "0.6"
    },
    {
        n: [
            "flag-ke",
            "kenya flag"
        ],
        u: "1f1f0-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-kg",
            "kyrgyzstan flag"
        ],
        u: "1f1f0-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-kh",
            "cambodia flag"
        ],
        u: "1f1f0-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ki",
            "kiribati flag"
        ],
        u: "1f1f0-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-km",
            "comoros flag"
        ],
        u: "1f1f0-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-kn",
            "st. kitts & nevis flag"
        ],
        u: "1f1f0-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-kp",
            "north korea flag"
        ],
        u: "1f1f0-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "kr",
            "flag-kr",
            "south korea flag"
        ],
        u: "1f1f0-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-kw",
            "kuwait flag"
        ],
        u: "1f1f0-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ky",
            "cayman islands flag"
        ],
        u: "1f1f0-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-kz",
            "kazakhstan flag"
        ],
        u: "1f1f0-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-la",
            "laos flag"
        ],
        u: "1f1f1-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-lb",
            "lebanon flag"
        ],
        u: "1f1f1-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-lc",
            "st. lucia flag"
        ],
        u: "1f1f1-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-li",
            "liechtenstein flag"
        ],
        u: "1f1f1-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-lk",
            "sri lanka flag"
        ],
        u: "1f1f1-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-lr",
            "liberia flag"
        ],
        u: "1f1f1-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ls",
            "lesotho flag"
        ],
        u: "1f1f1-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-lt",
            "lithuania flag"
        ],
        u: "1f1f1-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-lu",
            "luxembourg flag"
        ],
        u: "1f1f1-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-lv",
            "latvia flag"
        ],
        u: "1f1f1-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-ly",
            "libya flag"
        ],
        u: "1f1f1-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-ma",
            "morocco flag"
        ],
        u: "1f1f2-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-mc",
            "monaco flag"
        ],
        u: "1f1f2-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-md",
            "moldova flag"
        ],
        u: "1f1f2-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-me",
            "montenegro flag"
        ],
        u: "1f1f2-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-mf",
            "st. martin flag"
        ],
        u: "1f1f2-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-mg",
            "madagascar flag"
        ],
        u: "1f1f2-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-mh",
            "marshall islands flag"
        ],
        u: "1f1f2-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-mk",
            "north macedonia flag"
        ],
        u: "1f1f2-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ml",
            "mali flag"
        ],
        u: "1f1f2-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-mm",
            "myanmar (burma) flag"
        ],
        u: "1f1f2-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-mn",
            "mongolia flag"
        ],
        u: "1f1f2-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-mo",
            "macao sar china flag"
        ],
        u: "1f1f2-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-mp",
            "northern mariana islands flag"
        ],
        u: "1f1f2-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-mq",
            "martinique flag"
        ],
        u: "1f1f2-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-mr",
            "mauritania flag"
        ],
        u: "1f1f2-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ms",
            "montserrat flag"
        ],
        u: "1f1f2-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-mt",
            "malta flag"
        ],
        u: "1f1f2-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-mu",
            "mauritius flag"
        ],
        u: "1f1f2-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-mv",
            "maldives flag"
        ],
        u: "1f1f2-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-mw",
            "malawi flag"
        ],
        u: "1f1f2-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-mx",
            "mexico flag"
        ],
        u: "1f1f2-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-my",
            "malaysia flag"
        ],
        u: "1f1f2-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-mz",
            "mozambique flag"
        ],
        u: "1f1f2-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-na",
            "namibia flag"
        ],
        u: "1f1f3-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-nc",
            "new caledonia flag"
        ],
        u: "1f1f3-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ne",
            "niger flag"
        ],
        u: "1f1f3-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-nf",
            "norfolk island flag"
        ],
        u: "1f1f3-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ng",
            "nigeria flag"
        ],
        u: "1f1f3-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ni",
            "nicaragua flag"
        ],
        u: "1f1f3-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-nl",
            "netherlands flag"
        ],
        u: "1f1f3-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-no",
            "norway flag"
        ],
        u: "1f1f3-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-np",
            "nepal flag"
        ],
        u: "1f1f3-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-nr",
            "nauru flag"
        ],
        u: "1f1f3-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-nu",
            "niue flag"
        ],
        u: "1f1f3-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-nz",
            "new zealand flag"
        ],
        u: "1f1f3-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-om",
            "oman flag"
        ],
        u: "1f1f4-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pa",
            "panama flag"
        ],
        u: "1f1f5-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-pe",
            "peru flag"
        ],
        u: "1f1f5-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-pf",
            "french polynesia flag"
        ],
        u: "1f1f5-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-pg",
            "papua new guinea flag"
        ],
        u: "1f1f5-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ph",
            "philippines flag"
        ],
        u: "1f1f5-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-pk",
            "pakistan flag"
        ],
        u: "1f1f5-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-pl",
            "poland flag"
        ],
        u: "1f1f5-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-pm",
            "st. pierre & miquelon flag"
        ],
        u: "1f1f5-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pn",
            "pitcairn islands flag"
        ],
        u: "1f1f5-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-pr",
            "puerto rico flag"
        ],
        u: "1f1f5-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ps",
            "palestinian territories flag"
        ],
        u: "1f1f5-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-pt",
            "portugal flag"
        ],
        u: "1f1f5-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-pw",
            "palau flag"
        ],
        u: "1f1f5-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-py",
            "paraguay flag"
        ],
        u: "1f1f5-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-qa",
            "qatar flag"
        ],
        u: "1f1f6-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-re",
            "r\xe9union flag"
        ],
        u: "1f1f7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-ro",
            "romania flag"
        ],
        u: "1f1f7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-rs",
            "serbia flag"
        ],
        u: "1f1f7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "ru",
            "flag-ru",
            "russia flag"
        ],
        u: "1f1f7-1f1fa",
        a: "0.6"
    },
    {
        n: [
            "flag-rw",
            "rwanda flag"
        ],
        u: "1f1f7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-sa",
            "saudi arabia flag"
        ],
        u: "1f1f8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-sb",
            "solomon islands flag"
        ],
        u: "1f1f8-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-sc",
            "seychelles flag"
        ],
        u: "1f1f8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-sd",
            "sudan flag"
        ],
        u: "1f1f8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-se",
            "sweden flag"
        ],
        u: "1f1f8-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-sg",
            "singapore flag"
        ],
        u: "1f1f8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-sh",
            "st. helena flag"
        ],
        u: "1f1f8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-si",
            "slovenia flag"
        ],
        u: "1f1f8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-sj",
            "svalbard & jan mayen flag"
        ],
        u: "1f1f8-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-sk",
            "slovakia flag"
        ],
        u: "1f1f8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-sl",
            "sierra leone flag"
        ],
        u: "1f1f8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-sm",
            "san marino flag"
        ],
        u: "1f1f8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-sn",
            "senegal flag"
        ],
        u: "1f1f8-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-so",
            "somalia flag"
        ],
        u: "1f1f8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-sr",
            "suriname flag"
        ],
        u: "1f1f8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ss",
            "south sudan flag"
        ],
        u: "1f1f8-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-st",
            "s\xe3o tom\xe9 & pr\xedncipe flag"
        ],
        u: "1f1f8-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-sv",
            "el salvador flag"
        ],
        u: "1f1f8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-sx",
            "sint maarten flag"
        ],
        u: "1f1f8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-sy",
            "syria flag"
        ],
        u: "1f1f8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-sz",
            "eswatini flag"
        ],
        u: "1f1f8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ta",
            "tristan da cunha flag"
        ],
        u: "1f1f9-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-tc",
            "turks & caicos islands flag"
        ],
        u: "1f1f9-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-td",
            "chad flag"
        ],
        u: "1f1f9-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-tf",
            "french southern territories flag"
        ],
        u: "1f1f9-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-tg",
            "togo flag"
        ],
        u: "1f1f9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-th",
            "thailand flag"
        ],
        u: "1f1f9-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-tj",
            "tajikistan flag"
        ],
        u: "1f1f9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-tk",
            "tokelau flag"
        ],
        u: "1f1f9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-tl",
            "timor-leste flag"
        ],
        u: "1f1f9-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-tm",
            "turkmenistan flag"
        ],
        u: "1f1f9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-tn",
            "tunisia flag"
        ],
        u: "1f1f9-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-to",
            "tonga flag"
        ],
        u: "1f1f9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-tr",
            "turkey flag"
        ],
        u: "1f1f9-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-tt",
            "trinidad & tobago flag"
        ],
        u: "1f1f9-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-tv",
            "tuvalu flag"
        ],
        u: "1f1f9-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-tw",
            "taiwan flag"
        ],
        u: "1f1f9-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-tz",
            "tanzania flag"
        ],
        u: "1f1f9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ua",
            "ukraine flag"
        ],
        u: "1f1fa-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ug",
            "uganda flag"
        ],
        u: "1f1fa-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-um",
            "u.s. outlying islands flag"
        ],
        u: "1f1fa-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-un",
            "united nations flag"
        ],
        u: "1f1fa-1f1f3",
        a: "4.0"
    },
    {
        n: [
            "us",
            "flag-us",
            "united states flag"
        ],
        u: "1f1fa-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-uy",
            "uruguay flag"
        ],
        u: "1f1fa-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-uz",
            "uzbekistan flag"
        ],
        u: "1f1fa-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-va",
            "vatican city flag"
        ],
        u: "1f1fb-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-vc",
            "st. vincent & grenadines flag"
        ],
        u: "1f1fb-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ve",
            "venezuela flag"
        ],
        u: "1f1fb-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-vg",
            "british virgin islands flag"
        ],
        u: "1f1fb-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-vi",
            "u.s. virgin islands flag"
        ],
        u: "1f1fb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-vn",
            "vietnam flag"
        ],
        u: "1f1fb-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-vu",
            "vanuatu flag"
        ],
        u: "1f1fb-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-wf",
            "wallis & futuna flag"
        ],
        u: "1f1fc-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ws",
            "samoa flag"
        ],
        u: "1f1fc-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-xk",
            "kosovo flag"
        ],
        u: "1f1fd-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ye",
            "yemen flag"
        ],
        u: "1f1fe-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-yt",
            "mayotte flag"
        ],
        u: "1f1fe-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-za",
            "south africa flag"
        ],
        u: "1f1ff-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-zm",
            "zambia flag"
        ],
        u: "1f1ff-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-zw",
            "zimbabwe flag"
        ],
        u: "1f1ff-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "england flag",
            "flag-england"
        ],
        u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        a: "5.0"
    },
    {
        n: [
            "scotland flag",
            "flag-scotland"
        ],
        u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        a: "5.0"
    },
    {
        n: [
            "wales flag",
            "flag-wales"
        ],
        u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        a: "5.0"
    }
];
var emojis = {
    custom: custom,
    smileys_people: smileys_people,
    animals_nature: animals_nature,
    food_drink: food_drink,
    travel_places: travel_places,
    activities: activities,
    objects: objects,
    symbols: symbols,
    flags: flags
};
var skinToneVariations = [
    SkinTones.NEUTRAL,
    SkinTones.LIGHT,
    SkinTones.MEDIUM_LIGHT,
    SkinTones.MEDIUM,
    SkinTones.MEDIUM_DARK,
    SkinTones.DARK
];
var skinTonesNamed = /*#__PURE__*/ Object.entries(SkinTones).reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[value] = key;
    return acc;
}, {});
var skinTonesMapped = /*#__PURE__*/ skinToneVariations.reduce(function(mapped, skinTone) {
    var _Object$assign;
    return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var EmojiProperties;
(function(EmojiProperties) {
    EmojiProperties["name"] = "n";
    EmojiProperties["unified"] = "u";
    EmojiProperties["variations"] = "v";
    EmojiProperties["added_in"] = "a";
    EmojiProperties["imgUrl"] = "imgUrl";
})(EmojiProperties || (EmojiProperties = {}));
var alphaNumericEmojiIndex = {};
setTimeout(function() {
    allEmojis.reduce(function(searchIndex, emoji) {
        indexEmoji(emoji);
        return searchIndex;
    }, alphaNumericEmojiIndex);
});
function indexEmoji(emoji) {
    var joinedNameString = emojiNames(emoji).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
    joinedNameString.forEach(function(_char) {
        var _alphaNumericEmojiInd;
        alphaNumericEmojiIndex[_char] = (_alphaNumericEmojiInd = alphaNumericEmojiIndex[_char]) != null ? _alphaNumericEmojiInd : {};
        alphaNumericEmojiIndex[_char][emojiUnified(emoji)] = emoji;
    });
}
function emojiNames(emoji) {
    var _emoji$EmojiPropertie;
    return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function addedIn(emoji) {
    return parseFloat(emoji[EmojiProperties.added_in]);
}
function emojiName(emoji) {
    if (!emoji) return "";
    return emojiNames(emoji)[0];
}
function unifiedWithoutSkinTone(unified) {
    var splat = unified.split("-");
    var _splat$splice = splat.splice(1, 1), skinTone = _splat$splice[0];
    if (skinTonesMapped[skinTone]) return splat.join("-");
    return unified;
}
function emojiUnified(emoji, skinTone) {
    var _emojiVariationUnifie;
    var unified = emoji[EmojiProperties.unified];
    if (!skinTone || !emojiHasVariations(emoji)) return unified;
    return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojisByCategory(category) {
    var _emojis$category;
    // @ts-ignore
    return (_emojis$category = emojis == null ? void 0 : emojis[category]) != null ? _emojis$category : [];
}
// WARNING: DO NOT USE DIRECTLY
function emojiUrlByUnified(unified, emojiStyle) {
    return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
    var _emoji$EmojiPropertie2;
    return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
    return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
    return skinTone ? emojiVariations(emoji).find(function(variation) {
        return variation.includes(skinTone);
    }) : emojiUnified(emoji);
}
function emojiByUnified(unified) {
    if (!unified) return;
    if (allEmojisByUnified[unified]) return allEmojisByUnified[unified];
    var withoutSkinTone = unifiedWithoutSkinTone(unified);
    return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/ Object.values(emojis).flat();
function setCustomEmojis(customEmojis) {
    emojis[Categories.CUSTOM].length = 0;
    customEmojis.forEach(function(emoji) {
        var emojiData = customToRegularEmoji(emoji);
        emojis[Categories.CUSTOM].push(emojiData);
        if (allEmojisByUnified[emojiData[EmojiProperties.unified]]) return;
        allEmojis.push(emojiData);
        allEmojisByUnified[emojiData[EmojiProperties.unified]] = emojiData;
        indexEmoji(emojiData);
    });
}
function customToRegularEmoji(emoji) {
    var _ref;
    return _ref = {}, _ref[EmojiProperties.name] = emoji.names.map(function(name) {
        return name.toLowerCase();
    }), _ref[EmojiProperties.unified] = emoji.id.toLowerCase(), _ref[EmojiProperties.added_in] = "0", _ref[EmojiProperties.imgUrl] = emoji.imgUrl, _ref;
}
var allEmojisByUnified = {};
setTimeout(function() {
    allEmojis.reduce(function(allEmojis, Emoji) {
        allEmojis[emojiUnified(Emoji)] = Emoji;
        if (emojiHasVariations(Emoji)) emojiVariations(Emoji).forEach(function(variation) {
            allEmojis[variation] = Emoji;
        });
        return allEmojis;
    }, allEmojisByUnified);
});
function activeVariationFromUnified(unified) {
    var _unified$split = unified.split("-"), suspectedSkinTone = _unified$split[1];
    return skinToneVariations.includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var KNOWN_FAILING_EMOJIS = [
    "2640-fe0f",
    "2642-fe0f",
    "2695-fe0f"
];
var DEFAULT_SEARCH_PLACEHOLDER = "Search";
var SEARCH_RESULTS_NO_RESULTS_FOUND = "No results found";
var SEARCH_RESULTS_SUFFIX = " found. Use up and down arrow keys to navigate.";
var SEARCH_RESULTS_ONE_RESULT_FOUND = "1 result" + SEARCH_RESULTS_SUFFIX;
var SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND = "%n results" + SEARCH_RESULTS_SUFFIX;
function mergeConfig(userConfig) {
    var _userConfig$previewCo, _config$customEmojis;
    if (userConfig === void 0) userConfig = {};
    var base = basePickerConfig();
    var previewConfig = Object.assign(base.previewConfig, (_userConfig$previewCo = userConfig.previewConfig) != null ? _userConfig$previewCo : {});
    var config = Object.assign(base, userConfig);
    var categories = mergeCategoriesConfig(userConfig.categories, {
        suggestionMode: config.suggestedEmojisMode
    });
    config.hiddenEmojis.forEach(function(emoji) {
        config.unicodeToHide.add(emoji);
    });
    setCustomEmojis((_config$customEmojis = config.customEmojis) != null ? _config$customEmojis : []);
    var skinTonePickerLocation = config.searchDisabled ? SkinTonePickerLocation.PREVIEW : config.skinTonePickerLocation;
    return _extends({}, config, {
        categories: categories,
        previewConfig: previewConfig,
        skinTonePickerLocation: skinTonePickerLocation
    });
}
function basePickerConfig() {
    return {
        autoFocusSearch: true,
        categories: baseCategoriesConfig(),
        className: "",
        customEmojis: [],
        defaultSkinTone: SkinTones.NEUTRAL,
        emojiStyle: EmojiStyle.APPLE,
        emojiVersion: null,
        getEmojiUrl: emojiUrlByUnified,
        height: 450,
        lazyLoadEmojis: false,
        previewConfig: _extends({}, basePreviewConfig),
        searchDisabled: false,
        searchPlaceHolder: DEFAULT_SEARCH_PLACEHOLDER,
        searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
        skinTonePickerLocation: SkinTonePickerLocation.SEARCH,
        skinTonesDisabled: false,
        style: {},
        suggestedEmojisMode: SuggestionMode.FREQUENT,
        theme: Theme.LIGHT,
        unicodeToHide: new Set(KNOWN_FAILING_EMOJIS),
        width: 350,
        reactionsDefaultOpen: false,
        reactions: DEFAULT_REACTIONS,
        open: true,
        allowExpandReactions: true,
        hiddenEmojis: []
    };
}
var basePreviewConfig = {
    defaultEmoji: "1f60a",
    defaultCaption: "What's your mood?",
    showPreview: true
};
var _excluded = [
    "children"
];
var ConfigContext = /*#__PURE__*/ (0, _react.createContext)(/*#__PURE__*/ basePickerConfig());
function PickerConfigProvider(_ref) {
    var children = _ref.children, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    var mergedConfig = useSetConfig(config);
    return (0, _react.createElement)(ConfigContext.Provider, {
        value: mergedConfig
    }, children);
}
function useSetConfig(config) {
    var _config$customEmojis;
    var _React$useState = (0, _react.useState)(function() {
        return mergeConfig(config);
    }), mergedConfig = _React$useState[0], setMergedConfig = _React$useState[1];
    (0, _react.useEffect)(function() {
        if (compareConfig(mergedConfig, config)) return;
        setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (_config$customEmojis = config.customEmojis) == null ? void 0 : _config$customEmojis.length,
        config.open,
        config.emojiVersion,
        config.reactionsDefaultOpen,
        config.searchPlaceHolder,
        config.searchPlaceholder,
        config.defaultSkinTone,
        config.skinTonesDisabled,
        config.autoFocusSearch,
        config.emojiStyle,
        config.theme,
        config.suggestedEmojisMode,
        config.lazyLoadEmojis,
        config.className,
        config.height,
        config.width,
        config.searchDisabled,
        config.skinTonePickerLocation,
        config.allowExpandReactions
    ]);
    return mergedConfig;
}
function usePickerConfig() {
    return (0, _react.useContext)(ConfigContext);
}
var MutableConfigContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
function useMutableConfig() {
    var mutableConfig = (0, _reactDefault.default).useContext(MutableConfigContext);
    return mutableConfig;
}
function useDefineMutableConfig(config) {
    var MutableConfigRef = (0, _reactDefault.default).useRef({
        onEmojiClick: config.onEmojiClick || emptyFunc,
        onReactionClick: config.onReactionClick || config.onEmojiClick,
        onSkinToneChange: config.onSkinToneChange || emptyFunc
    });
    (0, _reactDefault.default).useEffect(function() {
        MutableConfigRef.current.onEmojiClick = config.onEmojiClick || emptyFunc;
        MutableConfigRef.current.onReactionClick = config.onReactionClick || config.onEmojiClick;
    }, [
        config.onEmojiClick,
        config.onReactionClick
    ]);
    (0, _reactDefault.default).useEffect(function() {
        MutableConfigRef.current.onSkinToneChange = config.onSkinToneChange || emptyFunc;
    }, [
        config.onSkinToneChange
    ]);
    return MutableConfigRef;
}
function emptyFunc() {}
var MOUSE_EVENT_SOURCE;
(function(MOUSE_EVENT_SOURCE) {
    MOUSE_EVENT_SOURCE["REACTIONS"] = "reactions";
    MOUSE_EVENT_SOURCE["PICKER"] = "picker";
})(MOUSE_EVENT_SOURCE || (MOUSE_EVENT_SOURCE = {}));
function useSearchPlaceHolderConfig() {
    var _find;
    var _usePickerConfig = usePickerConfig(), searchPlaceHolder = _usePickerConfig.searchPlaceHolder, searchPlaceholder = _usePickerConfig.searchPlaceholder;
    return (_find = [
        searchPlaceHolder,
        searchPlaceholder
    ].find(function(p) {
        return p !== DEFAULT_SEARCH_PLACEHOLDER;
    })) != null ? _find : DEFAULT_SEARCH_PLACEHOLDER;
}
function useDefaultSkinToneConfig() {
    var _usePickerConfig2 = usePickerConfig(), defaultSkinTone = _usePickerConfig2.defaultSkinTone;
    return defaultSkinTone;
}
function useAllowExpandReactions() {
    var _usePickerConfig3 = usePickerConfig(), allowExpandReactions = _usePickerConfig3.allowExpandReactions;
    return allowExpandReactions;
}
function useSkinTonesDisabledConfig() {
    var _usePickerConfig4 = usePickerConfig(), skinTonesDisabled = _usePickerConfig4.skinTonesDisabled;
    return skinTonesDisabled;
}
function useEmojiStyleConfig() {
    var _usePickerConfig5 = usePickerConfig(), emojiStyle = _usePickerConfig5.emojiStyle;
    return emojiStyle;
}
function useAutoFocusSearchConfig() {
    var _usePickerConfig6 = usePickerConfig(), autoFocusSearch = _usePickerConfig6.autoFocusSearch;
    return autoFocusSearch;
}
function useCategoriesConfig() {
    var _usePickerConfig7 = usePickerConfig(), categories = _usePickerConfig7.categories;
    return categories;
}
function useCustomEmojisConfig() {
    var _usePickerConfig8 = usePickerConfig(), customEmojis = _usePickerConfig8.customEmojis;
    return customEmojis;
}
function useOpenConfig() {
    var _usePickerConfig9 = usePickerConfig(), open = _usePickerConfig9.open;
    return open;
}
function useOnEmojiClickConfig(mouseEventSource) {
    var _ref;
    var _useMutableConfig = useMutableConfig(), current = _useMutableConfig.current;
    var handler = (_ref = mouseEventSource === MOUSE_EVENT_SOURCE.REACTIONS ? current.onReactionClick : current.onEmojiClick) != null ? _ref : current.onEmojiClick;
    return handler || function() {};
}
function useOnSkinToneChangeConfig() {
    var _useMutableConfig2 = useMutableConfig(), current = _useMutableConfig2.current;
    return current.onSkinToneChange || function() {};
}
function usePreviewConfig() {
    var _usePickerConfig10 = usePickerConfig(), previewConfig = _usePickerConfig10.previewConfig;
    return previewConfig;
}
function useThemeConfig() {
    var _usePickerConfig11 = usePickerConfig(), theme = _usePickerConfig11.theme;
    return theme;
}
function useSuggestedEmojisModeConfig() {
    var _usePickerConfig12 = usePickerConfig(), suggestedEmojisMode = _usePickerConfig12.suggestedEmojisMode;
    return suggestedEmojisMode;
}
function useLazyLoadEmojisConfig() {
    var _usePickerConfig13 = usePickerConfig(), lazyLoadEmojis = _usePickerConfig13.lazyLoadEmojis;
    return lazyLoadEmojis;
}
function useClassNameConfig() {
    var _usePickerConfig14 = usePickerConfig(), className = _usePickerConfig14.className;
    return className;
}
function useStyleConfig() {
    var _usePickerConfig15 = usePickerConfig(), height = _usePickerConfig15.height, width = _usePickerConfig15.width, style = _usePickerConfig15.style;
    return _extends({
        height: getDimension(height),
        width: getDimension(width)
    }, style);
}
function useReactionsOpenConfig() {
    var _usePickerConfig16 = usePickerConfig(), reactionsDefaultOpen = _usePickerConfig16.reactionsDefaultOpen;
    return reactionsDefaultOpen;
}
function useEmojiVersionConfig() {
    var _usePickerConfig17 = usePickerConfig(), emojiVersion = _usePickerConfig17.emojiVersion;
    return emojiVersion;
}
function useSearchDisabledConfig() {
    var _usePickerConfig18 = usePickerConfig(), searchDisabled = _usePickerConfig18.searchDisabled;
    return searchDisabled;
}
function useSkinTonePickerLocationConfig() {
    var _usePickerConfig19 = usePickerConfig(), skinTonePickerLocation = _usePickerConfig19.skinTonePickerLocation;
    return skinTonePickerLocation;
}
function useUnicodeToHide() {
    var _usePickerConfig20 = usePickerConfig(), unicodeToHide = _usePickerConfig20.unicodeToHide;
    return unicodeToHide;
}
function useReactionsConfig() {
    var _usePickerConfig21 = usePickerConfig(), reactions = _usePickerConfig21.reactions;
    return reactions;
}
function useGetEmojiUrlConfig() {
    var _usePickerConfig22 = usePickerConfig(), getEmojiUrl = _usePickerConfig22.getEmojiUrl;
    return getEmojiUrl;
}
function getDimension(dimensionConfig) {
    return typeof dimensionConfig === "number" ? dimensionConfig + "px" : dimensionConfig;
}
function useSearchResultsConfig(searchResultsCount) {
    var hasResults = searchResultsCount > 0;
    var isPlural = searchResultsCount > 1;
    if (hasResults) return isPlural ? SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND.replace("%n", searchResultsCount.toString()) : SEARCH_RESULTS_ONE_RESULT_FOUND;
    return SEARCH_RESULTS_NO_RESULTS_FOUND;
}
function useDebouncedState(initialValue, delay) {
    if (delay === void 0) delay = 0;
    var _useState = (0, _react.useState)(initialValue), state = _useState[0], setState = _useState[1];
    var timer = (0, _react.useRef)(null);
    function debouncedSetState(value) {
        return new Promise(function(resolve) {
            var _window;
            if (timer.current) clearTimeout(timer.current);
            timer.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
                setState(value);
                resolve(value);
            }, delay);
        });
    }
    return [
        state,
        debouncedSetState
    ];
}
function useIsUnicodeHidden() {
    var unicodeToHide = useUnicodeToHide();
    return function(emojiUnified) {
        return unicodeToHide.has(emojiUnified);
    };
}
function useDisallowedEmojis() {
    var DisallowedEmojisRef = (0, _react.useRef)({});
    var emojiVersionConfig = useEmojiVersionConfig();
    return (0, _react.useMemo)(function() {
        var emojiVersion = parseFloat("" + emojiVersionConfig);
        if (!emojiVersionConfig || Number.isNaN(emojiVersion)) return DisallowedEmojisRef.current;
        return allEmojis.reduce(function(disallowedEmojis, emoji) {
            if (addedInNewerVersion(emoji, emojiVersion)) disallowedEmojis[emojiUnified(emoji)] = true;
            return disallowedEmojis;
        }, DisallowedEmojisRef.current);
    }, [
        emojiVersionConfig
    ]);
}
function useIsEmojiDisallowed() {
    var disallowedEmojis = useDisallowedEmojis();
    var isUnicodeHidden = useIsUnicodeHidden();
    return function isEmojiDisallowed(emoji) {
        var unified = unifiedWithoutSkinTone(emojiUnified(emoji));
        return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
    };
}
function addedInNewerVersion(emoji, supportedLevel) {
    return addedIn(emoji) > supportedLevel;
}
function useMarkInitialLoad(dispatch) {
    (0, _react.useEffect)(function() {
        dispatch(true);
    }, [
        dispatch
    ]);
}
function PickerContextProvider(_ref) {
    var children = _ref.children;
    var disallowedEmojis = useDisallowedEmojis();
    var defaultSkinTone = useDefaultSkinToneConfig();
    var reactionsDefaultOpen = useReactionsOpenConfig();
    // Initialize the filter with the inititial dictionary
    var filterRef = (0, _react.useRef)(alphaNumericEmojiIndex);
    var disallowClickRef = (0, _react.useRef)(false);
    var disallowMouseRef = (0, _react.useRef)(false);
    var disallowedEmojisRef = (0, _react.useRef)(disallowedEmojis);
    var suggestedUpdateState = useDebouncedState(Date.now(), 200);
    var searchTerm = useDebouncedState("", 100);
    var skinToneFanOpenState = (0, _react.useState)(false);
    var activeSkinTone = (0, _react.useState)(defaultSkinTone);
    var activeCategoryState = (0, _react.useState)(null);
    var emojisThatFailedToLoadState = (0, _react.useState)(new Set());
    var emojiVariationPickerState = (0, _react.useState)(null);
    var reactionsModeState = (0, _react.useState)(reactionsDefaultOpen);
    var _useState = (0, _react.useState)(false), isPastInitialLoad = _useState[0], setIsPastInitialLoad = _useState[1];
    useMarkInitialLoad(setIsPastInitialLoad);
    return (0, _react.createElement)(PickerContext.Provider, {
        value: {
            activeCategoryState: activeCategoryState,
            activeSkinTone: activeSkinTone,
            disallowClickRef: disallowClickRef,
            disallowMouseRef: disallowMouseRef,
            disallowedEmojisRef: disallowedEmojisRef,
            emojiVariationPickerState: emojiVariationPickerState,
            emojisThatFailedToLoadState: emojisThatFailedToLoadState,
            filterRef: filterRef,
            isPastInitialLoad: isPastInitialLoad,
            searchTerm: searchTerm,
            skinToneFanOpenState: skinToneFanOpenState,
            suggestedUpdateState: suggestedUpdateState,
            reactionsModeState: reactionsModeState
        }
    }, children);
}
var PickerContext = /*#__PURE__*/ (0, _react.createContext)({
    activeCategoryState: [
        null,
        function() {}
    ],
    activeSkinTone: [
        SkinTones.NEUTRAL,
        function() {}
    ],
    disallowClickRef: {
        current: false
    },
    disallowMouseRef: {
        current: false
    },
    disallowedEmojisRef: {
        current: {}
    },
    emojiVariationPickerState: [
        null,
        function() {}
    ],
    emojisThatFailedToLoadState: [
        /*#__PURE__*/ new Set(),
        function() {}
    ],
    filterRef: {
        current: {}
    },
    isPastInitialLoad: true,
    searchTerm: [
        "",
        function() {
            return new Promise(function() {
                return undefined;
            });
        }
    ],
    skinToneFanOpenState: [
        false,
        function() {}
    ],
    suggestedUpdateState: [
        /*#__PURE__*/ Date.now(),
        function() {}
    ],
    reactionsModeState: [
        false,
        function() {}
    ]
});
function useFilterRef() {
    var _React$useContext = (0, _react.useContext)(PickerContext), filterRef = _React$useContext.filterRef;
    return filterRef;
}
function useDisallowClickRef() {
    var _React$useContext2 = (0, _react.useContext)(PickerContext), disallowClickRef = _React$useContext2.disallowClickRef;
    return disallowClickRef;
}
function useDisallowMouseRef() {
    var _React$useContext3 = (0, _react.useContext)(PickerContext), disallowMouseRef = _React$useContext3.disallowMouseRef;
    return disallowMouseRef;
}
function useReactionsModeState() {
    var _React$useContext4 = (0, _react.useContext)(PickerContext), reactionsModeState = _React$useContext4.reactionsModeState;
    return reactionsModeState;
}
function useSearchTermState() {
    var _React$useContext5 = (0, _react.useContext)(PickerContext), searchTerm = _React$useContext5.searchTerm;
    return searchTerm;
}
function useActiveSkinToneState() {
    var _React$useContext6 = (0, _react.useContext)(PickerContext), activeSkinTone = _React$useContext6.activeSkinTone;
    return activeSkinTone;
}
function useEmojisThatFailedToLoadState() {
    var _React$useContext7 = (0, _react.useContext)(PickerContext), emojisThatFailedToLoadState = _React$useContext7.emojisThatFailedToLoadState;
    return emojisThatFailedToLoadState;
}
function useIsPastInitialLoad() {
    var _React$useContext8 = (0, _react.useContext)(PickerContext), isPastInitialLoad = _React$useContext8.isPastInitialLoad;
    return isPastInitialLoad;
}
function useEmojiVariationPickerState() {
    var _React$useContext9 = (0, _react.useContext)(PickerContext), emojiVariationPickerState = _React$useContext9.emojiVariationPickerState;
    return emojiVariationPickerState;
}
function useSkinToneFanOpenState() {
    var _React$useContext10 = (0, _react.useContext)(PickerContext), skinToneFanOpenState = _React$useContext10.skinToneFanOpenState;
    return skinToneFanOpenState;
}
function useUpdateSuggested() {
    var _React$useContext12 = (0, _react.useContext)(PickerContext), suggestedUpdateState = _React$useContext12.suggestedUpdateState;
    var suggestedUpdated = suggestedUpdateState[0], setsuggestedUpdate = suggestedUpdateState[1];
    return [
        suggestedUpdated,
        function updateSuggested() {
            setsuggestedUpdate(Date.now());
        }
    ];
}
function useIsSearchMode() {
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    return !!searchTerm;
}
function focusElement(element) {
    if (!element) return;
    requestAnimationFrame(function() {
        element.focus();
    });
}
function focusPrevElementSibling(element) {
    if (!element) return;
    var prev = element.previousElementSibling;
    focusElement(prev);
}
function focusNextElementSibling(element) {
    if (!element) return;
    var next = element.nextElementSibling;
    focusElement(next);
}
function focusFirstElementChild(element) {
    if (!element) return;
    var first = element.firstElementChild;
    focusElement(first);
}
function getActiveElement() {
    return document.activeElement;
}
function ElementRefContextProvider(_ref) {
    var children = _ref.children;
    var PickerMainRef = (0, _react.useRef)(null);
    var AnchoredEmojiRef = (0, _react.useRef)(null);
    var BodyRef = (0, _react.useRef)(null);
    var SearchInputRef = (0, _react.useRef)(null);
    var SkinTonePickerRef = (0, _react.useRef)(null);
    var CategoryNavigationRef = (0, _react.useRef)(null);
    var VariationPickerRef = (0, _react.useRef)(null);
    var ReactionsRef = (0, _react.useRef)(null);
    return (0, _react.createElement)(ElementRefContext.Provider, {
        value: {
            AnchoredEmojiRef: AnchoredEmojiRef,
            BodyRef: BodyRef,
            CategoryNavigationRef: CategoryNavigationRef,
            PickerMainRef: PickerMainRef,
            SearchInputRef: SearchInputRef,
            SkinTonePickerRef: SkinTonePickerRef,
            VariationPickerRef: VariationPickerRef,
            ReactionsRef: ReactionsRef
        }
    }, children);
}
var ElementRefContext = /*#__PURE__*/ (0, _react.createContext)({
    AnchoredEmojiRef: /*#__PURE__*/ (0, _react.createRef)(),
    BodyRef: /*#__PURE__*/ (0, _react.createRef)(),
    CategoryNavigationRef: /*#__PURE__*/ (0, _react.createRef)(),
    PickerMainRef: /*#__PURE__*/ (0, _react.createRef)(),
    SearchInputRef: /*#__PURE__*/ (0, _react.createRef)(),
    SkinTonePickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    VariationPickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    ReactionsRef: /*#__PURE__*/ (0, _react.createRef)()
});
function useElementRef() {
    return (0, _react.useContext)(ElementRefContext);
}
function usePickerMainRef() {
    return useElementRef()["PickerMainRef"];
}
function useAnchoredEmojiRef() {
    return useElementRef()["AnchoredEmojiRef"];
}
function useSetAnchoredEmojiRef() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function(target) {
        if (target === null && AnchoredEmojiRef.current !== null) focusElement(AnchoredEmojiRef.current);
        AnchoredEmojiRef.current = target;
    };
}
function useBodyRef() {
    return useElementRef()["BodyRef"];
}
function useReactionsRef() {
    return useElementRef()["ReactionsRef"];
}
function useSearchInputRef() {
    return useElementRef()["SearchInputRef"];
}
function useSkinTonePickerRef() {
    return useElementRef()["SkinTonePickerRef"];
}
function useCategoryNavigationRef() {
    return useElementRef()["CategoryNavigationRef"];
}
function useVariationPickerRef() {
    return useElementRef()["VariationPickerRef"];
}
function scrollTo(root, top) {
    if (top === void 0) top = 0;
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = top;
    });
}
function scrollBy(root, by) {
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = $eprBody.scrollTop + by;
    });
}
function useScrollTo() {
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function(top) {
        requestAnimationFrame(function() {
            if (BodyRef.current) BodyRef.current.scrollTop = top;
        });
    }, [
        BodyRef
    ]);
}
function scrollEmojiAboveLabel(emoji) {
    if (!emoji || !isEmojiBehindLabel(emoji)) return;
    if (emoji.closest(asSelectors(ClassNames.variationPicker))) return;
    var scrollBody = closestScrollBody(emoji);
    var by = emojiDistanceFromScrollTop(emoji);
    scrollBy(scrollBody, -(categoryLabelHeight(closestCategory(emoji)) - by));
}
function focusFirstVisibleEmoji(parent) {
    var emoji = firstVisibleEmoji(parent);
    focusElement(emoji);
    scrollEmojiAboveLabel(emoji);
}
function focusAndClickFirstVisibleEmoji(parent) {
    var firstEmoji = firstVisibleEmoji(parent);
    focusElement(firstEmoji);
    firstEmoji == null || firstEmoji.click();
}
function focusLastVisibleEmoji(parent) {
    focusElement(lastVisibleEmoji(parent));
}
function focusNextVisibleEmoji(element) {
    if (!element) return;
    var next = nextVisibleEmoji(element);
    if (!next) return focusFirstVisibleEmoji(nextCategory(element));
    focusElement(next);
    scrollEmojiAboveLabel(next);
}
function focusPrevVisibleEmoji(element) {
    if (!element) return;
    var prev = prevVisibleEmoji(element);
    if (!prev) return focusLastVisibleEmoji(prevCategory(element));
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowUp(element, exitUp) {
    if (!element) return;
    var prev = visibleEmojiOneRowUp(element);
    if (!prev) return exitUp();
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowDown(element) {
    if (!element) return;
    var next = visibleEmojiOneRowDown(element);
    return focusElement(next);
}
function visibleEmojiOneRowUp(element) {
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var indexInRow = elementIndexInRow(categoryContent, element);
    var row = rowNumber(categoryContent, element);
    var countInRow = elementCountInRow(categoryContent, element);
    if (row === 0) {
        var prevVisibleCategory = prevCategory(category);
        if (!prevVisibleCategory) return null;
        return getElementInRow(allVisibleEmojis(prevVisibleCategory), -1, // last row
        countInRow, indexInRow);
    }
    return getElementInPrevRow(allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
}
function visibleEmojiOneRowDown(element) {
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var indexInRow = elementIndexInRow(categoryContent, element);
    var row = rowNumber(categoryContent, element);
    var countInRow = elementCountInRow(categoryContent, element);
    if (!hasNextRow(categoryContent, element)) {
        var nextVisibleCategory = nextCategory(category);
        if (!nextVisibleCategory) return null;
        return getElementInRow(allVisibleEmojis(nextVisibleCategory), 0, countInRow, indexInRow);
    }
    var itemInNextRow = getElementInNextRow(allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
    return itemInNextRow;
}
function useCloseAllOpenToggles() {
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic[0], setVariationPicker = _useEmojiVariationPic[1];
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt[0], setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
    var closeAllOpenToggles = (0, _react.useCallback)(function() {
        if (variationPicker) setVariationPicker(null);
        if (skinToneFanOpen) setSkinToneFanOpen(false);
    }, [
        variationPicker,
        skinToneFanOpen,
        setVariationPicker,
        setSkinToneFanOpen
    ]);
    return closeAllOpenToggles;
}
function useHasOpenToggles() {
    var _useEmojiVariationPic2 = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic2[0];
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt2[0];
    return function hasOpenToggles() {
        return !!variationPicker || skinToneFanOpen;
    };
}
function useDisallowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function disallowMouseMove() {
        DisallowMouseRef.current = true;
    };
}
function useAllowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function allowMouseMove() {
        DisallowMouseRef.current = false;
    };
}
function useIsMouseDisallowed() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function isMouseDisallowed() {
        return DisallowMouseRef.current;
    };
}
function useOnMouseMove() {
    var BodyRef = useBodyRef();
    var allowMouseMove = useAllowMouseMove();
    var isMouseDisallowed = useIsMouseDisallowed();
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("mousemove", onMouseMove, {
            passive: true
        });
        function onMouseMove() {
            if (isMouseDisallowed()) allowMouseMove();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mousemove", onMouseMove);
        };
    }, [
        BodyRef,
        allowMouseMove,
        isMouseDisallowed
    ]);
}
function useFocusSearchInput() {
    var SearchInputRef = useSearchInputRef();
    return (0, _react.useCallback)(function() {
        focusElement(SearchInputRef.current);
    }, [
        SearchInputRef
    ]);
}
function useFocusSkinTonePicker() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    return (0, _react.useCallback)(function() {
        if (!SkinTonePickerRef.current) return;
        focusFirstElementChild(SkinTonePickerRef.current);
    }, [
        SkinTonePickerRef
    ]);
}
function useFocusCategoryNavigation() {
    var CategoryNavigationRef = useCategoryNavigationRef();
    return (0, _react.useCallback)(function() {
        if (!CategoryNavigationRef.current) return;
        focusFirstElementChild(CategoryNavigationRef.current);
    }, [
        CategoryNavigationRef
    ]);
}
function useSetFilterRef() {
    var filterRef = useFilterRef();
    return function setFilter(setter) {
        if (typeof setter === "function") return setFilter(setter(filterRef.current));
        filterRef.current = setter;
    };
}
function useClearSearch() {
    var applySearch = useApplySearch();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    return function clearSearch() {
        if (SearchInputRef.current) SearchInputRef.current.value = "";
        applySearch("");
        focusSearchInput();
    };
}
function useAppendSearch() {
    var SearchInputRef = useSearchInputRef();
    var applySearch = useApplySearch();
    return function appendSearch(str) {
        if (SearchInputRef.current) {
            SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
            applySearch(getNormalizedSearchTerm(SearchInputRef.current.value));
        } else applySearch(getNormalizedSearchTerm(str));
    };
}
function useFilter() {
    var SearchInputRef = useSearchInputRef();
    var filterRef = useFilterRef();
    var setFilterRef = useSetFilterRef();
    var applySearch = useApplySearch();
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    var statusSearchResults = getStatusSearchResults(filterRef.current, searchTerm);
    return {
        onChange: onChange,
        searchTerm: searchTerm,
        SearchInputRef: SearchInputRef,
        statusSearchResults: statusSearchResults
    };
    function onChange(inputValue) {
        var filter = filterRef.current;
        var nextValue = inputValue.toLowerCase();
        if (filter != null && filter[nextValue] || nextValue.length <= 1) return applySearch(nextValue);
        var longestMatch = findLongestMatch(nextValue, filter);
        if (!longestMatch) // Can we even get here?
        // If so, we need to search among all emojis
        return applySearch(nextValue);
        setFilterRef(function(current) {
            var _Object$assign;
            return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
        });
        applySearch(nextValue);
    }
}
function useApplySearch() {
    var _useSearchTermState2 = useSearchTermState(), setSearchTerm = _useSearchTermState2[1];
    var PickerMainRef = usePickerMainRef();
    return function applySearch(searchTerm) {
        requestAnimationFrame(function() {
            setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function() {
                scrollTo(PickerMainRef.current, 0);
            });
        });
    };
}
function filterEmojiObjectByKeyword(emojis, keyword) {
    var filtered = {};
    for(var unified in emojis){
        var emoji = emojis[unified];
        if (hasMatch(emoji, keyword)) filtered[unified] = emoji;
    }
    return filtered;
}
function hasMatch(emoji, keyword) {
    return emojiNames(emoji).some(function(name) {
        return name.includes(keyword);
    });
}
function useIsEmojiFiltered() {
    var _useFilterRef = useFilterRef(), filter = _useFilterRef.current;
    var _useSearchTermState3 = useSearchTermState(), searchTerm = _useSearchTermState3[0];
    return function(unified) {
        return isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
    };
}
function isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
    var _filter$searchTerm;
    if (!filter || !searchTerm) return false;
    return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function findLongestMatch(keyword, dict) {
    if (!dict) return null;
    if (dict[keyword]) return dict[keyword];
    var longestMatchingKey = Object.keys(dict).sort(function(a, b) {
        return b.length - a.length;
    }).find(function(key) {
        return keyword.includes(key);
    });
    if (longestMatchingKey) return dict[longestMatchingKey];
    return null;
}
function getNormalizedSearchTerm(str) {
    if (!str || typeof str !== "string") return "";
    return str.trim().toLowerCase();
}
function getStatusSearchResults(filterState, searchTerm) {
    var _Object$entries;
    if (!(filterState != null && filterState[searchTerm])) return "";
    var searchResultsCount = ((_Object$entries = Object.entries(filterState == null ? void 0 : filterState[searchTerm])) == null ? void 0 : _Object$entries.length) || 0;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSearchResultsConfig(searchResultsCount);
}
function useSetVariationPicker() {
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    return function setVariationPicker(element) {
        var _emojiFromElement = emojiFromElement(element), emoji = _emojiFromElement[0];
        if (emoji) {
            setAnchoredEmojiRef(element);
            setEmojiVariationPicker(emoji);
        }
    };
}
function useIsSkinToneInSearch() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.SEARCH;
}
function useIsSkinToneInPreview() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.PREVIEW;
}
var KeyboardEvents;
(function(KeyboardEvents) {
    KeyboardEvents["ArrowDown"] = "ArrowDown";
    KeyboardEvents["ArrowUp"] = "ArrowUp";
    KeyboardEvents["ArrowLeft"] = "ArrowLeft";
    KeyboardEvents["ArrowRight"] = "ArrowRight";
    KeyboardEvents["Escape"] = "Escape";
    KeyboardEvents["Enter"] = "Enter";
    KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
function useKeyboardNavigation() {
    usePickerMainKeyboardEvents();
    useSearchInputKeyboardEvents();
    useSkinTonePickerKeyboardEvents();
    useCategoryNavigationKeyboardEvents();
    useBodyKeyboardEvents();
}
function usePickerMainKeyboardEvents() {
    var PickerMainRef = usePickerMainRef();
    var clearSearch = useClearSearch();
    var scrollTo = useScrollTo();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    var hasOpenToggles = useHasOpenToggles();
    var disallowMouseMove = useDisallowMouseMove();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            disallowMouseMove();
            switch(key){
                // eslint-disable-next-line no-fallthrough
                case KeyboardEvents.Escape:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        return;
                    }
                    clearSearch();
                    scrollTo(0);
                    focusSearchInput();
                    break;
            }
        };
    }, [
        scrollTo,
        clearSearch,
        closeAllOpenToggles,
        focusSearchInput,
        hasOpenToggles,
        disallowMouseMove
    ]);
    (0, _react.useEffect)(function() {
        var current = PickerMainRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        scrollTo,
        onKeyDown
    ]);
}
function useSearchInputKeyboardEvents() {
    var focusSkinTonePicker = useFocusSkinTonePicker();
    var PickerMainRef = usePickerMainRef();
    var BodyRef = useBodyRef();
    var SearchInputRef = useSearchInputRef();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowRight:
                    if (!isSkinToneInSearch) return;
                    event.preventDefault();
                    setSkinToneFanOpenState(true);
                    focusSkinTonePicker();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    goDownFromSearchInput();
                    break;
                case KeyboardEvents.Enter:
                    event.preventDefault();
                    focusAndClickFirstVisibleEmoji(BodyRef.current);
                    break;
            }
        };
    }, [
        focusSkinTonePicker,
        goDownFromSearchInput,
        setSkinToneFanOpenState,
        BodyRef,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SearchInputRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        onKeyDown
    ]);
}
function useSkinTonePickerKeyboardEvents() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    var focusSearchInput = useFocusSearchInput();
    var SearchInputRef = useSearchInputRef();
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt2[0], setIsOpen = _useSkinToneFanOpenSt2[1];
    var isSkinToneInPreview = useIsSkinToneInPreview();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            if (isSkinToneInSearch) switch(key){
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (isOpen) setIsOpen(false);
                    goDownFromSearchInput();
                    break;
                default:
                    onType(event);
                    break;
            }
            if (isSkinToneInPreview) switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        isOpen,
        focusSearchInput,
        setIsOpen,
        goDownFromSearchInput,
        onType,
        isSkinToneInPreview,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SkinTonePickerRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        SkinTonePickerRef,
        SearchInputRef,
        isOpen,
        onKeyDown
    ]);
}
function useCategoryNavigationKeyboardEvents() {
    var focusSearchInput = useFocusSearchInput();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var BodyRef = useBodyRef();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    focusSearchInput();
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    focusFirstVisibleEmoji(BodyRef.current);
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        BodyRef,
        focusSearchInput,
        onType
    ]);
    (0, _react.useEffect)(function() {
        var current = CategoryNavigationRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        CategoryNavigationRef,
        BodyRef,
        onKeyDown
    ]);
}
function useBodyKeyboardEvents() {
    var BodyRef = useBodyRef();
    var goUpFromBody = useGoUpFromBody();
    var setVariationPicker = useSetVariationPicker();
    var hasOpenToggles = useHasOpenToggles();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            var activeElement = buttonFromTarget(getActiveElement());
            switch(key){
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowDown(activeElement);
                    break;
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
                    break;
                case KeyboardEvents.Space:
                    event.preventDefault();
                    setVariationPicker(event.target);
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        goUpFromBody,
        onType,
        setVariationPicker,
        hasOpenToggles,
        closeAllOpenToggles
    ]);
    (0, _react.useEffect)(function() {
        var current = BodyRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        BodyRef,
        onKeyDown
    ]);
}
function useGoDownFromSearchInput() {
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function goDownFromSearchInput() {
        if (isSearchMode) return focusFirstVisibleEmoji(BodyRef.current);
        return focusCategoryNavigation();
    }, [
        BodyRef,
        focusCategoryNavigation,
        isSearchMode
    ]);
}
function useGoUpFromBody() {
    var focusSearchInput = useFocusSearchInput();
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    return (0, _react.useCallback)(function goUpFromEmoji() {
        if (isSearchMode) return focusSearchInput();
        return focusCategoryNavigation();
    }, [
        focusSearchInput,
        isSearchMode,
        focusCategoryNavigation
    ]);
}
function focusNextSkinTone(exitLeft) {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    if (!hasNextElementSibling(currentSkinTone)) exitLeft();
    focusNextElementSibling(currentSkinTone);
}
function focusPrevSkinTone() {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    focusPrevElementSibling(currentSkinTone);
}
function useOnType() {
    var appendSearch = useAppendSearch();
    var focusSearchInput = useFocusSearchInput();
    var searchDisabled = useSearchDisabledConfig();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    return function onType(event) {
        var key = event.key;
        if (hasModifier(event) || searchDisabled) return;
        if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
            event.preventDefault();
            closeAllOpenToggles();
            focusSearchInput();
            appendSearch(key);
        }
    };
}
function hasModifier(event) {
    var metaKey = event.metaKey, ctrlKey = event.ctrlKey, altKey = event.altKey;
    return metaKey || ctrlKey || altKey;
}
function preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
    if (!emoji) return;
    if (emojiStyle === EmojiStyle.NATIVE) return;
    var unified = emojiUnified(emoji);
    if (preloadedEmojs.has(unified)) return;
    emojiVariations(emoji).forEach(function(variation) {
        var emojiUrl = getEmojiUrl(variation, emojiStyle);
        preloadImage(emojiUrl);
    });
    preloadedEmojs.add(unified);
}
var preloadedEmojs = /*#__PURE__*/ new Set();
function preloadImage(url) {
    var image = new Image();
    image.src = url;
}
function useOnFocus() {
    var BodyRef = useBodyRef();
    var emojiStyle = useEmojiStyleConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    (0, _react.useEffect)(function() {
        if (emojiStyle === EmojiStyle.NATIVE) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("focusin", onFocus);
        return function() {
            bodyRef == null || bodyRef.removeEventListener("focusin", onFocus);
        };
        function onFocus(event) {
            var button = buttonFromTarget(event.target);
            if (!button) return;
            var _emojiFromElement = emojiFromElement(button), emoji = _emojiFromElement[0];
            if (!emoji) return;
            if (emojiHasVariations(emoji)) preloadEmoji(getEmojiUrl, emoji, emojiStyle);
        }
    }, [
        BodyRef,
        emojiStyle,
        getEmojiUrl
    ]);
}
var _excluded$1 = [
    "width",
    "height"
];
var DEFAULT_LABEL_HEIGHT = 40;
function PickerMain(_ref) {
    var children = _ref.children;
    return (0, _react.createElement)(PickerContextProvider, null, (0, _react.createElement)(PickerRootElement, null, children));
}
function PickerRootElement(_ref2) {
    var _cx;
    var children = _ref2.children;
    var _useReactionsModeStat = useReactionsModeState(), reactionsMode = _useReactionsModeStat[0];
    var theme = useThemeConfig();
    var searchModeActive = useIsSearchMode();
    var PickerMainRef = usePickerMainRef();
    var className = useClassNameConfig();
    var style = useStyleConfig();
    useKeyboardNavigation();
    useOnFocus();
    var _ref3 = style || {}, width = _ref3.width, height = _ref3.height, styleProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1);
    return (0, _react.createElement)("aside", {
        className: (0, _flairup.cx)(styles.main, styles.baseVariables, theme === Theme.DARK && styles.darkTheme, theme === Theme.AUTO && styles.autoThemeDark, (_cx = {}, _cx[ClassNames.searchActive] = searchModeActive, _cx), reactionsMode && styles.reactionsMenu, className),
        ref: PickerMainRef,
        style: _extends({}, styleProps, !reactionsMode && {
            height: height,
            width: width
        })
    }, children);
}
var DarkTheme = {
    "--epr-emoji-variation-picker-bg-color": "var(--epr-dark-emoji-variation-picker-bg-color)",
    "--epr-hover-bg-color-reduced-opacity": "var(--epr-dark-hover-bg-color-reduced-opacity)",
    "--epr-highlight-color": "var(--epr-dark-highlight-color)",
    "--epr-text-color": "var(--epr-dark-text-color)",
    "--epr-hover-bg-color": "var(--epr-dark-hover-bg-color)",
    "--epr-focus-bg-color": "var(--epr-dark-focus-bg-color)",
    "--epr-search-input-bg-color": "var(--epr-dark-search-input-bg-color)",
    "--epr-category-label-bg-color": "var(--epr-dark-category-label-bg-color)",
    "--epr-picker-border-color": "var(--epr-dark-picker-border-color)",
    "--epr-bg-color": "var(--epr-dark-bg-color)",
    "--epr-reactions-bg-color": "var(--epr-dark-reactions-bg-color)",
    "--epr-search-input-bg-color-active": "var(--epr-dark-search-input-bg-color-active)",
    "--epr-emoji-variation-indicator-color": "var(--epr-dark-emoji-variation-indicator-color)",
    "--epr-category-icon-active-color": "var(--epr-dark-category-icon-active-color)",
    "--epr-skin-tone-picker-menu-color": "var(--epr-dark-skin-tone-picker-menu-color)"
};
var styles = /*#__PURE__*/ stylesheet.create({
    main: {
        ".": [
            "epr-main",
            ClassNames.emojiPicker
        ],
        position: "relative",
        display: "flex",
        flexDirection: "column",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "var(--epr-picker-border-radius)",
        borderColor: "var(--epr-picker-border-color)",
        backgroundColor: "var(--epr-bg-color)",
        overflow: "hidden",
        transition: "all 0.3s ease-in-out, background-color 0.1s ease-in-out",
        "*": {
            boxSizing: "border-box",
            fontFamily: "sans-serif"
        }
    },
    baseVariables: {
        "--": {
            "--epr-highlight-color": "#007aeb",
            "--epr-hover-bg-color": "#f1f8ff",
            "--epr-hover-bg-color-reduced-opacity": "#f1f8ff80",
            "--epr-focus-bg-color": "#e0f0ff",
            "--epr-text-color": "#858585",
            "--epr-search-input-bg-color": "#f6f6f6",
            "--epr-picker-border-color": "#e7e7e7",
            "--epr-bg-color": "#fff",
            "--epr-reactions-bg-color": "#ffffff90",
            "--epr-category-icon-active-color": "#6aa8de",
            "--epr-skin-tone-picker-menu-color": "#ffffff95",
            "--epr-horizontal-padding": "10px",
            "--epr-picker-border-radius": "8px",
            /* Header */ "--epr-search-border-color": "var(--epr-highlight-color)",
            "--epr-header-padding": "15px var(--epr-horizontal-padding)",
            /* Skin Tone Picker */ "--epr-active-skin-tone-indicator-border-color": "var(--epr-highlight-color)",
            "--epr-active-skin-hover-color": "var(--epr-hover-bg-color)",
            /* Search */ "--epr-search-input-bg-color-active": "var(--epr-search-input-bg-color)",
            "--epr-search-input-padding": "0 30px",
            "--epr-search-input-border-radius": "8px",
            "--epr-search-input-height": "40px",
            "--epr-search-input-text-color": "var(--epr-text-color)",
            "--epr-search-input-placeholder-color": "var(--epr-text-color)",
            "--epr-search-bar-inner-padding": "var(--epr-horizontal-padding)",
            /*  Category Navigation */ "--epr-category-navigation-button-size": "30px",
            /* Variation Picker */ "--epr-emoji-variation-picker-height": "45px",
            "--epr-emoji-variation-picker-bg-color": "var(--epr-bg-color)",
            /*  Preview */ "--epr-preview-height": "70px",
            "--epr-preview-text-size": "14px",
            "--epr-preview-text-padding": "0 var(--epr-horizontal-padding)",
            "--epr-preview-border-color": "var(--epr-picker-border-color)",
            "--epr-preview-text-color": "var(--epr-text-color)",
            /* Category */ "--epr-category-padding": "0 var(--epr-horizontal-padding)",
            /*  Category Label */ "--epr-category-label-bg-color": "#ffffffe6",
            "--epr-category-label-text-color": "var(--epr-text-color)",
            "--epr-category-label-padding": "0 var(--epr-horizontal-padding)",
            "--epr-category-label-height": DEFAULT_LABEL_HEIGHT + "px",
            /*  Emoji */ "--epr-emoji-size": "30px",
            "--epr-emoji-padding": "5px",
            "--epr-emoji-fullsize": "calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)",
            "--epr-emoji-hover-color": "var(--epr-hover-bg-color)",
            "--epr-emoji-variation-indicator-color": "var(--epr-picker-border-color)",
            "--epr-emoji-variation-indicator-color-hover": "var(--epr-text-color)",
            /* Z-Index */ "--epr-header-overlay-z-index": "3",
            "--epr-emoji-variations-indictator-z-index": "1",
            "--epr-category-label-z-index": "2",
            "--epr-skin-variation-picker-z-index": "5",
            "--epr-preview-z-index": "6",
            /* Dark Theme Variables */ "--epr-dark": "#000",
            "--epr-dark-emoji-variation-picker-bg-color": "var(--epr-dark)",
            "--epr-dark-highlight-color": "#c0c0c0",
            "--epr-dark-text-color": "var(--epr-highlight-color)",
            "--epr-dark-hover-bg-color": "#363636f6",
            "--epr-dark-hover-bg-color-reduced-opacity": "#36363680",
            "--epr-dark-focus-bg-color": "#474747",
            "--epr-dark-search-input-bg-color": "#333333",
            "--epr-dark-category-label-bg-color": "#222222e6",
            "--epr-dark-picker-border-color": "#151617",
            "--epr-dark-bg-color": "#222222",
            "--epr-dark-reactions-bg-color": "#22222290",
            "--epr-dark-search-input-bg-color-active": "var(--epr-dark)",
            "--epr-dark-emoji-variation-indicator-color": "#444",
            "--epr-dark-category-icon-active-color": "#3271b7",
            "--epr-dark-skin-tone-picker-menu-color": "#22222295"
        }
    },
    autoThemeDark: {
        ".": ClassNames.autoTheme,
        "@media (prefers-color-scheme: dark)": {
            "--": DarkTheme
        }
    },
    darkTheme: {
        ".": ClassNames.darkTheme,
        "--": DarkTheme
    },
    reactionsMenu: {
        ".": "epr-reactions",
        height: "50px",
        display: "inline-flex",
        backgroundColor: "var(--epr-reactions-bg-color)",
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: "blur(8px)",
        "--": {
            "--epr-picker-border-radius": "50px"
        }
    }
});
function elementCountInRow(parent, element) {
    if (!parent || !element) return 0;
    var parentWidth = parent.getBoundingClientRect().width;
    var elementWidth = element.getBoundingClientRect().width;
    return Math.floor(parentWidth / elementWidth);
}
function elementIndexInRow(parent, element) {
    if (!parent || !element) return 0;
    var elementWidth = element.getBoundingClientRect().width;
    var elementLeft = element.getBoundingClientRect().left;
    var parentLeft = parent.getBoundingClientRect().left;
    return Math.floor((elementLeft - parentLeft) / elementWidth);
}
function rowNumber(parent, element) {
    if (!parent || !element) return 0;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    return Math.round((elementTop - parentTop) / elementHeight);
}
function hasNextRow(parent, element) {
    if (!parent || !element) return false;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    var parentHeight = parent.getBoundingClientRect().height;
    return Math.round(elementTop - parentTop + elementHeight) < parentHeight;
}
function getRowElements(elements, row, elementsInRow) {
    if (row === -1) {
        var lastRow = Math.floor((elements.length - 1) / elementsInRow);
        var firstElementIndex = lastRow * elementsInRow;
        var lastElementIndex = elements.length - 1;
        return elements.slice(firstElementIndex, lastElementIndex + 1);
    }
    return elements.slice(row * elementsInRow, (row + 1) * elementsInRow);
}
function getNextRowElements(allElements, currentRow, elementsInRow) {
    var nextRow = currentRow + 1;
    if (nextRow * elementsInRow > allElements.length) return [];
    return getRowElements(allElements, nextRow, elementsInRow);
}
function getElementInRow(elements, row, elementsInRow, indexInRow) {
    var rowElements = getRowElements(elements, row, elementsInRow);
    // get element, default to last
    return rowElements[indexInRow] || rowElements[rowElements.length - 1] || null;
}
function getElementInNextRow(allElements, currentRow, elementsInRow, index) {
    var nextRowElements = getNextRowElements(allElements, currentRow, elementsInRow);
    // return item in index, or last item in row
    return nextRowElements[index] || nextRowElements[nextRowElements.length - 1] || null;
}
function getElementInPrevRow(allElements, currentRow, elementsInRow, index) {
    var prevRowElements = getRowElements(allElements, currentRow - 1, elementsInRow);
    // default to last
    return prevRowElements[index] || prevRowElements[prevRowElements.length - 1] || null;
}
function firstVisibleElementInContainer(parent, elements, maxVisibilityDiffThreshold) {
    if (maxVisibilityDiffThreshold === void 0) maxVisibilityDiffThreshold = 0;
    if (!parent || !elements.length) return null;
    var parentTop = parent.getBoundingClientRect().top;
    var parentBottom = parent.getBoundingClientRect().bottom;
    var parentTopWithLabel = parentTop + getLabelHeight(parent);
    var visibleElements = elements.find(function(element) {
        var elementTop = element.getBoundingClientRect().top;
        var elementBottom = element.getBoundingClientRect().bottom;
        var maxVisibilityDiffPixels = element.clientHeight * maxVisibilityDiffThreshold;
        var elementTopWithAllowedDiff = elementTop + maxVisibilityDiffPixels;
        var elementBottomWithAllowedDiff = elementBottom - maxVisibilityDiffPixels;
        if (elementTopWithAllowedDiff < parentTopWithLabel) return false;
        return elementTopWithAllowedDiff >= parentTop && elementTopWithAllowedDiff <= parentBottom || elementBottomWithAllowedDiff >= parentTop && elementBottomWithAllowedDiff <= parentBottom;
    });
    return visibleElements || null;
}
function hasNextElementSibling(element) {
    return !!element.nextElementSibling;
}
function getLabelHeight(parentNode) {
    var labels = Array.from(parentNode.querySelectorAll(asSelectors(ClassNames.label)));
    for(var _i = 0, _labels = labels; _i < _labels.length; _i++){
        var label = _labels[_i];
        var height = label.getBoundingClientRect().height;
        // return height if label is not hidden
        if (height > 0) return height;
    }
    return DEFAULT_LABEL_HEIGHT;
}
var EmojiButtonSelector = "button" + /*#__PURE__*/ asSelectors(ClassNames.emoji);
var VisibleEmojiSelector = /*#__PURE__*/ [
    EmojiButtonSelector,
    asSelectors(ClassNames.visible),
    ":not(" + asSelectors(ClassNames.hidden) + ")"
].join("");
function buttonFromTarget(emojiElement) {
    var _emojiElement$closest;
    return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest(EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function emojiFromElement(element) {
    var originalUnified = originalUnifiedFromEmojiElement(element);
    var unified = unifiedFromEmojiElement(element);
    if (!originalUnified) return [];
    var emoji = emojiByUnified(unified != null ? unified : originalUnified);
    if (!emoji) return [];
    return [
        emoji,
        unified
    ];
}
function isEmojiElement(element) {
    var _element$parentElemen;
    return Boolean((element == null ? void 0 : element.matches(EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches(EmojiButtonSelector)));
}
function elementHeight(element) {
    var _element$clientHeight;
    return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function emojiTrueOffsetTop(element) {
    if (!element) return 0;
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    // compensate for the label height
    var labelHeight = categoryLabelHeight(category);
    return elementOffsetTop(button) + elementOffsetTop(category) + labelHeight;
}
function categoryLabelHeight(category) {
    var _category$clientHeigh, _categoryWithoutLabel;
    if (!category) return 0;
    var categoryWithoutLabel = category.querySelector(asSelectors(ClassNames.categoryContent));
    return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function isEmojiBehindLabel(emoji) {
    if (!emoji) return false;
    return emojiDistanceFromScrollTop(emoji) < categoryLabelHeight(closestCategory(emoji));
}
function queryScrollBody(root) {
    if (!root) return null;
    return root.matches(asSelectors(ClassNames.scrollBody)) ? root : root.querySelector(asSelectors(ClassNames.scrollBody));
}
function emojiDistanceFromScrollTop(emoji) {
    var _closestScrollBody$sc, _closestScrollBody;
    if (!emoji) return 0;
    return emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function closestScrollBody(element) {
    var _element$closest;
    if (!element) return null;
    return (_element$closest = element.closest(asSelectors(ClassNames.scrollBody))) != null ? _element$closest : null;
}
function emojiTruOffsetLeft(element) {
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    return elementOffsetLeft(button) + elementOffsetLeft(category);
}
function elementOffsetTop(element) {
    var _element$offsetTop;
    return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function elementOffsetLeft(element) {
    var _element$offsetLeft;
    return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function unifiedFromEmojiElement(emoji) {
    var _elementDataSetKey;
    return (_elementDataSetKey = elementDataSetKey(buttonFromTarget(emoji), "unified")) != null ? _elementDataSetKey : null;
}
function originalUnifiedFromEmojiElement(emoji) {
    var unified = unifiedFromEmojiElement(emoji);
    if (unified) return unifiedWithoutSkinTone(unified);
    return null;
}
function allUnifiedFromEmojiElement(emoji) {
    if (!emoji) return {
        unified: null,
        originalUnified: null
    };
    return {
        unified: unifiedFromEmojiElement(emoji),
        originalUnified: originalUnifiedFromEmojiElement(emoji)
    };
}
function elementDataSetKey(element, key) {
    var _elementDataSet$key;
    return (_elementDataSet$key = elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function elementDataSet(element) {
    var _element$dataset;
    return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function isVisibleEmoji(element) {
    return element.classList.contains(ClassNames.visible);
}
function isHidden(element) {
    if (!element) return true;
    return element.classList.contains(ClassNames.hidden);
}
function allVisibleEmojis(parent) {
    if (!parent) return [];
    return Array.from(parent.querySelectorAll(VisibleEmojiSelector));
}
function lastVisibleEmoji(element) {
    if (!element) return null;
    var allEmojis = allVisibleEmojis(element);
    var _allEmojis$slice = allEmojis.slice(-1), last = _allEmojis$slice[0];
    if (!last) return null;
    if (!isVisibleEmoji(last)) return prevVisibleEmoji(last);
    return last;
}
function nextVisibleEmoji(element) {
    var next = element.nextElementSibling;
    if (!next) return firstVisibleEmoji(nextCategory(element));
    if (!isVisibleEmoji(next)) return nextVisibleEmoji(next);
    return next;
}
function prevVisibleEmoji(element) {
    var prev = element.previousElementSibling;
    if (!prev) return lastVisibleEmoji(prevCategory(element));
    if (!isVisibleEmoji(prev)) return prevVisibleEmoji(prev);
    return prev;
}
function firstVisibleEmoji(parent) {
    if (!parent) return null;
    var allEmojis = allVisibleEmojis(parent);
    return firstVisibleElementInContainer(parent, allEmojis, 0.1);
}
function prevCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var prev = category.previousElementSibling;
    if (!prev) return null;
    if (isHidden(prev)) return prevCategory(prev);
    return prev;
}
function nextCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var next = category.nextElementSibling;
    if (!next) return null;
    if (isHidden(next)) return nextCategory(next);
    return next;
}
function closestCategory(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.category));
}
function closestCategoryContent(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.categoryContent));
}
function parseNativeEmoji(unified) {
    return unified.split("-").map(function(hex) {
        return String.fromCodePoint(parseInt(hex, 16));
    }).join("");
}
var SUGGESTED_LS_KEY = "epr_suggested";
function getSuggested(mode) {
    try {
        var _window, _window$localStorage$, _window2;
        if (!((_window = window) != null && _window.localStorage)) return [];
        var recent = JSON.parse((_window$localStorage$ = (_window2 = window) == null ? void 0 : _window2.localStorage.getItem(SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : "[]");
        if (mode === SuggestionMode.FREQUENT) return recent.sort(function(a, b) {
            return b.count - a.count;
        });
        return recent;
    } catch (_unused) {
        return [];
    }
}
function setSuggested(emoji, skinTone) {
    var recent = getSuggested();
    var unified = emojiUnified(emoji, skinTone);
    var originalUnified = emojiUnified(emoji);
    var existing = recent.find(function(_ref) {
        var u = _ref.unified;
        return u === unified;
    });
    var nextList;
    if (existing) nextList = [
        existing
    ].concat(recent.filter(function(i) {
        return i !== existing;
    }));
    else {
        existing = {
            unified: unified,
            original: originalUnified,
            count: 0
        };
        nextList = [
            existing
        ].concat(recent);
    }
    existing.count++;
    nextList.length = Math.min(nextList.length, 14);
    try {
        var _window3;
        (_window3 = window) == null || _window3.localStorage.setItem(SUGGESTED_LS_KEY, JSON.stringify(nextList));
    // Prevents the change from being seen immediately.
    } catch (_unused2) {
    // ignore
    }
}
function isCustomCategory(category) {
    return category.category === Categories.CUSTOM;
}
function isCustomEmoji(emoji) {
    return emoji.imgUrl !== undefined;
}
function useMouseDownHandlers(ContainerRef, mouseEventSource) {
    var mouseDownTimerRef = (0, _react.useRef)();
    var setVariationPicker = useSetVariationPicker();
    var disallowClickRef = useDisallowClickRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var onEmojiClick = useOnEmojiClickConfig(mouseEventSource);
    var _useUpdateSuggested = useUpdateSuggested(), updateSuggested = _useUpdateSuggested[1];
    var getEmojiUrl = useGetEmojiUrlConfig();
    var activeEmojiStyle = useEmojiStyleConfig();
    var onClick = (0, _react.useCallback)(function onClick(event) {
        if (disallowClickRef.current) return;
        closeAllOpenToggles();
        var _emojiFromEvent = emojiFromEvent(event), emoji = _emojiFromEvent[0], unified = _emojiFromEvent[1];
        if (!emoji || !unified) return;
        var skinToneToUse = activeVariationFromUnified(unified) || activeSkinTone;
        updateSuggested();
        setSuggested(emoji, skinToneToUse);
        onEmojiClick(emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
    }, [
        activeSkinTone,
        closeAllOpenToggles,
        disallowClickRef,
        onEmojiClick,
        updateSuggested,
        getEmojiUrl,
        activeEmojiStyle
    ]);
    var onMouseDown = (0, _react.useCallback)(function onMouseDown(event) {
        var _window;
        if (mouseDownTimerRef.current) clearTimeout(mouseDownTimerRef.current);
        var _emojiFromEvent2 = emojiFromEvent(event), emoji = _emojiFromEvent2[0];
        if (!emoji || !emojiHasVariations(emoji)) return;
        mouseDownTimerRef.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
            disallowClickRef.current = true;
            mouseDownTimerRef.current = undefined;
            closeAllOpenToggles();
            setVariationPicker(event.target);
            setEmojiVariationPicker(emoji);
        }, 500);
    }, [
        disallowClickRef,
        closeAllOpenToggles,
        setVariationPicker,
        setEmojiVariationPicker
    ]);
    var onMouseUp = (0, _react.useCallback)(function onMouseUp() {
        if (mouseDownTimerRef.current) {
            clearTimeout(mouseDownTimerRef.current);
            mouseDownTimerRef.current = undefined;
        } else if (disallowClickRef.current) // The problem we're trying to overcome here
        // is that the emoji has both mouseup and click events
        // and when releasing a mouseup event
        // the click gets triggered too
        // So we're disallowing the click event for a short time
        requestAnimationFrame(function() {
            disallowClickRef.current = false;
        });
    }, [
        disallowClickRef
    ]);
    (0, _react.useEffect)(function() {
        if (!ContainerRef.current) return;
        var confainerRef = ContainerRef.current;
        confainerRef.addEventListener("click", onClick, {
            passive: true
        });
        confainerRef.addEventListener("mousedown", onMouseDown, {
            passive: true
        });
        confainerRef.addEventListener("mouseup", onMouseUp, {
            passive: true
        });
        return function() {
            confainerRef == null || confainerRef.removeEventListener("click", onClick);
            confainerRef == null || confainerRef.removeEventListener("mousedown", onMouseDown);
            confainerRef == null || confainerRef.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        ContainerRef,
        onClick,
        onMouseDown,
        onMouseUp
    ]);
}
function emojiFromEvent(event) {
    var target = event == null ? void 0 : event.target;
    if (!isEmojiElement(target)) return [];
    return emojiFromElement(target);
}
function emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
    var names = emojiNames(emoji);
    if (isCustomEmoji(emoji)) {
        var _unified = emojiUnified(emoji);
        return {
            activeSkinTone: activeSkinTone,
            emoji: _unified,
            getImageUrl: function getImageUrl() {
                return emoji.imgUrl;
            },
            imageUrl: emoji.imgUrl,
            isCustom: true,
            names: names,
            unified: _unified,
            unifiedWithoutSkinTone: _unified
        };
    }
    var unified = emojiUnified(emoji, activeSkinTone);
    return {
        activeSkinTone: activeSkinTone,
        emoji: parseNativeEmoji(unified),
        getImageUrl: function getImageUrl(emojiStyle) {
            if (emojiStyle === void 0) emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE;
            return getEmojiUrl(unified, emojiStyle);
        },
        imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE),
        isCustom: false,
        names: names,
        unified: unified,
        unifiedWithoutSkinTone: emojiUnified(emoji)
    };
}
function Button(props) {
    return (0, _react.createElement)("button", Object.assign({
        type: "button"
    }, props, {
        className: (0, _flairup.cx)(styles$1.button, props.className)
    }), props.children);
}
var styles$1 = /*#__PURE__*/ stylesheet.create({
    button: {
        ".": "epr-btn",
        cursor: "pointer",
        border: "0",
        background: "none",
        outline: "none"
    }
});
function ClickableEmojiButton(_ref) {
    var _cx;
    var emojiNames = _ref.emojiNames, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, hasVariations = _ref.hasVariations, children = _ref.children, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground;
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$2.emoji, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch, (_cx = {}, _cx[ClassNames.visible] = !hidden && !hiddenOnSearch, _cx), !!(hasVariations && showVariations) && styles$2.hasVariations, noBackground && styles$2.noBackground, className),
        "data-unified": unified,
        "aria-label": getAriaLabel(emojiNames),
        "data-full-name": emojiNames
    }, children);
}
function getAriaLabel(emojiNames) {
    var _emojiNames$;
    return emojiNames[0].match("flag-") ? (_emojiNames$ = emojiNames[1]) != null ? _emojiNames$ : emojiNames[0] : emojiNames[0];
}
var styles$2 = /*#__PURE__*/ stylesheet.create({
    emoji: {
        ".": ClassNames.emoji,
        position: "relative",
        width: "var(--epr-emoji-fullsize)",
        height: "var(--epr-emoji-fullsize)",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "var(--epr-emoji-fullsize)",
        maxHeight: "var(--epr-emoji-fullsize)",
        borderRadius: "8px",
        overflow: "hidden",
        transition: "background-color 0.2s",
        ":hover": {
            backgroundColor: "var(--epr-emoji-hover-color)"
        },
        ":focus": {
            backgroundColor: "var(--epr-focus-bg-color)"
        }
    },
    noBackground: {
        background: "none",
        ":hover": {
            backgroundColor: "transparent",
            background: "none"
        },
        ":focus": {
            backgroundColor: "transparent",
            background: "none"
        }
    },
    hasVariations: {
        ".": ClassNames.emojiHasVariations,
        ":after": {
            content: "",
            display: "block",
            width: "0",
            height: "0",
            right: "0px",
            bottom: "1px",
            position: "absolute",
            borderLeft: "4px solid transparent",
            borderRight: "4px solid transparent",
            transform: "rotate(135deg)",
            borderBottom: "4px solid var(--epr-emoji-variation-indicator-color)",
            zIndex: "var(--epr-emoji-variations-indictator-z-index)"
        },
        ":hover:after": {
            borderBottom: "4px solid var(--epr-emoji-variation-indicator-color-hover)"
        }
    }
});
var emojiStyles = /*#__PURE__*/ stylesheet.create({
    external: {
        ".": ClassNames.external,
        fontSize: "0"
    },
    common: {
        alignSelf: "center",
        justifySelf: "center",
        display: "block"
    }
});
function EmojiImg(_ref) {
    var emojiName = _ref.emojiName, style = _ref.style, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, imgUrl = _ref.imgUrl, onError = _ref.onError, className = _ref.className;
    return (0, _react.createElement)("img", {
        src: imgUrl,
        alt: emojiName,
        className: (0, _flairup.cx)(styles$3.emojiImag, emojiStyles.external, emojiStyles.common, className),
        loading: lazyLoad ? "lazy" : "eager",
        onError: onError,
        style: style
    });
}
var styles$3 = /*#__PURE__*/ stylesheet.create({
    emojiImag: {
        ".": "epr-emoji-img",
        maxWidth: "var(--epr-emoji-fullsize)",
        maxHeight: "var(--epr-emoji-fullsize)",
        minWidth: "var(--epr-emoji-fullsize)",
        minHeight: "var(--epr-emoji-fullsize)",
        padding: "var(--epr-emoji-padding)"
    }
});
function NativeEmoji(_ref) {
    var unified = _ref.unified, style = _ref.style, className = _ref.className;
    return (0, _react.createElement)("span", {
        className: (0, _flairup.cx)(styles$4.nativeEmoji, emojiStyles.common, emojiStyles.external, className),
        "data-unified": unified,
        style: style
    }, parseNativeEmoji(unified));
}
var styles$4 = /*#__PURE__*/ stylesheet.create({
    nativeEmoji: {
        ".": "epr-emoji-native",
        fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
        position: "relative",
        lineHeight: "100%",
        fontSize: "var(--epr-emoji-size)",
        textAlign: "center",
        alignSelf: "center",
        justifySelf: "center",
        letterSpacing: "0",
        padding: "var(--epr-emoji-padding)"
    }
});
function ViewOnlyEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, emojiStyle = _ref.emojiStyle, size = _ref.size, lazyLoad = _ref.lazyLoad, _ref$getEmojiUrl = _ref.getEmojiUrl, getEmojiUrl = _ref$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref$getEmojiUrl, className = _ref.className;
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
    var style = {};
    if (size) style.width = style.height = style.fontSize = size + "px";
    var emojiToRender = emoji ? emoji : emojiByUnified(unified);
    if (!emojiToRender) return null;
    if (isCustomEmoji(emojiToRender)) return (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: unified,
        emojiStyle: EmojiStyle.NATIVE,
        lazyLoad: lazyLoad,
        imgUrl: emojiToRender.imgUrl,
        onError: onError,
        className: className
    });
    return (0, _react.createElement)((0, _react.Fragment), null, emojiStyle === EmojiStyle.NATIVE ? (0, _react.createElement)(NativeEmoji, {
        unified: unified,
        style: style,
        className: className
    }) : (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: emojiName(emojiToRender),
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        imgUrl: getEmojiUrl(unified, emojiStyle),
        onError: onError,
        className: className
    }));
    function onError() {
        setEmojisThatFailedToLoad(function(prev) {
            return new Set(prev).add(unified);
        });
    }
}
function ClickableEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, emojiStyle = _ref.emojiStyle, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, size = _ref.size, lazyLoad = _ref.lazyLoad, getEmojiUrl = _ref.getEmojiUrl, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground;
    var hasVariations = emojiHasVariations(emoji);
    return (0, _react.createElement)(ClickableEmojiButton, {
        hasVariations: hasVariations,
        showVariations: showVariations,
        hidden: hidden,
        hiddenOnSearch: hiddenOnSearch,
        emojiNames: emojiNames(emoji),
        unified: unified,
        noBackground: noBackground
    }, (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        emoji: emoji,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: getEmojiUrl,
        className: className
    }));
}
var Plus = "data:image/svg+xml;base64,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";
function BtnPlus() {
    var _useReactionsModeStat = useReactionsModeState(), setReactionsMode = _useReactionsModeStat[1];
    return (0, _react.createElement)(Button, {
        "aria-label": "Show all Emojis",
        title: "Show all Emojis",
        tabIndex: 0,
        className: (0, _flairup.cx)(styles$5.plusSign),
        onClick: function onClick() {
            return setReactionsMode(false);
        }
    });
}
var styles$5 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    plusSign: {
        fontSize: "20px",
        padding: "17px",
        color: "var(--epr-text-color)",
        borderRadius: "50%",
        textAlign: "center",
        lineHeight: "100%",
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "background-color 0.2s ease-in-out",
        ":after": {
            content: "",
            minWidth: "20px",
            minHeight: "20px",
            backgroundImage: "url(" + Plus + ")",
            backgroundColor: "transparent",
            backgroundRepeat: "no-repeat",
            backgroundSize: "20px",
            backgroundPositionY: "0"
        },
        ":hover": {
            color: "var(--epr-highlight-color)",
            backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
            ":after": {
                backgroundPositionY: "-20px"
            }
        },
        ":focus": {
            color: "var(--epr-highlight-color)",
            backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
            ":after": {
                backgroundPositionY: "-40px"
            }
        }
    }
}, /*#__PURE__*/ darkMode("plusSign", {
    ":after": {
        backgroundPositionY: "-40px"
    },
    ":hover:after": {
        backgroundPositionY: "-60px"
    }
})));
function Reactions() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsOpen = _useReactionsModeStat[0];
    var ReactionsRef = useReactionsRef();
    var reactions = useReactionsConfig();
    useMouseDownHandlers(ReactionsRef, MOUSE_EVENT_SOURCE.REACTIONS);
    var emojiStyle = useEmojiStyleConfig();
    var allowExpandReactions = useAllowExpandReactions();
    var getEmojiUrl = useGetEmojiUrlConfig();
    if (!reactionsOpen) return null;
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$6.list, !reactionsOpen && commonStyles.hidden),
        ref: ReactionsRef
    }, reactions.map(function(reaction) {
        return (0, _react.createElement)("li", {
            key: reaction
        }, (0, _react.createElement)(ClickableEmoji, {
            emoji: emojiByUnified(reaction),
            emojiStyle: emojiStyle,
            unified: reaction,
            showVariations: false,
            className: (0, _flairup.cx)(styles$6.emojiButton),
            noBackground: true,
            getEmojiUrl: getEmojiUrl
        }));
    }), allowExpandReactions ? (0, _react.createElement)("li", null, (0, _react.createElement)(BtnPlus, null)) : null);
}
var styles$6 = /*#__PURE__*/ stylesheet.create({
    list: {
        listStyle: "none",
        margin: "0",
        padding: "0 5px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100%"
    },
    emojiButton: {
        ":hover": {
            transform: "scale(1.2)"
        },
        ":focus": {
            transform: "scale(1.2)"
        },
        ":active": {
            transform: "scale(1.1)"
        },
        transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)"
    }
});
function useOnScroll(BodyRef) {
    var closeAllOpenToggles = useCloseAllOpenToggles();
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        if (!bodyRef) return;
        bodyRef.addEventListener("scroll", onScroll, {
            passive: true
        });
        function onScroll() {
            closeAllOpenToggles();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("scroll", onScroll);
        };
    }, [
        BodyRef,
        closeAllOpenToggles
    ]);
}
function useIsEmojiHidden() {
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), emojisThatFailedToLoad = _useEmojisThatFailedT[0];
    var isEmojiFiltered = useIsEmojiFiltered();
    return function(emoji) {
        var unified = emojiUnified(emoji);
        var failedToLoad = emojisThatFailedToLoad.has(unified);
        var filteredOut = isEmojiFiltered(unified);
        return {
            failedToLoad: failedToLoad,
            filteredOut: filteredOut,
            hidden: failedToLoad || filteredOut
        };
    };
}
function EmojiCategory(_ref) {
    var categoryConfig = _ref.categoryConfig, children = _ref.children, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch;
    var category = categoryFromCategoryConfig(categoryConfig);
    var categoryName = categoryNameFromCategoryConfig(categoryConfig);
    return (0, _react.createElement)("li", {
        className: (0, _flairup.cx)(styles$7.category, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch),
        "data-name": category,
        "aria-label": categoryName
    }, (0, _react.createElement)("h2", {
        className: (0, _flairup.cx)(styles$7.label)
    }, categoryName), (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$7.categoryContent)
    }, children));
}
var styles$7 = /*#__PURE__*/ stylesheet.create({
    category: {
        ".": ClassNames.category,
        ":not(:has(.epr-visible))": {
            display: "none"
        }
    },
    categoryContent: {
        ".": ClassNames.categoryContent,
        display: "grid",
        gridGap: "0",
        gridTemplateColumns: "repeat(auto-fill, var(--epr-emoji-fullsize))",
        justifyContent: "space-between",
        margin: "var(--epr-category-padding)",
        position: "relative"
    },
    label: {
        ".": ClassNames.label,
        alignItems: "center",
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: "blur(3px)",
        backgroundColor: "var(--epr-category-label-bg-color)",
        color: "var(--epr-category-label-text-color)",
        display: "flex",
        fontSize: "16px",
        fontWeight: "bold",
        height: "var(--epr-category-label-height)",
        margin: "0",
        padding: "var(--epr-category-label-padding)",
        position: "sticky",
        textTransform: "capitalize",
        top: "0",
        width: "100%",
        zIndex: "var(--epr-category-label-z-index)"
    }
});
var isEverMounted = false;
function useIsEverMounted() {
    var _React$useState = (0, _react.useState)(isEverMounted), isMounted = _React$useState[0], setIsMounted = _React$useState[1];
    (0, _react.useEffect)(function() {
        setIsMounted(true);
        isEverMounted = true;
    }, []);
    return isMounted || isEverMounted;
}
function Suggested(_ref) {
    var categoryConfig = _ref.categoryConfig;
    var _useUpdateSuggested = useUpdateSuggested(), suggestedUpdated = _useUpdateSuggested[0];
    var isMounted = useIsEverMounted();
    var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var suggested = (0, _react.useMemo)(function() {
        var _getSuggested;
        return (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        suggestedUpdated,
        suggestedEmojisModeConfig
    ]);
    var emojiStyle = useEmojiStyleConfig();
    if (!isMounted) return null;
    return (0, _react.createElement)(EmojiCategory, {
        categoryConfig: categoryConfig,
        hiddenOnSearch: true,
        hidden: suggested.length === 0
    }, suggested.map(function(suggestedItem) {
        var emoji = emojiByUnified(suggestedItem.original);
        if (!emoji) return null;
        return (0, _react.createElement)(ClickableEmoji, {
            showVariations: false,
            unified: suggestedItem.unified,
            emojiStyle: emojiStyle,
            emoji: emoji,
            key: suggestedItem.unified,
            getEmojiUrl: getEmojiUrl
        });
    }));
}
function EmojiList() {
    var categories = useCategoriesConfig();
    var renderdCategoriesCountRef = (0, _react.useRef)(0);
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$8.emojiList)
    }, categories.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        if (category === Categories.SUGGESTED) return (0, _react.createElement)(Suggested, {
            key: category,
            categoryConfig: categoryConfig
        });
        return (0, _react.createElement)((0, _react.Suspense), {
            key: category
        }, (0, _react.createElement)(RenderCategory, {
            category: category,
            categoryConfig: categoryConfig,
            renderdCategoriesCountRef: renderdCategoriesCountRef
        }));
    }));
}
function RenderCategory(_ref) {
    var category = _ref.category, categoryConfig = _ref.categoryConfig, renderdCategoriesCountRef = _ref.renderdCategoriesCountRef;
    var isEmojiHidden = useIsEmojiHidden();
    var lazyLoadEmojis = useLazyLoadEmojisConfig();
    var emojiStyle = useEmojiStyleConfig();
    var isPastInitialLoad = useIsPastInitialLoad();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var isEmojiDisallowed = useIsEmojiDisallowed();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var showVariations = !useSkinTonesDisabledConfig();
    // Small trick to defer the rendering of all emoji categories until the first category is visible
    // This way the user gets to actually see something and not wait for the whole picker to render.
    var emojisToPush = !isPastInitialLoad && renderdCategoriesCountRef.current > 0 ? [] : emojisByCategory(category);
    if (emojisToPush.length > 0) renderdCategoriesCountRef.current++;
    var hiddenCounter = 0;
    var emojis = emojisToPush.map(function(emoji) {
        var unified = emojiUnified(emoji, activeSkinTone);
        var _isEmojiHidden = isEmojiHidden(emoji), failedToLoad = _isEmojiHidden.failedToLoad, filteredOut = _isEmojiHidden.filteredOut, hidden = _isEmojiHidden.hidden;
        var isDisallowed = isEmojiDisallowed(emoji);
        if (hidden || isDisallowed) hiddenCounter++;
        if (isDisallowed) return null;
        return (0, _react.createElement)(ClickableEmoji, {
            showVariations: showVariations,
            key: unified,
            emoji: emoji,
            unified: unified,
            hidden: failedToLoad,
            hiddenOnSearch: filteredOut,
            emojiStyle: emojiStyle,
            lazyLoad: lazyLoadEmojis,
            getEmojiUrl: getEmojiUrl
        });
    });
    return (0, _react.createElement)(EmojiCategory, {
        categoryConfig: categoryConfig,
        // Indicates that there are no visible emojis
        // Hence, the category should be hidden
        hidden: hiddenCounter === emojis.length
    }, emojis);
}
var styles$8 = /*#__PURE__*/ stylesheet.create({
    emojiList: {
        ".": ClassNames.emojiList,
        listStyle: "none",
        margin: "0",
        padding: "0"
    }
});
var SVGTriangle = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=";
var Direction;
(function(Direction) {
    Direction[Direction["Up"] = 0] = "Up";
    Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
// eslint-disable-next-line complexity
function EmojiVariationPicker() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var VariationPickerRef = useVariationPickerRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), emoji = _useEmojiVariationPic[0];
    var emojiStyle = useEmojiStyleConfig();
    var _useVariationPickerTo = useVariationPickerTop(VariationPickerRef), getTop = _useVariationPickerTo.getTop, getMenuDirection = _useVariationPickerTo.getMenuDirection;
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var getPointerStyle = usePointerStyle(VariationPickerRef);
    var getEmojiUrl = useGetEmojiUrlConfig();
    var button = buttonFromTarget(AnchoredEmojiRef.current);
    var visible = Boolean(emoji && button && emojiHasVariations(emoji) && button.classList.contains(ClassNames.emojiHasVariations));
    (0, _react.useEffect)(function() {
        if (!visible) return;
        focusFirstVisibleEmoji(VariationPickerRef.current);
    }, [
        VariationPickerRef,
        visible,
        AnchoredEmojiRef
    ]);
    var top, pointerStyle;
    if (!visible && AnchoredEmojiRef.current) setAnchoredEmojiRef(null);
    else {
        top = getTop();
        pointerStyle = getPointerStyle();
    }
    return (0, _react.createElement)("div", {
        ref: VariationPickerRef,
        className: (0, _flairup.cx)(styles$9.variationPicker, getMenuDirection() === Direction.Down && styles$9.pointingUp, visible && styles$9.visible),
        style: {
            top: top
        }
    }, visible && emoji ? [
        emojiUnified(emoji)
    ].concat(emojiVariations(emoji)).slice(0, 6).map(function(unified) {
        return (0, _react.createElement)(ClickableEmoji, {
            key: unified,
            emoji: emoji,
            unified: unified,
            emojiStyle: emojiStyle,
            showVariations: false,
            getEmojiUrl: getEmojiUrl
        });
    }) : null, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$9.pointer),
        style: pointerStyle
    }));
}
function usePointerStyle(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function getPointerStyle() {
        var style = {};
        if (!VariationPickerRef.current) return style;
        if (AnchoredEmojiRef.current) {
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var offsetLeft = emojiTruOffsetLeft(button);
            if (!button) return style;
            // half of the button
            style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
        }
        return style;
    };
}
function useVariationPickerTop(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var BodyRef = useBodyRef();
    var direction = Direction.Up;
    return {
        getMenuDirection: getMenuDirection,
        getTop: getTop
    };
    function getMenuDirection() {
        return direction;
    }
    function getTop() {
        direction = Direction.Up;
        var emojiOffsetTop = 0;
        if (!VariationPickerRef.current) return 0;
        var height = elementHeight(VariationPickerRef.current);
        if (AnchoredEmojiRef.current) {
            var _bodyRef$scrollTop;
            var bodyRef = BodyRef.current;
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var buttonHeight = elementHeight(button);
            emojiOffsetTop = emojiTrueOffsetTop(button);
            var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
            if (scrollTop > emojiOffsetTop - height) {
                direction = Direction.Down;
                emojiOffsetTop += buttonHeight + height;
            }
        }
        return emojiOffsetTop - height;
    }
}
var styles$9 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    variationPicker: {
        ".": ClassNames.variationPicker,
        position: "absolute",
        right: "15px",
        left: "15px",
        padding: "5px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
        borderRadius: "3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        opacity: "0",
        visibility: "hidden",
        pointerEvents: "none",
        top: "-100%",
        border: "1px solid var(--epr-picker-border-color)",
        height: "var(--epr-emoji-variation-picker-height)",
        zIndex: "var(--epr-skin-variation-picker-z-index)",
        background: "var(--epr-emoji-variation-picker-bg-color)",
        transform: "scale(0.9)",
        transition: "transform 0.1s ease-out, opacity 0.2s ease-out"
    },
    visible: {
        opacity: "1",
        visibility: "visible",
        pointerEvents: "all",
        transform: "scale(1)"
    },
    pointingUp: {
        ".": "pointing-up",
        transformOrigin: "center 0%",
        transform: "scale(0.9)"
    },
    ".pointing-up": {
        pointer: {
            top: "0",
            transform: "rotate(180deg) translateY(100%) translateX(18px)"
        }
    },
    pointer: {
        ".": "epr-emoji-pointer",
        content: "",
        position: "absolute",
        width: "25px",
        height: "15px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0",
        backgroundSize: "50px 15px",
        top: "100%",
        transform: "translateX(-18px)",
        backgroundImage: "url(" + SVGTriangle + ")"
    }
}, /*#__PURE__*/ darkMode("pointer", {
    backgroundPosition: "-25px 0"
})));
function Body() {
    var BodyRef = useBodyRef();
    useOnScroll(BodyRef);
    useMouseDownHandlers(BodyRef, MOUSE_EVENT_SOURCE.PICKER);
    useOnMouseMove();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$a.body, commonInteractionStyles.hiddenOnReactions),
        ref: BodyRef
    }, (0, _react.createElement)(EmojiVariationPicker, null), (0, _react.createElement)(EmojiList, null));
}
var styles$a = /*#__PURE__*/ stylesheet.create({
    body: {
        ".": ClassNames.scrollBody,
        flex: "1",
        overflowY: "scroll",
        overflowX: "hidden",
        position: "relative"
    }
});
function detectEmojyPartiallyBelowFold(button, bodyRef) {
    if (!button || !bodyRef) return 0;
    var buttonRect = button.getBoundingClientRect();
    var bodyRect = bodyRef.getBoundingClientRect();
    // If the element is obscured by at least half of its size
    return bodyRect.height - (buttonRect.y - bodyRect.y);
}
function useEmojiPreviewEvents(allow, setPreviewEmoji) {
    var BodyRef = useBodyRef();
    var isMouseDisallowed = useIsMouseDisallowed();
    var allowMouseMove = useAllowMouseMove();
    (0, _react.useEffect)(function() {
        if (!allow) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("keydown", onEscape, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("mouseover", onMouseOver, true);
        bodyRef == null || bodyRef.addEventListener("focus", onEnter, true);
        bodyRef == null || bodyRef.addEventListener("mouseout", onLeave, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("blur", onLeave, true);
        function onEnter(e) {
            var button = buttonFromTarget(e.target);
            if (!button) return onLeave();
            var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(button), unified = _allUnifiedFromEmojiE.unified, originalUnified = _allUnifiedFromEmojiE.originalUnified;
            if (!unified || !originalUnified) return onLeave();
            setPreviewEmoji({
                unified: unified,
                originalUnified: originalUnified
            });
        }
        function onLeave(e) {
            if (e) {
                var relatedTarget = e.relatedTarget;
                if (!buttonFromTarget(relatedTarget)) return setPreviewEmoji(null);
            }
            setPreviewEmoji(null);
        }
        function onEscape(e) {
            if (e.key === "Escape") setPreviewEmoji(null);
        }
        function onMouseOver(e) {
            if (isMouseDisallowed()) return;
            var button = buttonFromTarget(e.target);
            if (button) {
                var belowFoldByPx = detectEmojyPartiallyBelowFold(button, bodyRef);
                var buttonHeight = button.getBoundingClientRect().height;
                if (belowFoldByPx < buttonHeight) return handlePartiallyVisibleElementFocus(button, setPreviewEmoji);
                focusElement(button);
            }
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mouseover", onMouseOver);
            bodyRef == null || bodyRef.removeEventListener("mouseout", onLeave);
            bodyRef == null || bodyRef.removeEventListener("focus", onEnter, true);
            bodyRef == null || bodyRef.removeEventListener("blur", onLeave, true);
            bodyRef == null || bodyRef.removeEventListener("keydown", onEscape);
        };
    }, [
        BodyRef,
        allow,
        setPreviewEmoji,
        isMouseDisallowed,
        allowMouseMove
    ]);
}
function handlePartiallyVisibleElementFocus(button, setPreviewEmoji) {
    var _document$activeEleme;
    var _allUnifiedFromEmojiE2 = allUnifiedFromEmojiElement(button), unified = _allUnifiedFromEmojiE2.unified, originalUnified = _allUnifiedFromEmojiE2.originalUnified;
    if (!unified || !originalUnified) return;
    (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur == null || _document$activeEleme.blur();
    setPreviewEmoji({
        unified: unified,
        originalUnified: originalUnified
    });
}
var _stylesheet$create;
var FlexDirection;
(function(FlexDirection) {
    FlexDirection["ROW"] = "FlexRow";
    FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
function Flex(_ref) {
    var children = _ref.children, className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? FlexDirection.ROW : _ref$direction;
    return (0, _react.createElement)("div", {
        style: _extends({}, style),
        className: (0, _flairup.cx)(styles$b.flex, className, styles$b[direction])
    }, children);
}
var styles$b = /*#__PURE__*/ stylesheet.create((_stylesheet$create = {
    flex: {
        display: "flex"
    }
}, _stylesheet$create[FlexDirection.ROW] = {
    flexDirection: "row"
}, _stylesheet$create[FlexDirection.COLUMN] = {
    flexDirection: "column"
}, _stylesheet$create));
function Space(_ref) {
    var className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    return (0, _react.createElement)("div", {
        style: _extends({
            flex: 1
        }, style),
        className: (0, _flairup.cx)(className)
    });
}
function Absolute(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: "absolute"
        }),
        className: className
    }, children);
}
function Relative(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: "relative"
        }),
        className: className
    }, children);
}
// eslint-disable-next-line complexity
function BtnSkinToneVariation(_ref) {
    var isOpen = _ref.isOpen, onClick = _ref.onClick, isActive = _ref.isActive, skinToneVariation = _ref.skinToneVariation, style = _ref.style;
    return (0, _react.createElement)(Button, {
        style: style,
        onClick: onClick,
        className: (0, _flairup.cx)("epr-tone-" + skinToneVariation, styles$c.tone, !isOpen && styles$c.closedTone, isActive && styles$c.active),
        tabIndex: isOpen ? 0 : -1,
        "aria-pressed": isActive,
        "aria-label": "Skin tone " + skinTonesNamed[skinToneVariation]
    });
}
var styles$c = /*#__PURE__*/ stylesheet.create({
    closedTone: {
        opacity: "0",
        zIndex: "0"
    },
    active: {
        ".": "epr-active",
        zIndex: "1",
        opacity: "1"
    },
    tone: {
        ".": "epr-tone",
        ":hover": {
            boxShadow: "0 0 0 3px var(--epr-active-skin-hover-color)"
        },
        ":focus": {
            boxShadow: "0 0 0 3px var(--epr-focus-bg-color)"
        },
        "&.epr-tone-neutral": {
            backgroundColor: "#ffd225"
        },
        "&.epr-tone-1f3fb": {
            backgroundColor: "#ffdfbd"
        },
        "&.epr-tone-1f3fc": {
            backgroundColor: "#e9c197"
        },
        "&.epr-tone-1f3fd": {
            backgroundColor: "#c88e62"
        },
        "&.epr-tone-1f3fe": {
            backgroundColor: "#a86637"
        },
        "&.epr-tone-1f3ff": {
            backgroundColor: "#60463a"
        }
    }
});
/* eslint-disable complexity */ var ITEM_SIZE = 28;
function SkinTonePickerMenu() {
    return (0, _react.createElement)(Relative, {
        style: {
            height: ITEM_SIZE
        }
    }, (0, _react.createElement)(Absolute, {
        style: {
            bottom: 0,
            right: 0
        }
    }, (0, _react.createElement)(SkinTonePicker, {
        direction: SkinTonePickerDirection.VERTICAL
    })));
}
function SkinTonePicker(_ref) {
    var _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? SkinTonePickerDirection.HORIZONTAL : _ref$direction;
    var SkinTonePickerRef = useSkinTonePickerRef();
    var isDisabled = useSkinTonesDisabledConfig();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt[0], setIsOpen = _useSkinToneFanOpenSt[1];
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0], setActiveSkinTone = _useActiveSkinToneSta[1];
    var onSkinToneChange = useOnSkinToneChangeConfig();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var focusSearchInput = useFocusSearchInput();
    if (isDisabled) return null;
    var fullWidth = ITEM_SIZE * skinToneVariations.length + "px";
    var expandedSize = isOpen ? fullWidth : ITEM_SIZE + "px";
    var vertical = direction === SkinTonePickerDirection.VERTICAL;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$d.skinTones, vertical && styles$d.vertical, isOpen && styles$d.open, vertical && isOpen && styles$d.verticalShadow),
        style: vertical ? {
            flexBasis: expandedSize,
            height: expandedSize
        } : {
            flexBasis: expandedSize
        }
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$d.select),
        ref: SkinTonePickerRef
    }, skinToneVariations.map(function(skinToneVariation, i) {
        var active = skinToneVariation === activeSkinTone;
        return (0, _react.createElement)(BtnSkinToneVariation, {
            key: skinToneVariation,
            skinToneVariation: skinToneVariation,
            isOpen: isOpen,
            style: {
                transform: (0, _flairup.cx)(vertical ? "translateY(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)", isOpen && active && "scale(1.3)")
            },
            isActive: active,
            onClick: function onClick() {
                if (isOpen) {
                    setActiveSkinTone(skinToneVariation);
                    onSkinToneChange(skinToneVariation);
                    focusSearchInput();
                } else setIsOpen(true);
                closeAllOpenToggles();
            }
        });
    })));
}
var SkinTonePickerDirection;
(function(SkinTonePickerDirection) {
    SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
    SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var styles$d = /*#__PURE__*/ stylesheet.create({
    skinTones: {
        ".": "epr-skin-tones",
        "--": {
            "--epr-skin-tone-size": "15px"
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        transition: "all 0.3s ease-in-out",
        padding: "10px 0"
    },
    vertical: {
        padding: "9px",
        alignItems: "flex-end",
        flexDirection: "column",
        borderRadius: "6px",
        border: "1px solid var(--epr-bg-color)"
    },
    verticalShadow: {
        boxShadow: "0px 0 7px var(--epr-picker-border-color)"
    },
    open: {
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: "blur(5px)",
        background: "var(--epr-skin-tone-picker-menu-color)",
        ".epr-active:after": {
            content: "",
            position: "absolute",
            top: "-2px",
            left: "-2px",
            right: "-2px",
            bottom: "-2px",
            borderRadius: "5px",
            border: "1px solid var(--epr-active-skin-tone-indicator-border-color)"
        }
    },
    select: {
        ".": "epr-skin-tone-select",
        position: "relative",
        width: "var(--epr-skin-tone-size)",
        height: "var(--epr-skin-tone-size)",
        "> button": {
            width: "var(--epr-skin-tone-size)",
            display: "block",
            cursor: "pointer",
            borderRadius: "4px",
            height: "var(--epr-skin-tone-size)",
            position: "absolute",
            right: "0",
            transition: "transform 0.3s ease-in-out, opacity 0.35s ease-in-out",
            zIndex: "0",
            boxShadow: "0 0 0 0px var(--epr-active-skin-hover-color)"
        }
    }
});
function Preview() {
    var previewConfig = usePreviewConfig();
    var isSkinToneInPreview = useIsSkinToneInPreview();
    if (!previewConfig.showPreview) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$e.preview, commonInteractionStyles.hiddenOnReactions)
    }, (0, _react.createElement)(PreviewBody, null), (0, _react.createElement)(Space, null), isSkinToneInPreview ? (0, _react.createElement)(SkinTonePickerMenu, null) : null);
}
function PreviewBody() {
    var _previewEmoji$unified;
    var previewConfig = usePreviewConfig();
    var _useState = (0, _react.useState)(null), previewEmoji = _useState[0], setPreviewEmoji = _useState[1];
    var emojiStyle = useEmojiStyleConfig();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPickerEmoji = _useEmojiVariationPic[0];
    var getEmojiUrl = useGetEmojiUrlConfig();
    useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
    var emoji = emojiByUnified((_previewEmoji$unified = previewEmoji == null ? void 0 : previewEmoji.unified) != null ? _previewEmoji$unified : previewEmoji == null ? void 0 : previewEmoji.originalUnified);
    var show = emoji != null && previewEmoji != null;
    return (0, _react.createElement)(PreviewContent, null);
    function PreviewContent() {
        var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : emojiByUnified(previewConfig.defaultEmoji);
        if (!defaultEmoji) return null;
        var defaultText = variationPickerEmoji ? emojiName(variationPickerEmoji) : previewConfig.defaultCaption;
        return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)("div", null, show ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: previewEmoji == null ? void 0 : previewEmoji.unified,
            emoji: emoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$e.emoji)
        }) : defaultEmoji ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: emojiUnified(defaultEmoji),
            emoji: defaultEmoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$e.emoji)
        }) : null), (0, _react.createElement)("div", {
            className: (0, _flairup.cx)(styles$e.label)
        }, show ? emojiName(emoji) : defaultText));
    }
}
var styles$e = /*#__PURE__*/ stylesheet.create({
    preview: {
        alignItems: "center",
        borderTop: "1px solid var(--epr-preview-border-color)",
        height: "var(--epr-preview-height)",
        padding: "0 var(--epr-horizontal-padding)",
        position: "relative",
        zIndex: "var(--epr-preview-z-index)"
    },
    label: {
        color: "var(--epr-preview-text-color)",
        fontSize: "var(--epr-preview-text-size)",
        padding: "var(--epr-preview-text-padding)",
        textTransform: "capitalize"
    },
    emoji: {
        padding: "0"
    }
});
function categoryNameFromDom($category) {
    var _$category$getAttribu;
    return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute("data-name")) != null ? _$category$getAttribu : null;
}
function useActiveCategoryScrollDetection(setActiveCategory) {
    var BodyRef = useBodyRef();
    (0, _react.useEffect)(function() {
        var visibleCategories = new Map();
        var bodyRef = BodyRef.current;
        var observer = new IntersectionObserver(function(entries) {
            if (!bodyRef) return;
            for(var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;){
                var entry = _step.value;
                var _id = categoryNameFromDom(entry.target);
                visibleCategories.set(_id, entry.intersectionRatio);
            }
            var ratios = Array.from(visibleCategories);
            var lastCategory = ratios[ratios.length - 1];
            if (lastCategory[1] == 1) return setActiveCategory(lastCategory[0]);
            for(var _i = 0, _ratios = ratios; _i < _ratios.length; _i++){
                var _ratios$_i = _ratios[_i], id = _ratios$_i[0], ratio = _ratios$_i[1];
                if (ratio) {
                    setActiveCategory(id);
                    break;
                }
            }
        }, {
            threshold: [
                0,
                1
            ]
        });
        bodyRef == null || bodyRef.querySelectorAll(asSelectors(ClassNames.category)).forEach(function(el) {
            observer.observe(el);
        });
    }, [
        BodyRef,
        setActiveCategory
    ]);
}
function useScrollCategoryIntoView() {
    var BodyRef = useBodyRef();
    var PickerMainRef = usePickerMainRef();
    return function scrollCategoryIntoView(category) {
        var _BodyRef$current;
        if (!BodyRef.current) return;
        var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector('[data-name="' + category + '"]');
        if (!$category) return;
        var offsetTop = $category.offsetTop || 0;
        scrollTo(PickerMainRef.current, offsetTop);
    };
}
function useShouldHideCustomEmojis() {
    var customCategoryConfig = useCustomEmojisConfig();
    if (!customCategoryConfig) return false;
    return customCategoryConfig.length === 0;
}
var SVGNavigation = "data:image/svg+xml;base64,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";
function CategoryButton(_ref) {
    var _cx;
    var isActiveCategory = _ref.isActiveCategory, category = _ref.category, allowNavigation = _ref.allowNavigation, categoryConfig = _ref.categoryConfig, onClick = _ref.onClick;
    return (0, _react.createElement)(Button, {
        tabIndex: allowNavigation ? 0 : -1,
        className: (0, _flairup.cx)(styles$f.catBtn, commonInteractionStyles.categoryBtn, "epr-icn-" + category, (_cx = {}, _cx[ClassNames.active] = isActiveCategory, _cx)),
        onClick: onClick,
        "aria-label": categoryNameFromCategoryConfig(categoryConfig),
        "aria-selected": isActiveCategory,
        role: "tab",
        "aria-controls": "epr-category-nav-id"
    });
}
var DarkActivePositionY = {
    backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 3)"
};
var DarkPositionY = {
    backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 2)"
};
var DarkInactivePosition = {
    ":not(.epr-search-active)": {
        catBtn: {
            ":hover": DarkActivePositionY,
            "&.epr-active": DarkActivePositionY
        }
    }
};
var styles$f = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    catBtn: {
        ".": "epr-cat-btn",
        display: "inline-block",
        transition: "opacity 0.2s ease-in-out",
        position: "relative",
        height: "var(--epr-category-navigation-button-size)",
        width: "var(--epr-category-navigation-button-size)",
        backgroundSize: "calc(var(--epr-category-navigation-button-size) * 10)",
        outline: "none",
        backgroundPosition: "0 0",
        backgroundImage: "url(" + SVGNavigation + ")",
        ":focus:before": {
            content: "",
            position: "absolute",
            top: "-2px",
            left: "-2px",
            right: "-2px",
            bottom: "-2px",
            border: "2px solid var(--epr-category-icon-active-color)",
            borderRadius: "50%"
        },
        "&.epr-icn-suggested": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -8)"
        },
        "&.epr-icn-custom": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -9)"
        },
        "&.epr-icn-activities": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -4)"
        },
        "&.epr-icn-animals_nature": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -1)"
        },
        "&.epr-icn-flags": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -7)"
        },
        "&.epr-icn-food_drink": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -2)"
        },
        "&.epr-icn-objects": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -5)"
        },
        "&.epr-icn-smileys_people": {
            backgroundPositionX: "0px"
        },
        "&.epr-icn-symbols": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -6)"
        },
        "&.epr-icn-travel_places": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -3)"
        }
    }
}, /*#__PURE__*/ darkMode("catBtn", DarkPositionY), {
    ".epr-dark-theme": /*#__PURE__*/ _extends({}, DarkInactivePosition),
    ".epr-auto-theme": /*#__PURE__*/ _extends({}, DarkInactivePosition)
}));
function CategoryNavigation() {
    var _useState = (0, _react.useState)(null), activeCategory = _useState[0], setActiveCategory = _useState[1];
    var scrollCategoryIntoView = useScrollCategoryIntoView();
    useActiveCategoryScrollDetection(setActiveCategory);
    var isSearchMode = useIsSearchMode();
    var categoriesConfig = useCategoriesConfig();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var hideCustomCategory = useShouldHideCustomEmojis();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$g.nav),
        role: "tablist",
        "aria-label": "Category navigation",
        id: "epr-category-nav-id",
        ref: CategoryNavigationRef
    }, categoriesConfig.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        var isActiveCategory = category === activeCategory;
        if (isCustomCategory(categoryConfig) && hideCustomCategory) return null;
        var allowNavigation = !isSearchMode && !isActiveCategory;
        return (0, _react.createElement)(CategoryButton, {
            key: category,
            category: category,
            isActiveCategory: isActiveCategory,
            allowNavigation: allowNavigation,
            categoryConfig: categoryConfig,
            onClick: function onClick() {
                setActiveCategory(category);
                scrollCategoryIntoView(category);
            }
        });
    }));
}
var styles$g = /*#__PURE__*/ stylesheet.create({
    nav: {
        ".": "epr-category-nav",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        padding: "var(--epr-header-padding)"
    },
    ".epr-search-active": {
        nav: {
            opacity: "0.3",
            cursor: "default",
            pointerEvents: "none"
        }
    },
    ".epr-main:has(input:not(:placeholder-shown))": {
        nav: {
            opacity: "0.3",
            cursor: "default",
            pointerEvents: "none"
        }
    }
});
var SVGTimes = "data:image/svg+xml;base64,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";
function BtnClearSearch() {
    var clearSearch = useClearSearch();
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$h.btnClearSearch, commonInteractionStyles.visibleOnSearchOnly),
        onClick: clearSearch,
        "aria-label": "Clear",
        title: "Clear"
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$h.icnClearnSearch)
    }));
}
var HoverDark = {
    ":hover": {
        "> .epr-icn-clear-search": {
            backgroundPositionY: "-60px"
        }
    }
};
var styles$h = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    btnClearSearch: {
        ".": "epr-btn-clear-search",
        position: "absolute",
        right: "var(--epr-search-bar-inner-padding)",
        height: "30px",
        width: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        transform: "translateY(-50%)",
        padding: "0",
        borderRadius: "50%",
        ":hover": {
            background: "var(--epr-hover-bg-color)"
        },
        ":focus": {
            background: "var(--epr-hover-bg-color)"
        }
    },
    icnClearnSearch: {
        ".": "epr-icn-clear-search",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20px",
        height: "20px",
        width: "20px",
        backgroundImage: "url(" + SVGTimes + ")",
        ":hover": {
            backgroundPositionY: "-20px"
        },
        ":focus": {
            backgroundPositionY: "-20px"
        }
    }
}, /*#__PURE__*/ darkMode("icnClearnSearch", {
    backgroundPositionY: "-40px"
}), /*#__PURE__*/ darkMode("btnClearSearch", HoverDark)));
var SCOPE = /*#__PURE__*/ asSelectors(ClassNames.emojiPicker) + " " + /*#__PURE__*/ asSelectors(ClassNames.emojiList);
var EMOJI_BUTTON = /*#__PURE__*/ [
    "button",
    asSelectors(ClassNames.emoji)
].join("");
var CATEGORY = /*#__PURE__*/ asSelectors(ClassNames.category);
function CssSearch(_ref) {
    var value = _ref.value;
    if (!value) return null;
    var q = genQuery(value);
    return (0, _react.createElement)("style", null, "\n    " + SCOPE + " " + EMOJI_BUTTON + " {\n      display: none;\n    }\n\n\n    " + SCOPE + " " + q + " {\n      display: flex;\n    }\n\n    " + SCOPE + " " + CATEGORY + ":not(:has(" + q + ")) {\n      display: none;\n    }\n  ");
}
function genQuery(value) {
    return [
        EMOJI_BUTTON,
        '[data-full-name*="',
        getNormalizedSearchTerm(value),
        '"]'
    ].join("");
}
var SVGMagnifier = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+";
function IcnSearch() {
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$i.icnSearch)
    });
}
var styles$i = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    icnSearch: {
        ".": "epr-icn-search",
        content: "",
        position: "absolute",
        top: "50%",
        left: "var(--epr-search-bar-inner-padding)",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0",
        backgroundSize: "20px",
        backgroundImage: "url(" + SVGMagnifier + ")"
    }
}, /*#__PURE__*/ darkMode("icnSearch", {
    backgroundPositionY: "-20px"
})));
function SearchContainer() {
    var searchDisabled = useSearchDisabledConfig();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    if (searchDisabled) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$j.overlay)
    }, (0, _react.createElement)(Search, null), isSkinToneInSearch ? (0, _react.createElement)(SkinTonePicker, null) : null);
}
function Search() {
    var _useState = (0, _react.useState)(0), inc = _useState[0], setInc = _useState[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var SearchInputRef = useSearchInputRef();
    var placeholder = useSearchPlaceHolderConfig();
    var autoFocus = useAutoFocusSearchConfig();
    var _useFilter = useFilter(), statusSearchResults = _useFilter.statusSearchResults, searchTerm = _useFilter.searchTerm, _onChange = _useFilter.onChange;
    var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
    var value = input == null ? void 0 : input.value;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$j.searchContainer)
    }, (0, _react.createElement)(CssSearch, {
        value: value
    }), (0, _react.createElement)("input", {
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        "aria-label": "Type to search for an emoji",
        onFocus: closeAllOpenToggles,
        className: (0, _flairup.cx)(styles$j.search),
        type: "text",
        "aria-controls": "epr-search-id",
        placeholder: placeholder,
        onChange: function onChange(event) {
            setInc(inc + 1);
            setTimeout(function() {
                var _event$target$value, _event$target;
                _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
            });
        },
        ref: SearchInputRef
    }), searchTerm ? (0, _react.createElement)("div", {
        role: "status",
        className: (0, _flairup.cx)("epr-status-search-results", styles$j.visuallyHidden),
        "aria-live": "polite",
        id: "epr-search-id",
        "aria-atomic": "true"
    }, statusSearchResults) : null, (0, _react.createElement)(IcnSearch, null), (0, _react.createElement)(BtnClearSearch, null));
}
var styles$j = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    overlay: {
        padding: "var(--epr-header-padding)",
        zIndex: "var(--epr-header-overlay-z-index)"
    },
    searchContainer: {
        ".": "epr-search-container",
        flex: "1",
        display: "block",
        minWidth: "0"
    },
    visuallyHidden: {
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: "1px",
        overflow: "hidden",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
    },
    search: {
        outline: "none",
        transition: "all 0.2s ease-in-out",
        color: "var(--epr-search-input-text-color)",
        borderRadius: "var(--epr-search-input-border-radius)",
        padding: "var(--epr-search-input-padding)",
        height: "var(--epr-search-input-height)",
        backgroundColor: "var(--epr-search-input-bg-color)",
        border: "1px solid var(--epr-search-input-bg-color)",
        width: "100%",
        ":focus": {
            backgroundColor: "var(--epr-search-input-bg-color-active)",
            border: "1px solid var(--epr-search-border-color)"
        },
        "::placeholder": {
            color: "var(--epr-search-input-placeholder-color)"
        }
    },
    btnClearSearch: {
        ".": "epr-btn-clear-search",
        position: "absolute",
        right: "var(--epr-search-bar-inner-padding)",
        height: "30px",
        width: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        transform: "translateY(-50%)",
        padding: "0",
        borderRadius: "50%",
        ":hover": {
            background: "var(--epr-hover-bg-color)"
        },
        ":focus": {
            background: "var(--epr-hover-bg-color)"
        }
    },
    icnClearnSearch: {
        ".": "epr-icn-clear-search",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20px",
        height: "20px",
        width: "20px",
        backgroundImage: "url(" + SVGTimes + ")",
        ":hover": {
            backgroundPositionY: "-20px"
        },
        ":focus": {
            backgroundPositionY: "-20px"
        }
    }
}, /*#__PURE__*/ darkMode("icnClearnSearch", {
    backgroundPositionY: "-40px"
}), /*#__PURE__*/ darkMode("btnClearSearch", {
    ":hover > .epr-icn-clear-search": {
        backgroundPositionY: "-60px"
    }
})));
function Header() {
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)("epr-header", commonInteractionStyles.hiddenOnReactions)
    }, (0, _react.createElement)(SearchContainer, null), (0, _react.createElement)(CategoryNavigation, null));
}
function EmojiPicker(props) {
    return (0, _react.createElement)(ElementRefContextProvider, null, (0, _react.createElement)(PickerStyleTag, null), (0, _react.createElement)(PickerConfigProvider, Object.assign({}, props), (0, _react.createElement)(ContentControl, null)));
}
function ContentControl() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsDefaultOpen = _useReactionsModeStat[0];
    var allowExpandReactions = useAllowExpandReactions();
    var _React$useState = (0, _react.useState)(!reactionsDefaultOpen), renderAll = _React$useState[0], setRenderAll = _React$useState[1];
    var isOpen = useOpenConfig();
    (0, _react.useEffect)(function() {
        if (reactionsDefaultOpen && !allowExpandReactions) return;
        if (!renderAll) setRenderAll(true);
    }, [
        renderAll,
        allowExpandReactions,
        reactionsDefaultOpen
    ]);
    if (!isOpen) return null;
    return (0, _react.createElement)(PickerMain, null, (0, _react.createElement)(Reactions, null), (0, _react.createElement)(ExpandedPickerContent, {
        renderAll: renderAll
    }));
}
function ExpandedPickerContent(_ref) {
    var renderAll = _ref.renderAll;
    if (!renderAll) return null;
    return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)(Header, null), (0, _react.createElement)(Body, null), (0, _react.createElement)(Preview, null));
}
// eslint-disable-next-line complexity
var EmojiPickerReact = /*#__PURE__*/ (0, _react.memo)(EmojiPicker, compareConfig);
var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);
    function ErrorBoundary(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error("Emoji Picker React failed to render:", error, errorInfo);
    };
    _proto.render = function render() {
        if (this.state.hasError) return null;
        return this.props.children;
    };
    return ErrorBoundary;
}((0, _react.Component));
function ExportedEmoji(_ref) {
    var unified = _ref.unified, _ref$size = _ref.size, size = _ref$size === void 0 ? 32 : _ref$size, _ref$emojiStyle = _ref.emojiStyle, emojiStyle = _ref$emojiStyle === void 0 ? EmojiStyle.APPLE : _ref$emojiStyle, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, getEmojiUrl = _ref.getEmojiUrl, emojiUrl = _ref.emojiUrl;
    if (!unified && !emojiUrl && !getEmojiUrl) return null;
    return (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: emojiUrl ? function() {
            return emojiUrl;
        } : getEmojiUrl
    });
}
function EmojiPicker$1(props) {
    var MutableConfigRef = useDefineMutableConfig({
        onEmojiClick: props.onEmojiClick,
        onReactionClick: props.onReactionClick,
        onSkinToneChange: props.onSkinToneChange
    });
    return (0, _react.createElement)(ErrorBoundary, null, (0, _react.createElement)(MutableConfigContext.Provider, {
        value: MutableConfigRef
    }, (0, _react.createElement)(EmojiPickerReact, Object.assign({}, props))));
}
exports.default = EmojiPicker$1;

},{"react":"6uln9","flairup":"gxuBZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxuBZ":[function(require,module,exports) {
"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    createSheet: function() {
        return createSheet;
    },
    cx: function() {
        return cx;
    }
});
module.exports = __toCommonJS(src_exports);
// src/utils/asArray.ts
function asArray(v) {
    return [].concat(v);
}
// src/utils/is.ts
function isPsuedoSelector(selector) {
    return selector.startsWith(":");
}
function isStyleCondition(selector) {
    return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
    return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
    return selector.startsWith("@media");
}
function isDirectClass(selector) {
    return selector === ".";
}
function isCssVariables(selector) {
    return selector === "--";
}
function isString(value) {
    return value + "" === value;
}
function isImmediatePostcondition(value) {
    return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}
// src/utils/joinTruthy.ts
function joinTruthy(arr) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return arr.filter(Boolean).join(delimiter);
}
// src/utils/stableHash.ts
function stableHash(prefix, seed) {
    var hash = 0;
    if (seed.length === 0) return hash.toString();
    for(var i = 0; i < seed.length; i++){
        var char = seed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return "".concat(prefix !== null && prefix !== void 0 ? prefix : "cl", "_").concat(hash.toString(36));
}
// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
    if (property === "content") return '"'.concat(value, '"');
    return value;
}
function camelCaseToDash(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
    return "".concat(property, ":").concat(value);
}
function toClass(str) {
    return str ? ".".concat(str) : "";
}
function appendString(base, line) {
    return base ? "".concat(base, "\n").concat(line) : line;
}
// src/Rule.ts
var Rule = /*#__PURE__*/ function() {
    function _Rule(sheet, property, value, selector) {
        _class_call_check(this, _Rule);
        this.sheet = sheet;
        this.property = property;
        this.value = value;
        this.selector = selector;
        this.property = property;
        this.value = value;
        this.joined = joinedProperty(property, value);
        var joinedConditions = this.selector.preconditions.concat(this.selector.postconditions);
        this.hash = this.selector.hasConditions ? this.selector.scopeClassName : stableHash(this.sheet.name, this.joined);
        this.key = joinTruthy([
            this.joined,
            joinedConditions,
            this.hash
        ]);
    }
    _create_class(_Rule, [
        {
            key: "toString",
            value: function toString() {
                var selectors = mergeSelectors(this.selector.preconditions, {
                    right: this.hash
                });
                selectors = mergeSelectors(this.selector.postconditions, {
                    left: selectors
                });
                return "".concat(selectors, " {").concat(_Rule.genRule(this.property, this.value), "}");
            }
        }
    ], [
        {
            key: "genRule",
            value: function genRule(property, value) {
                var transformedProperty = camelCaseToDash(property);
                return joinedProperty(transformedProperty, handlePropertyValue(property, value)) + ";";
            }
        }
    ]);
    return _Rule;
}();
function mergeSelectors(selectors) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_left = _ref.left, left = _ref_left === void 0 ? "" : _ref_left, _ref_right = _ref.right, right = _ref_right === void 0 ? "" : _ref_right;
    var output = selectors.reduce(function(selectors2, current) {
        if (isPsuedoSelector(current)) return selectors2 + current;
        if (isImmediatePostcondition(current)) return selectors2 + current.slice(1);
        return joinTruthy([
            selectors2,
            current
        ], " ");
    }, left);
    return joinTruthy([
        output,
        toClass(right)
    ], " ");
}
var Selector = /*#__PURE__*/ function() {
    function _Selector(sheet) {
        var scopeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, preconditions = _ref.preconditions, postconditions = _ref.postconditions;
        _class_call_check(this, _Selector);
        this.sheet = sheet;
        this.preconditions = [];
        this.scopeClassName = null;
        this.scopeName = null;
        this.postconditions = [];
        this.preconditions = preconditions ? asArray(preconditions) : [];
        this.postconditions = postconditions ? asArray(postconditions) : [];
        this.setScope(scopeName);
    }
    _create_class(_Selector, [
        {
            key: "setScope",
            value: function setScope(scopeName) {
                if (!scopeName) return this;
                if (!this.scopeClassName) {
                    this.scopeName = scopeName;
                    this.scopeClassName = stableHash(this.sheet.name, scopeName + this.sheet.count);
                }
                return this;
            }
        },
        {
            key: "hasConditions",
            get: function get() {
                return this.preconditions.length > 0 || this.postconditions.length > 0;
            }
        },
        {
            key: "addScope",
            value: function addScope(scopeName) {
                return new _Selector(this.sheet, scopeName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions
                });
            }
        },
        {
            key: "addPrecondition",
            value: function addPrecondition(precondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    postconditions: this.postconditions,
                    preconditions: this.preconditions.concat(precondition)
                });
            }
        },
        {
            key: "addPostcondition",
            value: function addPostcondition(postcondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions.concat(postcondition)
                });
            }
        },
        {
            key: "createRule",
            value: function createRule(property, value) {
                return new Rule(this.sheet, property, value, this);
            }
        }
    ]);
    return _Selector;
}();
// src/Sheet.ts
var Sheet = /*#__PURE__*/ function() {
    function Sheet(name, rootNode) {
        _class_call_check(this, Sheet);
        this.name = name;
        this.rootNode = rootNode;
        // Hash->css
        this.storedStyles = {};
        // styles->hash
        this.storedClasses = {};
        this.style = "";
        this.count = 0;
        this.id = "flairup-".concat(name);
        this.styleTag = this.createStyleTag();
    }
    _create_class(Sheet, [
        {
            key: "getStyle",
            value: function getStyle() {
                return this.style;
            }
        },
        {
            key: "append",
            value: function append(css) {
                this.style = appendString(this.style, css);
            }
        },
        {
            key: "apply",
            value: function apply() {
                this.count++;
                if (!this.styleTag) return;
                this.styleTag.innerHTML = this.style;
            }
        },
        {
            key: "isApplied",
            value: function isApplied() {
                return !!this.styleTag;
            }
        },
        {
            key: "createStyleTag",
            value: function createStyleTag() {
                if (typeof document === "undefined" || this.isApplied() || // Explicitly disallow mounting to the DOM
                this.rootNode === null) return this.styleTag;
                var styleTag = document.createElement("style");
                styleTag.type = "text/css";
                styleTag.id = this.id;
                var _this_rootNode;
                ((_this_rootNode = this.rootNode) !== null && _this_rootNode !== void 0 ? _this_rootNode : document.head).appendChild(styleTag);
                return styleTag;
            }
        },
        {
            key: "addRule",
            value: function addRule(rule) {
                var storedClass = this.storedClasses[rule.key];
                if (isString(storedClass)) return storedClass;
                this.storedClasses[rule.key] = rule.hash;
                this.storedStyles[rule.hash] = [
                    rule.property,
                    rule.value
                ];
                this.append(rule.toString());
                return rule.hash;
            }
        }
    ]);
    return Sheet;
}();
// src/utils/forIn.ts
function forIn(obj, fn) {
    for(var key in obj)fn(key.trim(), obj[key]);
}
// src/cx.ts
function cx() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var classes = args.reduce(function(classes2, arg) {
        if (_instanceof(arg, Set)) {
            var _classes2;
            (_classes2 = classes2).push.apply(_classes2, _to_consumable_array(arg));
        } else if (typeof arg === "string") classes2.push(arg);
        else if (Array.isArray(arg)) classes2.push(cx.apply(void 0, _to_consumable_array(arg)));
        else if (typeof arg === "object") Object.entries(arg).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (value) classes2.push(key);
        });
        return classes2;
    }, []);
    return joinTruthy(classes, " ").trim();
}
// src/index.ts
function createSheet(name, rootNode) {
    var sheet = new Sheet(name, rootNode);
    return {
        create: create,
        getStyle: sheet.getStyle.bind(sheet),
        isApplied: sheet.isApplied.bind(sheet)
    };
    function create(styles) {
        var scopedStyles = {};
        iteratePreconditions(sheet, styles, new Selector(sheet)).forEach(function(param) {
            var _param = _sliced_to_array(param, 3), scopeName = _param[0], styles2 = _param[1], selector = _param[2];
            iterateStyles(sheet, styles2, selector).forEach(function(className) {
                addScopedStyle(scopeName, className);
            });
        });
        sheet.apply();
        return scopedStyles;
        function addScopedStyle(name2, className) {
            var _scopedStyles_name2;
            scopedStyles[name2] = (_scopedStyles_name2 = scopedStyles[name2]) !== null && _scopedStyles_name2 !== void 0 ? _scopedStyles_name2 : /* @__PURE__ */ new Set();
            scopedStyles[name2].add(className);
        }
    }
}
function iteratePreconditions(sheet, styles, selector) {
    var output = [];
    forIn(styles, function(key, value) {
        if (isStyleCondition(key)) return iteratePreconditions(sheet, value, selector.addPrecondition(key)).forEach(function(item) {
            return output.push(item);
        });
        output.push([
            key,
            styles[key],
            selector.addScope(key)
        ]);
    });
    return output;
}
function iterateStyles(sheet, styles, selector) {
    var output = /* @__PURE__ */ new Set();
    forIn(styles, function(property, value) {
        var res = [];
        if (isStyleCondition(property)) res = iterateStyles(sheet, value, selector.addPostcondition(property));
        else if (isDirectClass(property)) res = asArray(value);
        else if (isMediaQuery(property)) res = handleMediaQuery(sheet, value, property, selector);
        else if (isCssVariables(property)) res = cssVariablesBlock(sheet, value, selector);
        else if (isValidProperty(property, value)) {
            var rule = selector.createRule(property, value);
            sheet.addRule(rule);
            output.add(rule.hash);
        }
        return addEachClass(res, output);
    });
    return output;
}
function addEachClass(list, to) {
    list.forEach(function(className) {
        return to.add(className);
    });
    return to;
}
function cssVariablesBlock(sheet, styles, selector) {
    var classes = /* @__PURE__ */ new Set();
    var chunkRows = [];
    forIn(styles, function(property, value) {
        if (isValidProperty(property, value)) {
            chunkRows.push(Rule.genRule(property, value));
            return;
        }
        var res = iterateStyles(sheet, value !== null && value !== void 0 ? value : {}, selector);
        addEachClass(res, classes);
    });
    if (!selector.scopeClassName) return classes;
    if (chunkRows.length) {
        var output = chunkRows.join(" ");
        sheet.append("".concat(mergeSelectors(selector.preconditions, {
            right: selector.scopeClassName
        }), " {").concat(output, "}"));
    }
    classes.add(selector.scopeClassName);
    return classes;
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
    sheet.append(mediaQuery + " {");
    var output = iterateStyles(sheet, styles, selector);
    sheet.append("}");
    return output;
}

},{}],"iQA0X":[function() {},{}],"gBFnl":[function(require,module,exports) {
module.exports = require("ae9fe29e3eb7352b").getBundleURL("8aiQJ") + "chatBoxImageCrop1.f8c4660a.png";

},{"ae9fe29e3eb7352b":"c7Tr5"}],"gulDC":[function(require,module,exports) {
module.exports = require("629ee7a165585f33").getBundleURL("8aiQJ") + "arrowDownConvert.17a2917c.png";

},{"629ee7a165585f33":"c7Tr5"}],"1uqOf":[function(require,module,exports) {
module.exports = require("6c45692938c9d02b").getBundleURL("8aiQJ") + "chatSoundSpeaker.150dba32.png";

},{"6c45692938c9d02b":"c7Tr5"}],"9MSx0":[function(require,module,exports) {
module.exports = require("2d2c807c5cd69605").getBundleURL("8aiQJ") + "chatMuteSpeaker.0a898270.png";

},{"2d2c807c5cd69605":"c7Tr5"}],"1bn3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frameNewCss = require("./frameNew.css");
const PageNotFound = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "d-flex align-items-center justify-content-center vh-100 errorPageMainClassOutside",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "text-center errorPageMainClass",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "display-1 fw-bold errorHead",
                    children: "404"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "fs-3 errorOopsPara",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-danger",
                            children: "Opps! "
                        }),
                        " Sorry the page you are looking could not be found!"
                    ]
                })
            ]
        })
    });
};
exports.default = PageNotFound;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","./frameNew.css":"iQA0X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQA0X":[function() {},{}],"2BPVl":[function(require,module,exports) {
// this is the final code for 
// Working
// 1. audio playing in iphone 
// 2. mic working in iphone and android 
// 3. no full screen video
// Not  working
// 1. sound toggle button 
// 2. response video only playing without soundd instead of static video 
// import React, { useState, useRef, useEffect } from 'react';
// import Picker from 'emoji-picker-react';
// import './frameNew.css';
// import chatBoxImage from '../../../static/img/chatBoxImageCrop1.png'
// import arrowDown from '../../../static/img/arrowDownConvert.png'
// import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
// import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
// import { useFetcher, useLocation, useParams } from 'react-router-dom';
// const NoEnglishAudio = () => {
//   // const avatarList = [
//   //   { name: 'Shweta', image: '/img/avatar/woman.png' },
//   //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Aman', image: '/img/avatar/man.png' },
//   //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
//   //   { name: 'Alex', image: '/img/avatar/man.png' },
//   //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
//   // ];
//   const languages = [
//     {
//       "language": "Afrikaans",
//       "code": "af"
//     },
//     {
//       "language": "Albanian",
//       "code": "sq"
//     },
//     {
//       "language": "Amharic",
//       "code": "am"
//     },
//     {
//       "language": "Arabic",
//       "code": "ar"
//     },
//     {
//       "language": "Armenian",
//       "code": "hy"
//     },
//     {
//       "language": "Azerbaijani",
//       "code": "az"
//     },
//     {
//       "language": "Basque",
//       "code": "eu"
//     },
//     {
//       "language": "Belarusian",
//       "code": "be"
//     },
//     {
//       "language": "Bengali",
//       "code": "bn"
//     },
//     {
//       "language": "Bosnian",
//       "code": "bs"
//     },
//     {
//       "language": "Bulgarian",
//       "code": "bg"
//     },
//     {
//       "language": "Catalan",
//       "code": "ca"
//     },
//     {
//       "language": "Cebuano",
//       "code": "ceb"
//     },
//     {
//       "language": "Chinese (Simplified)",
//       "code": "zh-CN"
//     },
//     {
//       "language": "Chinese (Traditional)",
//       "code": "zh-TW"
//     },
//     {
//       "language": "Corsican",
//       "code": "co"
//     },
//     {
//       "language": "Croatian",
//       "code": "hr"
//     },
//     {
//       "language": "Czech",
//       "code": "cs"
//     },
//     {
//       "language": "Danish",
//       "code": "da"
//     },
//     {
//       "language": "Dutch",
//       "code": "nl"
//     },
//     {
//       "language": "English",
//       "code": "en"
//     },
//     {
//       "language": "Esperanto",
//       "code": "eo"
//     },
//     {
//       "language": "Estonian",
//       "code": "et"
//     },
//     {
//       "language": "Finnish",
//       "code": "fi"
//     },
//     {
//       "language": "French",
//       "code": "fr"
//     },
//     {
//       "language": "Frisian",
//       "code": "fy"
//     },
//     {
//       "language": "Galician",
//       "code": "gl"
//     },
//     {
//       "language": "Georgian",
//       "code": "ka"
//     },
//     {
//       "language": "German",
//       "code": "de"
//     },
//     {
//       "language": "Greek",
//       "code": "el"
//     },
//     {
//       "language": "Gujarati",
//       "code": "gu"
//     },
//     {
//       "language": "Haitian Creole",
//       "code": "ht"
//     },
//     {
//       "language": "Hausa",
//       "code": "ha"
//     },
//     {
//       "language": "Hawaiian",
//       "code": "haw"
//     },
//     {
//       "language": "Hebrew",
//       "code": "iw"
//     },
//     {
//       "language": "Hindi",
//       "code": "hi"
//     },
//     {
//       "language": "Hmong",
//       "code": "hmn"
//     },
//     {
//       "language": "Hungarian",
//       "code": "hu"
//     },
//     {
//       "language": "Icelandic",
//       "code": "is"
//     },
//     {
//       "language": "Igbo",
//       "code": "ig"
//     },
//     {
//       "language": "Indonesian",
//       "code": "id"
//     },
//     {
//       "language": "Irish",
//       "code": "ga"
//     },
//     {
//       "language": "Italian",
//       "code": "it"
//     },
//     {
//       "language": "Japanese",
//       "code": "ja"
//     },
//     {
//       "language": "Javanese",
//       "code": "jw"
//     },
//     {
//       "language": "Kannada",
//       "code": "kn"
//     },
//     {
//       "language": "Kazakh",
//       "code": "kk"
//     },
//     {
//       "language": "Khmer",
//       "code": "km"
//     },
//     {
//       "language": "Korean",
//       "code": "ko"
//     },
//     {
//       "language": "Kurdish",
//       "code": "ku"
//     },
//     {
//       "language": "Kyrgyz",
//       "code": "ky"
//     },
//     {
//       "language": "Lao",
//       "code": "lo"
//     },
//     {
//       "language": "Latin",
//       "code": "la"
//     },
//     {
//       "language": "Latvian",
//       "code": "lv"
//     },
//     {
//       "language": "Lithuanian",
//       "code": "lt"
//     },
//     {
//       "language": "Luxembourgish",
//       "code": "lb"
//     },
//     {
//       "language": "Macedonian",
//       "code": "mk"
//     },
//     {
//       "language": "Malagasy",
//       "code": "mg"
//     },
//     {
//       "language": "Malay",
//       "code": "ms"
//     },
//     {
//       "language": "Malayalam",
//       "code": "ml"
//     },
//     {
//       "language": "Maltese",
//       "code": "mt"
//     },
//     {
//       "language": "Maori",
//       "code": "mi"
//     },
//     {
//       "language": "Marathi",
//       "code": "mr"
//     },
//     {
//       "language": "Mongolian",
//       "code": "mn"
//     },
//     {
//       "language": "Myanmar (Burmese)",
//       "code": "my"
//     },
//     {
//       "language": "Nepali",
//       "code": "ne"
//     },
//     {
//       "language": "Norwegian",
//       "code": "no"
//     },
//     {
//       "language": "Nyanja (Chichewa)",
//       "code": "ny"
//     },
//     {
//       "language": "Pashto",
//       "code": "ps"
//     },
//     {
//       "language": "Persian",
//       "code": "fa"
//     },
//     {
//       "language": "Polish",
//       "code": "pl"
//     },
//     {
//       "language": "Portuguese (Portugal, Brazil)",
//       "code": "pt"
//     },
//     {
//       "language": "Punjabi",
//       "code": "pa"
//     },
//     {
//       "language": "Romanian",
//       "code": "ro"
//     },
//     {
//       "language": "Russian",
//       "code": "ru"
//     },
//     {
//       "language": "Samoan",
//       "code": "sm"
//     },
//     {
//       "language": "Scots Gaelic",
//       "code": "gd"
//     },
//     {
//       "language": "Serbian",
//       "code": "sr"
//     },
//     {
//       "language": "Sesotho",
//       "code": "st"
//     },
//     {
//       "language": "Shona",
//       "code": "sn"
//     },
//     {
//       "language": "Sindhi",
//       "code": "sd"
//     },
//     {
//       "language": "Sinhala (Sinhalese)",
//       "code": "si"
//     },
//     {
//       "language": "Slovak",
//       "code": "sk"
//     },
//     {
//       "language": "Slovenian",
//       "code": "sl"
//     },
//     {
//       "language": "Somali",
//       "code": "so"
//     },
//     {
//       "language": "Spanish",
//       "code": "es"
//     },
//     {
//       "language": "Sundanese",
//       "code": "su"
//     },
//     {
//       "language": "Swahili",
//       "code": "sw"
//     },
//     {
//       "language": "Swedish",
//       "code": "sv"
//     },
//     {
//       "language": "Tagalog (Filipino)",
//       "code": "tl"
//     },
//     {
//       "language": "Tajik",
//       "code": "tg"
//     },
//     {
//       "language": "Tamil",
//       "code": "ta"
//     },
//     {
//       "language": "Telugu",
//       "code": "te"
//     },
//     {
//       "language": "Thai",
//       "code": "th"
//     },
//     {
//       "language": "Turkish",
//       "code": "tr"
//     },
//     {
//       "language": "Ukrainian",
//       "code": "uk"
//     },
//     {
//       "language": "Urdu",
//       "code": "ur"
//     },
//     {
//       "language": "Uzbek",
//       "code": "uz"
//     },
//     {
//       "language": "Vietnamese",
//       "code": "vi"
//     },
//     {
//       "language": "Welsh",
//       "code": "cy"
//     },
//     {
//       "language": "Xhosa",
//       "code": "xh"
//     },
//     {
//       "language": "Yiddish",
//       "code": "yi"
//     },
//     {
//       "language": "Yoruba",
//       "code": "yo"
//     },
//     {
//       "language": "Zulu",
//       "code": "zu"
//     }
//   ]
//   const [inputValue, setInputValue] = useState('');
//   const [welcomeApiMsg, setWelcomeApiMsg] = useState('');
//   const [staticApiVideo, setStaticApiVideo] = useState('');
//   const [welcomeApiVideo, setWelcomeApiVideo] = useState('');
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [videoUrl, setVideoUrl] = useState('');
//   const [audioToText, setAudioToText] = useState('');
//   const [recording, setRecording] = useState(false);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [timer, setTimer] = useState(0);
//   const [isSoundOn, setIsSoundOn] = useState(true);
//   const [videoLoading, setVideoLoading] = useState(true);
//   const [showChatBot, setShowChatBot] = useState(false);
//   const [recordMessage, setRecordMessage] = useState(false);
//   const [isApiCalled, setIsApiCalled] = useState(false);
//   const videoRef = useRef(null);
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const timerRef = useRef(null);
//   const chatHeadRef = useRef(null);
//   const messagesEndRef = useRef(null); // Ref for the autoscroll
//   const inputRef = useRef(null);
//   const dropdownAvatarRef = useRef(null);
//   const dropdownLanguageRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const [showInitialText, setShowInitialText] = useState(true);
//   const [recentBotIndex, setRecentBotIndex] = useState(null);
//   const [showWelcomeMsg, setShowWelcomeMsg] = useState(false);
//   const [checkAudio, setCheckAudio] = useState(false);
//   const [showWelcomeVideo, setShowWelcomeVideo] = useState(true);
//   const [showLanguages, setShowLanguages] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredLanguages, setFilteredLanguages] = useState(languages);
//   const [showAvatar, setShowAvatar] = useState(false);
//   const [selectedLanguage, setSelectedLanguage] = useState('English');
//   const [languageCode, setLanguageCode] = useState('en');
//   const [isRecordingTemp, setIsRecordingTemp] = useState(false);
//   const [audioUrlTemp, setAudioUrlTemp] = useState(null);
//   const [apiResponseTemp, setApiResponseTemp] = useState('');
//   const mediaRecorderRefTemp = useRef(null);
//   const recordedChunksRefTemp = useRef([]);
//   const mediaStreamRefTemp = useRef(null);
//   const audioRef = useRef(null);
//   const audioConstraintsTemp = {
//     audio: {
//       sampleRate: 16000,
//       channelCount: 1,
//       echoCancellation: false,
//       noiseSuppression: false,
//       autoGainControl: false,
//     },
//   };
//   // taking params from parent app and passing in iframe api
//   // const [params, setParams] = useState({
//   //   companyName: '',
//   //   moduleName: '',
//   //   avatarName: ''
//   // });
//   // useEffect(() => {
//   //   const receiveMessage = (event) => {
//   //     const { companyName, moduleName, avatarName } = event.data;
//   //     setParams({ companyName, moduleName, avatarName });
//   //   };
//   //   window.addEventListener('message', receiveMessage, false);
//   //   return () => {
//   //     window.removeEventListener('message', receiveMessage);
//   //   };
//   // }, []);
//   // taking params from iframe url only and passing in iframe api
//   const params = useLocation();
//   const pathSegments = params.pathname.split('/').filter(segment => segment);
//   const companyName = pathSegments[pathSegments.length - 3];
//   const moduleName = pathSegments[pathSegments.length - 2];
//   const avatarName = pathSegments[pathSegments.length - 1];
//   const avatarList = [
//     { name: 'Natasha', image: 'image1.png' },
//     // { name: 'Avatar2', image: 'image2.png' },
//   ];
//   const defaultAvatar = avatarList[0];
//   const [selectedAvatar, setSelectedAvatar] = useState({
//     name: defaultAvatar.name,
//     image: defaultAvatar.image,
//   });
//   useEffect(() => {
//     if (avatarName) {
//       const foundAvatar = avatarList.find(avatar => avatar.name.toLowerCase() === avatarName.toLowerCase());
//       if (foundAvatar) {
//         setSelectedAvatar({
//           name: foundAvatar.name,
//           image: foundAvatar.image,
//         });
//       } else {
//         setSelectedAvatar(defaultAvatar);
//       }
//     } else {
//       setSelectedAvatar(defaultAvatar);
//     }
//   }, [avatarName]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) {
//         setShowAvatar(false);
//       }
//     };
//     if (showAvatar) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showAvatar]);
//   const handleAvatarToggle = () => {
//     setShowAvatar(!showAvatar);
//   };
//   const handleLanguageToggle = () => {
//     setShowLanguages(!showLanguages);
//     if (!showLanguages) {
//       setFilteredLanguages(languages);
//       setSearchTerm('');
//     }
//   };
//   const handleLanguageSelect = (language) => {
//     setSelectedLanguage(language.language);
//     setSearchTerm('');
//     setFilteredLanguages(languages);
//     setShowLanguages(false);
//     setLanguageCode(language.code)
//   };
//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//     const filtered = languages.filter((language) =>
//       language.language.toLowerCase().includes(event.target.value.toLowerCase())
//     );
//     setFilteredLanguages(filtered);
//   };
//   useEffect(() => {
//     if (showLanguages) {
//       searchInputRef.current.focus();
//     }
//   }, [showLanguages]);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) {
//         setShowLanguages(false);
//       }
//     };
//     if (showLanguages) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showLanguages]);
//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter' && filteredLanguages.length > 0) {
//       handleLanguageSelect(filteredLanguages[0]);
//     }
//   };
//   const handleAvatarSelect = (avatar) => {
//     setSelectedAvatar(avatar);
//     setShowAvatar(false);
//   };
//   const handleWelcomeVideoEnd = () => {
//     setShowWelcomeVideo(false);
//   };
//   useEffect(() => {
//     const showTimeout = setTimeout(() => {
//       setShowWelcomeMsg(true);
//     }, 1);
//     const hideTimeout = setTimeout(() => {
//       setShowWelcomeMsg(false);
//     }, 3000);
//     return () => {
//       clearTimeout(showTimeout);
//       clearTimeout(hideTimeout);
//     };
//   }, []);
//   useEffect(() => {
//     const callApiOnPageLoad = async () => {
//       const payload = { user_input: 'hi' };
//       try {
//         const response = await fetch(
//           `https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`,
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(payload),
//           }
//         );
//         if (response.ok) {
//           const data = await response.json();
//           setWelcomeApiMsg(data.responses[0])
//           setStaticApiVideo(data.static_video)
//           setWelcomeApiVideo(data.video_path)
//         } else {
//           console.error('API error:', response.statusText);
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//       }
//     };
//     callApiOnPageLoad();
//   }, [companyName, moduleName, selectedAvatar]);
//   useEffect(() => {
//     const latestBotIndex = messages
//       .map((item, index) => (item.type === 'bot' ? index : null))
//       .filter(index => index !== null)
//       .pop();
//     if (latestBotIndex !== null) {
//       setRecentBotIndex(latestBotIndex);
//       // const timer = setTimeout(() => {
//       //   setShowInitialText(false);
//       // }, 1300);
//       setShowInitialText(true);
//       // return () => clearTimeout(timer);
//     }
//   }, [messages]);
//   const handleKeyPress = (event) => {
//     if (event.key === 'Enter') {
//       handleSendMessage();
//     }
//   };
//   const handleSendMessage = async () => {
//     setInputValue(''); // Clear the input field at the start
//     if (inputValue.trim() || audioToText) {
//       setLoading(true);
//       setIsApiCalled(true);
//       const userMessage = {
//         message: audioToText || inputValue.trim() || '',
//         type: 'user',
//         audioUrl: audioToText,
//         isActive: true,
//       };
//       setMessages((prevMessages) => [...prevMessages, userMessage]);
//       const payload = {
//         user_input: audioToText ? audioToText : inputValue.trim() || '',
//         lang: languageCode,
//         companyName: companyName,
//         moduleName: moduleName,
//         avatarName: selectedAvatar.name,
//       };
//       if (messagesEndRef.current) {
//         messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//       }
//       try {
//         const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(payload),
//         });
//         const data = await response.json();
//         setAudioToText('');
//         setAudioBlob(null);
//         setTimer(0);
//         handleResponse(data); // Call handleResponse to play audio and video
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       } catch (error) {
//         console.error('Error:', error);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };
//   // const handleResponse = (data) => {
//   //   // Check if there are bot responses
//   //   if (data.responses && data.responses.length > 0) {
//   //     const botMessage = data.responses.join(' ');
//   //     setMessages((prevMessages) => [
//   //       ...prevMessages,
//   //       {
//   //         message: botMessage,
//   //         type: 'bot',
//   //       },
//   //     ]);
//   //   } else {
//   //     setMessages((prevMessages) => [
//   //       ...prevMessages,
//   //       {
//   //         message: "Could you please repeat?",
//   //         type: 'bot',
//   //       },
//   //     ]);
//   //   }
//   //   // Check if there is a video path in the response
//   //   if (data.video_path) {
//   //     const fullVideoUrl = data.video_path;
//   //     setVideoUrl(fullVideoUrl);
//   //     // If there is audio data in base64 format, handle the audio
//   //     if (data.audio_data) {
//   //       // Convert the base64 audio data to a Blob
//   //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
//   //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
//   //       // Create audio and video elements
//   //       const videoElement = document.createElement('video');
//   //       videoElement.src = fullVideoUrl;
//   //       videoElement.controls = true;
//   //       videoElement.autoplay = true;
//   //       videoElement.muted = true; // Mute the video to avoid overlapping sound
//   //       const audioElement = document.createElement('audio');
//   //       audioElement.src = audioUrl;
//   //       audioElement.autoplay = true;
//   //       // const audioElement = new Audio(audioUrl);
//   //     audioRef.current = audioElement; 
//   //       // Sync the audio and video playback
//   //       videoElement.addEventListener('play', () => {
//   //         audioElement.play();
//   //       });
//   //       videoElement.addEventListener('pause', () => {
//   //         audioElement.pause();
//   //       });
//   //       // Append the video element to a container (assuming there is a container for the video)
//   //       const videoContainer = document.getElementById('video-container');
//   //       videoContainer.innerHTML = ''; // Clear any previous video
//   //       videoContainer.appendChild(videoElement);
//   //     } else {
//   //       console.log('No audio data received.');
//   //     }
//   //   } else {
//   //     setVideoUrl(''); // Clear the video if no path is provided
//   //   }
//   // };
//   // Utility function to convert base64 to Blob
//   const handleResponse = (data) => {
//     if (data.responses && data.responses.length > 0) {
//       const botMessage = data.responses.join(' ');
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: botMessage,
//           type: 'bot',
//         },
//       ]);
//     } else {
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           message: "Could you please repeat?",
//           type: 'bot',
//         },
//       ]);
//     }
//     if (data.video_path) {
//       const fullVideoUrl = data.video_path;
//       setVideoUrl(fullVideoUrl);
//       if (data.audio_data) {
//         if (audioRef.current) {
//           audioRef.current.pause(); 
//           audioRef.current.currentTime = 0; 
//           audioRef.current.src = ''; 
//         }
//         const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); 
//         const audioUrl = URL.createObjectURL(audioBlob); 
//         const audioElement = new Audio(audioUrl);
//         audioElement.autoplay = true;
//         audioRef.current = audioElement;
//         audioElement.play();
//         if (videoRef.current) {
//           videoRef.current.muted = true;
//           videoRef.current.src = fullVideoUrl; 
//           videoRef.current.autoplay = true;
//           videoRef.current.playsInline = true; 
//           videoRef.current.removeEventListener('play', handleVideoPlay);
//           videoRef.current.removeEventListener('pause', handleVideoPause);
//           videoRef.current.removeEventListener('ended', handleVideoEnd);
//           const handleVideoPlay = () => {
//             audioElement.play();
//           };
//           const handleVideoPause = () => {
//             audioElement.pause(); 
//           };
//           const handleVideoEnd = () => {
//             audioElement.pause();
//             audioElement.currentTime = 0; 
//             videoRef.current.currentTime = 0; 
//           };
//           videoRef.current.addEventListener('play', handleVideoPlay);
//           videoRef.current.addEventListener('pause', handleVideoPause);
//           videoRef.current.addEventListener('ended', handleVideoEnd);
//         }
//       } else {
//         console.log('No audio data received.');
//       }
//     } else {
//       setVideoUrl(''); // Clear the video if no path is provided
//     }
//   };
//   const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
//     const byteCharacters = atob(base64Data);
//     const byteArrays = [];
//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//       const slice = byteCharacters.slice(offset, offset + sliceSize);
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) {
//         byteNumbers[i] = slice.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//     }
//     return new Blob(byteArrays, { type: contentType });
//   };
//   useEffect(() => {
//     if (videoUrl) {
//       setVideoLoading(true);
//       const video = videoRef.current;
//       if (video) {
//         video.onloadeddata = () => {
//           setVideoLoading(false);
//           video.onended = () => {
//             setVideoUrl('');
//           };
//         };
//       }
//     }
//   }, [videoUrl]);
//   // useEffect(() => {
//   //   if (!loading && !recording) {
//   //     inputRef.current?.focus();
//   //   }
//   //   if (showWelcomeVideo) {
//   //     inputRef.current?.focus();
//   //   }
//   // }, [loading, recording, inputValue, messages]);
//   // recording check 
//   // const startRecording = async () => {
//   //   setRecording(true);
//   //   setRecordMessage(false)
//   //   setTimer(0);
//   //   audioChunksRef.current = [];
//   //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//   //   mediaRecorderRef.current = new MediaRecorder(stream);
//   //   mediaRecorderRef.current.ondataavailable = (event) => {
//   //     if (event.data.size > 0) {
//   //       audioChunksRef.current.push(event.data);
//   //     }
//   //   };
//   //   mediaRecorderRef.current.onstop = () => {
//   //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//   //     setAudioBlob(blob);
//   //   };
//   //   mediaRecorderRef.current.start();
//   //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
//   // };
//   // const stopRecording = () => {
//   //   setRecordMessage(true)
//   //   setRecording(false);
//   //   if (mediaRecorderRef.current) {
//   //     mediaRecorderRef.current.stop();
//   //   }
//   //   clearInterval(timerRef.current);
//   // };
//   useEffect(() => {
//     if (audioBlob) {
//       sendAudioToApi(audioBlob);
//     }
//   }, [audioBlob]);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setRecordMessage(false);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, [recordMessage]);
//   // const sendAudioToApi = async (blob) => {
//   //   try {
//   //     const base64Audio = await convertBlobToBase64(blob);
//   //     const fileExtension = blob.type.split('/')[1];
//   //     const formData = new FormData();
//   //     formData.append('audio_file', base64Audio.split(',')[1]);
//   //     formData.append('file_extension', fileExtension);
//   //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //       method: 'POST',
//   //       body: formData
//   //     });
//   //     const data = await response.json();
//   //     setAudioToText(data.response)
//   //     if (data.response.length > 0) {
//   //       setCheckAudio(false)
//   //     }
//   //     // if (data.response) {
//   //     //   setTimeout(() => {
//   //     //     setRecordMessage(false)
//   //     //     }, 880);
//   //     //   // }, 6200);
//   //     // }
//   //   } catch (error) {
//   //     console.error('Error sending audio:', error);
//   //   }
//   //   finally {
//   //     setCheckAudio(true)
//   //   }
//   // };
//   const convertBlobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };
//   useEffect(() => {
//     if (videoRef.current) {
//       setVideoLoading(true);
//       videoRef.current.load();
//       videoRef.current.play().finally(() => {
//         setVideoLoading(false);
//       });
//     }
//   }, [videoUrl]);
//   const toggleSound = () => {
//     if (audioRef.current) {
//       audioRef.current.muted = isSoundOn;
//       setIsSoundOn(!isSoundOn);
//     }
//   };
//   // const toggleSound = () => {
//   //   if (videoRef.current && audioRef.current) {
//   //     if (isSoundOn) {
//   //       // Mute both video and external audio
//   //       videoRef.current.muted = true;
//   //       audioRef.current.muted = true; // Mute external audio
//   //     } else {
//   //       // Unmute both video and external audio
//   //       videoRef.current.muted = false;
//   //       audioRef.current.muted = false; // Unmute external audio
//   //     }
//   //     // Toggle sound state
//   //     setIsSoundOn(!isSoundOn);
//   //   }
//   // };
//   const handleChatBotOpen = () => {
//     setShowChatBot(!showChatBot);
//   };
//   useEffect(() => {
//     setShowChatBot(true);
//   }, []);
//   useEffect(() => {
//     handleSendMessage()
//   }, [audioToText])
//   const handleVideoEnd = () => {
//     setVideoUrl(staticApiVideo)
//   }
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       setTimeout(() => {
//         if (messagesEndRef.current) {
//           messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//       }, 500);
//     }
//   }, [messages, showChatBot]);
//   // audio functionality for android
//   // const sendAudioToApi = async () => {
//   //   if (!isRecordingTemp) {
//   //     try {
//   //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//   //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
//   //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
//   //         if (event.data.size > 0) {
//   //           recordedChunksRefTemp.current.push(event.data);
//   //         }
//   //       };
//   //       mediaRecorderRefTemp.current.onstop = async () => {
//   //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
//   //         recordedChunksRefTemp.current = [];
//   //         // Convert blob to Base64
//   //         const readerTemp = new FileReader();
//   //         readerTemp.readAsDataURL(blobTemp);
//   //         readerTemp.onloadend = async () => {
//   //           const base64AudioTemp = readerTemp.result.split(',')[1];
//   //           // Display audio for playback
//   //           const audioUrlTemp = URL.createObjectURL(blobTemp);
//   //           setAudioUrlTemp(audioUrlTemp);
//   //           // Prepare the form data
//   //           const formDataTemp = new FormData();
//   //           formDataTemp.append('audio_file', base64AudioTemp);
//   //           formDataTemp.append('file_extension', 'webm');
//   //           // Call the API
//   //           try {
//   //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//   //               method: 'POST',
//   //               body: formDataTemp,
//   //             });
//   //             const resultTemp = await responseTemp.json();
//   //             console.log('pppppppppppp', resultTemp.response);
//   //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//   //             setAudioToText(resultTemp.response)
//   //             if (resultTemp.response.length > 0) {
//   //               setCheckAudio(false)
//   //             }
//   //           } catch (error) {
//   //             console.error('Error calling the API:', error);
//   //             setApiResponseTemp(`Error: ${error.message}`);
//   //           }
//   //         };
//   //       };
//   //       mediaRecorderRefTemp.current.start();
//   //       setIsRecordingTemp(true);
//   //     } catch (error) {
//   //       console.error('Error accessing microphone: ', error);
//   //     }
//   //   } else {
//   //     // Stop the recording
//   //     mediaRecorderRefTemp.current.stop();
//   //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//   //     setIsRecordingTemp(false);
//   //   }
//   // };
//   // audio functionality for ios 
//   const sendAudioToApi = async () => {
//     if (!isRecordingTemp) {
//       try {
//         mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//         // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
//         const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
//         mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
//         mediaRecorderRefTemp.current.ondataavailable = (event) => {
//           if (event.data.size > 0) {
//             recordedChunksRefTemp.current.push(event.data);
//           }
//         };
//         mediaRecorderRefTemp.current.onstop = async () => {
//           const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
//           recordedChunksRefTemp.current = [];
//           // Convert blob to Base64
//           const readerTemp = new FileReader();
//           readerTemp.readAsDataURL(blobTemp);
//           readerTemp.onloadend = async () => {
//             const base64AudioTemp = readerTemp.result.split(',')[1];
//             // Display audio for playback
//             const audioUrlTemp = URL.createObjectURL(blobTemp);
//             setAudioUrlTemp(audioUrlTemp);
//             // Prepare the form data
//             const formDataTemp = new FormData();
//             formDataTemp.append('audio_file', base64AudioTemp);
//             formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
//             // Call the API
//             try {
//               const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//                 method: 'POST',
//                 body: formDataTemp,
//               });
//               const resultTemp = await responseTemp.json();
//               console.log('API Response:', resultTemp.response);
//               setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//               setAudioToText(resultTemp.response);
//               if (resultTemp.response.length > 0) {
//                 setCheckAudio(false);
//               }
//             } catch (error) {
//               console.error('Error calling the API:', error);
//               setApiResponseTemp(`Error: ${error.message}`);
//             }
//           };
//         };
//         mediaRecorderRefTemp.current.start();
//         setIsRecordingTemp(true);
//       } catch (error) {
//         console.error('Error accessing microphone: ', error);
//       }
//     } else {
//       // Stop the recording
//       mediaRecorderRefTemp.current.stop();
//       mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//       setIsRecordingTemp(false);
//     }
//   };
//   // Helper function to check if the user is on iOS
//   const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
// const handleInputSearch=(e)=>{
//   e.stopPropagation()
// }
//   return (
//     <>
//       {
//         !showChatBot ?
//           <div className="videochartvalue ">
//             <div className='container'>
//               <div className='headAndOutput'>
//                 <div className='chatHead'>
//                   <div className='headIcontext'>
//                     <div className='group-2'></div>
//                     <div className='iconHeadChat'>
//                       <img src="/img/chatAvatarIcon3.png" alt="Avatar" />
//                       <div className='headTextClass'>
//                         <div className="text-wrapper miniHead">Chat with</div>
//                         <div className="text-wrapper-2">AI Assistant</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className='headMinClose'>
//                     <div className='languagesDivBoth'>
//                       <div className='languagesDiv' onClick={handleAvatarToggle} ref={dropdownAvatarRef} >
//                         <div className='avatarNameImgClass'>
//                           {selectedAvatar.name}
//                         </div>
//                         <span className={`arrow ${showAvatar ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showAvatar && (
//                           <ul className='languageDropdown'>
//                             {avatarList
//                               .filter(avatar => avatar !== selectedAvatar)
//                               .map((avatar, index) => (
//                                 <li key={index} onClick={() => handleAvatarSelect(avatar)} className='avatarNameImgClass'>
//                                   {avatar.name}
//                                 </li>
//                               ))}
//                           </ul>
//                         )}
//                       </div>
//                       <div ref={dropdownLanguageRef} className='languagesDiv' onClick={handleLanguageToggle}>
//                         {selectedLanguage}
//                         <span className={`arrow ${showLanguages ? 'open' : ''}`}>
//                           <img src={arrowDown} alt="" className='downArrowClass' />
//                         </span>
//                         {showLanguages && (
//                           <ul className='languageDropdown'>
//                             <input
//                               ref={searchInputRef}
//                               type="text"
//                               value={searchTerm}
//                               onChange={handleSearchChange}
//                               onKeyDown={handleKeyDown}
//                               onClick={handleInputSearch}
//                               placeholder="Search"
//                               className='searchLanguageInput'
//                             />
//                           </ul>
//                         )}
//                         {showLanguages && (
//                           <ul className='languageDropdown languageSearchDropdown'>
//                             {filteredLanguages.map((language, index) => (
//                               <li key={index} onClick={() => handleLanguageSelect(language)} className='languageOption'>
//                                 <p>
//                                   {language.language}
//                                 </p>
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div>
//                     </div>
//                     <div className=' speakerIconButton' >
//                       {isSoundOn ? (
//                         <img src={chatSoundIconWhite} alt="Speaker" onClick={toggleSound} />
//                       ) : (
//                         <img src={chatSpeakerMuteIcon} alt="Speaker" onClick={toggleSound} />
//                       )}
//                       {/* <img src="/img/minimizeChatWhite.png" alt="Line" onClick={handleChatBotOpen} /> */}
//                       <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={handleChatBotOpen} />
//                     </div>
//                   </div>
//                 </div>
//                 <div id="output-container">
//                   <div className="messages-container">
//                     {
//                       showWelcomeMsg ?
//                         <div className='message-item receiver'>
//                           <div className='senderIconText'>
//                             <div className='message'>
//                               <div className="chat-bubble">
//                                 <div className="typing">
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                   <div className="dot"></div>
//                                 </div>
//                               </div>
//                             </div>
//                             <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           </div>
//                         </div>
//                         :
//                         <div className='receiverIconText'>
//                           <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                           <div className="success-status">
//                             {welcomeApiMsg}
//                           </div>
//                         </div>
//                     }
//                     {messages.map((item, index) => (
//                       <div key={index} className={`message-item ${item.type === 'user' ? 'sender' : 'receiver'}`}>
//                         <div className='senderIconText'>
//                           <div className="message">
//                             {
//                               item.audioUrl ?
//                                 recordMessage && index === recentBotIndex ? (
//                                   <div className="chat-bubble-audio">
//                                     <div className="typing">
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                       <div className="dot"></div>
//                                     </div>
//                                   </div>
//                                 )
//                                   : (
//                                     <p>{item.audioUrl}</p>
//                                   )
//                                 :
//                                 //  (
//                                 //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
//                                 //     <div className="chat-bubble">
//                                 //       <div className="typing">
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //         <div className="dot"></div>
//                                 //       </div>
//                                 //     </div>
//                                 //   ) : (
//                                 //     <p>{item.message}</p>
//                                 //   )
//                                 // )
//                                 <p>{item.message}</p>
//                             }
//                           </div>
//                           {item.type === 'user' && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
//                           {item.type === 'bot' && <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />}
//                         </div>
//                         <div ref={messagesEndRef} /> {/* Auto-scroll target */}
//                       </div>
//                     ))}
//                     {/* {recordMessage ?
//                     <div className="senderIconText">
//                       <div className="message">
//                         <div className="typing">
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                         </div>
//                       </div>
//                       <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />
//                     </div>
//                     : ""} */}
//                     <div ref={messagesEndRef} />
//                   </div>
//                   <div className="hello-container" >
//                     {showWelcomeVideo && welcomeApiVideo ? (
//                       <video
//                         ref={videoRef}
//                         width="100%"
//                         autoPlay
//                         muted={!isSoundOn}
//                         onEnded={handleWelcomeVideoEnd}
//                         playsInline
//                       >
//                         <source src={welcomeApiVideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     ) : (
//                       <div>
//                         {!isApiCalled || !videoUrl ? (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             loop
//                             muted
//                             playsInline
//                           >
//                             <source src={staticApiVideo} type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         ) : (
//                           <video
//                             ref={videoRef}
//                             width="100%"
//                             autoPlay
//                             // muted={!isSoundOn}
//                             onEnded={handleVideoEnd}
//                             muted
//                             playsInline
//                           >
//                             <source
//                               src={videoUrl}
//                               type="video/mp4" />
//                             Your browser does not support the video tag.
//                           </video>
//                         )}
//                       </div>
//                     )}
//                     {/* <video
//                       ref={videoRef}
//                       width="100%"
//                     height="auto"
//                     objectFit="cover" 
//                       autoPlay
//                       muted={showWelcomeVideo && welcomeApiVideo ? !isSoundOn : true} 
//                       loop={!showWelcomeVideo && (!isApiCalled || !videoUrl)} 
//                       onEnded={showWelcomeVideo && welcomeApiVideo ? handleWelcomeVideoEnd : handleVideoEnd} 
//                       playsInline
//                     >
//                       <source
//                         src={
//                           showWelcomeVideo && welcomeApiVideo
//                             ? welcomeApiVideo 
//                             : !isApiCalled || !videoUrl
//                               ? staticApiVideo 
//                               : videoUrl 
//                         }
//                         type="video/mp4"
//                       />
//                       Your browser does not support the video tag.
//                     </video> */}
//                   </div>
//                 </div>
//               </div>
//               <div className='outputHelpfulClass'>
//                 <div className="input-container">
//                   <input
//                     type="text"
//                     value={inputValue}
//                     onChange={(e) => setInputValue(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     placeholder="Enter your message"
//                     disabled={loading || recording}
//                     ref={inputRef}
//                   />
//                   {/* {recording ? ( */}
//                   {isRecordingTemp ? (
//                     <div className="recording-indicator">
//                       <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
//                         <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
//                       <img src="/img/chatMicIcon.png" alt="Mic" />
//                     </div>
//                   )}
//                   <div className='iconButton' onClick={handleSendMessage} disabled={loading || recording}>
//                     <img src="/img/chatSendIcon.png" alt="Send" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           :
//           <div className='chatBoxImageClass' >
//             <img src={chatBoxImage} alt="" onClick={handleChatBotOpen} />
//           </div>
//       }
//     </>
//   );
// };
// export default NoEnglishAudio;
// working for english video to play instead of sound and playing static video after english video 
// import React, { useState, useRef, useEffect } from 'react';
// import Picker from 'emoji-picker-react';
// import './frameNew.css';
// import chatBoxImage from '../../../static/img/chatBoxImageCrop1.png'
// import arrowDown from '../../../static/img/arrowDownConvert.png'
// import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
// import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
// import { useFetcher, useLocation, useParams } from 'react-router-dom';
// const NoEnglishAudio = () => {
//     // const avatarList = [
//     //   { name: 'Shweta', image: '/img/avatar/woman.png' },
//     //   { name: 'Jensey', image: '/img/avatar/avatarAman.svg' },
//     //   { name: 'Aman', image: '/img/avatar/man.png' },
//     //   { name: 'Salman', image: '/img/avatar/avatarAman.svg' },
//     //   { name: 'Alex', image: '/img/avatar/man.png' },
//     //   { name: 'Dharmesh', image: '/img/avatar/woman.png' },
//     // ];
//     const languages = [
//         {
//             "language": "Afrikaans",
//             "code": "af"
//         },
//         {
//             "language": "Albanian",
//             "code": "sq"
//         },
//         {
//             "language": "Amharic",
//             "code": "am"
//         },
//         {
//             "language": "Arabic",
//             "code": "ar"
//         },
//         {
//             "language": "Armenian",
//             "code": "hy"
//         },
//         {
//             "language": "Azerbaijani",
//             "code": "az"
//         },
//         {
//             "language": "Basque",
//             "code": "eu"
//         },
//         {
//             "language": "Belarusian",
//             "code": "be"
//         },
//         {
//             "language": "Bengali",
//             "code": "bn"
//         },
//         {
//             "language": "Bosnian",
//             "code": "bs"
//         },
//         {
//             "language": "Bulgarian",
//             "code": "bg"
//         },
//         {
//             "language": "Catalan",
//             "code": "ca"
//         },
//         {
//             "language": "Cebuano",
//             "code": "ceb"
//         },
//         {
//             "language": "Chinese (Simplified)",
//             "code": "zh-CN"
//         },
//         {
//             "language": "Chinese (Traditional)",
//             "code": "zh-TW"
//         },
//         {
//             "language": "Corsican",
//             "code": "co"
//         },
//         {
//             "language": "Croatian",
//             "code": "hr"
//         },
//         {
//             "language": "Czech",
//             "code": "cs"
//         },
//         {
//             "language": "Danish",
//             "code": "da"
//         },
//         {
//             "language": "Dutch",
//             "code": "nl"
//         },
//         {
//             "language": "English",
//             "code": "en"
//         },
//         {
//             "language": "Esperanto",
//             "code": "eo"
//         },
//         {
//             "language": "Estonian",
//             "code": "et"
//         },
//         {
//             "language": "Finnish",
//             "code": "fi"
//         },
//         {
//             "language": "French",
//             "code": "fr"
//         },
//         {
//             "language": "Frisian",
//             "code": "fy"
//         },
//         {
//             "language": "Galician",
//             "code": "gl"
//         },
//         {
//             "language": "Georgian",
//             "code": "ka"
//         },
//         {
//             "language": "German",
//             "code": "de"
//         },
//         {
//             "language": "Greek",
//             "code": "el"
//         },
//         {
//             "language": "Gujarati",
//             "code": "gu"
//         },
//         {
//             "language": "Haitian Creole",
//             "code": "ht"
//         },
//         {
//             "language": "Hausa",
//             "code": "ha"
//         },
//         {
//             "language": "Hawaiian",
//             "code": "haw"
//         },
//         {
//             "language": "Hebrew",
//             "code": "iw"
//         },
//         {
//             "language": "Hindi",
//             "code": "hi"
//         },
//         {
//             "language": "Hmong",
//             "code": "hmn"
//         },
//         {
//             "language": "Hungarian",
//             "code": "hu"
//         },
//         {
//             "language": "Icelandic",
//             "code": "is"
//         },
//         {
//             "language": "Igbo",
//             "code": "ig"
//         },
//         {
//             "language": "Indonesian",
//             "code": "id"
//         },
//         {
//             "language": "Irish",
//             "code": "ga"
//         },
//         {
//             "language": "Italian",
//             "code": "it"
//         },
//         {
//             "language": "Japanese",
//             "code": "ja"
//         },
//         {
//             "language": "Javanese",
//             "code": "jw"
//         },
//         {
//             "language": "Kannada",
//             "code": "kn"
//         },
//         {
//             "language": "Kazakh",
//             "code": "kk"
//         },
//         {
//             "language": "Khmer",
//             "code": "km"
//         },
//         {
//             "language": "Korean",
//             "code": "ko"
//         },
//         {
//             "language": "Kurdish",
//             "code": "ku"
//         },
//         {
//             "language": "Kyrgyz",
//             "code": "ky"
//         },
//         {
//             "language": "Lao",
//             "code": "lo"
//         },
//         {
//             "language": "Latin",
//             "code": "la"
//         },
//         {
//             "language": "Latvian",
//             "code": "lv"
//         },
//         {
//             "language": "Lithuanian",
//             "code": "lt"
//         },
//         {
//             "language": "Luxembourgish",
//             "code": "lb"
//         },
//         {
//             "language": "Macedonian",
//             "code": "mk"
//         },
//         {
//             "language": "Malagasy",
//             "code": "mg"
//         },
//         {
//             "language": "Malay",
//             "code": "ms"
//         },
//         {
//             "language": "Malayalam",
//             "code": "ml"
//         },
//         {
//             "language": "Maltese",
//             "code": "mt"
//         },
//         {
//             "language": "Maori",
//             "code": "mi"
//         },
//         {
//             "language": "Marathi",
//             "code": "mr"
//         },
//         {
//             "language": "Mongolian",
//             "code": "mn"
//         },
//         {
//             "language": "Myanmar (Burmese)",
//             "code": "my"
//         },
//         {
//             "language": "Nepali",
//             "code": "ne"
//         },
//         {
//             "language": "Norwegian",
//             "code": "no"
//         },
//         {
//             "language": "Nyanja (Chichewa)",
//             "code": "ny"
//         },
//         {
//             "language": "Pashto",
//             "code": "ps"
//         },
//         {
//             "language": "Persian",
//             "code": "fa"
//         },
//         {
//             "language": "Polish",
//             "code": "pl"
//         },
//         {
//             "language": "Portuguese (Portugal, Brazil)",
//             "code": "pt"
//         },
//         {
//             "language": "Punjabi",
//             "code": "pa"
//         },
//         {
//             "language": "Romanian",
//             "code": "ro"
//         },
//         {
//             "language": "Russian",
//             "code": "ru"
//         },
//         {
//             "language": "Samoan",
//             "code": "sm"
//         },
//         {
//             "language": "Scots Gaelic",
//             "code": "gd"
//         },
//         {
//             "language": "Serbian",
//             "code": "sr"
//         },
//         {
//             "language": "Sesotho",
//             "code": "st"
//         },
//         {
//             "language": "Shona",
//             "code": "sn"
//         },
//         {
//             "language": "Sindhi",
//             "code": "sd"
//         },
//         {
//             "language": "Sinhala (Sinhalese)",
//             "code": "si"
//         },
//         {
//             "language": "Slovak",
//             "code": "sk"
//         },
//         {
//             "language": "Slovenian",
//             "code": "sl"
//         },
//         {
//             "language": "Somali",
//             "code": "so"
//         },
//         {
//             "language": "Spanish",
//             "code": "es"
//         },
//         {
//             "language": "Sundanese",
//             "code": "su"
//         },
//         {
//             "language": "Swahili",
//             "code": "sw"
//         },
//         {
//             "language": "Swedish",
//             "code": "sv"
//         },
//         {
//             "language": "Tagalog (Filipino)",
//             "code": "tl"
//         },
//         {
//             "language": "Tajik",
//             "code": "tg"
//         },
//         {
//             "language": "Tamil",
//             "code": "ta"
//         },
//         {
//             "language": "Telugu",
//             "code": "te"
//         },
//         {
//             "language": "Thai",
//             "code": "th"
//         },
//         {
//             "language": "Turkish",
//             "code": "tr"
//         },
//         {
//             "language": "Ukrainian",
//             "code": "uk"
//         },
//         {
//             "language": "Urdu",
//             "code": "ur"
//         },
//         {
//             "language": "Uzbek",
//             "code": "uz"
//         },
//         {
//             "language": "Vietnamese",
//             "code": "vi"
//         },
//         {
//             "language": "Welsh",
//             "code": "cy"
//         },
//         {
//             "language": "Xhosa",
//             "code": "xh"
//         },
//         {
//             "language": "Yiddish",
//             "code": "yi"
//         },
//         {
//             "language": "Yoruba",
//             "code": "yo"
//         },
//         {
//             "language": "Zulu",
//             "code": "zu"
//         }
//     ]
//     const [inputValue, setInputValue] = useState('');
//     const [welcomeApiMsg, setWelcomeApiMsg] = useState('');
//     const [staticApiVideo, setStaticApiVideo] = useState('');
//     const [welcomeApiVideo, setWelcomeApiVideo] = useState('');
//     const [messages, setMessages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [videoUrl, setVideoUrl] = useState('');
//     const [audioToText, setAudioToText] = useState('');
//     const [recording, setRecording] = useState(false);
//     const [audioBlob, setAudioBlob] = useState(null);
//     const [timer, setTimer] = useState(0);
//     const [isSoundOn, setIsSoundOn] = useState(true);
//     const [videoLoading, setVideoLoading] = useState(true);
//     const [showChatBot, setShowChatBot] = useState(false);
//     const [recordMessage, setRecordMessage] = useState(false);
//     const [isApiCalled, setIsApiCalled] = useState(false);
//     const videoRef = useRef(null);
//     const mediaRecorderRef = useRef(null);
//     const audioChunksRef = useRef([]);
//     const timerRef = useRef(null);
//     const chatHeadRef = useRef(null);
//     const messagesEndRef = useRef(null); // Ref for the autoscroll
//     const inputRef = useRef(null);
//     const dropdownAvatarRef = useRef(null);
//     const dropdownLanguageRef = useRef(null);
//     const searchInputRef = useRef(null);
//     const [showInitialText, setShowInitialText] = useState(true);
//     const [recentBotIndex, setRecentBotIndex] = useState(null);
//     const [showWelcomeMsg, setShowWelcomeMsg] = useState(false);
//     const [checkAudio, setCheckAudio] = useState(false);
//     const [showWelcomeVideo, setShowWelcomeVideo] = useState(true);
//     const [showLanguages, setShowLanguages] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filteredLanguages, setFilteredLanguages] = useState(languages);
//     const [showAvatar, setShowAvatar] = useState(false);
//     const [selectedLanguage, setSelectedLanguage] = useState('English');
//     const [languageCode, setLanguageCode] = useState('en');
//     const [isRecordingTemp, setIsRecordingTemp] = useState(false);
//     const [audioUrlTemp, setAudioUrlTemp] = useState(null);
//     const [apiResponseTemp, setApiResponseTemp] = useState('');
//     const mediaRecorderRefTemp = useRef(null);
//     const recordedChunksRefTemp = useRef([]);
//     const mediaStreamRefTemp = useRef(null);
//     const audioRef = useRef(null);
//     const audioConstraintsTemp = {
//         audio: {
//             sampleRate: 16000,
//             channelCount: 1,
//             echoCancellation: false,
//             noiseSuppression: false,
//             autoGainControl: false,
//         },
//     };
//     // taking params from parent app and passing in iframe api
//     // const [params, setParams] = useState({
//     //   companyName: '',
//     //   moduleName: '',
//     //   avatarName: ''
//     // });
//     // useEffect(() => {
//     //   const receiveMessage = (event) => {
//     //     const { companyName, moduleName, avatarName } = event.data;
//     //     setParams({ companyName, moduleName, avatarName });
//     //   };
//     //   window.addEventListener('message', receiveMessage, false);
//     //   return () => {
//     //     window.removeEventListener('message', receiveMessage);
//     //   };
//     // }, []);
//     // taking params from iframe url only and passing in iframe api
//     const params = useLocation();
//     const pathSegments = params.pathname.split('/').filter(segment => segment);
//     const companyName = pathSegments[pathSegments.length - 3];
//     const moduleName = pathSegments[pathSegments.length - 2];
//     const avatarName = pathSegments[pathSegments.length - 1];
//     const avatarList = [
//         { name: 'Natasha', image: 'image1.png' },
//         // { name: 'Avatar2', image: 'image2.png' },
//     ];
//     const defaultAvatar = avatarList[0];
//     const [selectedAvatar, setSelectedAvatar] = useState({
//         name: defaultAvatar.name,
//         image: defaultAvatar.image,
//     });
//     useEffect(() => {
//         if (avatarName) {
//             const foundAvatar = avatarList.find(avatar => avatar.name.toLowerCase() === avatarName.toLowerCase());
//             if (foundAvatar) {
//                 setSelectedAvatar({
//                     name: foundAvatar.name,
//                     image: foundAvatar.image,
//                 });
//             } else {
//                 setSelectedAvatar(defaultAvatar);
//             }
//         } else {
//             setSelectedAvatar(defaultAvatar);
//         }
//     }, [avatarName]);
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) {
//                 setShowAvatar(false);
//             }
//         };
//         if (showAvatar) {
//             document.addEventListener('mousedown', handleClickOutside);
//         }
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showAvatar]);
//     const handleAvatarToggle = () => {
//         setShowAvatar(!showAvatar);
//     };
//     const handleLanguageToggle = () => {
//         setShowLanguages(!showLanguages);
//         if (!showLanguages) {
//             setFilteredLanguages(languages);
//             setSearchTerm('');
//         }
//     };
//     const handleLanguageSelect = (language) => {
//         setSelectedLanguage(language.language);
//         setSearchTerm('');
//         setFilteredLanguages(languages);
//         setShowLanguages(false);
//         setLanguageCode(language.code)
//     };
//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//         const filtered = languages.filter((language) =>
//             language.language.toLowerCase().includes(event.target.value.toLowerCase())
//         );
//         setFilteredLanguages(filtered);
//     };
//     useEffect(() => {
//         if (showLanguages) {
//             searchInputRef.current.focus();
//         }
//     }, [showLanguages]);
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) {
//                 setShowLanguages(false);
//             }
//         };
//         if (showLanguages) {
//             document.addEventListener('mousedown', handleClickOutside);
//         }
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showLanguages]);
//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter' && filteredLanguages.length > 0) {
//             handleLanguageSelect(filteredLanguages[0]);
//         }
//     };
//     const handleAvatarSelect = (avatar) => {
//         setSelectedAvatar(avatar);
//         setShowAvatar(false);
//     };
//     const handleWelcomeVideoEnd = () => {
//         setShowWelcomeVideo(false);
//     };
//     useEffect(() => {
//         const showTimeout = setTimeout(() => {
//             setShowWelcomeMsg(true);
//         }, 1);
//         const hideTimeout = setTimeout(() => {
//             setShowWelcomeMsg(false);
//         }, 3000);
//         return () => {
//             clearTimeout(showTimeout);
//             clearTimeout(hideTimeout);
//         };
//     }, []);
//     useEffect(() => {
//         const callApiOnPageLoad = async () => {
//             const payload = { user_input: 'hi' };
//             try {
//                 const response = await fetch(
//                     `https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`,
//                     {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(payload),
//                     }
//                 );
//                 if (response.ok) {
//                     const data = await response.json();
//                     setWelcomeApiMsg(data.responses[0])
//                     setStaticApiVideo(data.static_video)
//                     setWelcomeApiVideo(data.video_path)
//                 } else {
//                     console.error('API error:', response.statusText);
//                 }
//             } catch (error) {
//                 console.error('Fetch error:', error);
//             }
//         };
//         callApiOnPageLoad();
//     }, [companyName, moduleName, selectedAvatar]);
//     useEffect(() => {
//         const latestBotIndex = messages
//             .map((item, index) => (item.type === 'bot' ? index : null))
//             .filter(index => index !== null)
//             .pop();
//         if (latestBotIndex !== null) {
//             setRecentBotIndex(latestBotIndex);
//             // const timer = setTimeout(() => {
//             //   setShowInitialText(false);
//             // }, 1300);
//             setShowInitialText(true);
//             // return () => clearTimeout(timer);
//         }
//     }, [messages]);
//     const handleKeyPress = (event) => {
//         if (event.key === 'Enter') {
//             handleSendMessage();
//         }
//     };
//     const handleSendMessage = async () => {
//         setInputValue(''); // Clear the input field at the start
//         if (inputValue.trim() || audioToText) {
//             setLoading(true);
//             setIsApiCalled(true);
//             const userMessage = {
//                 message: audioToText || inputValue.trim() || '',
//                 type: 'user',
//                 audioUrl: audioToText,
//                 isActive: true,
//             };
//             setMessages((prevMessages) => [...prevMessages, userMessage]);
//             const payload = {
//                 user_input: audioToText ? audioToText : inputValue.trim() || '',
//                 lang: languageCode,
//                 companyName: companyName,
//                 moduleName: moduleName,
//                 avatarName: selectedAvatar.name,
//             };
//             if (messagesEndRef.current) {
//                 messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//             }
//             try {
//                 const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify(payload),
//                 });
//                 const data = await response.json();
//                 setAudioToText('');
//                 setAudioBlob(null);
//                 setTimer(0);
//                 handleResponse(data); // Call handleResponse to play audio and video
//                 if (messagesEndRef.current) {
//                     messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//                 }
//             } catch (error) {
//                 console.error('Error:', error);
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };
//     // const handleResponse = (data) => {
//     //   // Check if there are bot responses
//     //   if (data.responses && data.responses.length > 0) {
//     //     const botMessage = data.responses.join(' ');
//     //     setMessages((prevMessages) => [
//     //       ...prevMessages,
//     //       {
//     //         message: botMessage,
//     //         type: 'bot',
//     //       },
//     //     ]);
//     //   } else {
//     //     setMessages((prevMessages) => [
//     //       ...prevMessages,
//     //       {
//     //         message: "Could you please repeat?",
//     //         type: 'bot',
//     //       },
//     //     ]);
//     //   }
//     //   // Check if there is a video path in the response
//     //   if (data.video_path) {
//     //     const fullVideoUrl = data.video_path;
//     //     setVideoUrl(fullVideoUrl);
//     //     // If there is audio data in base64 format, handle the audio
//     //     if (data.audio_data) {
//     //       // Convert the base64 audio data to a Blob
//     //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
//     //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
//     //       // Create audio and video elements
//     //       const videoElement = document.createElement('video');
//     //       videoElement.src = fullVideoUrl;
//     //       videoElement.controls = true;
//     //       videoElement.autoplay = true;
//     //       videoElement.muted = true; // Mute the video to avoid overlapping sound
//     //       const audioElement = document.createElement('audio');
//     //       audioElement.src = audioUrl;
//     //       audioElement.autoplay = true;
//     //       // const audioElement = new Audio(audioUrl);
//     //     audioRef.current = audioElement; 
//     //       // Sync the audio and video playback
//     //       videoElement.addEventListener('play', () => {
//     //         audioElement.play();
//     //       });
//     //       videoElement.addEventListener('pause', () => {
//     //         audioElement.pause();
//     //       });
//     //       // Append the video element to a container (assuming there is a container for the video)
//     //       const videoContainer = document.getElementById('video-container');
//     //       videoContainer.innerHTML = ''; // Clear any previous video
//     //       videoContainer.appendChild(videoElement);
//     //     } else {
//     //       console.log('No audio data received.');
//     //     }
//     //   } else {
//     //     setVideoUrl(''); // Clear the video if no path is provided
//     //   }
//     // };
//     // Utility function to convert base64 to Blob
//     useEffect(() => {
//         // Play the video whenever the videoUrl changes
//         if (videoUrl && videoRef.current) {
//             videoRef.current.src = videoUrl;
//             videoRef.current.load(); // Ensure video loads correctly
//             videoRef.current.play(); // Play the video
//         }
//     }, [videoUrl]); // Add videoUrl to the dependency array to track changes
//     const handleResponse = (data) => {
//         // Handle bot messages
//         if (data.responses && data.responses.length > 0) {
//           const botMessage = data.responses.join(' ');
//           setMessages((prevMessages) => [
//             ...prevMessages,
//             { message: botMessage, type: 'bot' },
//           ]);
//         } else {
//           setMessages((prevMessages) => [
//             ...prevMessages,
//             { message: "Could you please repeat?", type: 'bot' },
//           ]);
//         }
//         // Handle video from API
//         if (data.video_path) {
//           const fullVideoUrl = data.video_path;
//           setVideoUrl(fullVideoUrl); // Set the new video URL
//           // Stop any previous audio before handling the new response
//           if (audioRef.current) {
//             audioRef.current.pause();
//             audioRef.current.currentTime = 0; // Reset previous audio
//           }
//           if (languageCode === 'en') {
//             // For English language, play the video sound and switch to static video when it ends
//             if (videoRef.current) {
//               videoRef.current.src = fullVideoUrl;
//               videoRef.current.muted = !isSoundOn; // Set mute based on toggle state
//               videoRef.current.play();
//               // Remove any previous 'ended' event listeners
//               videoRef.current.removeEventListener('ended', playStaticVideo);
//               // Add 'ended' event listener to play static video after API video ends
//               videoRef.current.addEventListener('ended', playStaticVideo);
//             }
//           } else if (data.audio_data) {
//             // For non-English languages, mute the video and play the audio key
//             if (videoRef.current) {
//               videoRef.current.src = fullVideoUrl;
//               videoRef.current.muted = true; // Mute the video sound for other languages
//               videoRef.current.play();
//               // Remove any previous 'ended' event listeners
//               videoRef.current.removeEventListener('ended', playStaticVideo);
//               // Add 'ended' event listener to play static video after API video ends
//               videoRef.current.addEventListener('ended', playStaticVideo);
//             }
//             // Handle API-provided audio key
//             const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3');
//             const audioUrl = URL.createObjectURL(audioBlob);
//             const audioElement = new Audio(audioUrl);
//             audioRef.current = audioElement;
//             // Play API audio key only if sound is turned on
//             if (isSoundOn) {
//               audioElement.play();
//             }
//             // Handle audio end event
//             audioElement.addEventListener('ended', () => {
//               if (videoRef.current) {
//                 videoRef.current.pause();
//                 playStaticVideo(); // Play static video after API video finishes
//               }
//             });
//           }
//         } else {
//           setVideoUrl(''); // Clear the video if no path is provided
//         }
//       };
//     // Function to toggle sound for both video and audio
//     const toggleSound = () => {
//         if (languageCode === 'en') {
//           // If the language is English, control only the video sound
//           if (videoRef.current) {
//             videoRef.current.muted = isSoundOn; // Toggle video sound (no restart)
//           }
//         } else {
//           // If the language is not English, control the API audio key
//           if (audioRef.current) {
//             audioRef.current.muted = isSoundOn; // Toggle API audio key sound (no restart)
//           }
//         }
//         setIsSoundOn(!isSoundOn); // Toggle the sound state
//       };
//     // Function to play the static video
//     const playStaticVideo = () => {
//         if (videoRef.current) {
//           videoRef.current.src = staticApiVideo; // Set the static video source
//           videoRef.current.muted = true; // Ensure the static video is muted
//           videoRef.current.play(); // Play the static video
//         }
//       };
//     const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
//         const byteCharacters = atob(base64Data);
//         const byteArrays = [];
//         for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//             const slice = byteCharacters.slice(offset, offset + sliceSize);
//             const byteNumbers = new Array(slice.length);
//             for (let i = 0; i < slice.length; i++) {
//                 byteNumbers[i] = slice.charCodeAt(i);
//             }
//             const byteArray = new Uint8Array(byteNumbers);
//             byteArrays.push(byteArray);
//         }
//         return new Blob(byteArrays, { type: contentType });
//     };
//     useEffect(() => {
//         if (videoUrl) {
//             setVideoLoading(true);
//             const video = videoRef.current;
//             if (video) {
//                 video.onloadeddata = () => {
//                     setVideoLoading(false);
//                     video.onended = () => {
//                         setVideoUrl('');
//                     };
//                 };
//             }
//         }
//     }, [videoUrl]);
//     // useEffect(() => {
//     //   if (!loading && !recording) {
//     //     inputRef.current?.focus();
//     //   }
//     //   if (showWelcomeVideo) {
//     //     inputRef.current?.focus();
//     //   }
//     // }, [loading, recording, inputValue, messages]);
//     // recording check 
//     // const startRecording = async () => {
//     //   setRecording(true);
//     //   setRecordMessage(false)
//     //   setTimer(0);
//     //   audioChunksRef.current = [];
//     //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//     //   mediaRecorderRef.current = new MediaRecorder(stream);
//     //   mediaRecorderRef.current.ondataavailable = (event) => {
//     //     if (event.data.size > 0) {
//     //       audioChunksRef.current.push(event.data);
//     //     }
//     //   };
//     //   mediaRecorderRef.current.onstop = () => {
//     //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//     //     setAudioBlob(blob);
//     //   };
//     //   mediaRecorderRef.current.start();
//     //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
//     // };
//     // const stopRecording = () => {
//     //   setRecordMessage(true)
//     //   setRecording(false);
//     //   if (mediaRecorderRef.current) {
//     //     mediaRecorderRef.current.stop();
//     //   }
//     //   clearInterval(timerRef.current);
//     // };
//     useEffect(() => {
//         if (audioBlob) {
//             sendAudioToApi(audioBlob);
//         }
//     }, [audioBlob]);
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setRecordMessage(false);
//         }, 3000);
//         return () => clearTimeout(timer);
//     }, [recordMessage]);
//     // const sendAudioToApi = async (blob) => {
//     //   try {
//     //     const base64Audio = await convertBlobToBase64(blob);
//     //     const fileExtension = blob.type.split('/')[1];
//     //     const formData = new FormData();
//     //     formData.append('audio_file', base64Audio.split(',')[1]);
//     //     formData.append('file_extension', fileExtension);
//     //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//     //       method: 'POST',
//     //       body: formData
//     //     });
//     //     const data = await response.json();
//     //     setAudioToText(data.response)
//     //     if (data.response.length > 0) {
//     //       setCheckAudio(false)
//     //     }
//     //     // if (data.response) {
//     //     //   setTimeout(() => {
//     //     //     setRecordMessage(false)
//     //     //     }, 880);
//     //     //   // }, 6200);
//     //     // }
//     //   } catch (error) {
//     //     console.error('Error sending audio:', error);
//     //   }
//     //   finally {
//     //     setCheckAudio(true)
//     //   }
//     // };
//     const convertBlobToBase64 = (blob) => {
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result);
//             reader.onerror = reject;
//             reader.readAsDataURL(blob);
//         });
//     };
//     useEffect(() => {
//         if (videoRef.current) {
//             setVideoLoading(true);
//             videoRef.current.load();
//             videoRef.current.play().finally(() => {
//                 setVideoLoading(false);
//             });
//         }
//     }, [videoUrl]);
//     //   const toggleSound = () => {
//     //     if (audioRef.current) {
//     //       audioRef.current.muted = isSoundOn;
//     //       setIsSoundOn(!isSoundOn);
//     //     }
//     //   };
//     // const toggleSound = () => {
//     //   if (videoRef.current && audioRef.current) {
//     //     if (isSoundOn) {
//     //       // Mute both video and external audio
//     //       videoRef.current.muted = true;
//     //       audioRef.current.muted = true; // Mute external audio
//     //     } else {
//     //       // Unmute both video and external audio
//     //       videoRef.current.muted = false;
//     //       audioRef.current.muted = false; // Unmute external audio
//     //     }
//     //     // Toggle sound state
//     //     setIsSoundOn(!isSoundOn);
//     //   }
//     // };
//     const handleChatBotOpen = () => {
//         setShowChatBot(!showChatBot);
//     };
//     useEffect(() => {
//         setShowChatBot(true);
//     }, []);
//     useEffect(() => {
//         handleSendMessage()
//     }, [audioToText])
//     const handleVideoEnd = () => {
//         setVideoUrl(staticApiVideo)
//     }
//     useEffect(() => {
//         if (messagesEndRef.current) {
//             setTimeout(() => {
//                 if (messagesEndRef.current) {
//                     messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//                 }
//             }, 500);
//         }
//     }, [messages, showChatBot]);
//     // audio functionality for android
//     // const sendAudioToApi = async () => {
//     //   if (!isRecordingTemp) {
//     //     try {
//     //       mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//     //       mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType: 'audio/webm' });
//     //       mediaRecorderRefTemp.current.ondataavailable = (event) => {
//     //         if (event.data.size > 0) {
//     //           recordedChunksRefTemp.current.push(event.data);
//     //         }
//     //       };
//     //       mediaRecorderRefTemp.current.onstop = async () => {
//     //         const blobTemp = new Blob(recordedChunksRefTemp.current, { type: 'audio/webm' });
//     //         recordedChunksRefTemp.current = [];
//     //         // Convert blob to Base64
//     //         const readerTemp = new FileReader();
//     //         readerTemp.readAsDataURL(blobTemp);
//     //         readerTemp.onloadend = async () => {
//     //           const base64AudioTemp = readerTemp.result.split(',')[1];
//     //           // Display audio for playback
//     //           const audioUrlTemp = URL.createObjectURL(blobTemp);
//     //           setAudioUrlTemp(audioUrlTemp);
//     //           // Prepare the form data
//     //           const formDataTemp = new FormData();
//     //           formDataTemp.append('audio_file', base64AudioTemp);
//     //           formDataTemp.append('file_extension', 'webm');
//     //           // Call the API
//     //           try {
//     //             const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//     //               method: 'POST',
//     //               body: formDataTemp,
//     //             });
//     //             const resultTemp = await responseTemp.json();
//     //             console.log('pppppppppppp', resultTemp.response);
//     //             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//     //             setAudioToText(resultTemp.response)
//     //             if (resultTemp.response.length > 0) {
//     //               setCheckAudio(false)
//     //             }
//     //           } catch (error) {
//     //             console.error('Error calling the API:', error);
//     //             setApiResponseTemp(`Error: ${error.message}`);
//     //           }
//     //         };
//     //       };
//     //       mediaRecorderRefTemp.current.start();
//     //       setIsRecordingTemp(true);
//     //     } catch (error) {
//     //       console.error('Error accessing microphone: ', error);
//     //     }
//     //   } else {
//     //     // Stop the recording
//     //     mediaRecorderRefTemp.current.stop();
//     //     mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//     //     setIsRecordingTemp(false);
//     //   }
//     // };
//     // audio functionality for ios 
//     const sendAudioToApi = async () => {
//         if (!isRecordingTemp) {
//             try {
//                 mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
//                 // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
//                 const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
//                 mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
//                 mediaRecorderRefTemp.current.ondataavailable = (event) => {
//                     if (event.data.size > 0) {
//                         recordedChunksRefTemp.current.push(event.data);
//                     }
//                 };
//                 mediaRecorderRefTemp.current.onstop = async () => {
//                     const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
//                     recordedChunksRefTemp.current = [];
//                     // Convert blob to Base64
//                     const readerTemp = new FileReader();
//                     readerTemp.readAsDataURL(blobTemp);
//                     readerTemp.onloadend = async () => {
//                         const base64AudioTemp = readerTemp.result.split(',')[1];
//                         // Display audio for playback
//                         const audioUrlTemp = URL.createObjectURL(blobTemp);
//                         setAudioUrlTemp(audioUrlTemp);
//                         // Prepare the form data
//                         const formDataTemp = new FormData();
//                         formDataTemp.append('audio_file', base64AudioTemp);
//                         formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
//                         // Call the API
//                         try {
//                             // const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
//                                   const responseTemp = await fetch(`https://speech.pranathiss.com/api/vad-base64-speech-to-text/${selectedLanguage}/`, {
//                                 method: 'POST',
//                                 body: formDataTemp,
//                             });
//                             const resultTemp = await responseTemp.json();
//                             console.log('API Response:', resultTemp.response);
//                             setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
//                             setAudioToText(resultTemp.response);
//                             if (resultTemp.response.length > 0) {
//                                 setCheckAudio(false);
//                             }
//                         } catch (error) {
//                             console.error('Error calling the API:', error);
//                             setApiResponseTemp(`Error: ${error.message}`);
//                         }
//                     };
//                 };
//                 mediaRecorderRefTemp.current.start();
//                 setIsRecordingTemp(true);
//             } catch (error) {
//                 console.error('Error accessing microphone: ', error);
//             }
//         } else {
//             // Stop the recording
//             mediaRecorderRefTemp.current.stop();
//             mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
//             setIsRecordingTemp(false);
//         }
//     };
//     // Helper function to check if the user is on iOS
//     const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
//     const handleInputSearch = (e) => {
//         e.stopPropagation()
//     }
//     return (
//         <>
//             {
//                 !showChatBot ?
//                     <div className="videochartvalue ">
//                         <div className='container'>
//                             <div className='headAndOutput'>
//                                 <div className='chatHead'>
//                                     <div className='headIcontext'>
//                                         <div className='group-2'></div>
//                                         <div className='iconHeadChat'>
//                                             <img src="/img/chatAvatarIcon3.png" alt="Avatar" />
//                                             <div className='headTextClass'>
//                                                 <div className="text-wrapper miniHead">Chat with</div>
//                                                 <div className="text-wrapper-2">AI Assistant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className='headMinClose'>
//                                         <div className='languagesDivBoth'>
//                                             <div className='languagesDiv' onClick={handleAvatarToggle} ref={dropdownAvatarRef} >
//                                                 <div className='avatarNameImgClass'>
//                                                     {selectedAvatar.name}
//                                                 </div>
//                                                 <span className={`arrow ${showAvatar ? 'open' : ''}`}>
//                                                     <img src={arrowDown} alt="" className='downArrowClass' />
//                                                 </span>
//                                                 {showAvatar && (
//                                                     <ul className='languageDropdown'>
//                                                         {avatarList
//                                                             .filter(avatar => avatar !== selectedAvatar)
//                                                             .map((avatar, index) => (
//                                                                 <li key={index} onClick={() => handleAvatarSelect(avatar)} className='avatarNameImgClass'>
//                                                                     {avatar.name}
//                                                                 </li>
//                                                             ))}
//                                                     </ul>
//                                                 )}
//                                             </div>
//                                             <div ref={dropdownLanguageRef} className='languagesDiv' onClick={handleLanguageToggle}>
//                                                 {selectedLanguage}
//                                                 <span className={`arrow ${showLanguages ? 'open' : ''}`}>
//                                                     <img src={arrowDown} alt="" className='downArrowClass' />
//                                                 </span>
//                                                 {showLanguages && (
//                                                     <ul className='languageDropdown'>
//                                                         <input
//                                                             ref={searchInputRef}
//                                                             type="text"
//                                                             value={searchTerm}
//                                                             onChange={handleSearchChange}
//                                                             onKeyDown={handleKeyDown}
//                                                             onClick={handleInputSearch}
//                                                             placeholder="Search"
//                                                             className='searchLanguageInput'
//                                                         />
//                                                     </ul>
//                                                 )}
//                                                 {showLanguages && (
//                                                     <ul className='languageDropdown languageSearchDropdown'>
//                                                         {filteredLanguages.map((language, index) => (
//                                                             <li key={index} onClick={() => handleLanguageSelect(language)} className='languageOption'>
//                                                                 <p>
//                                                                     {language.language}
//                                                                 </p>
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className=' speakerIconButton' >
//                                             {isSoundOn ? (
//                                                 <img src={chatSoundIconWhite} alt="Speaker" onClick={toggleSound} />
//                                             ) : (
//                                                 <img src={chatSpeakerMuteIcon} alt="Speaker" onClick={toggleSound} />
//                                             )}
//                                             {/* <img src="/img/minimizeChatWhite.png" alt="Line" onClick={handleChatBotOpen} /> */}
//                                             <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={handleChatBotOpen} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div id="output-container">
//                                     <div className="messages-container">
//                                         {
//                                             showWelcomeMsg ?
//                                                 <div className='message-item receiver'>
//                                                     <div className='senderIconText'>
//                                                         <div className='message'>
//                                                             <div className="chat-bubble">
//                                                                 <div className="typing">
//                                                                     <div className="dot"></div>
//                                                                     <div className="dot"></div>
//                                                                     <div className="dot"></div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                         <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                                                     </div>
//                                                 </div>
//                                                 :
//                                                 <div className='receiverIconText'>
//                                                     <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />
//                                                     <div className="success-status">
//                                                         {welcomeApiMsg}
//                                                     </div>
//                                                 </div>
//                                         }
//                                         {messages.map((item, index) => (
//                                             <div key={index} className={`message-item ${item.type === 'user' ? 'sender' : 'receiver'}`}>
//                                                 <div className='senderIconText'>
//                                                     <div className="message">
//                                                         {
//                                                             item.audioUrl ?
//                                                                 recordMessage && index === recentBotIndex ? (
//                                                                     <div className="chat-bubble-audio">
//                                                                         <div className="typing">
//                                                                             <div className="dot"></div>
//                                                                             <div className="dot"></div>
//                                                                             <div className="dot"></div>
//                                                                         </div>
//                                                                     </div>
//                                                                 )
//                                                                     : (
//                                                                         <p>{item.audioUrl}</p>
//                                                                     )
//                                                                 :
//                                                                 //  (
//                                                                 //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
//                                                                 //     <div className="chat-bubble">
//                                                                 //       <div className="typing">
//                                                                 //         <div className="dot"></div>
//                                                                 //         <div className="dot"></div>
//                                                                 //         <div className="dot"></div>
//                                                                 //       </div>
//                                                                 //     </div>
//                                                                 //   ) : (
//                                                                 //     <p>{item.message}</p>
//                                                                 //   )
//                                                                 // )
//                                                                 <p>{item.message}</p>
//                                                         }
//                                                     </div>
//                                                     {item.type === 'user' && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
//                                                     {item.type === 'bot' && <img src="/img/chatAvatarIcon3.png" alt="Receiver Avatar" />}
//                                                 </div>
//                                                 <div ref={messagesEndRef} /> {/* Auto-scroll target */}
//                                             </div>
//                                         ))}
//                                         {/* {recordMessage ?
//                     <div className="senderIconText">
//                       <div className="message">
//                         <div className="typing">
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                           <div className="dot"></div>
//                         </div>
//                       </div>
//                       <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />
//                     </div>
//                     : ""} */}
//                                         <div ref={messagesEndRef} />
//                                     </div>
//                                     <div className="hello-container" >
//                                         {showWelcomeVideo && welcomeApiVideo ? (
//                                             <video
//                                                 ref={videoRef}
//                                                 width="100%"
//                                                 autoPlay
//                                                 muted={languageCode !== 'en' || !isSoundOn} // Mute video if language is not English or sound is off
//                                                 onEnded={handleWelcomeVideoEnd}
//                                                 playsInline
//                                             >
//                                                 <source src={welcomeApiVideo} type="video/mp4" />
//                                                 Your browser does not support the video tag.
//                                             </video>
//                                         ) : (
//                                             <div>
//                                                 {!isApiCalled || !videoUrl ? (
//                                                     <video
//                                                         ref={videoRef}
//                                                         width="100%"
//                                                         autoPlay
//                                                         loop
//                                                         muted
//                                                         playsInline
//                                                     >
//                                                         <source src={staticApiVideo} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 ) : (
//                                                     <video
//                                                         ref={videoRef}
//                                                         width="100%"
//                                                         autoPlay
//                                                         muted={languageCode === 'en' ? false : true} // Play sound only if language is English
//                                                         onEnded={handleVideoEnd}
//                                                         playsInline
//                                                     >
//                                                         <source src={videoUrl} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 )}
//                                             </div>
//                                         )}
//                                         {/* <video
//                       ref={videoRef}
//                       width="100%"
//                     height="auto"
//                     objectFit="cover" 
//                       autoPlay
//                       muted={showWelcomeVideo && welcomeApiVideo ? !isSoundOn : true} 
//                       loop={!showWelcomeVideo && (!isApiCalled || !videoUrl)} 
//                       onEnded={showWelcomeVideo && welcomeApiVideo ? handleWelcomeVideoEnd : handleVideoEnd} 
//                       playsInline
//                     >
//                       <source
//                         src={
//                           showWelcomeVideo && welcomeApiVideo
//                             ? welcomeApiVideo 
//                             : !isApiCalled || !videoUrl
//                               ? staticApiVideo 
//                               : videoUrl 
//                         }
//                         type="video/mp4"
//                       />
//                       Your browser does not support the video tag.
//                     </video> */}
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='outputHelpfulClass'>
//                                 <div className="input-container">
//                                     <input
//                                         type="text"
//                                         value={inputValue}
//                                         onChange={(e) => setInputValue(e.target.value)}
//                                         onKeyPress={handleKeyPress}
//                                         placeholder="Enter your message"
//                                         disabled={loading || recording}
//                                         ref={inputRef}
//                                     />
//                                     {/* {recording ? ( */}
//                                     {isRecordingTemp ? (
//                                         <div className="recording-indicator">
//                                             <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
//                                                 <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
//                                             <img src="/img/chatMicIcon.png" alt="Mic" />
//                                         </div>
//                                     )}
//                                     <div className='iconButton' onClick={handleSendMessage} disabled={loading || recording}>
//                                         <img src="/img/chatSendIcon.png" alt="Send" />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     :
//                     <div className='chatBoxImageClass' >
//                         <img src={chatBoxImage} alt="" onClick={handleChatBotOpen} />
//                     </div>
//             }
//         </>
//     );
// };
// export default NoEnglishAudio;
// working on sound off and on 
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emojiPickerReact = require("emoji-picker-react");
var _emojiPickerReactDefault = parcelHelpers.interopDefault(_emojiPickerReact);
var _frameNewCss = require("./frameNew.css");
// import './noAudioEnglish.css'
var _chatBoxImageCrop1Png = require("../../../static/img/chatBoxImageCrop1.png");
var _chatBoxImageCrop1PngDefault = parcelHelpers.interopDefault(_chatBoxImageCrop1Png);
var _arrowDownConvertPng = require("../../../static/img/arrowDownConvert.png");
var _arrowDownConvertPngDefault = parcelHelpers.interopDefault(_arrowDownConvertPng);
var _chatSoundSpeakerPng = require("../../../static/img/chatSoundSpeaker.png");
var _chatSoundSpeakerPngDefault = parcelHelpers.interopDefault(_chatSoundSpeakerPng);
var _chatMuteSpeakerPng = require("../../../static/img/chatMuteSpeaker.png");
var _chatMuteSpeakerPngDefault = parcelHelpers.interopDefault(_chatMuteSpeakerPng);
var _reactRouterDom = require("react-router-dom");
const NoAudioEnglish = ()=>{
    const languages = [
        {
            "language": "Afrikaans",
            "code": "af"
        },
        {
            "language": "Albanian",
            "code": "sq"
        },
        {
            "language": "Amharic",
            "code": "am"
        },
        {
            "language": "Arabic",
            "code": "ar"
        },
        {
            "language": "Armenian",
            "code": "hy"
        },
        {
            "language": "Azerbaijani",
            "code": "az"
        },
        {
            "language": "Basque",
            "code": "eu"
        },
        {
            "language": "Bengali",
            "code": "bn"
        },
        {
            "language": "Bosnian",
            "code": "bs"
        },
        {
            "language": "Bulgarian",
            "code": "bg"
        },
        {
            "language": "Catalan",
            "code": "ca"
        },
        {
            "language": "Chinese (Simplified)",
            "code": "zh-CN"
        },
        {
            "language": "Croatian",
            "code": "hr"
        },
        {
            "language": "Czech",
            "code": "cs"
        },
        {
            "language": "Danish",
            "code": "da"
        },
        {
            "language": "Dutch",
            "code": "nl"
        },
        {
            "language": "English",
            "code": "en"
        },
        {
            "language": "Estonian",
            "code": "et"
        },
        {
            "language": "Finnish",
            "code": "fi"
        },
        {
            "language": "French",
            "code": "fr"
        },
        {
            "language": "Galician",
            "code": "gl"
        },
        {
            "language": "Georgian",
            "code": "ka"
        },
        {
            "language": "German",
            "code": "de"
        },
        {
            "language": "Greek",
            "code": "el"
        },
        {
            "language": "Hebrew",
            "code": "iw"
        },
        {
            "language": "Hindi",
            "code": "hi"
        },
        {
            "language": "Hungarian",
            "code": "hu"
        },
        {
            "language": "Icelandic",
            "code": "is"
        },
        {
            "language": "Indonesian",
            "code": "id"
        },
        {
            "language": "Irish",
            "code": "ga"
        },
        {
            "language": "Italian",
            "code": "it"
        },
        {
            "language": "Japanese",
            "code": "ja"
        },
        {
            "language": "Javanese",
            "code": "jw"
        },
        {
            "language": "Kannada",
            "code": "kn"
        },
        {
            "language": "Kazakh",
            "code": "kk"
        },
        {
            "language": "Khmer",
            "code": "km"
        },
        {
            "language": "Korean",
            "code": "ko"
        },
        {
            "language": "Lao",
            "code": "lo"
        },
        {
            "language": "Latvian",
            "code": "lv"
        },
        {
            "language": "Lithuanian",
            "code": "lt"
        },
        {
            "language": "Macedonian",
            "code": "mk"
        },
        {
            "language": "Malay",
            "code": "ms"
        },
        {
            "language": "Malayalam",
            "code": "ml"
        },
        {
            "language": "Maltese",
            "code": "mt"
        },
        {
            "language": "Mongolian",
            "code": "mn"
        },
        {
            "language": "Nepali",
            "code": "ne"
        },
        {
            "language": "Norwegian",
            "code": "no"
        },
        {
            "language": "Pashto",
            "code": "ps"
        },
        {
            "language": "Persian",
            "code": "fa"
        },
        {
            "language": "Polish",
            "code": "pl"
        },
        {
            "language": "Portuguese",
            "code": "pt"
        },
        {
            "language": "Romanian",
            "code": "ro"
        },
        {
            "language": "Russian",
            "code": "ru"
        },
        {
            "language": "Serbian",
            "code": "sr"
        },
        {
            "language": "Sinhala",
            "code": "si"
        },
        {
            "language": "Slovak",
            "code": "sk"
        },
        {
            "language": "Slovenian",
            "code": "sl"
        },
        {
            "language": "Somali",
            "code": "so"
        },
        {
            "language": "Spanish",
            "code": "es"
        },
        {
            "language": "Sundanese",
            "code": "su"
        },
        {
            "language": "Swahili",
            "code": "sw"
        },
        {
            "language": "Swedish",
            "code": "sv"
        },
        {
            "language": "Tamil",
            "code": "ta"
        },
        {
            "language": "Telugu",
            "code": "te"
        },
        {
            "language": "Thai",
            "code": "th"
        },
        {
            "language": "Turkish",
            "code": "tr"
        },
        {
            "language": "Ukrainian",
            "code": "uk"
        },
        {
            "language": "Urdu",
            "code": "ur"
        },
        {
            "language": "Uzbek",
            "code": "uz"
        },
        {
            "language": "Vietnamese",
            "code": "vi"
        },
        {
            "language": "Welsh",
            "code": "cy"
        },
        {
            "language": "Zulu",
            "code": "zu"
        }
    ];
    const [inputValue, setInputValue] = (0, _react.useState)("");
    const [welcomeApiMsg, setWelcomeApiMsg] = (0, _react.useState)("");
    const [staticApiVideo, setStaticApiVideo] = (0, _react.useState)("");
    const [welcomeApiVideo, setWelcomeApiVideo] = (0, _react.useState)("");
    const [messages, setMessages] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [videoUrl, setVideoUrl] = (0, _react.useState)("");
    const [audioToText, setAudioToText] = (0, _react.useState)("");
    const [recording, setRecording] = (0, _react.useState)(false);
    const [audioBlob, setAudioBlob] = (0, _react.useState)(null);
    const [timer, setTimer] = (0, _react.useState)(0);
    const [isSoundOn, setIsSoundOn] = (0, _react.useState)(true);
    const [videoLoading, setVideoLoading] = (0, _react.useState)(true);
    const [showChatBot, setShowChatBot] = (0, _react.useState)(false);
    const [recordMessage, setRecordMessage] = (0, _react.useState)(false);
    const [isApiCalled, setIsApiCalled] = (0, _react.useState)(false);
    const videoRef = (0, _react.useRef)(null);
    const videoApiRef = (0, _react.useRef)(null);
    const mediaRecorderRef = (0, _react.useRef)(null);
    const audioChunksRef = (0, _react.useRef)([]);
    const timerRef = (0, _react.useRef)(null);
    const chatHeadRef = (0, _react.useRef)(null);
    const messagesEndRef = (0, _react.useRef)(null); // Ref for the autoscroll
    const inputRef = (0, _react.useRef)(null);
    const dropdownAvatarRef = (0, _react.useRef)(null);
    const dropdownLanguageRef = (0, _react.useRef)(null);
    const searchInputRef = (0, _react.useRef)(null);
    const [showInitialText, setShowInitialText] = (0, _react.useState)(true);
    const [recentBotIndex, setRecentBotIndex] = (0, _react.useState)(null);
    const [showWelcomeMsg, setShowWelcomeMsg] = (0, _react.useState)(false);
    const [checkAudio, setCheckAudio] = (0, _react.useState)(false);
    const [showWelcomeVideo, setShowWelcomeVideo] = (0, _react.useState)(true);
    const [showLanguages, setShowLanguages] = (0, _react.useState)(false);
    const [searchTerm, setSearchTerm] = (0, _react.useState)("");
    const [filteredLanguages, setFilteredLanguages] = (0, _react.useState)(languages);
    const [showAvatar, setShowAvatar] = (0, _react.useState)(false);
    const [selectedLanguage, setSelectedLanguage] = (0, _react.useState)("English");
    const [languageCode, setLanguageCode] = (0, _react.useState)("en");
    const [isRecordingTemp, setIsRecordingTemp] = (0, _react.useState)(false);
    const [audioUrlTemp, setAudioUrlTemp] = (0, _react.useState)(null);
    const [apiResponseTemp, setApiResponseTemp] = (0, _react.useState)("");
    const mediaRecorderRefTemp = (0, _react.useRef)(null);
    const recordedChunksRefTemp = (0, _react.useRef)([]);
    const mediaStreamRefTemp = (0, _react.useRef)(null);
    const audioRef = (0, _react.useRef)(null);
    const audioConstraintsTemp = {
        audio: {
            sampleRate: 16000,
            channelCount: 1,
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false
        }
    };
    // taking params from parent app and passing in iframe api
    // const [params, setParams] = useState({
    //   companyName: '',
    //   moduleName: '',
    //   avatarName: ''
    // });
    // useEffect(() => {
    //   const receiveMessage = (event) => {
    //     const { companyName, moduleName, avatarName } = event.data;
    //     setParams({ companyName, moduleName, avatarName });
    //   };
    //   window.addEventListener('message', receiveMessage, false);
    //   return () => {
    //     window.removeEventListener('message', receiveMessage);
    //   };
    // }, []);
    // taking params from iframe url only and passing in iframe api
    const params = (0, _reactRouterDom.useLocation)();
    const pathSegments = params.pathname.split("/").filter((segment)=>segment);
    const companyName = pathSegments[pathSegments.length - 3];
    const moduleName = pathSegments[pathSegments.length - 2];
    const avatarName = pathSegments[pathSegments.length - 1];
    const avatarList = [
        {
            name: "Natasha",
            image: "image1.png"
        }
    ];
    const defaultAvatar = avatarList[0];
    const [selectedAvatar, setSelectedAvatar] = (0, _react.useState)({
        name: defaultAvatar.name,
        image: defaultAvatar.image
    });
    (0, _react.useEffect)(()=>{
        if (avatarName) {
            const foundAvatar = avatarList.find((avatar)=>avatar.name.toLowerCase() === avatarName.toLowerCase());
            if (foundAvatar) setSelectedAvatar({
                name: foundAvatar.name,
                image: foundAvatar.image
            });
            else setSelectedAvatar(defaultAvatar);
        } else setSelectedAvatar(defaultAvatar);
    }, [
        avatarName
    ]);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownAvatarRef.current && !dropdownAvatarRef.current.contains(event.target)) setShowAvatar(false);
        };
        if (showAvatar) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showAvatar
    ]);
    const handleAvatarToggle = ()=>{
        setShowAvatar(!showAvatar);
    };
    const handleLanguageToggle = ()=>{
        setShowLanguages(!showLanguages);
        if (!showLanguages) {
            setFilteredLanguages(languages);
            setSearchTerm("");
        }
    };
    const handleLanguageSelect = (language)=>{
        setSelectedLanguage(language.language);
        setSearchTerm("");
        setFilteredLanguages(languages);
        setShowLanguages(false);
        setLanguageCode(language.code);
    };
    const handleSearchChange = (event)=>{
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);
        const filtered = languages.filter((language)=>language.language.toLowerCase().startsWith(searchTerm));
        setFilteredLanguages(filtered);
    };
    (0, _react.useEffect)(()=>{
        if (showLanguages) searchInputRef.current.focus();
    }, [
        showLanguages
    ]);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target)) setShowLanguages(false);
        };
        if (showLanguages) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showLanguages
    ]);
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" && filteredLanguages.length > 0) handleLanguageSelect(filteredLanguages[0]);
    };
    const handleAvatarSelect = (avatar)=>{
        setSelectedAvatar(avatar);
        setShowAvatar(false);
    };
    const handleWelcomeVideoEnd = ()=>{
        setShowWelcomeVideo(false);
    };
    (0, _react.useEffect)(()=>{
        const showTimeout = setTimeout(()=>{
            setShowWelcomeMsg(true);
        }, 1);
        const hideTimeout = setTimeout(()=>{
            setShowWelcomeMsg(false);
        }, 3000);
        return ()=>{
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        const callApiOnPageLoad = async ()=>{
            const payload = {
                user_input: "hi"
            };
            try {
                const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                if (response.ok) {
                    const data = await response.json();
                    setWelcomeApiMsg(data.responses[0]);
                    setStaticApiVideo(data.static_video);
                    setWelcomeApiVideo(data.video_path);
                } else console.error("API error:", response.statusText);
            } catch (error) {
                console.error("Fetch error:", error);
            }
        };
        callApiOnPageLoad();
    }, [
        companyName,
        moduleName,
        selectedAvatar
    ]);
    (0, _react.useEffect)(()=>{
        const latestBotIndex = messages.map((item, index)=>item.type === "bot" ? index : null).filter((index)=>index !== null).pop();
        if (latestBotIndex !== null) {
            setRecentBotIndex(latestBotIndex);
            // const timer = setTimeout(() => {
            //   setShowInitialText(false);
            // }, 1300);
            setShowInitialText(true);
        // return () => clearTimeout(timer);
        }
    }, [
        messages
    ]);
    const handleKeyPress = (event)=>{
        if (event.key === "Enter") handleSendMessage();
    };
    const handleSendMessage = async ()=>{
        setInputValue(""); // Clear the input field at the start
        if (inputValue.trim() || audioToText) {
            setLoading(true);
            setIsApiCalled(true);
            const userMessage = {
                message: audioToText || inputValue.trim() || "",
                type: "user",
                audioUrl: audioToText,
                isActive: true
            };
            setMessages((prevMessages)=>[
                    ...prevMessages,
                    userMessage
                ]);
            const payload = {
                user_input: audioToText ? audioToText : inputValue.trim() || "",
                lang: languageCode,
                companyName: companyName,
                moduleName: moduleName,
                avatarName: selectedAvatar.name
            };
            if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                behavior: "smooth"
            });
            try {
                const response = await fetch(`https://avengine.pranathiss.com/api/company/${companyName}/${moduleName}/${selectedAvatar.name.toLowerCase()}/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                const data = await response.json();
                setAudioToText("");
                setAudioBlob(null);
                setTimer(0);
                handleResponse(data); // Call handleResponse to play audio and video
                if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            } catch (error) {
                console.error("Error:", error);
            } finally{
                setLoading(false);
            }
        }
    };
    // const handleResponse = (data) => {
    //   // Check if there are bot responses
    //   if (data.responses && data.responses.length > 0) {
    //     const botMessage = data.responses.join(' ');
    //     setMessages((prevMessages) => [
    //       ...prevMessages,
    //       {
    //         message: botMessage,
    //         type: 'bot',
    //       },
    //     ]);
    //   } else {
    //     setMessages((prevMessages) => [
    //       ...prevMessages,
    //       {
    //         message: "Could you please repeat?",
    //         type: 'bot',
    //       },
    //     ]);
    //   }
    //   // Check if there is a video path in the response
    //   if (data.video_path) {
    //     const fullVideoUrl = data.video_path;
    //     setVideoUrl(fullVideoUrl);
    //     // If there is audio data in base64 format, handle the audio
    //     if (data.audio_data) {
    //       // Convert the base64 audio data to a Blob
    //       const audioBlob = base64ToBlob(data.audio_data, 'audio/mp3'); // Assuming audio is in mp3 format
    //       const audioUrl = URL.createObjectURL(audioBlob); // Create a URL for the audio Blob
    //       // Create audio and video elements
    //       const videoElement = document.createElement('video');
    //       videoElement.src = fullVideoUrl;
    //       videoElement.controls = true;
    //       videoElement.autoplay = true;
    //       videoElement.muted = true; // Mute the video to avoid overlapping sound
    //       const audioElement = document.createElement('audio');
    //       audioElement.src = audioUrl;
    //       audioElement.autoplay = true;
    //       // const audioElement = new Audio(audioUrl);
    //     audioRef.current = audioElement; 
    //       // Sync the audio and video playback
    //       videoElement.addEventListener('play', () => {
    //         audioElement.play();
    //       });
    //       videoElement.addEventListener('pause', () => {
    //         audioElement.pause();
    //       });
    //       // Append the video element to a container (assuming there is a container for the video)
    //       const videoContainer = document.getElementById('video-container');
    //       videoContainer.innerHTML = ''; // Clear any previous video
    //       videoContainer.appendChild(videoElement);
    //     } else {
    //       console.log('No audio data received.');
    //     }
    //   } else {
    //     setVideoUrl(''); // Clear the video if no path is provided
    //   }
    // };
    // Utility function to convert base64 to Blob
    (0, _react.useEffect)(()=>{
    // Play the video whenever the videoUrl changes
    // if (videoUrl && videoRef.current) {
    //     videoRef.current.src = videoUrl;
    //     videoRef.current.load(); // Ensure video loads correctly
    //     videoRef.current.play(); // Play the video
    // }
    }, [
        videoUrl
    ]); // Add videoUrl to the dependency array to track changes
    const handleResponse = (data)=>{
        // Handle bot messages
        if (data.responses && data.responses.length > 0) {
            const botMessage = data.responses.join(" ");
            setMessages((prevMessages)=>[
                    ...prevMessages,
                    {
                        message: botMessage,
                        type: "bot"
                    }
                ]);
        } else setMessages((prevMessages)=>[
                ...prevMessages,
                {
                    message: "Could you please repeat?",
                    type: "bot"
                }
            ]);
        // Handle video from API
        if (data.video_path) {
            const fullVideoUrl = data.video_path;
            setVideoUrl(fullVideoUrl); // Set the new video URL
            // Stop any previous audio before handling the new response
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reset previous audio
            }
            if (languageCode == "en") // For English language, play the video sound and ensure it's muted based on current state
            {
                if (videoRef.current) {
                    videoRef.current.src = fullVideoUrl;
                    //   videoRef.current.muted = !isSoundOn; // Play video with or without sound based on sound state
                    videoRef.current.play();
                    // Remove any previous 'ended' event listeners and add the new one
                    videoRef.current.removeEventListener("ended", playStaticVideo);
                    videoRef.current.addEventListener("ended", playStaticVideo);
                }
            } else {
                // For non-English languages, mute the video and play the API audio key
                if (videoRef.current) {
                    videoRef.current.src = fullVideoUrl;
                    videoRef.current.muted = true; // Mute video sound
                    videoRef.current.play();
                    // Remove any previous 'ended' event listeners and add the new one
                    videoRef.current.removeEventListener("ended", playStaticVideo);
                    videoRef.current.addEventListener("ended", playStaticVideo);
                }
                // Handle API-provided audio key for non-English languages
                if (data.audio_data) {
                    const audioBlob = base64ToBlob(data.audio_data, "audio/mp3");
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const audioElement = new Audio(audioUrl);
                    audioRef.current = audioElement;
                    // Ensure audio is played or muted based on the sound toggle
                    audioElement.muted = !isSoundOn;
                    audioElement.play();
                    // Handle audio end event
                    audioElement.addEventListener("ended", ()=>{
                        if (videoRef.current) {
                            videoRef.current.pause();
                            playStaticVideo(); // Play static video after API video finishes
                        }
                    });
                }
            }
        } else setVideoUrl(""); // Clear the video if no path is provided
    };
    // Function to toggle sound for both video and audio
    const toggleSound = ()=>{
        setIsSoundOn((prevIsSoundOn)=>{
            const newIsSoundOn = !prevIsSoundOn;
            if (languageCode === "en") {
                if (videoRef.current) videoRef.current.muted = !newIsSoundOn; // Toggle video sound based on state
            } else if (audioRef.current) audioRef.current.muted = !newIsSoundOn; // Toggle API-provided audio key sound
            return newIsSoundOn;
        });
    };
    // Function to play the static video
    const playStaticVideo = ()=>{
        if (videoRef.current) {
            videoRef.current.src = staticApiVideo; // Set the static video source
            videoRef.current.muted = true; // Ensure the static video is muted
            videoRef.current.play(); // Play the static video
        }
    };
    const base64ToBlob = (base64Data, contentType = "", sliceSize = 512)=>{
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for(let i = 0; i < slice.length; i++)byteNumbers[i] = slice.charCodeAt(i);
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: contentType
        });
    };
    (0, _react.useEffect)(()=>{
        if (videoUrl) {
            setVideoLoading(true);
            const video = videoRef.current;
            if (video) video.onloadeddata = ()=>{
                setVideoLoading(false);
                video.onended = ()=>{
                    setVideoUrl("");
                };
            };
        }
    }, [
        videoUrl
    ]);
    // useEffect(() => {
    //   if (!loading && !recording) {
    //     inputRef.current?.focus();
    //   }
    //   if (showWelcomeVideo) {
    //     inputRef.current?.focus();
    //   }
    // }, [loading, recording, inputValue, messages]);
    // recording check 
    // const startRecording = async () => {
    //   setRecording(true);
    //   setRecordMessage(false)
    //   setTimer(0);
    //   audioChunksRef.current = [];
    //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //   mediaRecorderRef.current = new MediaRecorder(stream);
    //   mediaRecorderRef.current.ondataavailable = (event) => {
    //     if (event.data.size > 0) {
    //       audioChunksRef.current.push(event.data);
    //     }
    //   };
    //   mediaRecorderRef.current.onstop = () => {
    //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    //     setAudioBlob(blob);
    //   };
    //   mediaRecorderRef.current.start();
    //   timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
    // };
    // const stopRecording = () => {
    //   setRecordMessage(true)
    //   setRecording(false);
    //   if (mediaRecorderRef.current) {
    //     mediaRecorderRef.current.stop();
    //   }
    //   clearInterval(timerRef.current);
    // };
    (0, _react.useEffect)(()=>{
        if (audioBlob) sendAudioToApi(audioBlob);
    }, [
        audioBlob
    ]);
    (0, _react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setRecordMessage(false);
        }, 3000);
        return ()=>clearTimeout(timer);
    }, [
        recordMessage
    ]);
    // const sendAudioToApi = async (blob) => {
    //   try {
    //     const base64Audio = await convertBlobToBase64(blob);
    //     const fileExtension = blob.type.split('/')[1];
    //     const formData = new FormData();
    //     formData.append('audio_file', base64Audio.split(',')[1]);
    //     formData.append('file_extension', fileExtension);
    //     const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
    //       method: 'POST',
    //       body: formData
    //     });
    //     const data = await response.json();
    //     setAudioToText(data.response)
    //     if (data.response.length > 0) {
    //       setCheckAudio(false)
    //     }
    //     // if (data.response) {
    //     //   setTimeout(() => {
    //     //     setRecordMessage(false)
    //     //     }, 880);
    //     //   // }, 6200);
    //     // }
    //   } catch (error) {
    //     console.error('Error sending audio:', error);
    //   }
    //   finally {
    //     setCheckAudio(true)
    //   }
    // };
    const convertBlobToBase64 = (blob)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };
    (0, _react.useEffect)(()=>{
    // if (videoRef.current) {
    //     setVideoLoading(true);
    //     videoRef.current.load();
    //     videoRef.current.play().finally(() => {
    //         setVideoLoading(false);
    //     });
    // }
    }, [
        videoUrl
    ]);
    //   const toggleSound = () => {
    //     if (audioRef.current) {
    //       audioRef.current.muted = isSoundOn;
    //       setIsSoundOn(!isSoundOn);
    //     }
    //   };
    // const toggleSound = () => {
    //   if (videoRef.current && audioRef.current) {
    //     if (isSoundOn) {
    //       // Mute both video and external audio
    //       videoRef.current.muted = true;
    //       audioRef.current.muted = true; // Mute external audio
    //     } else {
    //       // Unmute both video and external audio
    //       videoRef.current.muted = false;
    //       audioRef.current.muted = false; // Unmute external audio
    //     }
    //     // Toggle sound state
    //     setIsSoundOn(!isSoundOn);
    //   }
    // };
    const handleChatBotOpen = ()=>{
        setShowChatBot(!showChatBot);
    };
    (0, _react.useEffect)(()=>{
        setShowChatBot(true);
    }, []);
    (0, _react.useEffect)(()=>{
        handleSendMessage();
    }, [
        audioToText
    ]);
    const handleVideoEnd = ()=>{
        setVideoUrl(staticApiVideo);
    };
    (0, _react.useEffect)(()=>{
        if (messagesEndRef.current) setTimeout(()=>{
            if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }, 500);
    }, [
        messages,
        showChatBot
    ]);
    // audio functionality for ios 
    // const sendAudioToApi = async () => {
    //     if (!isRecordingTemp) {
    //         try {
    //             mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
    //             // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
    //             const mimeType = isIOS() ? 'audio/mp4' : 'audio/webm';
    //             mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
    //             mediaRecorderRefTemp.current.ondataavailable = (event) => {
    //                 if (event.data.size > 0) {
    //                     recordedChunksRefTemp.current.push(event.data);
    //                 }
    //             };
    //             mediaRecorderRefTemp.current.onstop = async () => {
    //                 const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
    //                 recordedChunksRefTemp.current = [];
    //                 // Convert blob to Base64
    //                 const readerTemp = new FileReader();
    //                 readerTemp.readAsDataURL(blobTemp);
    //                 readerTemp.onloadend = async () => {
    //                     const base64AudioTemp = readerTemp.result.split(',')[1];
    //                     // Display audio for playback
    //                     const audioUrlTemp = URL.createObjectURL(blobTemp);
    //                     setAudioUrlTemp(audioUrlTemp);
    //                     // Prepare the form data
    //                     const formDataTemp = new FormData();
    //                     formDataTemp.append('audio_file', base64AudioTemp);
    //                     formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
    //                     // Call the API
    //                     try {
    //                         // const responseTemp = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
    //                         const responseTemp = await fetch(`https://speech.pranathiss.com/api/vad-base64-speech-to-text/${selectedLanguage}/`, {
    //                             method: 'POST',
    //                             body: formDataTemp,
    //                         });
    //                         const resultTemp = await responseTemp.json();
    //                         console.log('API Response:', resultTemp.response);
    //                         setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
    //                         setAudioToText(resultTemp.response);
    //                         if (resultTemp.response.length > 0) {
    //                             setCheckAudio(false);
    //                         }
    //                     } catch (error) {
    //                         console.error('Error calling the API:', error);
    //                         setApiResponseTemp(`Error: ${error.message}`);
    //                     }
    //                 };
    //             };
    //             mediaRecorderRefTemp.current.start();
    //             setIsRecordingTemp(true);
    //         } catch (error) {
    //             console.error('Error accessing microphone: ', error);
    //         }
    //     } else {
    //         // Stop the recording
    //         mediaRecorderRefTemp.current.stop();
    //         mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
    //         setIsRecordingTemp(false);
    //     }
    // };
    const sendAudioToApi = async ()=>{
        if (!isRecordingTemp) try {
            // Request microphone access
            mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
            // Detect if the user is on iOS and use 'audio/mp4' else 'audio/webm'
            const mimeType = isIOS() ? "audio/mp4" : "audio/webm";
            mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, {
                mimeType
            });
            mediaRecorderRefTemp.current.ondataavailable = (event)=>{
                if (event.data.size > 0) recordedChunksRefTemp.current.push(event.data);
            };
            mediaRecorderRefTemp.current.onstop = async ()=>{
                const blobTemp = new Blob(recordedChunksRefTemp.current, {
                    type: mimeType
                });
                recordedChunksRefTemp.current = [];
                // Convert blob to Base64
                const readerTemp = new FileReader();
                readerTemp.readAsDataURL(blobTemp);
                readerTemp.onloadend = async ()=>{
                    const base64AudioTemp = readerTemp.result.split(",")[1];
                    // Display audio for playback
                    const audioUrlTemp = URL.createObjectURL(blobTemp);
                    setAudioUrlTemp(audioUrlTemp);
                    // Prepare the form data
                    const formDataTemp = new FormData();
                    formDataTemp.append("audio_file", base64AudioTemp);
                    formDataTemp.append("file_extension", mimeType === "audio/mp4" ? "mp4" : "webm");
                    // Call the API
                    try {
                        const responseTemp = await fetch(`https://speech.pranathiss.com/api/vad-base64-speech-to-text/${selectedLanguage}/`, {
                            method: "POST",
                            body: formDataTemp
                        });
                        const resultTemp = await responseTemp.json();
                        console.log("API Response:", resultTemp.response);
                        setApiResponseTemp(JSON.stringify(resultTemp, null, 2));
                        setAudioToText(resultTemp.response);
                        if (resultTemp.response.length > 0) setCheckAudio(false);
                    } catch (error) {
                        console.error("Error calling the API:", error);
                        setApiResponseTemp(`Error: ${error.message}`);
                    }
                };
            };
            mediaRecorderRefTemp.current.start();
            setIsRecordingTemp(true);
        } catch (error) {
            // Handle errors and provide feedback to the user
            if (error.name === "NotAllowedError") {
                console.error("Microphone permission denied: ", error);
                alert("Microphone access was denied. Please enable it in the settings.");
            } else {
                console.error("Error accessing microphone: ", error);
                alert("An error occurred while trying to access your microphone. Please try again.");
            }
        }
        else {
            // Stop the recording
            mediaRecorderRefTemp.current.stop();
            mediaStreamRefTemp.current.getTracks().forEach((track)=>track.stop());
            setIsRecordingTemp(false);
        }
    };
    // Helper function to check if the user is on iOS
    const isIOS = ()=>/iPhone|iPad|iPod/i.test(navigator.userAgent);
    const handleInputSearch = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: !showChatBot ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "videochartvalue ",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "headAndOutput",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chatHead",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "headIcontext",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "iconHeadChat",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/chatAvatarIcon3.png",
                                                        alt: "Avatar"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "headTextClass",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper miniHead",
                                                                children: "Chat with"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-2",
                                                                children: "AI Assistant"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "headMinClose",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "languagesDivBoth",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "languagesDiv",
                                                        onClick: handleAvatarToggle,
                                                        ref: dropdownAvatarRef,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "avatarNameImgClass",
                                                                children: selectedAvatar.name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `arrow ${showAvatar ? "open" : ""}`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: (0, _arrowDownConvertPngDefault.default),
                                                                    alt: "",
                                                                    className: "downArrowClass"
                                                                })
                                                            }),
                                                            showAvatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown",
                                                                children: avatarList.filter((avatar)=>avatar !== selectedAvatar).map((avatar, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                                        onClick: ()=>handleAvatarSelect(avatar),
                                                                        className: "avatarNameImgClass",
                                                                        children: avatar.name
                                                                    }, index))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        ref: dropdownLanguageRef,
                                                        className: "languagesDiv",
                                                        onClick: handleLanguageToggle,
                                                        children: [
                                                            selectedLanguage,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `arrow ${showLanguages ? "open" : ""}`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: (0, _arrowDownConvertPngDefault.default),
                                                                    alt: "",
                                                                    className: "downArrowClass"
                                                                })
                                                            }),
                                                            showLanguages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    ref: searchInputRef,
                                                                    type: "text",
                                                                    value: searchTerm,
                                                                    onChange: handleSearchChange,
                                                                    onKeyDown: handleKeyDown,
                                                                    onClick: handleInputSearch,
                                                                    placeholder: "Search",
                                                                    className: "searchLanguageInput"
                                                                })
                                                            }),
                                                            showLanguages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "languageDropdown languageSearchDropdown",
                                                                children: filteredLanguages.map((language, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                                        onClick: ()=>handleLanguageSelect(language),
                                                                        className: "languageOption",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            children: language.language
                                                                        })
                                                                    }, index))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: " speakerIconButton",
                                                children: [
                                                    isSoundOn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _chatSoundSpeakerPngDefault.default),
                                                        alt: "Speaker",
                                                        onClick: toggleSound
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _chatMuteSpeakerPngDefault.default),
                                                        alt: "Speaker",
                                                        onClick: toggleSound
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/minimizeIcon/minimize1.png",
                                                        alt: "Line",
                                                        onClick: handleChatBotOpen
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                id: "output-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "messages-container",
                                        children: [
                                            showWelcomeMsg ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-item receiver",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "senderIconText",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "message",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "chat-bubble",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "typing",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "dot"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: "/img/chatAvatarIcon3.png",
                                                            alt: "Receiver Avatar"
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "receiverIconText",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: "/img/chatAvatarIcon3.png",
                                                        alt: "Receiver Avatar"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "success-status",
                                                        children: welcomeApiMsg
                                                    })
                                                ]
                                            }),
                                            messages.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: `message-item ${item.type === "user" ? "sender" : "receiver"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "senderIconText",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "message",
                                                                    children: item.audioUrl ? recordMessage && index === recentBotIndex ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "chat-bubble-audio",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "typing",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "dot"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        children: item.audioUrl
                                                                    }) : //  (
                                                                    //   item.type === 'bot' && index === recentBotIndex && showInitialText ? (
                                                                    //     <div className="chat-bubble">
                                                                    //       <div className="typing">
                                                                    //         <div className="dot"></div>
                                                                    //         <div className="dot"></div>
                                                                    //         <div className="dot"></div>
                                                                    //       </div>
                                                                    //     </div>
                                                                    //   ) : (
                                                                    //     <p>{item.message}</p>
                                                                    //   )
                                                                    // )
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        children: item.message
                                                                    })
                                                                }),
                                                                item.type === "user" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/chatSenderIcon.png",
                                                                    alt: "Sender Avatar"
                                                                }),
                                                                item.type === "bot" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/chatAvatarIcon3.png",
                                                                    alt: "Receiver Avatar"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            ref: messagesEndRef
                                                        }),
                                                        " "
                                                    ]
                                                }, index)),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                ref: messagesEndRef
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "hello-container",
                                        children: showWelcomeVideo && welcomeApiVideo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                            ref: videoRef,
                                            width: "100%",
                                            autoPlay: true,
                                            muted: !isSoundOn,
                                            onEnded: handleWelcomeVideoEnd,
                                            playsInline: true,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                    src: welcomeApiVideo,
                                                    type: "video/mp4"
                                                }),
                                                "Your browser does not support the video tag."
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: !isApiCalled || !videoUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                                ref: videoRef,
                                                width: "100%",
                                                autoPlay: true,
                                                loop: true,
                                                muted: true,
                                                playsInline: true,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                        src: staticApiVideo,
                                                        type: "video/mp4"
                                                    }),
                                                    "Your browser does not support the video tag."
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                                ref: videoRef,
                                                width: "100%",
                                                autoPlay: true,
                                                muted: languageCode == "en" ? !isSoundOn : true,
                                                onEnded: handleVideoEnd,
                                                playsInline: true,
                                                className: "responseVideoClass",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                        src: videoUrl,
                                                        type: "video/mp4"
                                                    }),
                                                    "Your browser does not support the video tag."
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "outputHelpfulClass",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    value: inputValue,
                                    onChange: (e)=>setInputValue(e.target.value),
                                    onKeyPress: handleKeyPress,
                                    placeholder: "Enter your message",
                                    disabled: loading || recording,
                                    ref: inputRef
                                }),
                                isRecordingTemp ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "recording-indicator",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        onClick: sendAudioToApi,
                                        disabled: loading,
                                        className: "iconButton",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: "/img/chatMicSpeakIcon.png",
                                            alt: "Mic"
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "iconButton",
                                    onClick: sendAudioToApi,
                                    disabled: loading,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "/img/chatMicIcon.png",
                                        alt: "Mic"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "iconButton",
                                    onClick: handleSendMessage,
                                    disabled: loading || recording,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "/img/chatSendIcon.png",
                                        alt: "Send"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "chatBoxImageClass",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _chatBoxImageCrop1PngDefault.default),
                alt: "",
                onClick: handleChatBotOpen
            })
        })
    });
};
exports.default = NoAudioEnglish;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","emoji-picker-react":"4s16w","./frameNew.css":"iQA0X","../../../static/img/chatBoxImageCrop1.png":"gBFnl","../../../static/img/arrowDownConvert.png":"gulDC","../../../static/img/chatSoundSpeaker.png":"1uqOf","../../../static/img/chatMuteSpeaker.png":"9MSx0","react-router-dom":"l6ORY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQA0X":[function() {},{}],"6DYtW":[function(require,module,exports) {
// import './botUserApp.css'
// const BotUserApp=()=>{
//     console.log('dddddddd');
//     return(
//         <p>botUserApp</p>
//     )
// }
// export default BotUserApp
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _botUserAppCss = require("./botUserApp.css");
const BotUserApp = ()=>{
    const [messages, setMessages] = (0, _react.useState)([
        {
            sender: "bot",
            text: "How can I help you? Please select one option:\n1. Talk to customer support\n2. Guide\n3. Contact us"
        }
    ]);
    const [input, setInput] = (0, _react.useState)("");
    // Handle user input and send message
    const handleSend = ()=>{
        if (!input) return;
        const userMessage = {
            sender: "user",
            text: input
        };
        // Add user message to chat
        setMessages([
            ...messages,
            userMessage
        ]);
        // Bot response based on user input
        let botReply = "";
        if (input === "1") botReply = "You chose to talk to customer support.";
        else if (input === "2") botReply = "Here is a guide to help you.";
        else if (input === "3") botReply = "You can contact us at contact@company.com.";
        else botReply = "Please select a valid option (1, 2, or 3).";
        // Add bot reply to chat
        setTimeout(()=>{
            setMessages((prevMessages)=>[
                    ...prevMessages,
                    {
                        sender: "bot",
                        text: botReply
                    }
                ]);
        }, 1000); // Adding a delay to mimic bot response time
        setInput(""); // Clear input field after sending
    };
    // Handle Enter key press to send message
    const handleKeyPress = (event)=>{
        if (event.key === "Enter") handleSend();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "App",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "chat-window",
                children: messages.map((message, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `message ${message.sender === "bot" ? "bot" : "user"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                children: [
                                    message.sender === "bot" ? "Bot" : "User",
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "message-text",
                                children: message.text
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "input-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: input,
                        onChange: (e)=>setInput(e.target.value),
                        onKeyPress: handleKeyPress,
                        placeholder: "Type a number (1, 2, or 3)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleSend,
                        children: "Send"
                    })
                ]
            })
        ]
    });
};
exports.default = BotUserApp;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./botUserApp.css":"bGXa5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGXa5":[function() {},{}]},["5Tqlz"], "5Tqlz", "parcelRequireb8e7")

//# sourceMappingURL=index.c19e87f7.js.map
